import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: Object; output: Object; }
  Upload: { input: File; output: never; }
  Url: { input: URL; output: URL; }
  Uuid: { input: string; output: string; }
  Void: { input: void; output: void; }
}

export interface ApiKey {
  __typename?: 'APIKey';
  createDate: Scalars['DateTime']['output'];
  expiresOn: Scalars['DateTime']['output'];
  ipAllowList: Array<Scalars['String']['output']>;
  keyId: Scalars['ID']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  keyPrefix: Scalars['String']['output'];
  lastUsedDate?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Scalars['String']['output']>;
  updateDate: Scalars['DateTime']['output'];
}

export interface ApiKeySettings {
  __typename?: 'APIKeySettings';
  apiKeysLimit: Scalars['Int']['output'];
}

export interface ApiLog extends PaginatedType {
  __typename?: 'APILog';
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['ID']['output']>;
  method: ApiLogMethod;
  origin?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  request?: Maybe<Scalars['JSON']['output']>;
  requestId?: Maybe<Scalars['ID']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
}

export enum ApiLogMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export interface ApiLogSearchInput {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  methods?: InputMaybe<Array<ApiLogMethod>>;
  pageOffset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchBoxString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ApiLogStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

export enum ApiLogStatus {
  failed = 'failed',
  succeeded = 'succeeded'
}

export interface ApiLogs extends PaginationExtends {
  __typename?: 'APILogs';
  links: PaginationLinks;
  list: Array<ApiLog>;
}

export interface AccountSetupInfo {
  __typename?: 'AccountSetupInfo';
  hasCompletedAllVerifications: Scalars['Boolean']['output'];
  hasConfirmedDetails: Scalars['Boolean']['output'];
  isCOPBusinessOnboardingInProgress: Scalars['Boolean']['output'];
  isNonAuthorizedRep: Scalars['Boolean']['output'];
  isOnboardingInitiator: Scalars['Boolean']['output'];
  isRolrUser: Scalars['Boolean']['output'];
}

export enum AccountType {
  MERCHANT = 'MERCHANT',
  MINT_ROLR_EEA = 'MINT_ROLR_EEA',
  MINT_ROLR_NON_EEA = 'MINT_ROLR_NON_EEA'
}

export enum AddBankAccountFlowVariant {
  IBAN = 'IBAN',
  NON_IBAN = 'NON_IBAN',
  US = 'US'
}

export interface AddBlockchainDepositAddressInput {
  abbreviation: BlockchainAbbreviation;
  currency?: InputMaybe<Currency>;
}

export interface AddBlockchainRecipientAddressInput {
  address: Scalars['String']['input'];
  addressTag?: InputMaybe<Scalars['String']['input']>;
  chain: Scalars['String']['input'];
  currency?: InputMaybe<Currency>;
  description: Scalars['String']['input'];
}

export interface AddCaBankAccountInput {
  accountNumber: Scalars['String']['input'];
  bankAddress: OtherBankAddressInput;
  billingDetails: BillingDetailsInput;
  institutionCode: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
  transitNumber: Scalars['String']['input'];
}

export interface AddCbitBankAccountInput {
  nickname: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
}

export interface AddCubixBankAccountInput {
  accountId: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
}

export interface AddEntriesToWatchListInput {
  entries: Array<AddEntryToWatchListInput>;
  variant: WatchLists;
}

export interface AddEntryToWatchListInput {
  entity: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  type: WatchlistTypes;
}

export interface AddIbanBankAccountInput {
  bankAddress: IbanBankAddressInput;
  billingDetails: BillingDetailsInput;
  iban: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
}

export interface AddOtherBankAccountInput {
  accountNumber: Scalars['String']['input'];
  bankAddress: OtherBankAddressInput;
  billingDetails: BillingDetailsInput;
  nickname: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
}

export interface AddPixBankAccountInput {
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  ispb: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  taxId: Scalars['String']['input'];
}

export interface AddRtpBankAccountInput {
  accountNumber: Scalars['String']['input'];
  billingDetails: BillingDetailsInput;
  nickname: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
}

export interface AddSenBankAccountInput {
  accountNumber: Scalars['String']['input'];
  currency: Currency;
  nickname: Scalars['String']['input'];
}

export interface AddUsBankAccountInput {
  accountNumber: Scalars['String']['input'];
  bankAddress: UsBankAddressInput;
  billingDetails: BillingDetailsInput;
  ffcMemo?: InputMaybe<Scalars['String']['input']>;
  nickname: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
}

export interface AddXpayBankAccountInput {
  accountNumber: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
}

export interface AddressBook {
  __typename?: 'AddressBook';
  address: Scalars['String']['output'];
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: BlockchainAbbreviation;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: AddressBookMetadata;
  riskEvaluation?: Maybe<RiskEvaluation>;
  status: AddressBookStatus;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface AddressBookMetadata {
  __typename?: 'AddressBookMetadata';
  bns?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
}

export interface AddressBookProposal {
  __typename?: 'AddressBookProposal';
  externalAddress: ExternalAddress;
  id: Scalars['ID']['output'];
  status: ProposalStatus;
}

export enum AddressBookStatus {
  active = 'active',
  denied = 'denied',
  inactive = 'inactive',
  on_hold = 'on_hold',
  pending = 'pending'
}

export interface AddressStatusResponse {
  __typename?: 'AddressStatusResponse';
  state: BlockchainAddressStatus;
}

export enum AddressType {
  chained_deposit_address = 'chained_deposit_address',
  deposit_address = 'deposit_address',
  withdrawal_address = 'withdrawal_address'
}

/** Admin approvals settings: Proposal types */
export enum AdminApprovalPolicyType {
  USER_INVITE_POLICY = 'USER_INVITE_POLICY',
  USER_REMOVE_POLICY = 'USER_REMOVE_POLICY'
}

/** Admin approvals policy */
export interface AdminApprovalsPolicy {
  __typename?: 'AdminApprovalsPolicy';
  approvalsNeeded: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  isSubmitted: Scalars['Boolean']['output'];
  policyId: Scalars['ID']['output'];
  proposerId: Scalars['ID']['output'];
  type: AdminApprovalPolicyType;
}

/** Admin approvals settings: input */
export interface AdminApprovalsSettingsInput {
  approvalsNeeded?: InputMaybe<Scalars['Int']['input']>;
  type: AdminApprovalPolicyType;
  workflowEnabled: Scalars['Boolean']['input'];
}

/** Admin approvals user invite: input */
export interface AdminApprovalsUserInvite {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  permissionGroup: UserRoleGroupType;
}

export enum AllowEntityReason {
  trusted = 'trusted'
}

export interface Amount {
  __typename?: 'Amount';
  amount: Scalars['String']['output'];
  currency: Currency;
}

export interface AmountInput {
  amount: Scalars['String']['input'];
  currency: Currency;
}

export interface ApprovalPolicies {
  __typename?: 'ApprovalPolicies';
  apiKey?: Maybe<BaseApprovalPolicy>;
  blockchainAddress?: Maybe<BaseApprovalPolicy>;
  userInvite?: Maybe<BaseApprovalPolicy>;
  userRemoval?: Maybe<BaseApprovalPolicy>;
}

export interface ApprovalPoliciesInput {
  type?: InputMaybe<ApprovalPolicyType>;
}

export enum ApprovalPolicyQuorumType {
  ALL = 'ALL',
  ANY = 'ANY',
  MAJORITY = 'MAJORITY'
}

export enum ApprovalPolicyType {
  API_KEY = 'API_KEY',
  BLOCKCHAIN_ADDRESS = 'BLOCKCHAIN_ADDRESS',
  USER_INVITE = 'USER_INVITE',
  USER_REMOVAL = 'USER_REMOVAL'
}

export interface ApproverUserGroup {
  __typename?: 'ApproverUserGroup';
  id: Scalars['String']['output'];
  members?: Maybe<Array<UserGroupMember>>;
  name?: Maybe<Scalars['String']['output']>;
}

export enum AssetIcon {
  ALGO = 'ALGO',
  APTOS = 'APTOS',
  ARB = 'ARB',
  AVAX = 'AVAX',
  BASE = 'BASE',
  BTC = 'BTC',
  CELO = 'CELO',
  CODEX = 'CODEX',
  ETH = 'ETH',
  EURC = 'EURC',
  EVMOS = 'EVMOS',
  FLOW = 'FLOW',
  HBAR = 'HBAR',
  LINEA = 'LINEA',
  MANA = 'MANA',
  MATIC = 'MATIC',
  NEAR = 'NEAR',
  NOBLE = 'NOBLE',
  OP = 'OP',
  PAH = 'PAH',
  POLY = 'POLY',
  SOL = 'SOL',
  SUI = 'SUI',
  TRX = 'TRX',
  UNI = 'UNI',
  USDC = 'USDC',
  Unknown = 'Unknown',
  XLM = 'XLM',
  XRP = 'XRP',
  ZKS = 'ZKS'
}

export enum AuthorizedRepOccupation {
  ceo = 'ceo',
  cfo = 'cfo',
  cio = 'cio',
  coo = 'coo',
  cto = 'cto',
  director = 'director',
  founder = 'founder',
  manager = 'manager',
  other = 'other',
  owner = 'owner',
  partner = 'partner',
  president = 'president'
}

export interface Balances {
  __typename?: 'Balances';
  main?: Maybe<BalancesMain>;
  total?: Maybe<BalancesTotal>;
}

export interface BalancesMain {
  __typename?: 'BalancesMain';
  balance: Amount;
}

export interface BalancesTotal {
  __typename?: 'BalancesTotal';
  balance: Amount;
}

export type BankAccount = CbitBankAccount | CubixBankAccount | PixBankAccount | RtpBankAccount | SenBankAccount | SignetBankAccount | WireBankAccount | XpayBankAccount;

export enum BankAccountFtuLinkStatus {
  complete = 'complete',
  failed = 'failed',
  none = 'none',
  pending = 'pending'
}

export interface BankAccountMetadata {
  __typename?: 'BankAccountMetadata';
  userConfirmedWireSend?: Maybe<Scalars['Boolean']['output']>;
}

export interface BankAccountMetadataInput {
  userConfirmedWireSend: Scalars['Boolean']['input'];
}

export enum BankAccountStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export enum BankAccountType {
  cbit = 'cbit',
  cubix = 'cubix',
  pix = 'pix',
  rtp = 'rtp',
  sen = 'sen',
  signet = 'signet',
  wire = 'wire',
  xpay = 'xpay'
}

export interface BankAddress {
  __typename?: 'BankAddress';
  bankName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
}

export interface BankLocation {
  __typename?: 'BankLocation';
  description?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
}

export interface BankSettings {
  __typename?: 'BankSettings';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  fiatAccountId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BankAccountMetadata>;
  nickname?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface BaseApprovalPolicy {
  __typename?: 'BaseApprovalPolicy';
  approverGroup?: Maybe<UserGroup>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  requires?: Maybe<ApprovalPolicyQuorumType>;
  type: ApprovalPolicyType;
}

export interface BaseInAppNotification {
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  type: InAppNotificationType;
}

export enum BeneficiaryType {
  business = 'business',
  individual = 'individual'
}

export interface BillingAddress {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
}

export interface BillingAddressInput {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
}

export interface BillingContact {
  __typename?: 'BillingContact';
  email?: Maybe<Scalars['String']['output']>;
}

export interface BillingContactInput {
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface BillingDetails {
  __typename?: 'BillingDetails';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
}

export interface BillingDetailsInput {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  district: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}

export interface BillingProfileDetails {
  __typename?: 'BillingProfileDetails';
  billingAddress?: Maybe<BillingAddress>;
  billingContact?: Maybe<BillingContact>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
}

export enum BlockEntityReason {
  fraud = 'fraud',
  unsupported = 'unsupported'
}

export interface Blockchain {
  __typename?: 'Blockchain';
  chain: BlockchainAbbreviation;
  chainId?: Maybe<Scalars['Int']['output']>;
  icon: AssetIcon;
  isAceSupported: Scalars['Boolean']['output'];
  isBridged: Scalars['Boolean']['output'];
  isTRMSupported: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export enum BlockchainAbbreviation {
  ALGO = 'ALGO',
  APTOS = 'APTOS',
  ARB = 'ARB',
  AVAX = 'AVAX',
  BASE = 'BASE',
  BTC = 'BTC',
  CELO = 'CELO',
  CODEX = 'CODEX',
  ETH = 'ETH',
  EVMOS = 'EVMOS',
  FLOW = 'FLOW',
  HBAR = 'HBAR',
  LINEA = 'LINEA',
  MANA = 'MANA',
  MATIC = 'MATIC',
  NEAR = 'NEAR',
  NOBLE = 'NOBLE',
  OP = 'OP',
  PAH = 'PAH',
  POLY = 'POLY',
  SOL = 'SOL',
  SUI = 'SUI',
  TRX = 'TRX',
  UNI = 'UNI',
  XLM = 'XLM',
  XRP = 'XRP',
  ZKS = 'ZKS'
}

export enum BlockchainActivityType {
  ALL = 'ALL',
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL'
}

export interface BlockchainAddressFilterInput {
  chain?: InputMaybe<BlockchainAbbreviation>;
  currency?: InputMaybe<Currency>;
}

export enum BlockchainAddressStatus {
  ACTIVE = 'ACTIVE',
  ON_HOLD = 'ON_HOLD',
  PENDING_ADDITIONAL_INFORMATION = 'PENDING_ADDITIONAL_INFORMATION',
  PENDING_BENEFICIARY_INFORMATION = 'PENDING_BENEFICIARY_INFORMATION',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  UNSUPPORTED = 'UNSUPPORTED'
}

export interface BlockchainAsset {
  __typename?: 'BlockchainAsset';
  icon: AssetIcon;
  name?: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  txcoreCurrency?: Maybe<Scalars['String']['output']>;
}

export interface BlockchainDepositAddress {
  __typename?: 'BlockchainDepositAddress';
  address: Scalars['String']['output'];
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: BlockchainAbbreviation;
  currency?: Maybe<Currency>;
}

export interface BlockchainLocation {
  __typename?: 'BlockchainLocation';
  address?: Maybe<Scalars['String']['output']>;
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: Scalars['String']['output'];
  type: TransferLocationType;
}

export interface BlockchainLocationMetadata {
  __typename?: 'BlockchainLocationMetadata';
  attestation?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export interface BlockchainRecipientAddress {
  __typename?: 'BlockchainRecipientAddress';
  address: Scalars['String']['output'];
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: BlockchainAbbreviation;
  currency?: Maybe<Currency>;
  delayedWithdrawalInfo?: Maybe<DelayedWithdrawalInfo>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
}

export interface BlockchainRecipientAddressLocation {
  __typename?: 'BlockchainRecipientAddressLocation';
  address?: Maybe<Scalars['String']['output']>;
  addressId?: Maybe<Scalars['ID']['output']>;
  addressTag?: Maybe<Scalars['String']['output']>;
  chain?: Maybe<BlockchainAbbreviation>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<BlockchainRecipientAddressOwner>;
  status?: Maybe<BlockchainAddressStatus>;
}

export enum BlockchainRecipientAddressOwner {
  customer = 'customer',
  non_customer_entity = 'non_customer_entity'
}

export interface BlockchainRecipientAddressWithMetadata {
  __typename?: 'BlockchainRecipientAddressWithMetadata';
  address: Scalars['String']['output'];
  addressTag?: Maybe<Scalars['String']['output']>;
  assets: Array<BlockchainAsset>;
  chain: BlockchainAbbreviation;
  createDate: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  delayedWithdrawalInfo?: Maybe<DelayedWithdrawalInfo>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  icon: AssetIcon;
  id: Scalars['ID']['output'];
  isVaultAddress?: Maybe<Scalars['Boolean']['output']>;
  owner: BlockchainRecipientAddressOwner;
  status: BlockchainAddressStatus;
  updateDate: Scalars['DateTime']['output'];
}

export interface BlockchainRecipientAddressesWithMetadataInput {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  chain?: InputMaybe<Array<BlockchainAbbreviation>>;
  currency?: InputMaybe<Currency>;
  descriptionFilter?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<BlockchainRecipientAddressOwner>;
  show?: InputMaybe<RecipientAddressFilterBy>;
  status?: InputMaybe<Array<BlockchainAddressStatus>>;
}

export interface BlockchainsFilterInput {
  activityType: BlockchainActivityType;
  currency?: InputMaybe<Currency>;
  isAceSupported?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CardPayment {
  __typename?: 'CardPayment';
  billingDetails: BillingDetails;
  bin: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  fingerprint: Scalars['ID']['output'];
  fundingType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issuerCountry: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  network: Scalars['String']['output'];
  pairEntries: Array<CardPaymentPairEntries>;
  status?: Maybe<MerchantPaymentStatus>;
  updateDate: Scalars['DateTime']['output'];
  verification: CardPaymentVerification;
}

export enum CardPaymentCvvStatus {
  fail = 'fail',
  not_requested = 'not_requested',
  pass = 'pass',
  pending = 'pending',
  unavailable = 'unavailable',
  unchecked = 'unchecked'
}

export interface CardPaymentMethod extends PaginatedType {
  __typename?: 'CardPaymentMethod';
  billingDetails: BillingDetails;
  createDate: Scalars['DateTime']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last4: Scalars['String']['output'];
  metadata?: Maybe<CardPaymentMethodMetadata>;
  network: Scalars['String']['output'];
  verification?: Maybe<CardPaymentVerification>;
}

export interface CardPaymentMethodMetadata {
  __typename?: 'CardPaymentMethodMetadata';
  email?: Maybe<Scalars['String']['output']>;
}

export interface CardPaymentMethods extends PaginationExtends {
  __typename?: 'CardPaymentMethods';
  links: PaginationLinks;
  list: Array<CardPaymentMethod>;
}

export interface CardPaymentPairEntries {
  __typename?: 'CardPaymentPairEntries';
  entity: Scalars['String']['output'];
  type: WatchlistTypes;
}

export interface CardPaymentVerification {
  __typename?: 'CardPaymentVerification';
  avs?: Maybe<Scalars['String']['output']>;
  cvvStatus?: Maybe<CardPaymentCvvStatus>;
}

export interface CardSetup {
  __typename?: 'CardSetup';
  accountId?: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
}

export interface CbitBankAccount {
  __typename?: 'CbitBankAccount';
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  walletAddress: Scalars['String']['output'];
}

export interface CbitReceive {
  __typename?: 'CbitReceive';
  payment: Payment;
  source?: Maybe<CbitBankAccount>;
}

export enum CbitTransactionType {
  cbit_receive = 'cbit_receive',
  cbit_withdrawal = 'cbit_withdrawal'
}

export interface CbitTransferInstruction {
  __typename?: 'CbitTransferInstruction';
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  walletAddress: Scalars['String']['output'];
}

export interface CbitWithdrawal {
  __typename?: 'CbitWithdrawal';
  destination?: Maybe<CbitBankAccount>;
  payment: Payment;
}

export interface ChainLocation {
  __typename?: 'ChainLocation';
  address?: Maybe<Scalars['String']['output']>;
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: BlockchainAbbreviation;
  currency?: Maybe<Currency>;
  nickname?: Maybe<Scalars['String']['output']>;
}

export interface ChainedBlockchainLocation {
  __typename?: 'ChainedBlockchainLocation';
  address?: Maybe<Scalars['String']['output']>;
  addressTag?: Maybe<Scalars['String']['output']>;
  chain: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isCompleteAceTransfer?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<BlockchainLocationMetadata>;
  type: TransferLocationType;
}

export enum ChainedTransferStatus {
  complete = 'complete',
  incomplete = 'incomplete'
}

export enum ChargebackCategory {
  canceled_recurring_payment = 'canceled_recurring_payment',
  credit_not_issued = 'credit_not_issued',
  customer_dispute = 'customer_dispute',
  fraudulent = 'fraudulent',
  general = 'general',
  not_defined = 'not_defined',
  processing_error = 'processing_error'
}

export interface ChargebackHistory {
  __typename?: 'ChargebackHistory';
  chargebackAmount: Amount;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Amount>;
  settlementId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface CircleInternalAddress {
  __typename?: 'CircleInternalAddress';
  address?: Maybe<Scalars['String']['output']>;
  addressRefId?: Maybe<Scalars['ID']['output']>;
  blockchain: BlockchainAbbreviation;
  currency: Currency;
  icon: AssetIcon;
  id: Scalars['ID']['output'];
  state: InternalAddressState;
  type: InternalAddressType;
}

export interface CircleWallet {
  __typename?: 'CircleWallet';
  balance: Amount;
  icon: AssetIcon;
  name: Scalars['String']['output'];
}

export interface CircleWalletsFtuStatus {
  __typename?: 'CircleWalletsFtuStatus';
  hasDepositedOnce: Scalars['Boolean']['output'];
  linkStatus: BankAccountFtuLinkStatus;
}

export interface ClientIpAddress {
  __typename?: 'ClientIpAddress';
  ip?: Maybe<Scalars['String']['output']>;
}

export enum CommentAuthorType {
  CIRCLE = 'CIRCLE',
  USER = 'USER'
}

export enum CommentStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export interface CompleteInviteInput {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  stateToken: Scalars['String']['input'];
}

/** List of continents */
export enum Continent {
  Africa = 'Africa',
  Antarctica = 'Antarctica',
  Asia = 'Asia',
  Europe = 'Europe',
  NorthAmerica = 'NorthAmerica',
  Oceania = 'Oceania',
  SouthAmerica = 'SouthAmerica'
}

export enum ConvertTransactionType {
  convert_mint = 'convert_mint',
  convert_withdrawal = 'convert_withdrawal'
}

/** List of countries */
export interface Countries {
  __typename?: 'Countries';
  /** Array of codes from the list */
  codes: Array<CountryCode>;
  /** List of countries */
  list: Array<Country>;
}

/** Countries Filter */
export interface CountriesInput {
  blockchain?: InputMaybe<CountryBlockchainInput>;
  codes?: InputMaybe<Array<CountryCode>>;
  continents?: InputMaybe<Array<Continent>>;
  link?: InputMaybe<CountryLinkInput>;
  onboarding?: InputMaybe<CountryOnboardingInput>;
  support?: InputMaybe<CountrySupportInput>;
}

/** Single Country */
export interface Country {
  __typename?: 'Country';
  /** ISO2 Code */
  code: CountryCode;
  /** Bank linking */
  link: CountryLink;
  /** Bank onboarding */
  onboarding: CountryOnboarding;
  /** Bank support */
  support: CountrySupport;
}

/** Allow Blockchain capabilities for? */
export interface CountryBlockchainInput {
  /** Allowed where business is registered in this country? */
  registeredIn?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Country codes of all the countries */
export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  /** Canada */
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  /** United States */
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW'
}

/** Allow Linking Bank Account for? */
export interface CountryLink {
  __typename?: 'CountryLink';
  /** Allowed where the bank is located in this country? */
  locatedIn: Scalars['Boolean']['output'];
  /** Allowed to open an account where holder is registered in this country? */
  registeredIn: Scalars['Boolean']['output'];
}

/** Allow Linking Bank Account for? */
export interface CountryLinkInput {
  /** Allowed where the bank is located in this country? */
  locatedIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed to open an account where holder is registered in this country? */
  registeredIn?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Onboarding properties of this country */
export interface CountryOnboarding {
  __typename?: 'CountryOnboarding';
  /** Country or territory a part of EEA (European Economic Area)? */
  eea?: Maybe<Scalars['Boolean']['output']>;
  /** Comprehensively sanctioned country? */
  sanctioned?: Maybe<Scalars['Boolean']['output']>;
}

/** Indicate what is supported in onboarding */
export interface CountryOnboardingInput {
  /** Country or territory a part of EEA (European Economic Area)? */
  eea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Comprehensively sanctioned country? */
  sanctioned?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Indicate what is supported in this country */
export interface CountrySupport {
  __typename?: 'CountrySupport';
  /** Supports iban flow? */
  iban?: Maybe<Scalars['Boolean']['output']>;
  /** Supports non iban flow? */
  nonIban?: Maybe<Scalars['Boolean']['output']>;
}

/** Indicate what is supported in this country */
export interface CountrySupportInput {
  /** Supports iban flow? */
  iban?: InputMaybe<Scalars['Boolean']['input']>;
  /** Supports non iban flow? */
  nonIban?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateApiKey {
  __typename?: 'CreateAPIKey';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
}

export interface CreateApiKeyInput {
  ipAllowList: Array<Scalars['String']['input']>;
  keyName: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
}

export interface CreateAccountInput {
  businessEmail: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  country: CountryCode;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface CreateBlockchainRecipientAddressWithMetadataInput {
  address: Scalars['String']['input'];
  addressTag?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  chain: BlockchainAbbreviation;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  owner: BlockchainRecipientAddressOwner;
}

export interface CreateDeleteUserGroupProposalInput {
  groupId: Scalars['String']['input'];
}

export interface CreateIpAllowListingIpAddressInput {
  valueMax?: InputMaybe<Scalars['String']['input']>;
  valueMin: Scalars['String']['input'];
}

export interface CreateNotificationSubscriptionInput {
  endpoint: Scalars['Url']['input'];
}

export interface CreateOperationInput {
  onboardingLevel: OnboardingLevel;
  operationType: OnboardingApplicationOperationType;
}

export interface CreatePasswordResponse {
  __typename?: 'CreatePasswordResponse';
  sessionToken?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

export interface CreatePayoutInput {
  amount: AmountInput;
  destination: DestinationInput;
  toAmount?: InputMaybe<AmountInput>;
}

export interface CreateRolrAccountInput {
  accountType: AccountType;
  businessName: Scalars['String']['input'];
  countryOfIncorporation: CountryCode;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  legalEntityType: OnboardingEntityType;
  natureOfBusiness: Scalars['String']['input'];
  password: Scalars['String']['input'];
  primaryPlaceOfBusiness: CountryCode;
  redemptionAmount: CreateRolrAccountRedemptionAmountInput;
}

export interface CreateRolrAccountRedemptionAmountInput {
  eurcRedemptionAmount?: InputMaybe<Scalars['Float']['input']>;
  usdcRedemptionAmount?: InputMaybe<Scalars['Float']['input']>;
}

export interface CreateStablecoinExpressDepositRouteInput {
  address: Scalars['String']['input'];
  addressTag?: InputMaybe<Scalars['String']['input']>;
  bankId: Scalars['String']['input'];
  bankType: BankAccountType;
  chain: BlockchainAbbreviation;
  fromCurrency: Currency;
  toCurrency: Currency;
}

export interface CreateStablecoinExpressWithdrawalRouteInput {
  bankId: Scalars['String']['input'];
  bankType: BankAccountType;
  chain: BlockchainAbbreviation;
  fromCurrency: Currency;
  toCurrency: Currency;
}

export interface CreateTransferDestinationInput {
  address: Scalars['String']['input'];
  chain: BlockchainAbbreviation;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
}

export interface CreateTransferInput {
  amount: AmountInput;
  destination: CreateTransferDestinationInput;
}

export interface CreateTransferResponse {
  __typename?: 'CreateTransferResponse';
  proposalId?: Maybe<Scalars['String']['output']>;
  transferId?: Maybe<Scalars['String']['output']>;
}

export interface CreateUpdateUserGroupProposalInput {
  groupId: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface CreateUserGroupInput {
  name: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
}

export interface CreateUserGroupResponse {
  __typename?: 'CreateUserGroupResponse';
  id: Scalars['String']['output'];
}

export enum CryptoPayoutSourceType {
  wallet = 'wallet'
}

export interface CryptoRefundDestination {
  address: Scalars['String']['input'];
  chain: BlockchainAbbreviation;
}

export interface CubixBankAccount {
  __typename?: 'CubixBankAccount';
  accountId: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface CubixReceive {
  __typename?: 'CubixReceive';
  payment: Payment;
  source?: Maybe<CubixBankAccount>;
}

export enum CubixTransactionType {
  cubix_receive = 'cubix_receive',
  cubix_withdrawal = 'cubix_withdrawal'
}

export interface CubixTransferInstruction {
  __typename?: 'CubixTransferInstruction';
  accountId: Scalars['String']['output'];
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
}

export interface CubixWithdrawal {
  __typename?: 'CubixWithdrawal';
  destination?: Maybe<CubixBankAccount>;
  payment: Payment;
}

export enum Currency {
  ALGO = 'ALGO',
  AVAX = 'AVAX',
  BRL = 'BRL',
  BTC = 'BTC',
  CUSDC = 'CUSDC',
  ETH = 'ETH',
  EUR = 'EUR',
  EURC = 'EURC',
  FLOW = 'FLOW',
  MANA = 'MANA',
  MATIC = 'MATIC',
  MXN = 'MXN',
  SGD = 'SGD',
  SOL = 'SOL',
  TRX = 'TRX',
  USD = 'USD',
  USDC = 'USDC',
  XLM = 'XLM'
}

export interface CustodyAmount {
  __typename?: 'CustodyAmount';
  amount: Scalars['String']['output'];
  asset: CustodyAssetMetadata;
}

export interface CustodyAssetMetadata {
  __typename?: 'CustodyAssetMetadata';
  decimals: Scalars['Int']['output'];
  icon: AssetIcon;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
}

export enum CustomerState {
  active = 'active',
  banned = 'banned',
  closed = 'closed',
  deposit_only = 'deposit_only',
  pending = 'pending',
  suspended = 'suspended'
}

export interface DailyLimit {
  __typename?: 'DailyLimit';
  currency: Currency;
  limit: Limit;
}

export interface DefaultPaymentMethod {
  __typename?: 'DefaultPaymentMethod';
  createDate: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  type: PaymentMethodType;
}

export interface DefaultPaymentMethodInput {
  id?: InputMaybe<Scalars['String']['input']>;
  type: PaymentMethodType;
}

/** Delayed withdrawal info: Optional metadata on blockchain and wire schemas */
export interface DelayedWithdrawalInfo {
  __typename?: 'DelayedWithdrawalInfo';
  enabled: Scalars['Boolean']['output'];
  withdrawalEnabledAfterHours?: Maybe<Scalars['Int']['output']>;
}

/** Delayed withdrawals settings */
export interface DelayedWithdrawalsSettings {
  __typename?: 'DelayedWithdrawalsSettings';
  delayHours?: Maybe<Scalars['Int']['output']>;
  disabledAfterHours?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
}

/** Delayed withdrawals settings input */
export interface DelayedWithdrawalsSettingsInput {
  delayHours?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
}

export interface DeleteGroupProposal extends Proposal {
  __typename?: 'DeleteGroupProposal';
  approverGroup: ApproverUserGroup;
  createdAt: Scalars['DateTime']['output'];
  data: DeleteGroupProposalData;
  events: Array<ProposalEvent>;
  id: Scalars['String']['output'];
  initiator: UserGroupMember;
  requires: ApprovalPolicyQuorumType;
  status: ProposalStatusType;
  type: ProposalType;
}

export interface DeleteGroupProposalData {
  __typename?: 'DeleteGroupProposalData';
  groupId: Scalars['String']['output'];
  members?: Maybe<Array<UserGroupMember>>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface Deposit {
  __typename?: 'Deposit';
  amount?: Maybe<Amount>;
  createDate: Scalars['DateTime']['output'];
  destination?: Maybe<DepositDestination>;
  fees?: Maybe<Amount>;
  fromAmount?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  riskEvaluation?: Maybe<RiskEvaluation>;
  source?: Maybe<DepositSource>;
  status?: Maybe<DepositStatus>;
  updateDate: Scalars['DateTime']['output'];
}

export interface DepositDestination {
  __typename?: 'DepositDestination';
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
}

export interface DepositSource {
  __typename?: 'DepositSource';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export enum DepositStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export interface Destination {
  __typename?: 'Destination';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: BankAccountType;
}

export interface DestinationInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  railType?: InputMaybe<RailType>;
  type?: InputMaybe<BankAccountType>;
}

export interface DirectInternalAddress {
  __typename?: 'DirectInternalAddress';
  address?: Maybe<Scalars['String']['output']>;
  asset: BlockchainAsset;
  blockchain: BlockchainAbbreviation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: InternalAddressState;
  type: InternalAddressType;
  vaultId: Scalars['ID']['output'];
}

export enum DocumentType {
  addressDoc = 'addressDoc',
  amlPolicyDoc = 'amlPolicyDoc',
  bankStatement = 'bankStatement',
  businessLicense = 'businessLicense',
  fincenDoc = 'fincenDoc',
  fundDoc = 'fundDoc',
  fundFormDExemDoc = 'fundFormDExemDoc',
  genericDoc = 'genericDoc',
  idNotarization = 'idNotarization',
  orgDoc = 'orgDoc',
  passport = 'passport',
  usdl = 'usdl',
  usid = 'usid'
}

export interface DownloadReport {
  __typename?: 'DownloadReport';
  downloadUrl: Scalars['String']['output'];
  reportExecutionId: Scalars['String']['output'];
  reportType: WalletReportType;
}

export interface EligibleUserFactor {
  __typename?: 'EligibleUserFactor';
  provider: FactorProvider;
  status: FactorStatus;
  type: FactorType;
}

export interface EmailVerifiedNotification extends BaseInAppNotification, PaginatedType {
  __typename?: 'EmailVerifiedNotification';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: EmailVerifiedNotificationPayload;
  type: InAppNotificationType;
}

export interface EmailVerifiedNotificationPayload {
  __typename?: 'EmailVerifiedNotificationPayload';
  emailVerified: Scalars['Boolean']['output'];
}

export interface EnrolledFactorInfo {
  __typename?: 'EnrolledFactorInfo';
  id: Scalars['String']['output'];
  qrHref: Scalars['String']['output'];
  sharedSecret?: Maybe<Scalars['String']['output']>;
}

export interface Entity {
  __typename?: 'Entity';
  accountType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  district?: Maybe<Scalars['String']['output']>;
  entityAccountNumber?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  group: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  legalEntity?: Maybe<Scalars['String']['output']>;
}

export interface EntityLimits {
  __typename?: 'EntityLimits';
  available: Scalars['String']['output'];
  currency: Currency;
  duration: WireTransferLimitDurationEnum;
  total: Scalars['String']['output'];
  used: Scalars['String']['output'];
}

export interface ExternalAddress {
  __typename?: 'ExternalAddress';
  address: Scalars['String']['output'];
  chain: BlockchainAbbreviation;
  createDate: Scalars['DateTime']['output'];
  currency: Currency;
  entityId: Scalars['ID']['output'];
  nickname: Scalars['String']['output'];
}

export interface Factor {
  __typename?: 'Factor';
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  provider: FactorProvider;
  status: FactorStatus;
  type: FactorType;
}

export enum FactorActivationStatus {
  COMPLETE = 'COMPLETE',
  TIMEOUT = 'TIMEOUT',
  WAITING = 'WAITING'
}

export enum FactorProvider {
  GOOGLE = 'GOOGLE',
  OKTA = 'OKTA'
}

export enum FactorStatus {
  ACTIVE = 'ACTIVE',
  NOT_SETUP = 'NOT_SETUP',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION'
}

export enum FactorType {
  PIN_CODE = 'PIN_CODE',
  PUSH = 'PUSH',
  TOKEN_SOFTWARE_TOTP = 'TOKEN_SOFTWARE_TOTP'
}

export interface FeeLocation {
  __typename?: 'FeeLocation';
  id: Scalars['ID']['output'];
  type: LocationType;
}

export interface FeeReport extends PaginatedType {
  __typename?: 'FeeReport';
  createDate: Scalars['DateTime']['output'];
  cumulatedNetAmount: Amount;
  cumulatedPaymentAmount: Amount;
  cumulatedPayoutAmount: Amount;
  fee: Amount;
  id: Scalars['ID']['output'];
  status: FeeStatus;
  thresholdResetTimestamp: Scalars['DateTime']['output'];
  valueDate: Scalars['DateTime']['output'];
}

export interface FeeReports extends PaginationExtends {
  __typename?: 'FeeReports';
  links: PaginationLinks;
  list: Array<FeeReport>;
}

export interface FeeReportsFilterInput {
  currency?: InputMaybe<Currency>;
  minFeeAmount?: InputMaybe<Scalars['String']['input']>;
}

export enum FeeStatus {
  paid = 'paid',
  pending = 'pending',
  scheduled = 'scheduled'
}

export enum FiatTransactionType {
  cbit = 'cbit',
  crb_rtp = 'crb_rtp',
  crb_wire = 'crb_wire',
  crb_xpay = 'crb_xpay',
  cubi_wire = 'cubi_wire',
  cubix = 'cubix',
  pix = 'pix',
  rtgs = 'rtgs',
  rtp = 'rtp',
  scb_wire = 'scb_wire',
  sepa = 'sepa',
  sepa_instant = 'sepa_instant',
  signature_wire = 'signature_wire',
  signet = 'signet',
  silvergate_sen = 'silvergate_sen',
  silvergate_wire = 'silvergate_wire',
  wire = 'wire'
}

export enum FieldType {
  base = 'base',
  question_bank = 'question_bank'
}

export interface FilteredLongPollInAppNotificationInput {
  type: InAppNotificationType;
}

export interface FxQuote {
  __typename?: 'FxQuote';
  expiry?: Maybe<Scalars['DateTime']['output']>;
  from: Amount;
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
  to: Amount;
}

export enum FxQuoteType {
  reference = 'reference',
  tradable = 'tradable'
}

export interface GetFxQuoteInput {
  from: OptionalAmountInput;
  to: OptionalAmountInput;
  type?: InputMaybe<FxQuoteType>;
}

export interface GrossRedemptionFee {
  __typename?: 'GrossRedemptionFee';
  payment: GrossRedemptionFeePayment;
}

export interface GrossRedemptionFeePayment extends PaginatedType {
  __typename?: 'GrossRedemptionFeePayment';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: FeeLocation;
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  type: TransactionType;
  updateDate: Scalars['DateTime']['output'];
}

export interface IbanBankAddressInput {
  bankName?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
}

export interface Identity {
  __typename?: 'Identity';
  addresses?: Maybe<Array<BillingDetails>>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
}

export interface IdentityChallenge {
  __typename?: 'IdentityChallenge';
  addressId: Scalars['ID']['output'];
  amount: Amount;
  chain: BlockchainAbbreviation;
  createDate: Scalars['DateTime']['output'];
  destinationAddress: Scalars['String']['output'];
  expiryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  sourceAddress: Scalars['String']['output'];
  status: IdentityChallengeStatus;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export enum IdentityChallengeStatus {
  active = 'active',
  denied = 'denied',
  failed = 'failed',
  inactive = 'inactive',
  pending = 'pending'
}

export type InAppNotification = EmailVerifiedNotification | MainWalletPendingTransactionApprovalRequestNotification | MainWalletPolicyApprovalRequestNotification | PreQualAutoApprovedNotification;

export enum InAppNotificationType {
  currencyPolicyApprovalRequest = 'currencyPolicyApprovalRequest',
  emailVerified = 'emailVerified',
  preQualAutoApproved = 'preQualAutoApproved',
  transactionApprovalRequest = 'transactionApprovalRequest'
}

export interface InAppNotifications {
  __typename?: 'InAppNotifications';
  links: PaginationLinks;
  list: Array<InAppNotification>;
}

export interface IncompleteChainedTransfer {
  __typename?: 'IncompleteChainedTransfer';
  amount: Amount;
  chainedBlockchainTransferStatus: ChainedTransferStatus;
  destination: TransferLocation;
  id: Scalars['ID']['output'];
  status: TransferStatus;
}

export type InternalAddress = CircleInternalAddress | DirectInternalAddress;

export interface InternalAddressInput {
  excludedVaultIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

export enum InternalAddressState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum InternalAddressType {
  CIRCLE = 'CIRCLE',
  DIRECT = 'DIRECT'
}

export interface InviteAuthorizedRepInput {
  invitedEmail: Scalars['String']['input'];
  invitedFirstName: Scalars['String']['input'];
  invitedLastName: Scalars['String']['input'];
  invitedOccupation: Scalars['String']['input'];
}

export interface InviteeInput {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  permissionGroup: UserRoleGroupType;
}

export interface Invoice extends PaginatedType {
  __typename?: 'Invoice';
  amountDue: Amount;
  amountPaid: Amount;
  amountTotal: Amount;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface InvoiceDetail {
  __typename?: 'InvoiceDetail';
  amountDue: Amount;
  amountPaid: Amount;
  amountTotal: Amount;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceLink: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
}

export interface InvoicePayment {
  __typename?: 'InvoicePayment';
  amount: Amount;
  id: Scalars['ID']['output'];
  paymentId: Scalars['String']['output'];
  status: InvoiceStatus;
  type: InvoicePaymentType;
}

export interface InvoicePaymentDetail {
  __typename?: 'InvoicePaymentDetail';
  amountDue: Amount;
  amountPaid: Amount;
  amountTotal: Amount;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceLink: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  latestPaymentDetails?: Maybe<InvoicePayment>;
  status: InvoiceStatus;
}

export interface InvoicePaymentInput {
  cardId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  paymentType: PaymentMethodType;
}

export enum InvoicePaymentType {
  cps_card_payment = 'cps_card_payment',
  direct_transfer = 'direct_transfer'
}

export enum InvoiceStatus {
  complete = 'complete',
  confirmed = 'confirmed',
  failed = 'failed',
  not_paid = 'not_paid',
  paid = 'paid',
  payment_due = 'payment_due',
  pending = 'pending',
  posted = 'posted',
  processing = 'processing',
  voided = 'voided'
}

export interface Invoices extends PaginationExtends {
  __typename?: 'Invoices';
  links: PaginationLinks;
  list: Array<Invoice>;
}

export interface IpAllowListingIpAddress {
  __typename?: 'IpAllowListingIpAddress';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: IpAllowListingIpAddressType;
  value: Scalars['String']['output'];
}

export enum IpAllowListingIpAddressType {
  range = 'range',
  single = 'single'
}

export interface IpAllowListingSetting {
  __typename?: 'IpAllowListingSetting';
  enabled: Scalars['Boolean']['output'];
}

/**
 * Possible jurisdictions.
 *  * US = Circle LLC.
 *  * FR = Circle France.
 *  * SG = Circle Singapore.
 */
export enum Jurisdiction {
  FR = 'FR',
  SG = 'SG',
  US = 'US'
}

export interface KybProperties {
  __typename?: 'KybProperties';
  activeUsersOnPlatform?: Maybe<Scalars['String']['output']>;
  awaitingBusinessReview: Scalars['Boolean']['output'];
  businessCountry: CountryCode;
  businessInfoConfirmed?: Maybe<Scalars['Boolean']['output']>;
  businessName: Scalars['String']['output'];
  businessState: Scalars['String']['output'];
  businessWebsite?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  expectedUsdcMintingVolume?: Maybe<Scalars['String']['output']>;
  isAuthorizedRepresentative: Scalars['Boolean']['output'];
  isOnboardingInitiator: Scalars['Boolean']['output'];
  natureOfBusiness: Scalars['String']['output'];
  productInterests?: Maybe<Array<Maybe<ProductInterest>>>;
  userEmail: Scalars['String']['output'];
}

export interface KybQualificationDetail {
  __typename?: 'KybQualificationDetail';
  properties: KybProperties;
  state: QualificationUiState;
}

export interface KybSummary {
  __typename?: 'KybSummary';
  isAuthorizedRepresentative: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
}

export interface KycQualificationDetail {
  __typename?: 'KycQualificationDetail';
  state: QualificationUiState;
}

export interface KycSummary {
  __typename?: 'KycSummary';
  isComplete: Scalars['Boolean']['output'];
}

export enum L3OnboardingAssets {
  from0to10m = 'from0to10m',
  from10mto50m = 'from10mto50m',
  from50mto100m = 'from50mto100m',
  from100mto500m = 'from100mto500m',
  from500mto1b = 'from500mto1b',
  notApplicable = 'notApplicable',
  over1b = 'over1b'
}

export enum L3OnboardingControllerOfPrivateKeys {
  company = 'company',
  endUser = 'endUser'
}

export enum L3OnboardingCryptoActivity {
  from0to100k = 'from0to100k',
  from1mto10m = 'from1mto10m',
  from10mto50m = 'from10mto50m',
  from50mto100m = 'from50mto100m',
  from100kto200k = 'from100kto200k',
  from100mto500m = 'from100mto500m',
  from200kto500k = 'from200kto500k',
  from500kto1m = 'from500kto1m',
  notApplicable = 'notApplicable',
  over500mil = 'over500mil'
}

export enum L3OnboardingCryptoPaymentProportion {
  from0to5 = 'from0to5',
  from5to10 = 'from5to10',
  from10to20 = 'from10to20',
  from20to50 = 'from20to50',
  moreThan50 = 'moreThan50',
  zero = 'zero'
}

export enum L3OnboardingCustomerBasePercentage {
  from0to5 = 'from0to5',
  from5to10 = 'from5to10',
  from10to20 = 'from10to20',
  from20to50 = 'from20to50',
  moreThan50 = 'moreThan50'
}

export enum L3OnboardingEcommercePlatformSupportType {
  onlyDirect = 'onlyDirect',
  otherPlatforms = 'otherPlatforms'
}

export enum L3OnboardingEntityType {
  associationOrConsortium = 'associationOrConsortium',
  coop = 'coop',
  foundation = 'foundation',
  governmentBody = 'governmentBody',
  partnership = 'partnership',
  privateCo = 'privateCo',
  publicCo = 'publicCo',
  trust = 'trust'
}

export enum L3OnboardingFatcaStatus {
  activeNFFE = 'activeNFFE',
  certifiedCompliantInvestmentVehicle = 'certifiedCompliantInvestmentVehicle',
  certifiedCompliantLifeDebt = 'certifiedCompliantLifeDebt',
  certifiedCompliantLowValue = 'certifiedCompliantLowValue',
  certifiedCompliantNonRegisteringBank = 'certifiedCompliantNonRegisteringBank',
  directReportingNFFE = 'directReportingNFFE',
  exceptedInterAffiliateFFI = 'exceptedInterAffiliateFFI',
  exceptedTerritory = 'exceptedTerritory',
  exemptBeneficialOwners = 'exemptBeneficialOwners',
  exemptRetirementPlans = 'exemptRetirementPlans',
  foreignGovernmentCentralBank = 'foreignGovernmentCentralBank',
  internationalOrganization = 'internationalOrganization',
  investmentEntitiesNoFinancialAccounts = 'investmentEntitiesNoFinancialAccounts',
  nonFinancialAccount = 'nonFinancialAccount',
  nonFinancialEntityLiquidation = 'nonFinancialEntityLiquidation',
  nonFinancialGroupEntity = 'nonFinancialGroupEntity',
  nonFinancialStartUpCompany = 'nonFinancialStartUpCompany',
  nonParticipatingFFI = 'nonParticipatingFFI',
  nonProfitOrganization = 'nonProfitOrganization',
  nonReportingIGA = 'nonReportingIGA',
  organization501c = 'organization501c',
  ownerDocumentedFFI = 'ownerDocumentedFFI',
  participatingFFI = 'participatingFFI',
  passiveNFFE = 'passiveNFFE',
  publiclyTradedNFFE = 'publiclyTradedNFFE',
  registeredCompliantFFI = 'registeredCompliantFFI',
  reportingModel1 = 'reportingModel1',
  reportingModel2 = 'reportingModel2',
  restrictedDistributor = 'restrictedDistributor',
  sponsoredFFI = 'sponsoredFFI',
  sponsoredNFFE = 'sponsoredNFFE',
  territoryFinancialInstitution = 'territoryFinancialInstitution'
}

export enum L3OnboardingFiatActivity {
  from0to100k = 'from0to100k',
  from1mto10m = 'from1mto10m',
  from10mto50m = 'from10mto50m',
  from50mto100m = 'from50mto100m',
  from100kto200k = 'from100kto200k',
  from100mto500m = 'from100mto500m',
  from200kto500k = 'from200kto500k',
  from500kto1m = 'from500kto1m',
  notApplicable = 'notApplicable',
  over500mil = 'over500mil'
}

export enum L3OnboardingFieldName {
  acceptedCryptoCoins = 'acceptedCryptoCoins',
  acceptsAnonymousDonations = 'acceptsAnonymousDonations',
  acceptsCryptoDonations = 'acceptsCryptoDonations',
  acceptsCryptoPayments = 'acceptsCryptoPayments',
  accountPurpose = 'accountPurpose',
  accountPurposeDescription = 'accountPurposeDescription',
  additionalApplicationNotes = 'additionalApplicationNotes',
  additionalKycApplicationNotes = 'additionalKycApplicationNotes',
  allPartiesAreListedInTrustAgreement = 'allPartiesAreListedInTrustAgreement',
  amlTestingReport = 'amlTestingReport',
  amlTestingReportProvided = 'amlTestingReportProvided',
  amlTestingReportProvidedRFI = 'amlTestingReportProvidedRFI',
  amlTestingReportRFI = 'amlTestingReportRFI',
  areCertainJurisdictionsProhibited = 'areCertainJurisdictionsProhibited',
  assetManagerEntityAuthorizationNumber = 'assetManagerEntityAuthorizationNumber',
  assetManagerEntityCity = 'assetManagerEntityCity',
  assetManagerEntityCountry = 'assetManagerEntityCountry',
  assetManagerEntityCountryOfFormation = 'assetManagerEntityCountryOfFormation',
  assetManagerEntityCountryOfPrincipalPlaceOfBusiness = 'assetManagerEntityCountryOfPrincipalPlaceOfBusiness',
  assetManagerEntityLegalName = 'assetManagerEntityLegalName',
  assetManagerEntityLine1 = 'assetManagerEntityLine1',
  assetManagerEntityLine2 = 'assetManagerEntityLine2',
  assetManagerEntityPostalCode = 'assetManagerEntityPostalCode',
  assetManagerEntityState = 'assetManagerEntityState',
  assetsUnderManagement = 'assetsUnderManagement',
  authRepW8ben = 'authRepW8ben',
  authorizationNumber = 'authorizationNumber',
  authorizedRepBirthCity = 'authorizedRepBirthCity',
  authorizedRepBirthCountry = 'authorizedRepBirthCountry',
  authorizedRepCitizenship = 'authorizedRepCitizenship',
  authorizedRepCity = 'authorizedRepCity',
  authorizedRepCountry = 'authorizedRepCountry',
  authorizedRepCurpRFI = 'authorizedRepCurpRFI',
  authorizedRepDob = 'authorizedRepDob',
  authorizedRepEmail = 'authorizedRepEmail',
  authorizedRepFirstName = 'authorizedRepFirstName',
  authorizedRepGovernmentId = 'authorizedRepGovernmentId',
  authorizedRepGovernmentIdNotarized = 'authorizedRepGovernmentIdNotarized',
  authorizedRepIdentificationNumber = 'authorizedRepIdentificationNumber',
  authorizedRepJobTitle = 'authorizedRepJobTitle',
  authorizedRepLastName = 'authorizedRepLastName',
  authorizedRepLine1 = 'authorizedRepLine1',
  authorizedRepLine2 = 'authorizedRepLine2',
  authorizedRepMaternalLastNameRFI = 'authorizedRepMaternalLastNameRFI',
  authorizedRepNotarizedPowerOfAttorneyRFI = 'authorizedRepNotarizedPowerOfAttorneyRFI',
  authorizedRepPostalCode = 'authorizedRepPostalCode',
  authorizedRepProofOfAddressRFI = 'authorizedRepProofOfAddressRFI',
  authorizedRepProofOfAuthorization = 'authorizedRepProofOfAuthorization',
  authorizedRepProofOfAuthorizationPowerOfAttorney = 'authorizedRepProofOfAuthorizationPowerOfAttorney',
  authorizedRepRfcNumberRFI = 'authorizedRepRfcNumberRFI',
  authorizedRepState = 'authorizedRepState',
  authorizedRepresentativeSourceOfWealth = 'authorizedRepresentativeSourceOfWealth',
  bankBrokerageCryptoStatement = 'bankBrokerageCryptoStatement',
  beneficialOwnerBirthCity = 'beneficialOwnerBirthCity',
  beneficialOwnerBirthCountry = 'beneficialOwnerBirthCountry',
  beneficialOwnerBirthCountryRFI = 'beneficialOwnerBirthCountryRFI',
  beneficialOwnerCURPDocumentRFI = 'beneficialOwnerCURPDocumentRFI',
  beneficialOwnerCitizenship = 'beneficialOwnerCitizenship',
  beneficialOwnerCity = 'beneficialOwnerCity',
  beneficialOwnerCountry = 'beneficialOwnerCountry',
  beneficialOwnerCurpRFI = 'beneficialOwnerCurpRFI',
  beneficialOwnerDob = 'beneficialOwnerDob',
  beneficialOwnerEmail = 'beneficialOwnerEmail',
  beneficialOwnerEmailRFI = 'beneficialOwnerEmailRFI',
  beneficialOwnerEntityCountryOfFormation = 'beneficialOwnerEntityCountryOfFormation',
  beneficialOwnerEntityCountryOfPrincipalPlaceOfBusiness = 'beneficialOwnerEntityCountryOfPrincipalPlaceOfBusiness',
  beneficialOwnerEntityLegalName = 'beneficialOwnerEntityLegalName',
  beneficialOwnerEntityPercentOwnership = 'beneficialOwnerEntityPercentOwnership',
  beneficialOwnerFirstName = 'beneficialOwnerFirstName',
  beneficialOwnerGovernmentId = 'beneficialOwnerGovernmentId',
  beneficialOwnerGovernmentIdNotarized = 'beneficialOwnerGovernmentIdNotarized',
  beneficialOwnerIdentificationNumber = 'beneficialOwnerIdentificationNumber',
  beneficialOwnerLastName = 'beneficialOwnerLastName',
  beneficialOwnerLine1 = 'beneficialOwnerLine1',
  beneficialOwnerLine2 = 'beneficialOwnerLine2',
  beneficialOwnerMaternalLastNameRFI = 'beneficialOwnerMaternalLastNameRFI',
  beneficialOwnerOccupationRFI = 'beneficialOwnerOccupationRFI',
  beneficialOwnerPercentOwnership = 'beneficialOwnerPercentOwnership',
  beneficialOwnerPostalCode = 'beneficialOwnerPostalCode',
  beneficialOwnerProofOfAddressRFI = 'beneficialOwnerProofOfAddressRFI',
  beneficialOwnerRfcNumberRFI = 'beneficialOwnerRfcNumberRFI',
  beneficialOwnerSourceOfWealth = 'beneficialOwnerSourceOfWealth',
  beneficialOwnerState = 'beneficialOwnerState',
  beneficialOwnerTelephoneRFI = 'beneficialOwnerTelephoneRFI',
  beneficialOwnersExist = 'beneficialOwnersExist',
  beneficialOwnershipExempted = 'beneficialOwnershipExempted',
  beneficialOwnershipExemptionReason = 'beneficialOwnershipExemptionReason',
  beneficiaryCountries = 'beneficiaryCountries',
  beneficiaryInformation = 'beneficiaryInformation',
  beneficiaryPolicy = 'beneficiaryPolicy',
  businessAcceptsPrivacyCoin = 'businessAcceptsPrivacyCoin',
  businessAddressRemote = 'businessAddressRemote',
  businessAreaCodeRFI = 'businessAreaCodeRFI',
  businessFormationDocuments = 'businessFormationDocuments',
  businessFormationDocumentsNotarized = 'businessFormationDocumentsNotarized',
  businessModelDescription = 'businessModelDescription',
  businessName = 'businessName',
  businessNameDifferent = 'businessNameDifferent',
  businessPhoneNumber = 'businessPhoneNumber',
  businessPhoneNumberRFI = 'businessPhoneNumberRFI',
  businessStateOfRegistrationOfFormation = 'businessStateOfRegistrationOfFormation',
  businessWebsite = 'businessWebsite',
  businessWebsiteProvided = 'businessWebsiteProvided',
  canProvideDbaCertificate = 'canProvideDbaCertificate',
  canUploadEntityTermsOfService = 'canUploadEntityTermsOfService',
  canUploadProtocolWhitepaper = 'canUploadProtocolWhitepaper',
  canUploadSanctionsCompliancePolicy = 'canUploadSanctionsCompliancePolicy',
  charityOrNonProfitDescription = 'charityOrNonProfitDescription',
  circleNbfi = 'circleNbfi',
  circumstancesForIdCollection = 'circumstancesForIdCollection',
  complianceOfficerCity = 'complianceOfficerCity',
  complianceOfficerCountry = 'complianceOfficerCountry',
  complianceOfficerDetailsProvided = 'complianceOfficerDetailsProvided',
  complianceOfficerDob = 'complianceOfficerDob',
  complianceOfficerEmail = 'complianceOfficerEmail',
  complianceOfficerFirstName = 'complianceOfficerFirstName',
  complianceOfficerJobTitle = 'complianceOfficerJobTitle',
  complianceOfficerLastName = 'complianceOfficerLastName',
  complianceOfficerLine1 = 'complianceOfficerLine1',
  complianceOfficerLine2 = 'complianceOfficerLine2',
  complianceOfficerPostalCode = 'complianceOfficerPostalCode',
  complianceOfficerSourceOfWealth = 'complianceOfficerSourceOfWealth',
  complianceOfficerState = 'complianceOfficerState',
  controlledFromOutsideFrance = 'controlledFromOutsideFrance',
  controlledFromOutsideFranceStatement = 'controlledFromOutsideFranceStatement',
  controllerBirthCity = 'controllerBirthCity',
  controllerBirthCountry = 'controllerBirthCountry',
  controllerCitizenship = 'controllerCitizenship',
  controllerCity = 'controllerCity',
  controllerCountry = 'controllerCountry',
  controllerDob = 'controllerDob',
  controllerEmail = 'controllerEmail',
  controllerFirstName = 'controllerFirstName',
  controllerGovernmentId = 'controllerGovernmentId',
  controllerGovernmentIdNotarized = 'controllerGovernmentIdNotarized',
  controllerIdentificationNumber = 'controllerIdentificationNumber',
  controllerJobTitle = 'controllerJobTitle',
  controllerLastName = 'controllerLastName',
  controllerLine1 = 'controllerLine1',
  controllerLine2 = 'controllerLine2',
  controllerOfPrivateKeys = 'controllerOfPrivateKeys',
  controllerPostalCode = 'controllerPostalCode',
  controllerState = 'controllerState',
  countriesWithMostCustomers = 'countriesWithMostCustomers',
  countriesWithPhysicalPresence = 'countriesWithPhysicalPresence',
  countryOfFormation = 'countryOfFormation',
  cryptoProvenanceAnalysis = 'cryptoProvenanceAnalysis',
  customerBaseByType = 'customerBaseByType',
  customerTypesDescription = 'customerTypesDescription',
  daoCompositionAndPurposeDetails = 'daoCompositionAndPurposeDetails',
  daoEngagesInFundraising = 'daoEngagesInFundraising',
  daoInceptionDetails = 'daoInceptionDetails',
  dateOfFormation = 'dateOfFormation',
  dbaCertificate = 'dbaCertificate',
  disbursementCriteria = 'disbursementCriteria',
  doSignificantDonorsAbove25PctExist = 'doSignificantDonorsAbove25PctExist',
  doSignificantDonorsExist = 'doSignificantDonorsExist',
  doingBusinessAsName = 'doingBusinessAsName',
  donorCountries = 'donorCountries',
  donorEntityCountryOfFormation = 'donorEntityCountryOfFormation',
  donorEntityLegalName = 'donorEntityLegalName',
  donorEntityPrimaryPlaceOfBusiness = 'donorEntityPrimaryPlaceOfBusiness',
  donorPersonCitizenship = 'donorPersonCitizenship',
  donorPersonCity = 'donorPersonCity',
  donorPersonCountry = 'donorPersonCountry',
  donorPersonDob = 'donorPersonDob',
  donorPersonFirstName = 'donorPersonFirstName',
  donorPersonGovernmentId = 'donorPersonGovernmentId',
  donorPersonIdentificationNumber = 'donorPersonIdentificationNumber',
  donorPersonLastName = 'donorPersonLastName',
  donorPersonLine1 = 'donorPersonLine1',
  donorPersonLine2 = 'donorPersonLine2',
  donorPersonPostalCode = 'donorPersonPostalCode',
  donorPersonSourceOfWealth = 'donorPersonSourceOfWealth',
  donorPersonState = 'donorPersonState',
  ecommercePlatformSupportType = 'ecommercePlatformSupportType',
  enablesUsersToSendCryptoPayments = 'enablesUsersToSendCryptoPayments',
  engagesInFundraising = 'engagesInFundraising',
  entityServesCustomers = 'entityServesCustomers',
  entityServesUSCustomers = 'entityServesUSCustomers',
  entityTermsOfServiceFile = 'entityTermsOfServiceFile',
  entityTermsOfServiceLink = 'entityTermsOfServiceLink',
  expectedMonthlyCryptoActivity = 'expectedMonthlyCryptoActivity',
  expectedMonthlyFiatActivity = 'expectedMonthlyFiatActivity',
  expectedProductsForUsage = 'expectedProductsForUsage',
  facilitatesGambling = 'facilitatesGambling',
  familyOfficeType = 'familyOfficeType',
  fatcaStatus = 'fatcaStatus',
  financialDocumentsProvided = 'financialDocumentsProvided',
  financialDocumentsProvidedRFI = 'financialDocumentsProvidedRFI',
  financialRegulatoryAuthorityDescription = 'financialRegulatoryAuthorityDescription',
  financialRegulatoryAuthorityName = 'financialRegulatoryAuthorityName',
  financialStatements = 'financialStatements',
  financialStatementsRFI = 'financialStatementsRFI',
  fundProvenanceAnalysisDetails = 'fundProvenanceAnalysisDetails',
  fundraisingMethods = 'fundraisingMethods',
  genericFileUploadAdditionalUsersPerson = 'genericFileUploadAdditionalUsersPerson',
  genericFileUploadAssetManager = 'genericFileUploadAssetManager',
  genericFileUploadAuthorizedRepresentativePerson = 'genericFileUploadAuthorizedRepresentativePerson',
  genericFileUploadBasicBusinessInfo = 'genericFileUploadBasicBusinessInfo',
  genericFileUploadBeneficialOwnerEntity = 'genericFileUploadBeneficialOwnerEntity',
  genericFileUploadBeneficialOwnerPerson = 'genericFileUploadBeneficialOwnerPerson',
  genericFileUploadBeneficialOwners = 'genericFileUploadBeneficialOwners',
  genericFileUploadDonorEntity = 'genericFileUploadDonorEntity',
  genericFileUploadDonorPerson = 'genericFileUploadDonorPerson',
  genericFileUploadDonors = 'genericFileUploadDonors',
  genericFileUploadEntityOps = 'genericFileUploadEntityOps',
  genericFileUploadFatcaInformation = 'genericFileUploadFatcaInformation',
  genericFileUploadFieldBusinessRegistrationDetails = 'genericFileUploadFieldBusinessRegistrationDetails',
  genericFileUploadFinancialCrimesCompliance = 'genericFileUploadFinancialCrimesCompliance',
  genericFileUploadFinancialCrimesCompliancePerson = 'genericFileUploadFinancialCrimesCompliancePerson',
  genericFileUploadIndividualsWithSignificantControl = 'genericFileUploadIndividualsWithSignificantControl',
  genericFileUploadIndividualsWithSignificantControlPerson = 'genericFileUploadIndividualsWithSignificantControlPerson',
  genericFileUploadIntendedUseOfAccount = 'genericFileUploadIntendedUseOfAccount',
  genericFileUploadInvestorEntity = 'genericFileUploadInvestorEntity',
  genericFileUploadInvestorPerson = 'genericFileUploadInvestorPerson',
  genericFileUploadInvestors = 'genericFileUploadInvestors',
  genericFileUploadLicensingAndRegistration = 'genericFileUploadLicensingAndRegistration',
  genericFileUploadPartyPerformingInvestorDueDiligence = 'genericFileUploadPartyPerformingInvestorDueDiligence',
  genericFileUploadPhysicalBusinessAddress = 'genericFileUploadPhysicalBusinessAddress',
  genericFileUploadRegisteredOfficeAddress = 'genericFileUploadRegisteredOfficeAddress',
  genericFileUploadRelatedParties = 'genericFileUploadRelatedParties',
  genericFileUploadRelatedPartyEntity = 'genericFileUploadRelatedPartyEntity',
  genericFileUploadRelatedPartyPerson = 'genericFileUploadRelatedPartyPerson',
  genericFileUploadSelfCertificationCrs = 'genericFileUploadSelfCertificationCrs',
  genericFileUploadTaxInfoEeaVat = 'genericFileUploadTaxInfoEeaVat',
  genericFileUploadTokenHolderPerson = 'genericFileUploadTokenHolderPerson',
  genericFileUploadTokenHolders = 'genericFileUploadTokenHolders',
  genericTextFieldAdditionalUsersPerson = 'genericTextFieldAdditionalUsersPerson',
  genericTextFieldAssetManager = 'genericTextFieldAssetManager',
  genericTextFieldAuthorizedRepresentativePerson = 'genericTextFieldAuthorizedRepresentativePerson',
  genericTextFieldBasicBusinessInfo = 'genericTextFieldBasicBusinessInfo',
  genericTextFieldBeneficialOwnerEntity = 'genericTextFieldBeneficialOwnerEntity',
  genericTextFieldBeneficialOwnerPerson = 'genericTextFieldBeneficialOwnerPerson',
  genericTextFieldBeneficialOwners = 'genericTextFieldBeneficialOwners',
  genericTextFieldBusinessRegistrationDetails = 'genericTextFieldBusinessRegistrationDetails',
  genericTextFieldDonorEntity = 'genericTextFieldDonorEntity',
  genericTextFieldDonorPerson = 'genericTextFieldDonorPerson',
  genericTextFieldDonors = 'genericTextFieldDonors',
  genericTextFieldEntityOps = 'genericTextFieldEntityOps',
  genericTextFieldFatcaInformation = 'genericTextFieldFatcaInformation',
  genericTextFieldFinancialCrimesCompliance = 'genericTextFieldFinancialCrimesCompliance',
  genericTextFieldFinancialCrimesCompliancePerson = 'genericTextFieldFinancialCrimesCompliancePerson',
  genericTextFieldIndividualsWithSignificantControl = 'genericTextFieldIndividualsWithSignificantControl',
  genericTextFieldIndividualsWithSignificantControlPerson = 'genericTextFieldIndividualsWithSignificantControlPerson',
  genericTextFieldIntendedUseOfAccount = 'genericTextFieldIntendedUseOfAccount',
  genericTextFieldInvestorEntity = 'genericTextFieldInvestorEntity',
  genericTextFieldInvestorPerson = 'genericTextFieldInvestorPerson',
  genericTextFieldInvestors = 'genericTextFieldInvestors',
  genericTextFieldLicensingAndRegistration = 'genericTextFieldLicensingAndRegistration',
  genericTextFieldPartyPerformingInvestorDueDiligence = 'genericTextFieldPartyPerformingInvestorDueDiligence',
  genericTextFieldPhysicalBusinessAddress = 'genericTextFieldPhysicalBusinessAddress',
  genericTextFieldRegisteredOfficeAddress = 'genericTextFieldRegisteredOfficeAddress',
  /**
   * Shared field names
   * - hasComplexOwnershipStructure
   * - ownershipStructureChart
   */
  genericTextFieldRelatedParties = 'genericTextFieldRelatedParties',
  genericTextFieldRelatedPartyEntity = 'genericTextFieldRelatedPartyEntity',
  genericTextFieldRelatedPartyPerson = 'genericTextFieldRelatedPartyPerson',
  genericTextFieldSelfCertificationCrs = 'genericTextFieldSelfCertificationCrs',
  genericTextFieldTaxInfoEeaVat = 'genericTextFieldTaxInfoEeaVat',
  genericTextFieldTokenHolderPerson = 'genericTextFieldTokenHolderPerson',
  genericTextFieldTokenHolders = 'genericTextFieldTokenHolders',
  geofencingControlsDescription = 'geofencingControlsDescription',
  hasComplexOwnershipStructure = 'hasComplexOwnershipStructure',
  hasGeofencingControls = 'hasGeofencingControls',
  hasHighRiskActivityControls = 'hasHighRiskActivityControls',
  hasPoliciesProhibitingCertainClients = 'hasPoliciesProhibitingCertainClients',
  highRiskActivityControlsDescription = 'highRiskActivityControlsDescription',
  individualsWithSignificantControlPersonSourceOfWealth = 'individualsWithSignificantControlPersonSourceOfWealth',
  institutionType = 'institutionType',
  investmentPolicyStatement = 'investmentPolicyStatement',
  investorAgreement = 'investorAgreement',
  investorDueDiligencePerformerEntityCountryOfFormation = 'investorDueDiligencePerformerEntityCountryOfFormation',
  investorDueDiligencePerformerEntityCountryOfPrincipalPlaceOfBusiness = 'investorDueDiligencePerformerEntityCountryOfPrincipalPlaceOfBusiness',
  investorDueDiligencePerformerEntityLegalName = 'investorDueDiligencePerformerEntityLegalName',
  investorEntityCountry = 'investorEntityCountry',
  investorEntityCountryOfFormation = 'investorEntityCountryOfFormation',
  investorEntityLegalName = 'investorEntityLegalName',
  investorLocations = 'investorLocations',
  investorPersonBirthCity = 'investorPersonBirthCity',
  investorPersonBirthCountry = 'investorPersonBirthCountry',
  investorPersonCitizenship = 'investorPersonCitizenship',
  investorPersonCity = 'investorPersonCity',
  investorPersonCountry = 'investorPersonCountry',
  investorPersonDob = 'investorPersonDob',
  investorPersonEmail = 'investorPersonEmail',
  investorPersonFirstName = 'investorPersonFirstName',
  investorPersonGovernmentId = 'investorPersonGovernmentId',
  investorPersonGovernmentIdNotarized = 'investorPersonGovernmentIdNotarized',
  investorPersonIdentificationNumber = 'investorPersonIdentificationNumber',
  investorPersonLastName = 'investorPersonLastName',
  investorPersonLine1 = 'investorPersonLine1',
  investorPersonLine2 = 'investorPersonLine2',
  investorPersonPercentOwnership = 'investorPersonPercentOwnership',
  investorPersonPostalCode = 'investorPersonPostalCode',
  investorPersonSourceOfWealth = 'investorPersonSourceOfWealth',
  investorPersonState = 'investorPersonState',
  investorsExist = 'investorsExist',
  isBeneficiaryScreeningPerformed = 'isBeneficiaryScreeningPerformed',
  isDonorScreeningPerformed = 'isDonorScreeningPerformed',
  isLargePrivateDonorsPolicyMaintained = 'isLargePrivateDonorsPolicyMaintained',
  isMemberOfCryptoComplianceCooperative = 'isMemberOfCryptoComplianceCooperative',
  isPassiveEntity = 'isPassiveEntity',
  isSelfHostedWallet = 'isSelfHostedWallet',
  isUsEntity = 'isUsEntity',
  isin = 'isin',
  kioskLocationsCountries = 'kioskLocationsCountries',
  kioskLocationsUsStates = 'kioskLocationsUsStates',
  knowsParticipantCountries = 'knowsParticipantCountries',
  knowsTokenHolderNames = 'knowsTokenHolderNames',
  kycAuthorizedRepFirstName = 'kycAuthorizedRepFirstName',
  kycAuthorizedRepLastName = 'kycAuthorizedRepLastName',
  kycBusinessCountryOfFormation = 'kycBusinessCountryOfFormation',
  kycBusinessName = 'kycBusinessName',
  kycNatureOfBusiness = 'kycNatureOfBusiness',
  laConstanciaDeSituacionFiscalRFI = 'laConstanciaDeSituacionFiscalRFI',
  lastYearAmlProgram = 'lastYearAmlProgram',
  lastYearAmlProgramProvided = 'lastYearAmlProgramProvided',
  legalOpinionOnDAO = 'legalOpinionOnDAO',
  licenseAndRegistrationDescription = 'licenseAndRegistrationDescription',
  licenseAndRegistrationRequired = 'licenseAndRegistrationRequired',
  licensesForHumanitarianAid = 'licensesForHumanitarianAid',
  mintsAndSellsNFTs = 'mintsAndSellsNFTs',
  natureOfBusiness = 'natureOfBusiness',
  noAmlTestingReportReason = 'noAmlTestingReportReason',
  noAmlTestingReportReasonRFI = 'noAmlTestingReportReasonRFI',
  noComplianceOfficerDetailsReason = 'noComplianceOfficerDetailsReason',
  noCustomersReason = 'noCustomersReason',
  noDbaCertificateReason = 'noDbaCertificateReason',
  noFinancialDocumentReason = 'noFinancialDocumentReason',
  noFinancialDocumentReasonRFI = 'noFinancialDocumentReasonRFI',
  noLastYearAmlProgramReason = 'noLastYearAmlProgramReason',
  noLicenseAndRegistrationRequiredReason = 'noLicenseAndRegistrationRequiredReason',
  noWebsiteReason = 'noWebsiteReason',
  nonProfitCharitableStatusEvidence = 'nonProfitCharitableStatusEvidence',
  offersAdditionalFinancialServices = 'offersAdditionalFinancialServices',
  offersAtmType = 'offersAtmType',
  offersSecondaryMarketNFTSales = 'offersSecondaryMarketNFTSales',
  organizationChart = 'organizationChart',
  otherAccountPurpose = 'otherAccountPurpose',
  otherTaxClassification = 'otherTaxClassification',
  ownershipChart = 'ownershipChart',
  ownershipStructureChart = 'ownershipStructureChart',
  participantCountries = 'participantCountries',
  partyResponsibleForDueDiligenceDifferentFromAssetManager = 'partyResponsibleForDueDiligenceDifferentFromAssetManager',
  passiveEntityStatement = 'passiveEntityStatement',
  paymentProcessingOptions = 'paymentProcessingOptions',
  performsDueDiligenceOnSourceOfWealthAndFunds = 'performsDueDiligenceOnSourceOfWealthAndFunds',
  performsIdentityVerification = 'performsIdentityVerification',
  performsProvenanceAnalysisOnCryptoAccepted = 'performsProvenanceAnalysisOnCryptoAccepted',
  performsProvenanceAnalysisOnCryptoPaymentsOrCollateral = 'performsProvenanceAnalysisOnCryptoPaymentsOrCollateral',
  performsProvenanceAnalysisOnCryptoTransferred = 'performsProvenanceAnalysisOnCryptoTransferred',
  performsSanctionsScreening = 'performsSanctionsScreening',
  performsScreeningOnFundraisingInvestors = 'performsScreeningOnFundraisingInvestors',
  performsTransactionMonitoringControls = 'performsTransactionMonitoringControls',
  physicalAddressCity = 'physicalAddressCity',
  physicalAddressCountry = 'physicalAddressCountry',
  physicalAddressLine1 = 'physicalAddressLine1',
  physicalAddressLine2 = 'physicalAddressLine2',
  physicalAddressPostalCode = 'physicalAddressPostalCode',
  physicalAddressProofOfAddress = 'physicalAddressProofOfAddress',
  physicalAddressState = 'physicalAddressState',
  privacyCoinNames = 'privacyCoinNames',
  privacyFunctionalityDescription = 'privacyFunctionalityDescription',
  privacyTokenFunctionality = 'privacyTokenFunctionality',
  productHasPrivacyFunctionality = 'productHasPrivacyFunctionality',
  productsAndServicesDescription = 'productsAndServicesDescription',
  projectWhitepaper = 'projectWhitepaper',
  projectWhitepaperProvided = 'projectWhitepaperProvided',
  proofOfAssetsUnderManagement = 'proofOfAssetsUnderManagement',
  proofOfCodeAudit = 'proofOfCodeAudit',
  proofOfInvestors = 'proofOfInvestors',
  proofOfTrustRelation = 'proofOfTrustRelation',
  proofOfWealth = 'proofOfWealth',
  proofOfWealthRFI = 'proofOfWealthRFI',
  proportionOfPaymentsInCrypto = 'proportionOfPaymentsInCrypto',
  protocolWhitepaperFile = 'protocolWhitepaperFile',
  protocolWhitepaperLink = 'protocolWhitepaperLink',
  provenanceAnalysisOnCryptoAcceptedDescription = 'provenanceAnalysisOnCryptoAcceptedDescription',
  provenanceAnalysisOnCryptoPaymentsOrCollateralDescription = 'provenanceAnalysisOnCryptoPaymentsOrCollateralDescription',
  provenanceAnalysisOnCryptoTransferredDescription = 'provenanceAnalysisOnCryptoTransferredDescription',
  registeredAddressSameAsPhysical = 'registeredAddressSameAsPhysical',
  registeredForVat = 'registeredForVat',
  registeredOfficeAddressCity = 'registeredOfficeAddressCity',
  registeredOfficeAddressCountry = 'registeredOfficeAddressCountry',
  registeredOfficeAddressLine1 = 'registeredOfficeAddressLine1',
  registeredOfficeAddressLine2 = 'registeredOfficeAddressLine2',
  registeredOfficeAddressPostalCode = 'registeredOfficeAddressPostalCode',
  registeredOfficeAddressProofOfAddress = 'registeredOfficeAddressProofOfAddress',
  registeredOfficeAddressState = 'registeredOfficeAddressState',
  registrationNumber = 'registrationNumber',
  relevantBusinessLicenses = 'relevantBusinessLicenses',
  residentOutsideFranceForTaxPurposes = 'residentOutsideFranceForTaxPurposes',
  riskControlsForPrivacyToken = 'riskControlsForPrivacyToken',
  sanctionControlsDescription = 'sanctionControlsDescription',
  sanctionsCompliancePolicy = 'sanctionsCompliancePolicy',
  sanctionsCompliancePolicyFile = 'sanctionsCompliancePolicyFile',
  selfHostedWalletBlockchains = 'selfHostedWalletBlockchains',
  shareholderRegistry = 'shareholderRegistry',
  shareholderW9s = 'shareholderW9s',
  shareholdersAreNotUsPersons = 'shareholdersAreNotUsPersons',
  shareholdersAreUsPersons = 'shareholdersAreUsPersons',
  shareholdersW8bens = 'shareholdersW8bens',
  singleFamilyOfficeName = 'singleFamilyOfficeName',
  sourceOfFunds = 'sourceOfFunds',
  sourceOfFundsDescription = 'sourceOfFundsDescription',
  sourceOfWealth = 'sourceOfWealth',
  sourceOfWealthDescription = 'sourceOfWealthDescription',
  sourceOfWealthDescriptionRFI = 'sourceOfWealthDescriptionRFI',
  sourceOfWealthRFI = 'sourceOfWealthRFI',
  subjectToCodeAudit = 'subjectToCodeAudit',
  taxClassification = 'taxClassification',
  taxId = 'taxId',
  taxIdentificationDocumentRFI = 'taxIdentificationDocumentRFI',
  thirdPartyPaymentsProcessorName = 'thirdPartyPaymentsProcessorName',
  tokenHolderAddressLine1 = 'tokenHolderAddressLine1',
  tokenHolderAddressLine2 = 'tokenHolderAddressLine2',
  tokenHolderBirthCity = 'tokenHolderBirthCity',
  tokenHolderBirthCountry = 'tokenHolderBirthCountry',
  tokenHolderCitizenship = 'tokenHolderCitizenship',
  tokenHolderCity = 'tokenHolderCity',
  tokenHolderCountry = 'tokenHolderCountry',
  tokenHolderDob = 'tokenHolderDob',
  tokenHolderEmail = 'tokenHolderEmail',
  tokenHolderFirstName = 'tokenHolderFirstName',
  tokenHolderGovernmentId = 'tokenHolderGovernmentId',
  tokenHolderGovernmentIdNotarized = 'tokenHolderGovernmentIdNotarized',
  tokenHolderIdentificationNumber = 'tokenHolderIdentificationNumber',
  tokenHolderLastName = 'tokenHolderLastName',
  tokenHolderPostalCode = 'tokenHolderPostalCode',
  tokenHolderState = 'tokenHolderState',
  tokenIssuanceProcess = 'tokenIssuanceProcess',
  transactionLimitAndMontioringDescription = 'transactionLimitAndMontioringDescription',
  trustRelatedEntityCity = 'trustRelatedEntityCity',
  trustRelatedEntityCountry = 'trustRelatedEntityCountry',
  trustRelatedEntityCountryOfFormation = 'trustRelatedEntityCountryOfFormation',
  trustRelatedEntityIdentificationNumber = 'trustRelatedEntityIdentificationNumber',
  trustRelatedEntityLegalName = 'trustRelatedEntityLegalName',
  trustRelatedEntityLine1 = 'trustRelatedEntityLine1',
  trustRelatedEntityLine2 = 'trustRelatedEntityLine2',
  trustRelatedEntityPostalCode = 'trustRelatedEntityPostalCode',
  trustRelatedEntityRegistrationNumber = 'trustRelatedEntityRegistrationNumber',
  trustRelatedEntityState = 'trustRelatedEntityState',
  trustRelatedEntityTrustRelationship = 'trustRelatedEntityTrustRelationship',
  trustRelatedPersonBirthCity = 'trustRelatedPersonBirthCity',
  trustRelatedPersonBirthCountry = 'trustRelatedPersonBirthCountry',
  trustRelatedPersonCitizenship = 'trustRelatedPersonCitizenship',
  trustRelatedPersonCity = 'trustRelatedPersonCity',
  trustRelatedPersonCountry = 'trustRelatedPersonCountry',
  trustRelatedPersonDob = 'trustRelatedPersonDob',
  trustRelatedPersonEmail = 'trustRelatedPersonEmail',
  trustRelatedPersonFirstName = 'trustRelatedPersonFirstName',
  trustRelatedPersonGovernmentId = 'trustRelatedPersonGovernmentId',
  trustRelatedPersonGovernmentIdNotarized = 'trustRelatedPersonGovernmentIdNotarized',
  trustRelatedPersonIdentificationNumber = 'trustRelatedPersonIdentificationNumber',
  trustRelatedPersonLastName = 'trustRelatedPersonLastName',
  trustRelatedPersonLine1 = 'trustRelatedPersonLine1',
  trustRelatedPersonLine2 = 'trustRelatedPersonLine2',
  trustRelatedPersonPostalCode = 'trustRelatedPersonPostalCode',
  trustRelatedPersonSourceOfWealth = 'trustRelatedPersonSourceOfWealth',
  trustRelatedPersonState = 'trustRelatedPersonState',
  trustRelatedPersonTrustRelationship = 'trustRelatedPersonTrustRelationship',
  userManagementAdminBirthCity = 'userManagementAdminBirthCity',
  userManagementAdminBirthCountry = 'userManagementAdminBirthCountry',
  userManagementAdminCitizenship = 'userManagementAdminCitizenship',
  userManagementAdminCity = 'userManagementAdminCity',
  userManagementAdminCountry = 'userManagementAdminCountry',
  userManagementAdminDob = 'userManagementAdminDob',
  userManagementAdminEmail = 'userManagementAdminEmail',
  userManagementAdminFirstName = 'userManagementAdminFirstName',
  userManagementAdminGovernmentId = 'userManagementAdminGovernmentId',
  userManagementAdminGovernmentIdNotarized = 'userManagementAdminGovernmentIdNotarized',
  userManagementAdminIdentificationNumber = 'userManagementAdminIdentificationNumber',
  userManagementAdminJobTitle = 'userManagementAdminJobTitle',
  userManagementAdminLastName = 'userManagementAdminLastName',
  userManagementAdminLine1 = 'userManagementAdminLine1',
  userManagementAdminLine2 = 'userManagementAdminLine2',
  userManagementAdminPostalCode = 'userManagementAdminPostalCode',
  userManagementAdminProofOfAuthorizationPowerOfAttorney = 'userManagementAdminProofOfAuthorizationPowerOfAttorney',
  userManagementAdminProofofAuthorization = 'userManagementAdminProofofAuthorization',
  userManagementAdminSourceOfWealth = 'userManagementAdminSourceOfWealth',
  userManagementAdminState = 'userManagementAdminState',
  vatNumber = 'vatNumber',
  w8bene = 'w8bene',
  w9 = 'w9',
  walletAddressesOfSignificantTokenHolders = 'walletAddressesOfSignificantTokenHolders'
}

export enum L3OnboardingFlowGroup {
  additionalInformation = 'additionalInformation',
  additionalUsers = 'additionalUsers',
  additionalUsersKyc = 'additionalUsersKyc',
  additionalUsersPersons = 'additionalUsersPersons',
  additionalUsersPersonsKyc = 'additionalUsersPersonsKyc',
  assetManager = 'assetManager',
  assetManagerDetails = 'assetManagerDetails',
  assetManagerEntity = 'assetManagerEntity',
  authorizedRepresentative = 'authorizedRepresentative',
  basicBusinessInfo = 'basicBusinessInfo',
  beneficialOwnerEntity = 'beneficialOwnerEntity',
  beneficialOwnerPersons = 'beneficialOwnerPersons',
  beneficialOwners = 'beneficialOwners',
  beneficialOwnersDetails = 'beneficialOwnersDetails',
  businessDetails = 'businessDetails',
  businessRegistrationDetails = 'businessRegistrationDetails',
  certificationInfo = 'certificationInfo',
  certifications = 'certifications',
  complianceOfficer = 'complianceOfficer',
  donorEntity = 'donorEntity',
  donorPersons = 'donorPersons',
  donors = 'donors',
  donorsDetails = 'donorsDetails',
  entityOperations = 'entityOperations',
  fatcaInformation = 'fatcaInformation',
  financialCrimesCompliance = 'financialCrimesCompliance',
  financialCrimesComplianceDetails = 'financialCrimesComplianceDetails',
  individualWithSignificantControlPersons = 'individualWithSignificantControlPersons',
  individualsWithSignificantControl = 'individualsWithSignificantControl',
  individualsWithSignificantControlDetails = 'individualsWithSignificantControlDetails',
  intendedUseOfAccount = 'intendedUseOfAccount',
  investorDueDiligencePerformerEntity = 'investorDueDiligencePerformerEntity',
  investorEntity = 'investorEntity',
  investorPersons = 'investorPersons',
  investors = 'investors',
  investorsDetails = 'investorsDetails',
  kycAuthorizedRepInfo = 'kycAuthorizedRepInfo',
  kycBusinessInfo = 'kycBusinessInfo',
  kycCertificationInfo = 'kycCertificationInfo',
  kycCertifications = 'kycCertifications',
  licensingAndRegistration = 'licensingAndRegistration',
  partyPerformingInvestorDueDiligence = 'partyPerformingInvestorDueDiligence',
  partyPerformingInvestorDueDiligenceDetails = 'partyPerformingInvestorDueDiligenceDetails',
  physicalBusinessAddress = 'physicalBusinessAddress',
  registeredOfficeAddress = 'registeredOfficeAddress',
  relatedParties = 'relatedParties',
  selfCertificationCrs = 'selfCertificationCrs',
  significantDonorsAbove25Pct = 'significantDonorsAbove25Pct',
  significantDonorsAbove25PctDetails = 'significantDonorsAbove25PctDetails',
  significantDonorsAbove25PctEntity = 'significantDonorsAbove25PctEntity',
  significantDonorsAbove25PctPersons = 'significantDonorsAbove25PctPersons',
  taxInfoEea = 'taxInfoEea',
  taxInfoEeaVat = 'taxInfoEeaVat',
  tokenHolderPersons = 'tokenHolderPersons',
  tokenHolders = 'tokenHolders',
  tokenHoldersDetails = 'tokenHoldersDetails',
  topFiveInvestorEntity = 'topFiveInvestorEntity',
  topFiveInvestorPersons = 'topFiveInvestorPersons',
  topFiveInvestors = 'topFiveInvestors',
  topFiveInvestorsDetails = 'topFiveInvestorsDetails',
  trustRelatedEntity = 'trustRelatedEntity',
  trustRelatedParties = 'trustRelatedParties',
  trustRelatedPartiesDetails = 'trustRelatedPartiesDetails',
  trustRelatedPersons = 'trustRelatedPersons'
}

export enum L3OnboardingIndustryClassification {
  charitiesAndNonProfitOrganizations = 'charitiesAndNonProfitOrganizations',
  commercialAndRetailServices = 'commercialAndRetailServices',
  cryptoWeb3NativeServicesAndApplications = 'cryptoWeb3NativeServicesAndApplications',
  financialInstitutions = 'financialInstitutions',
  pooledInvestmentVehiclesAssetManagers = 'pooledInvestmentVehiclesAssetManagers',
  privateWealthManagement = 'privateWealthManagement',
  proprietaryTraders = 'proprietaryTraders'
}

export enum L3OnboardingKioksStatesOptions {
  notApplicable = 'notApplicable'
}

export interface L3OnboardingOverviewGroupFieldV2 {
  __typename?: 'L3OnboardingOverviewGroupFieldV2';
  apiValue?: Maybe<Scalars['String']['output']>;
  group?: Maybe<L3OnboardingFlowGroup>;
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rfiId?: Maybe<Scalars['String']['output']>;
  rfiStatus?: Maybe<RfiFieldStatus>;
  value: Scalars['String']['output'];
}

export enum L3OnboardingOverviewGroupStatus {
  COMPLETED = 'COMPLETED',
  IGNORED_FOR_PROGRESS = 'IGNORED_FOR_PROGRESS',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  RFI_COMPLETED = 'RFI_COMPLETED',
  RFI_IN_PROGRESS = 'RFI_IN_PROGRESS'
}

export enum L3OnboardingPartyRelationType {
  BENEFICIARY = 'BENEFICIARY',
  GRANTOR_TRUSTOR_SETTLOR = 'GRANTOR_TRUSTOR_SETTLOR',
  PROTECTOR_CONTROLLER = 'PROTECTOR_CONTROLLER',
  TRUSTEE = 'TRUSTEE'
}

export enum L3OnboardingPartyType {
  entity = 'entity',
  naturalPerson = 'naturalPerson'
}

export enum L3OnboardingPaymentProcessorType {
  direct = 'direct',
  thirdParty = 'thirdParty'
}

export enum L3OnboardingPhysicalPresenceOrService {
  AF = 'AF',
  BY = 'BY',
  CD = 'CD',
  CF = 'CF',
  CU = 'CU',
  GW = 'GW',
  IQ = 'IQ',
  IR = 'IR',
  KP = 'KP',
  LY = 'LY',
  ML = 'ML',
  MM = 'MM',
  RU = 'RU',
  SD = 'SD',
  SO = 'SO',
  SS = 'SS',
  SY = 'SY',
  UA = 'UA',
  VE = 'VE',
  YE = 'YE',
  notApplicable = 'notApplicable'
}

export enum L3OnboardingProduct {
  circleMint = 'circleMint'
}

export enum L3OnboardingPurpose {
  activityForCustomers = 'activityForCustomers',
  cryptoInvestments = 'cryptoInvestments',
  cryptoPayroll = 'cryptoPayroll',
  custodyOfFunds = 'custodyOfFunds',
  otcService = 'otcService',
  other = 'other',
  paymentProcessingPlatform = 'paymentProcessingPlatform',
  proprietaryTrading = 'proprietaryTrading',
  receivingCryptoPayments = 'receivingCryptoPayments',
  sendingCryptoPayments = 'sendingCryptoPayments'
}

export enum L3OnboardingRegulators {
  acpr = 'acpr',
  apra = 'apra',
  asic = 'asic',
  austrac = 'austrac',
  cftc = 'cftc',
  fca = 'fca',
  fdic = 'fdic',
  fed = 'fed',
  fincen = 'fincen',
  finra = 'finra',
  fintrac = 'fintrac',
  iiroc = 'iiroc',
  mas = 'mas',
  occ = 'occ',
  osfi = 'osfi',
  other = 'other',
  pra = 'pra',
  sec = 'sec'
}

export enum L3OnboardingSourceOfFunds {
  businessOperatingFunds = 'businessOperatingFunds',
  customerFunds = 'customerFunds',
  donations = 'donations',
  investorFunds = 'investorFunds',
  loans = 'loans',
  miningProceedsStakingRewards = 'miningProceedsStakingRewards',
  other = 'other',
  proprietaryFunds = 'proprietaryFunds'
}

export enum L3OnboardingSourceOfWealth {
  familyGenerationalInheritance = 'familyGenerationalInheritance',
  gifts = 'gifts',
  incomeRevenueBusinessActivities = 'incomeRevenueBusinessActivities',
  investmentActivities = 'investmentActivities',
  other = 'other',
  retirementPension = 'retirementPension',
  ventureCapitalPrivateEquityFunding = 'ventureCapitalPrivateEquityFunding',
  winnings = 'winnings'
}

export enum L3OnboardingUsFederalTaxClassification {
  cCorporation = 'cCorporation',
  individual = 'individual',
  llc = 'llc',
  other = 'other',
  partnership = 'partnership',
  sCorporation = 'sCorporation',
  trustEstate = 'trustEstate'
}

export enum LegalEntity {
  CIRCLE_BERMUDA = 'CIRCLE_BERMUDA',
  CIRCLE_FR = 'CIRCLE_FR',
  CIRCLE_INC = 'CIRCLE_INC',
  CIRCLE_LLC = 'CIRCLE_LLC',
  CIRCLE_PAYMENTS = 'CIRCLE_PAYMENTS',
  CIRCLE_SG = 'CIRCLE_SG',
  CIRCLE_TECHNOLOGY = 'CIRCLE_TECHNOLOGY',
  CIRCLE_TRADING = 'CIRCLE_TRADING',
  CIRCLE_UK = 'CIRCLE_UK',
  UNKNOWN = 'UNKNOWN'
}

export interface Limit {
  __typename?: 'Limit';
  available: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
  usage: Scalars['Float']['output'];
}

export enum LocationType {
  wallet = 'wallet'
}

export interface MainWalletPendingTransactionApprovalRequestNotification extends BaseInAppNotification, PaginatedType {
  __typename?: 'MainWalletPendingTransactionApprovalRequestNotification';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: MainWalletPendingTransactionApprovalRequestPayload;
  type: InAppNotificationType;
}

export interface MainWalletPendingTransactionApprovalRequestPayload {
  __typename?: 'MainWalletPendingTransactionApprovalRequestPayload';
  amount: Scalars['Float']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  initiatorEmail: Scalars['String']['output'];
  initiatorFullName: Scalars['String']['output'];
  type: WalletApprovalTransactionType;
}

export interface MainWalletPolicyApprovalRequestNotification extends BaseInAppNotification, PaginatedType {
  __typename?: 'MainWalletPolicyApprovalRequestNotification';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: MainWalletPolicyApprovalRequestNotificationPayload;
  type: InAppNotificationType;
}

export interface MainWalletPolicyApprovalRequestNotificationPayload {
  __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload';
  currency: Currency;
  policyCreator: Scalars['String']['output'];
  policyId: Scalars['ID']['output'];
  policyName: Scalars['String']['output'];
}

export interface ManageWalletApprovalPolicyInput {
  currency: Currency;
  policyId: Scalars['String']['input'];
}

export interface MerchantAchBankAccount {
  __typename?: 'MerchantAchBankAccount';
  accountNumber: Scalars['String']['output'];
  bankAddress?: Maybe<BankAddress>;
  billingDetails?: Maybe<BillingDetails>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Metadata>;
  pairEntries: Array<MerchantPairEntries>;
  riskEvaluation?: Maybe<RiskEvaluation>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface MerchantBillingDetailsInput {
  city: Scalars['String']['input'];
  country: CountryCode;
  email: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
}

export interface MerchantCardVerification {
  __typename?: 'MerchantCardVerification';
  avs?: Maybe<Scalars['String']['output']>;
  cvv?: Maybe<Scalars['String']['output']>;
}

export interface MerchantChargeback extends PaginatedType {
  __typename?: 'MerchantChargeback';
  category: Scalars['String']['output'];
  chargebackAmount: Amount;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fees: Amount;
  history: Array<ChargebackHistory>;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface MerchantChargebacks extends PaginationExtends {
  __typename?: 'MerchantChargebacks';
  links: PaginationLinks;
  list: Array<MerchantChargeback>;
}

export interface MerchantCreditCard {
  __typename?: 'MerchantCreditCard';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  network: Scalars['String']['output'];
  verification?: Maybe<MerchantCardVerification>;
}

export interface MerchantCreditCardInput {
  billingDetails: MerchantBillingDetailsInput;
  cardNumber: Scalars['String']['input'];
  cvv: Scalars['String']['input'];
  expMonth: Scalars['String']['input'];
  expYear: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
}

export interface MerchantCreditCardRemoval {
  __typename?: 'MerchantCreditCardRemoval';
  id: Scalars['ID']['output'];
}

export interface MerchantPairEntries {
  __typename?: 'MerchantPairEntries';
  entity: Scalars['String']['output'];
  type: WatchlistTypes;
}

export interface MerchantPayment extends PaginatedType {
  __typename?: 'MerchantPayment';
  allowEntityToBeBlocked: Scalars['Boolean']['output'];
  amount: Amount;
  cancel?: Maybe<MerchantPaymentOperationStatus>;
  captured?: Maybe<Scalars['Boolean']['output']>;
  createDate: Scalars['DateTime']['output'];
  depositAddress?: Maybe<BlockchainDepositAddress>;
  description?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<MerchantPaymentErrorCode>;
  fees?: Maybe<Amount>;
  fromAmount?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  isCancellable: Scalars['Boolean']['output'];
  isRefundable: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantWalletId: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  networkFees?: Maybe<MerchantPaymentNetworkFee>;
  originalPayment?: Maybe<MerchantPaymentOperationStatus>;
  paymentIntentId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<MerchantPaymentCancellationReason>;
  refunds?: Maybe<Array<MerchantPaymentRefund>>;
  relatedTransactions: Array<MerchantPaymentOperationStatus>;
  riskEvaluation?: Maybe<RiskEvaluation>;
  settlementAmount?: Maybe<Amount>;
  source?: Maybe<MerchantPaymentSource>;
  status: MerchantPaymentStatus;
  transactionHash?: Maybe<Scalars['String']['output']>;
  type: MerchantPaymentOperationType;
  updateDate: Scalars['DateTime']['output'];
  verification?: Maybe<CardPaymentVerification>;
}

export interface MerchantPaymentCancellationInput {
  paymentId: Scalars['ID']['input'];
  reason: MerchantPaymentCancellationReason;
}

export enum MerchantPaymentCancellationReason {
  bank_account_ineligible = 'bank_account_ineligible',
  bank_transaction_error = 'bank_transaction_error',
  duplicate = 'duplicate',
  fraudulent = 'fraudulent',
  insufficient_funds = 'insufficient_funds',
  invalid_account_number = 'invalid_account_number',
  invalid_ach_rtn = 'invalid_ach_rtn',
  payment_failed = 'payment_failed',
  payment_returned = 'payment_returned',
  payment_stopped_by_issuer = 'payment_stopped_by_issuer',
  requested_by_customer = 'requested_by_customer',
  unauthorized_transaction = 'unauthorized_transaction'
}

export enum MerchantPaymentErrorCode {
  account_ineligible = 'account_ineligible',
  account_name_mismatch = 'account_name_mismatch',
  account_number_mismatch = 'account_number_mismatch',
  bank_account_closed = 'bank_account_closed',
  bank_account_ineligible = 'bank_account_ineligible',
  bank_transaction_error = 'bank_transaction_error',
  card_account_ineligible = 'card_account_ineligible',
  card_address_mismatch = 'card_address_mismatch',
  card_cvv_invalid = 'card_cvv_invalid',
  card_cvv_required = 'card_cvv_required',
  card_encrypted_data_invalid = 'card_encrypted_data_invalid',
  card_expired = 'card_expired',
  card_failed = 'card_failed',
  card_invalid = 'card_invalid',
  card_limit_violated = 'card_limit_violated',
  card_network_unsupported = 'card_network_unsupported',
  card_not_honored = 'card_not_honored',
  card_restricted = 'card_restricted',
  card_zip_mismatch = 'card_zip_mismatch',
  channel_invalid = 'channel_invalid',
  customer_name_mismatch = 'customer_name_mismatch',
  institution_name_mismatch = 'institution_name_mismatch',
  invalid_account_number = 'invalid_account_number',
  invalid_ach_rtn = 'invalid_ach_rtn',
  invalid_sender = 'invalid_sender',
  invalid_wire_rtn = 'invalid_wire_rtn',
  missing_ach_configurations = 'missing_ach_configurations',
  payment_authorization_expired = 'payment_authorization_expired',
  payment_canceled = 'payment_canceled',
  payment_denied = 'payment_denied',
  payment_failed = 'payment_failed',
  payment_failed_balance_check = 'payment_failed_balance_check',
  payment_fraud_detected = 'payment_fraud_detected',
  payment_not_funded = 'payment_not_funded',
  payment_not_supported_by_issuer = 'payment_not_supported_by_issuer',
  payment_returned = 'payment_returned',
  payment_stopped_by_issuer = 'payment_stopped_by_issuer',
  payment_unprocessable = 'payment_unprocessable',
  ref_id_invalid = 'ref_id_invalid',
  source_already_used = 'source_already_used',
  three_d_secure_action_expired = 'three_d_secure_action_expired',
  three_d_secure_failure = 'three_d_secure_failure',
  three_d_secure_invalid_request = 'three_d_secure_invalid_request',
  three_d_secure_not_supported = 'three_d_secure_not_supported',
  three_d_secure_required = 'three_d_secure_required',
  transaction_orphaned = 'transaction_orphaned',
  unauthorized_transaction = 'unauthorized_transaction',
  vendor_inactive = 'vendor_inactive',
  wallet_address_mismatch = 'wallet_address_mismatch'
}

export interface MerchantPaymentFilterInput {
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<MerchantPaymentOperationType>;
  settlementId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MerchantPaymentStatus>;
  type?: InputMaybe<MerchantPaymentSourceType>;
}

export interface MerchantPaymentIntent extends PaginatedType {
  __typename?: 'MerchantPaymentIntent';
  amount?: Maybe<Amount>;
  amountPaid?: Maybe<Amount>;
  amountRefunded?: Maybe<Amount>;
  context?: Maybe<MerchantPaymentIntentTimelineItemContext>;
  createDate: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  fees?: Maybe<Array<Maybe<MerchantPaymentIntentFee>>>;
  id: Scalars['ID']['output'];
  paymentIds?: Maybe<Array<Scalars['String']['output']>>;
  paymentMethods: Array<Maybe<MerchantPaymentIntentPaymentMethod>>;
  settlementCurrency: Currency;
  status: MerchantPaymentIntentTimelineItemStatus;
  timeline: Array<MerchantPaymentIntentTimelineItem>;
  totalPaymentFees?: Maybe<MerchantPaymentIntentFee>;
  type?: Maybe<MerchantPaymentIntentType>;
  updateDate: Scalars['DateTime']['output'];
}

export interface MerchantPaymentIntentFee {
  __typename?: 'MerchantPaymentIntentFee';
  amount: Scalars['String']['output'];
  currency: Currency;
  type: MerchantPaymentIntentFeeType;
}

export enum MerchantPaymentIntentFeeType {
  blockchainAddressLease = 'blockchainAddressLease',
  blockchainLeaseFee = 'blockchainLeaseFee',
  totalPaymentFees = 'totalPaymentFees'
}

export interface MerchantPaymentIntentPaymentMethod {
  __typename?: 'MerchantPaymentIntentPaymentMethod';
  address?: Maybe<Scalars['String']['output']>;
  chain: BlockchainAbbreviation;
  type: MerchantPaymentIntentPaymentMethodType;
}

export enum MerchantPaymentIntentPaymentMethodType {
  blockchain = 'blockchain'
}

export interface MerchantPaymentIntentRefundInput {
  amount: AmountInput;
  destination: CryptoRefundDestination;
  paymentIntentId: Scalars['ID']['input'];
  toAmount: AmountInput;
}

export interface MerchantPaymentIntentTimelineItem {
  __typename?: 'MerchantPaymentIntentTimelineItem';
  context?: Maybe<MerchantPaymentIntentTimelineItemContext>;
  status: MerchantPaymentIntentTimelineItemStatus;
  time: Scalars['DateTime']['output'];
}

export enum MerchantPaymentIntentTimelineItemContext {
  overpaid = 'overpaid',
  paid = 'paid',
  underpaid = 'underpaid'
}

export enum MerchantPaymentIntentTimelineItemStatus {
  active = 'active',
  complete = 'complete',
  created = 'created',
  expired = 'expired',
  failed = 'failed',
  pending = 'pending',
  refunded = 'refunded'
}

export enum MerchantPaymentIntentType {
  continuous = 'continuous',
  transient = 'transient'
}

export interface MerchantPaymentIntents extends PaginationExtends {
  __typename?: 'MerchantPaymentIntents';
  links: PaginationLinks;
  list: Array<MerchantPaymentIntent>;
}

export interface MerchantPaymentIntentsFilterInput {
  settlementCurrency?: InputMaybe<Currency>;
  status?: InputMaybe<MerchantPaymentIntentTimelineItemStatus>;
}

export interface MerchantPaymentNetworkFee {
  __typename?: 'MerchantPaymentNetworkFee';
  amount: Scalars['String']['output'];
  currency: Currency;
  feePayer: NetworkFeePayer;
}

export interface MerchantPaymentOperationStatus {
  __typename?: 'MerchantPaymentOperationStatus';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: MerchantPaymentStatus;
  type: MerchantPaymentOperationType;
  updateDate: Scalars['DateTime']['output'];
}

export enum MerchantPaymentOperationType {
  cancel = 'cancel',
  payment = 'payment',
  refund = 'refund'
}

export interface MerchantPaymentRefund {
  __typename?: 'MerchantPaymentRefund';
  amount?: Maybe<Amount>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<MerchantPaymentCancellationReason>;
  source?: Maybe<MerchantPaymentSource>;
  status: MerchantPaymentStatus;
  type: MerchantPaymentOperationType;
  updateDate: Scalars['DateTime']['output'];
}

export interface MerchantPaymentRefundInput {
  amount: AmountInput;
  paymentId: Scalars['ID']['input'];
  reason: MerchantPaymentCancellationReason;
}

export interface MerchantPaymentSource {
  __typename?: 'MerchantPaymentSource';
  id: Scalars['ID']['output'];
  type: MerchantPaymentSourceType;
}

export enum MerchantPaymentSourceType {
  ach = 'ach',
  card = 'card',
  payment_token = 'payment_token',
  sepa = 'sepa',
  signet = 'signet',
  wire = 'wire'
}

export enum MerchantPaymentStatus {
  action_required = 'action_required',
  complete = 'complete',
  confirmed = 'confirmed',
  failed = 'failed',
  paid = 'paid',
  pending = 'pending',
  reversed = 'reversed'
}

export enum MerchantPaymentType {
  instant_settlement = 'instant_settlement'
}

export interface MerchantPayments extends PaginationExtends {
  __typename?: 'MerchantPayments';
  links: PaginationLinks;
  list: Array<MerchantPayment>;
}

export interface MerchantPayout extends PaginatedType {
  __typename?: 'MerchantPayout';
  adjustments?: Maybe<MerchantPayoutAdjustments>;
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destination: MerchantPayoutDestination;
  errorCode?: Maybe<MerchantPayoutErrorCode>;
  externalRef?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<MerchantPayoutMetadata>;
  return?: Maybe<MerchantPayoutReturn>;
  riskEvaluation?: Maybe<RiskEvaluation>;
  source?: Maybe<MerchantPayoutSource>;
  sourceWalletId: Scalars['String']['output'];
  status: MerchantPayoutStatus;
  toAmount?: Maybe<Amount>;
  trackingRef?: Maybe<Scalars['String']['output']>;
  updateDate: Scalars['DateTime']['output'];
}

export interface MerchantPayoutAdjustments {
  __typename?: 'MerchantPayoutAdjustments';
  bankFees?: Maybe<Amount>;
  fxCredit?: Maybe<Amount>;
  fxDebit?: Maybe<Amount>;
}

export interface MerchantPayoutDestination {
  __typename?: 'MerchantPayoutDestination';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: MerchantPayoutType;
}

export enum MerchantPayoutErrorCode {
  bank_transaction_error = 'bank_transaction_error',
  fiat_account_limit_exceeded = 'fiat_account_limit_exceeded',
  intermediary_bank_required = 'intermediary_bank_required',
  invalid_ach_rtn = 'invalid_ach_rtn',
  invalid_bank_account_number = 'invalid_bank_account_number',
  invalid_travel_rule_identity = 'invalid_travel_rule_identity',
  invalid_wire_rtn = 'invalid_wire_rtn',
  transaction_denied = 'transaction_denied',
  transaction_failed = 'transaction_failed',
  transaction_returned = 'transaction_returned',
  vendor_inactive = 'vendor_inactive'
}

export interface MerchantPayoutMetadata {
  __typename?: 'MerchantPayoutMetadata';
  beneficiaryEmail: Scalars['String']['output'];
}

export interface MerchantPayoutReturn {
  __typename?: 'MerchantPayoutReturn';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  payoutId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  status: MerchantPayoutStatus;
  updateDate: Scalars['DateTime']['output'];
}

export interface MerchantPayoutSource {
  __typename?: 'MerchantPayoutSource';
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Maybe<Identity>>>;
  type: CryptoPayoutSourceType;
}

export enum MerchantPayoutStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export enum MerchantPayoutType {
  ach = 'ach',
  address_book = 'address_book',
  sepa = 'sepa',
  wire = 'wire'
}

export interface MerchantPayouts extends PaginationExtends {
  __typename?: 'MerchantPayouts';
  links: PaginationLinks;
  list: Array<MerchantPayout>;
}

export interface MerchantSepaBankAccount {
  __typename?: 'MerchantSepaBankAccount';
  billingDetails?: Maybe<BillingDetails>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pairEntries: Array<MerchantPairEntries>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface MerchantWireBankAccount {
  __typename?: 'MerchantWireBankAccount';
  bankAddress?: Maybe<BankAddress>;
  billingDetails?: Maybe<BillingDetails>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  pairEntries: Array<MerchantPairEntries>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  userConfirmedWireSend: Scalars['Boolean']['output'];
}

export interface Metadata {
  __typename?: 'Metadata';
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
}

export interface MsaOperationInput {
  onboardingLevel: OnboardingLevel;
}

export interface MsaOperationResponse {
  __typename?: 'MsaOperationResponse';
  certification?: Maybe<OnboardingCertification>;
  operation: OnboardingApplication;
}

export interface Mutation {
  __typename?: 'Mutation';
  activateMfa?: Maybe<Scalars['Void']['output']>;
  addBlockchainDepositAddresses: Array<BlockchainDepositAddress>;
  addBlockchainRecipientAddress?: Maybe<BlockchainRecipientAddress>;
  addCaBankAccount: WireBankAccount;
  addCbitBankAccount: CbitBankAccount;
  addCubixBankAccount: CubixBankAccount;
  addEntriesToWatchList: Array<WatchlistEntry>;
  addIbanBankAccount: WireBankAccount;
  addMerchantCreditCard: MerchantCreditCard;
  addOtherBankAccount: WireBankAccount;
  addPaymentMethod?: Maybe<Scalars['Void']['output']>;
  addPixBankAccount: PixBankAccount;
  addRtpBankAccount: RtpBankAccount;
  addUsBankAccount: WireBankAccount;
  addUser?: Maybe<User>;
  addXpayBankAccount: XpayBankAccount;
  cancelPendingUserProposal?: Maybe<Scalars['Void']['output']>;
  cancelSubmittedSettingsChange?: Maybe<Scalars['Void']['output']>;
  cancelWalletApprovalPendingTransaction?: Maybe<Scalars['Void']['output']>;
  cancelWalletApprovalSubmittedPolicy?: Maybe<Scalars['Void']['output']>;
  changePassword: Scalars['Boolean']['output'];
  completeInvite?: Maybe<SignInCredential>;
  createAPIKey: CreateApiKey;
  createAccount?: Maybe<SignInCredential>;
  createBlockchainRecipientAddressWithMetadata: BlockchainRecipientAddressWithMetadata;
  createCardSetup: CardSetup;
  createDeleteUserGroupProposal?: Maybe<Scalars['Void']['output']>;
  createIpAllowListingIpAddress: Scalars['Boolean']['output'];
  createNotificationSubscription?: Maybe<NotificationSubscription>;
  createPayout?: Maybe<Payout>;
  createRolrAccount?: Maybe<SignInCredential>;
  createSettlementCreditTransfer: SettlementCreditTransfer;
  createStablecoinExpressDepositRoute: StablecoinExpressRoute;
  createStablecoinExpressWithdrawalRoute: StablecoinExpressRoute;
  createTrade: Trade;
  createUpdateUserGroupProposal?: Maybe<Scalars['Void']['output']>;
  createUserGroup: CreateUserGroupResponse;
  deleteNotificationSubscription?: Maybe<Scalars['Void']['output']>;
  discardWalletApprovalDraftPolicy?: Maybe<Scalars['Void']['output']>;
  enrollInOktaVerifyMfa: EnrolledFactorInfo;
  enrollInTotpMfa: EnrolledFactorInfo;
  enrollPinCode?: Maybe<Scalars['Void']['output']>;
  inviteAuthorizedRep?: Maybe<Scalars['Void']['output']>;
  inviteUser?: Maybe<Scalars['Void']['output']>;
  inviteUserWithAdminApproval?: Maybe<Scalars['Void']['output']>;
  invoicePayment: InvoicePayment;
  markInAppNotificationsAsRead?: Maybe<Scalars['Void']['output']>;
  merchantPaymentCancellation: MerchantPayment;
  merchantPaymentIntentRefund: MerchantPayment;
  merchantPaymentRefund: MerchantPayment;
  mockStepUp: Scalars['Boolean']['output'];
  onboardingCreateMsaOperation?: Maybe<MsaOperationResponse>;
  onboardingCreateRfiUserComment?: Maybe<Scalars['Void']['output']>;
  onboardingDeleteGroupValue?: Maybe<Scalars['Void']['output']>;
  onboardingInitiateKycApplication?: Maybe<OnboardingApplication>;
  onboardingInitiateRolrApplication?: Maybe<OnboardingApplication>;
  onboardingMarkRfisAsResponded?: Maybe<Scalars['Void']['output']>;
  onboardingSaveFieldValuesV2: Array<OnboardingGroupValueV2>;
  onboardingSubmitApplication: OnboardingApplicationSubmission;
  onboardingUploadDocumentWithoutLinking: OnboardingUploadDocumentResponse;
  removeBlockchainRecipientAddress?: Maybe<Scalars['Void']['output']>;
  removeIpAllowListingIpAddress: Scalars['Boolean']['output'];
  removeMerchantCreditCard: MerchantCreditCardRemoval;
  removeUser?: Maybe<Scalars['Void']['output']>;
  removeUserWithAdminApproval?: Maybe<Scalars['Void']['output']>;
  resendInvite?: Maybe<Scalars['Void']['output']>;
  resendUserActivation: Scalars['Boolean']['output'];
  resetMfaRequest?: Maybe<Scalars['Void']['output']>;
  resetPinCode?: Maybe<Scalars['Void']['output']>;
  revokeAPIKey?: Maybe<Scalars['Void']['output']>;
  sandboxSignup: Scalars['Boolean']['output'];
  setAdminApprovalsSettings?: Maybe<Scalars['Void']['output']>;
  setBankAccountNickname: BankAccount;
  setBlockchainRecipientAddressAdditionalInfo: AddressStatusResponse;
  setBlockchainRecipientAddressBeneficiaryInfo?: Maybe<Scalars['Void']['output']>;
  setBlockchainRecipientAddressWithMetadata: BlockchainRecipientAddressWithMetadata;
  setDefaultPaymentMethod: Scalars['Boolean']['output'];
  setDelayedWithdrawalsSettings: DelayedWithdrawalsSettings;
  setIpAllowListingSetting: Scalars['Boolean']['output'];
  setMerchantCreditCard: MerchantCreditCard;
  setMfaRequired?: Maybe<Scalars['Void']['output']>;
  setProductInterests: Scalars['Boolean']['output'];
  setSettingsFeature: Settings;
  setStablecoinExpressRoute: StablecoinExpressRoute;
  setWatchListEntry: SetWatchListEntry;
  setWireBankAccountMetadata: WireBankAccount;
  submitAddressBookApprovalVote?: Maybe<Scalars['Void']['output']>;
  submitEmailApprovalVote?: Maybe<Scalars['Void']['output']>;
  submitWalletApprovalDraftPolicy?: Maybe<Scalars['Void']['output']>;
  testPushInAppNotificationMessage?: Maybe<Scalars['Void']['output']>;
  travelRuleSpeDispute?: Maybe<Scalars['Void']['output']>;
  travelRuleSpeRequestOtp?: Maybe<Scalars['Void']['output']>;
  travelRuleSpeVerifyOtp?: Maybe<Scalars['Void']['output']>;
  travelRuleSubmitSpePii?: Maybe<Scalars['Void']['output']>;
  updateAPIKey?: Maybe<Scalars['Void']['output']>;
  updateAndReturnEmailVerified: Scalars['Boolean']['output'];
  updateAutoPay: Scalars['Boolean']['output'];
  updateBillingProfile?: Maybe<Scalars['Void']['output']>;
  updateCardPaymentMethod?: Maybe<Scalars['Void']['output']>;
  updateOnboardingData: Scalars['Boolean']['output'];
  updatePinCode?: Maybe<Scalars['Void']['output']>;
  upsertWalletApprovalDraftPolicy?: Maybe<Scalars['Void']['output']>;
  walletApprovalCreateOnchainTransfer?: Maybe<CreateTransferResponse>;
  walletApprovalCreatePayoutTransfer?: Maybe<Scalars['Void']['output']>;
}


export interface MutationActivateMfaArgs {
  code: Scalars['String']['input'];
  factorId: Scalars['ID']['input'];
}


export interface MutationAddBlockchainDepositAddressesArgs {
  input: Array<AddBlockchainDepositAddressInput>;
}


export interface MutationAddBlockchainRecipientAddressArgs {
  input: AddBlockchainRecipientAddressInput;
}


export interface MutationAddCaBankAccountArgs {
  bankAccount: AddCaBankAccountInput;
}


export interface MutationAddCbitBankAccountArgs {
  input: AddCbitBankAccountInput;
}


export interface MutationAddCubixBankAccountArgs {
  input: AddCubixBankAccountInput;
}


export interface MutationAddEntriesToWatchListArgs {
  input: AddEntriesToWatchListInput;
}


export interface MutationAddIbanBankAccountArgs {
  bankAccount: AddIbanBankAccountInput;
}


export interface MutationAddMerchantCreditCardArgs {
  merchantCreditCardInput: MerchantCreditCardInput;
}


export interface MutationAddOtherBankAccountArgs {
  bankAccount: AddOtherBankAccountInput;
}


export interface MutationAddPaymentMethodArgs {
  isDefault: Scalars['Boolean']['input'];
  paymentProviderPaymentMethodId: Scalars['String']['input'];
}


export interface MutationAddPixBankAccountArgs {
  input: AddPixBankAccountInput;
}


export interface MutationAddRtpBankAccountArgs {
  input: AddRtpBankAccountInput;
}


export interface MutationAddUsBankAccountArgs {
  bankAccount: AddUsBankAccountInput;
}


export interface MutationAddUserArgs {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationAddXpayBankAccountArgs {
  input: AddXpayBankAccountInput;
}


export interface MutationCancelPendingUserProposalArgs {
  proposalId: Scalars['String']['input'];
}


export interface MutationCancelSubmittedSettingsChangeArgs {
  policyId: Scalars['ID']['input'];
}


export interface MutationCancelWalletApprovalPendingTransactionArgs {
  proposalId: Scalars['String']['input'];
}


export interface MutationCancelWalletApprovalSubmittedPolicyArgs {
  input: ManageWalletApprovalPolicyInput;
}


export interface MutationChangePasswordArgs {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}


export interface MutationCompleteInviteArgs {
  input: CompleteInviteInput;
}


export interface MutationCreateApiKeyArgs {
  input: CreateApiKeyInput;
}


export interface MutationCreateAccountArgs {
  input: CreateAccountInput;
}


export interface MutationCreateBlockchainRecipientAddressWithMetadataArgs {
  input: CreateBlockchainRecipientAddressWithMetadataInput;
}


export interface MutationCreateCardSetupArgs {
  userEmail: Scalars['String']['input'];
}


export interface MutationCreateDeleteUserGroupProposalArgs {
  input: CreateDeleteUserGroupProposalInput;
}


export interface MutationCreateIpAllowListingIpAddressArgs {
  input: CreateIpAllowListingIpAddressInput;
}


export interface MutationCreateNotificationSubscriptionArgs {
  input: CreateNotificationSubscriptionInput;
}


export interface MutationCreatePayoutArgs {
  input: CreatePayoutInput;
}


export interface MutationCreateRolrAccountArgs {
  input: CreateRolrAccountInput;
}


export interface MutationCreateSettlementCreditTransferArgs {
  input: SettlementCreditTransferInput;
}


export interface MutationCreateStablecoinExpressDepositRouteArgs {
  input: CreateStablecoinExpressDepositRouteInput;
}


export interface MutationCreateStablecoinExpressWithdrawalRouteArgs {
  input: CreateStablecoinExpressWithdrawalRouteInput;
}


export interface MutationCreateTradeArgs {
  quoteId: Scalars['ID']['input'];
}


export interface MutationCreateUpdateUserGroupProposalArgs {
  input: CreateUpdateUserGroupProposalInput;
}


export interface MutationCreateUserGroupArgs {
  input: CreateUserGroupInput;
}


export interface MutationDeleteNotificationSubscriptionArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDiscardWalletApprovalDraftPolicyArgs {
  input: ManageWalletApprovalPolicyInput;
}


export interface MutationEnrollPinCodeArgs {
  code: Scalars['String']['input'];
}


export interface MutationInviteAuthorizedRepArgs {
  input: InviteAuthorizedRepInput;
}


export interface MutationInviteUserArgs {
  invitee: InviteeInput;
}


export interface MutationInviteUserWithAdminApprovalArgs {
  input: AdminApprovalsUserInvite;
}


export interface MutationInvoicePaymentArgs {
  invoicePaymentInput: InvoicePaymentInput;
}


export interface MutationMarkInAppNotificationsAsReadArgs {
  notificationIds: Array<Scalars['ID']['input']>;
}


export interface MutationMerchantPaymentCancellationArgs {
  input: MerchantPaymentCancellationInput;
}


export interface MutationMerchantPaymentIntentRefundArgs {
  input: MerchantPaymentIntentRefundInput;
}


export interface MutationMerchantPaymentRefundArgs {
  input: MerchantPaymentRefundInput;
}


export interface MutationOnboardingCreateMsaOperationArgs {
  input: MsaOperationInput;
}


export interface MutationOnboardingCreateRfiUserCommentArgs {
  input: OnboardingCreateRfiUserCommentInput;
}


export interface MutationOnboardingDeleteGroupValueArgs {
  input: OnboardingDeleteGroupValueInput;
}


export interface MutationOnboardingMarkRfisAsRespondedArgs {
  input: OnboardingMarkRfisAsRespondedInput;
}


export interface MutationOnboardingSaveFieldValuesV2Args {
  input: OnboardingSaveFieldValuesV2Input;
}


export interface MutationOnboardingSubmitApplicationArgs {
  input: OnboardingApplicationSubmissionInput;
}


export interface MutationOnboardingUploadDocumentWithoutLinkingArgs {
  document: OnboardingUploadDocumentWithoutLinkingInput;
  onboardingId: Scalars['ID']['input'];
}


export interface MutationRemoveBlockchainRecipientAddressArgs {
  addressId: Scalars['ID']['input'];
}


export interface MutationRemoveIpAllowListingIpAddressArgs {
  id: Scalars['ID']['input'];
}


export interface MutationRemoveMerchantCreditCardArgs {
  id: Scalars['String']['input'];
}


export interface MutationRemoveUserArgs {
  email: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationRemoveUserWithAdminApprovalArgs {
  userId: Scalars['String']['input'];
}


export interface MutationResendInviteArgs {
  email: Scalars['String']['input'];
}


export interface MutationResendUserActivationArgs {
  email: Scalars['String']['input'];
}


export interface MutationResetMfaRequestArgs {
  input: ResetMfaRequestInput;
}


export interface MutationRevokeApiKeyArgs {
  keyId: Scalars['ID']['input'];
}


export interface MutationSandboxSignupArgs {
  input: SandboxSignupInput;
}


export interface MutationSetAdminApprovalsSettingsArgs {
  input: AdminApprovalsSettingsInput;
}


export interface MutationSetBankAccountNicknameArgs {
  accountType: BankAccountType;
  bankAccountId: Scalars['ID']['input'];
  nickname: Scalars['String']['input'];
}


export interface MutationSetBlockchainRecipientAddressAdditionalInfoArgs {
  input: SetRecipientAddressAdditionalInfoInput;
}


export interface MutationSetBlockchainRecipientAddressBeneficiaryInfoArgs {
  input: SetRecipientAddressBeneficiaryInfoInput;
}


export interface MutationSetBlockchainRecipientAddressWithMetadataArgs {
  input: SetBlockchainRecipientAddressWithMetadataInput;
}


export interface MutationSetDefaultPaymentMethodArgs {
  defaultPaymentMethodInput: DefaultPaymentMethodInput;
}


export interface MutationSetDelayedWithdrawalsSettingsArgs {
  input: DelayedWithdrawalsSettingsInput;
}


export interface MutationSetIpAllowListingSettingArgs {
  enabled: Scalars['Boolean']['input'];
}


export interface MutationSetMerchantCreditCardArgs {
  setMerchantCreditCardInput: SetMerchantCreditCardInput;
}


export interface MutationSetProductInterestsArgs {
  input: SetProductInterestsInput;
}


export interface MutationSetSettingsFeatureArgs {
  type: SettingsFeaturesType;
}


export interface MutationSetStablecoinExpressRouteArgs {
  input: StablecoinExpressRouteInput;
}


export interface MutationSetWatchListEntryArgs {
  input: SetWatchListEntryInput;
}


export interface MutationSetWireBankAccountMetadataArgs {
  input: SetWireBankAccountMetadataInput;
}


export interface MutationSubmitAddressBookApprovalVoteArgs {
  input: SubmitAddressBookApprovalVoteInput;
}


export interface MutationSubmitEmailApprovalVoteArgs {
  input: SubmitEmailApprovalVoteInput;
}


export interface MutationSubmitWalletApprovalDraftPolicyArgs {
  input: ManageWalletApprovalPolicyInput;
}


export interface MutationTravelRuleSpeDisputeArgs {
  linkId: Scalars['String']['input'];
}


export interface MutationTravelRuleSpeRequestOtpArgs {
  linkId: Scalars['String']['input'];
}


export interface MutationTravelRuleSpeVerifyOtpArgs {
  linkId: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}


export interface MutationTravelRuleSubmitSpePiiArgs {
  input: TravelRuleSubmitSpePiiInput;
}


export interface MutationUpdateApiKeyArgs {
  input: UpdateApiKeyInput;
}


export interface MutationUpdateAutoPayArgs {
  automaticPaymentEnabled: Scalars['Boolean']['input'];
}


export interface MutationUpdateBillingProfileArgs {
  input: UpdateBillingProfileInput;
}


export interface MutationUpdateCardPaymentMethodArgs {
  cardId: Scalars['String']['input'];
  input: UpdateCardPaymentMethodInput;
  isDefault: Scalars['Boolean']['input'];
}


export interface MutationUpdateOnboardingDataArgs {
  input: UpdateOnboardingDataInput;
}


export interface MutationUpdatePinCodeArgs {
  input: UpdatePinCodeInput;
}


export interface MutationUpsertWalletApprovalDraftPolicyArgs {
  input: UpsertWalletApprovalPolicyInput;
}


export interface MutationWalletApprovalCreateOnchainTransferArgs {
  input: CreateTransferInput;
}


export interface MutationWalletApprovalCreatePayoutTransferArgs {
  input: CreatePayoutInput;
}

export interface NetRedemptionFee {
  __typename?: 'NetRedemptionFee';
  payment: NetRedemptionFeePayment;
}

export interface NetRedemptionFeePayment extends PaginatedType {
  __typename?: 'NetRedemptionFeePayment';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: TransactionStatus;
  type: TransactionType;
  updateDate: Scalars['DateTime']['output'];
}

export enum NetworkFeePayer {
  endUser = 'endUser',
  merchant = 'merchant'
}

export interface NotificationSubscription {
  __typename?: 'NotificationSubscription';
  endpoint: Scalars['Url']['output'];
  id: Scalars['ID']['output'];
  status: NotificationSubscriptionStatus;
  subscriptionDetails: Array<NotificationSubscriptionDetail>;
}

export interface NotificationSubscriptionDetail {
  __typename?: 'NotificationSubscriptionDetail';
  status: NotificationSubscriptionStatus;
  url: Scalars['Url']['output'];
}

export enum NotificationSubscriptionStatus {
  confirmed = 'confirmed',
  deleted = 'deleted',
  pending = 'pending'
}

export enum OktaStatusType {
  ACTIVE = 'ACTIVE',
  DEPROVISIONED = 'DEPROVISIONED',
  INCOMPLETE_INVITE = 'INCOMPLETE_INVITE',
  LOCKED_OUT = 'LOCKED_OUT',
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  PROVISIONED = 'PROVISIONED',
  RECOVERY = 'RECOVERY',
  STAGED = 'STAGED',
  SUSPENDED = 'SUSPENDED'
}

export interface OktaVerifyActivationStatus {
  __typename?: 'OktaVerifyActivationStatus';
  status: FactorActivationStatus;
}

export interface OktaVerifyActivationStatusInput {
  factorId: Scalars['String']['input'];
}

export enum OnboardingActiveUsers {
  from0to9k = 'from0to9k',
  from10kto49k = 'from10kto49k',
  from50kto249k = 'from50kto249k',
  from250kto1mil = 'from250kto1mil',
  notApplicable = 'notApplicable',
  over1mil = 'over1mil'
}

export interface OnboardingApplication {
  __typename?: 'OnboardingApplication';
  applicableJurisdiction: Jurisdiction;
  onboardingId: Scalars['ID']['output'];
  operationType: OnboardingApplicationOperationType;
  status: OnboardingApplicationStatus;
}

export enum OnboardingApplicationOperationType {
  CUSTOMER_INFO_EDIT = 'CUSTOMER_INFO_EDIT',
  KYC = 'KYC',
  LEGAL_ENTITY_MIGRATION = 'LEGAL_ENTITY_MIGRATION',
  ONBOARDING_APPLICATION = 'ONBOARDING_APPLICATION',
  PERIODIC_REVIEW = 'PERIODIC_REVIEW'
}

export enum OnboardingApplicationStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  DENIED = 'DENIED',
  DRAFT = 'DRAFT',
  PENDING_CUSTOMER_INFORMATION = 'PENDING_CUSTOMER_INFORMATION',
  SUBMITTED = 'SUBMITTED',
  UNDER_REVIEW = 'UNDER_REVIEW'
}

export interface OnboardingApplicationSubmission {
  __typename?: 'OnboardingApplicationSubmission';
  onboardingId: Scalars['ID']['output'];
  status: OnboardingApplicationStatus;
}

export interface OnboardingApplicationSubmissionInput {
  certificationIds: Array<Scalars['String']['input']>;
  onboardingId: Scalars['ID']['input'];
}

export interface OnboardingCertification {
  __typename?: 'OnboardingCertification';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: OnboardingCertificationType;
}

export enum OnboardingCertificationType {
  AUTHORIZED_REPRESENTATIVE = 'AUTHORIZED_REPRESENTATIVE',
  JUMIO_NOTICE = 'JUMIO_NOTICE',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE'
}

export interface OnboardingChildSection {
  __typename?: 'OnboardingChildSection';
  data?: Maybe<Array<OnboardingGroupDataV2>>;
  groups?: Maybe<Array<Maybe<OnboardingChildSection>>>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: L3OnboardingFlowGroup;
  overviewGroups?: Maybe<Array<L3OnboardingFlowGroup>>;
  rfiBundle?: Maybe<OnboardingRfiBundle>;
  rfiComments?: Maybe<Array<OnboardingRfiComment>>;
  status?: Maybe<L3OnboardingOverviewGroupStatus>;
}

export interface OnboardingCompanyInfo {
  activeUsersOnPlatform?: InputMaybe<Scalars['String']['input']>;
  businessCountry: Scalars['String']['input'];
  businessEntityName: Scalars['String']['input'];
  businessState: Scalars['String']['input'];
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  expectedUsdcMintingVolume?: InputMaybe<Scalars['String']['input']>;
  natureOfBusiness: Scalars['String']['input'];
}

export interface OnboardingCreateRfiUserCommentInput {
  operationId: Scalars['ID']['input'];
  userComment: OnboardingRfiCommentInput;
}

export interface OnboardingDeleteGroupValueInput {
  groupId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
  refId: Scalars['ID']['input'];
}

export interface OnboardingDocument {
  __typename?: 'OnboardingDocument';
  documentId: Scalars['ID']['output'];
  documentType?: Maybe<DocumentType>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  issuedCountry?: Maybe<CountryCode>;
  uploadDate: Scalars['String']['output'];
}

export enum OnboardingEntityType {
  associationOrConsortium = 'associationOrConsortium',
  coop = 'coop',
  foundation = 'foundation',
  governmentBody = 'governmentBody',
  partnership = 'partnership',
  privateCo = 'privateCo',
  publicCo = 'publicCo',
  soleTrader = 'soleTrader',
  trust = 'trust'
}

export interface OnboardingFieldValueV2 {
  __typename?: 'OnboardingFieldValueV2';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rfiComment?: Maybe<Scalars['String']['output']>;
  rfiId?: Maybe<Scalars['String']['output']>;
  rfiStatus: RfiFieldStatus;
  value: Scalars['String']['output'];
}

export interface OnboardingFieldValueV2Input {
  name: Scalars['String']['input'];
  refId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
}

export interface OnboardingGroupDataGroupsInput {
  id: Scalars['ID']['input'];
  name: L3OnboardingFlowGroup;
}

export interface OnboardingGroupDataV2 {
  __typename?: 'OnboardingGroupDataV2';
  groupName: Scalars['String']['output'];
  groupSchema: Array<OnboardingSchemaFieldV2>;
  groupValues: Array<OnboardingGroupValueV2>;
  id: Scalars['ID']['output'];
}

export interface OnboardingGroupDataV2Input {
  groupsInput: Array<OnboardingGroupDataGroupsInput>;
  operationId: Scalars['ID']['input'];
}

export interface OnboardingGroupSectionFilter {
  excludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  includeChildSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface OnboardingGroupValueV2 {
  __typename?: 'OnboardingGroupValueV2';
  fields: Array<OnboardingFieldValueV2>;
  groupId: Scalars['ID']['output'];
  refId: Scalars['ID']['output'];
}

export enum OnboardingLevel {
  LEVEL_3 = 'LEVEL_3',
  LEVEL_3_ADDITIONAL_USER = 'LEVEL_3_ADDITIONAL_USER',
  LEVEL_3_CORE_MSA = 'LEVEL_3_CORE_MSA',
  LEVEL_3_ROLR = 'LEVEL_3_ROLR',
  LEVEL_3_TRADE_MSA = 'LEVEL_3_TRADE_MSA'
}

export interface OnboardingMarkRfisAsRespondedInput {
  rfiIds: Array<Scalars['ID']['input']>;
}

export enum OnboardingMintingVolume {
  from0to49k = 'from0to49k',
  from50kto99k = 'from50kto99k',
  from100kto249k = 'from100kto249k',
  from250kto499k = 'from250kto499k',
  from500kto1mil = 'from500kto1mil',
  over1mil = 'over1mil'
}

export interface OnboardingNatureOfBusiness {
  __typename?: 'OnboardingNatureOfBusiness';
  name: Scalars['String']['output'];
  prohibited: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
}

export interface OnboardingNaturesOfBusinessInput {
  excludeProhibited?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface OnboardingOverviewSection {
  __typename?: 'OnboardingOverviewSection';
  groups: Array<OnboardingChildSection>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: L3OnboardingFlowGroup;
}

/** OnboardingQualifications types */
export interface OnboardingQualifications {
  __typename?: 'OnboardingQualifications';
  kyb?: Maybe<KybQualificationDetail>;
  kyc?: Maybe<KycQualificationDetail>;
}

export enum OnboardingQuarterlyMintingVolume {
  from1milto5mil = 'from1milto5mil',
  from250kto499k = 'from250kto499k',
  from500kto1mil = 'from500kto1mil',
  over5mil = 'over5mil'
}

export interface OnboardingRepresentativeInfo {
  authorizedEmail: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isAuthorizedRepresentative: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  nonAuthorizedEmail?: InputMaybe<Scalars['String']['input']>;
}

export interface OnboardingRfiBundle {
  __typename?: 'OnboardingRfiBundle';
  createDate: Scalars['DateTime']['output'];
  fields?: Maybe<Array<OnboardingRfiField>>;
  id: Scalars['ID']['output'];
  status?: Maybe<RfiBundleStatus>;
}

export interface OnboardingRfiBundleInput {
  groupNames?: InputMaybe<Array<Scalars['String']['input']>>;
  operationId: Scalars['ID']['input'];
}

export interface OnboardingRfiComment {
  __typename?: 'OnboardingRfiComment';
  authorType: CommentAuthorType;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rfiId?: Maybe<Scalars['ID']['output']>;
}

export interface OnboardingRfiCommentInput {
  content: Scalars['String']['input'];
  rfiId: Scalars['String']['input'];
}

export interface OnboardingRfiField {
  __typename?: 'OnboardingRfiField';
  elementName: Scalars['String']['output'];
  elementType: RfiElementType;
  fieldId: Scalars['String']['output'];
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  refId: Scalars['String']['output'];
  responded: Scalars['Boolean']['output'];
  rfiType: RfiType;
}

export interface OnboardingRfiGroupComments {
  __typename?: 'OnboardingRfiGroupComments';
  circleComment?: Maybe<OnboardingRfiComment>;
  userComment?: Maybe<OnboardingRfiComment>;
}

export interface OnboardingRfiGroupCommentsInput {
  groupName: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
}

export interface OnboardingSaveFieldValuesV2Input {
  fieldValues: Array<OnboardingFieldValueV2Input>;
  groupId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}

export interface OnboardingSchemaFieldV2 {
  __typename?: 'OnboardingSchemaFieldV2';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  type: FieldType;
}

export interface OnboardingUploadDocumentResponse {
  __typename?: 'OnboardingUploadDocumentResponse';
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentType: DocumentType;
  entityId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  issuedCountry?: Maybe<CountryCode>;
  uploadDate: Scalars['String']['output'];
}

export interface OnboardingUploadDocumentWithoutLinkingInput {
  datumName: Scalars['String']['input'];
  documentType?: InputMaybe<DocumentType>;
  file: Scalars['Upload']['input'];
}

export interface OnchainReceive {
  __typename?: 'OnchainReceive';
  explorerLink?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  source?: Maybe<BlockchainRecipientAddressLocation>;
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export interface OnchainSend {
  __typename?: 'OnchainSend';
  destination?: Maybe<BlockchainRecipientAddressLocation>;
  explorerLink?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export interface OptionalAmountInput {
  amount?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
}

export interface OrganizationConfigurations {
  __typename?: 'OrganizationConfigurations';
  /** `userLimit` is no longer used in the UI -- remove once we have other configs */
  userLimit?: Maybe<Scalars['Int']['output']>;
}

export interface OtherBankAddressInput {
  bankName: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
}

export interface PaginatedType {
  id: Scalars['ID']['output'];
}

export interface PaginationExtends {
  links: PaginationLinks;
  list: Array<PaginatedType>;
}

export interface PaginationInput {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageAfter?: InputMaybe<Scalars['ID']['input']>;
  pageBefore?: InputMaybe<Scalars['ID']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface PaginationLink {
  __typename?: 'PaginationLink';
  from?: Maybe<Scalars['DateTime']['output']>;
  pageAfter?: Maybe<Scalars['ID']['output']>;
  pageBefore?: Maybe<Scalars['ID']['output']>;
  pageSize: Scalars['Int']['output'];
  to?: Maybe<Scalars['DateTime']['output']>;
}

export interface PaginationLinks {
  __typename?: 'PaginationLinks';
  next?: Maybe<PaginationLink>;
  prev?: Maybe<PaginationLink>;
}

export interface PartialAmount {
  __typename?: 'PartialAmount';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
}

export interface Payment extends PaginatedType {
  __typename?: 'Payment';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  fiatTransactionType?: Maybe<FiatTransactionType>;
  id: Scalars['ID']['output'];
  status: TransactionStatus;
  type: TransactionType;
  updateDate: Scalars['DateTime']['output'];
}

export type PaymentDetails = CbitReceive | CbitWithdrawal | CubixReceive | CubixWithdrawal | GrossRedemptionFee | NetRedemptionFee | OnchainReceive | OnchainSend | RtpReceive | RtpWithdrawal | SenReceive | SenWithdrawal | SepaInstantReceive | SepaInstantWithdrawal | SepaReceive | SepaWithdrawal | SettlementCreditFee | SettlementCreditReceive | SignetReceive | SignetWithdrawal | WireReceive | WireWithdrawal | XpayReceive | XpayWithdrawal;

export interface PaymentInput {
  currency?: InputMaybe<Currency>;
  refId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Array<TransactionType>>;
}

export enum PaymentMethodType {
  card = 'card',
  wallet = 'wallet'
}

export enum PaymentTransactionType {
  blockchain_wallet = 'blockchain_wallet',
  book_transfer = 'book_transfer',
  cbit_receive = 'cbit_receive',
  cbit_withdrawal = 'cbit_withdrawal',
  cubix_receive = 'cubix_receive',
  cubix_withdrawal = 'cubix_withdrawal',
  fees = 'fees',
  internal_transfer = 'internal_transfer',
  onchain_transfer = 'onchain_transfer',
  pix_receive = 'pix_receive',
  pix_withdrawal = 'pix_withdrawal',
  rtp_receive = 'rtp_receive',
  rtp_withdrawal = 'rtp_withdrawal',
  sepa_instant_receive = 'sepa_instant_receive',
  sepa_instant_withdrawal = 'sepa_instant_withdrawal',
  sepa_receive = 'sepa_receive',
  sepa_withdrawal = 'sepa_withdrawal',
  signet_receive = 'signet_receive',
  signet_withdrawal = 'signet_withdrawal',
  wire_receive = 'wire_receive',
  wire_withdrawal = 'wire_withdrawal',
  xpay_receive = 'xpay_receive',
  xpay_withdrawal = 'xpay_withdrawal'
}

export enum PaymentType {
  card = 'card',
  wallet = 'wallet'
}

export interface Payments extends PaginationExtends {
  __typename?: 'Payments';
  links: PaginationLinks;
  list: Array<Payment>;
}

export interface Payout {
  __typename?: 'Payout';
  adjustments?: Maybe<PayoutAdjustments>;
  amount?: Maybe<Amount>;
  createDate: Scalars['DateTime']['output'];
  destination?: Maybe<PayoutDestination>;
  errorCode?: Maybe<PayoutErrorCode>;
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  return?: Maybe<PayoutReturn>;
  riskEvaluation?: Maybe<RiskEvaluation>;
  sourceWalletId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayoutStatus>;
  toAmount?: Maybe<PartialAmount>;
  trackingRef?: Maybe<Scalars['String']['output']>;
  updateDate: Scalars['DateTime']['output'];
}

export interface PayoutAdjustments {
  __typename?: 'PayoutAdjustments';
  fxCredit?: Maybe<Amount>;
  fxDebit?: Maybe<Amount>;
}

export interface PayoutDestination {
  __typename?: 'PayoutDestination';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export enum PayoutErrorCode {
  bank_transaction_error = 'bank_transaction_error',
  fiat_account_limit_exceeded = 'fiat_account_limit_exceeded',
  insufficient_funds = 'insufficient_funds',
  intermediary_bank_required = 'intermediary_bank_required',
  invalid_ach_rtn = 'invalid_ach_rtn',
  invalid_bank_account_number = 'invalid_bank_account_number',
  invalid_wire_rtn = 'invalid_wire_rtn',
  transaction_denied = 'transaction_denied',
  transaction_failed = 'transaction_failed',
  transaction_returned = 'transaction_returned',
  vendor_inactive = 'vendor_inactive'
}

export interface PayoutReturn {
  __typename?: 'PayoutReturn';
  amount?: Maybe<Amount>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  payoutId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayoutStatus>;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export enum PayoutStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export interface PciPublicKey {
  __typename?: 'PciPublicKey';
  keyId?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
}

/** PeriodicReviewLegacyQualification types */
export interface PeriodicReviewLegacyQualification {
  __typename?: 'PeriodicReviewLegacyQualification';
  properties?: Maybe<PeriodicReviewProperties>;
  state?: Maybe<QualificationUiState>;
}

export interface PeriodicReviewProperties {
  __typename?: 'PeriodicReviewProperties';
  dueDate?: Maybe<Scalars['Float']['output']>;
}

/** PeriodicReviewQualification types */
export interface PeriodicReviewQualification {
  __typename?: 'PeriodicReviewQualification';
  actionRequired: Scalars['Boolean']['output'];
  dayRemaining?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  inProgress: Scalars['Boolean']['output'];
}

export interface PixBankAccount {
  __typename?: 'PixBankAccount';
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  transferTypes?: Maybe<Array<Maybe<TransferTypes>>>;
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface PixReceive {
  __typename?: 'PixReceive';
  payment: Payment;
  source?: Maybe<PixBankAccount>;
}

export enum PixTransactionType {
  pix_receive = 'pix_receive',
  pix_withdrawal = 'pix_withdrawal'
}

export interface PixTransferInstruction {
  __typename?: 'PixTransferInstruction';
  accountNumber: Scalars['String']['output'];
  accountType?: Maybe<Scalars['String']['output']>;
  branchCode?: Maybe<Scalars['String']['output']>;
  compe?: Maybe<Scalars['String']['output']>;
  ispb?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
}

export interface PixWithdrawal {
  __typename?: 'PixWithdrawal';
  destination?: Maybe<PixBankAccount>;
  payment: Payment;
}

export interface PreQualAutoApprovedNotification extends BaseInAppNotification, PaginatedType {
  __typename?: 'PreQualAutoApprovedNotification';
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  payload: PreQualAutoApprovedNotificationPayload;
  type: InAppNotificationType;
}

export interface PreQualAutoApprovedNotificationPayload {
  __typename?: 'PreQualAutoApprovedNotificationPayload';
  approved: Scalars['Boolean']['output'];
}

export interface PreQualificationData {
  __typename?: 'PreQualificationData';
  activeUsersOnPlatform?: Maybe<Scalars['String']['output']>;
  businessCountry: CountryCode;
  businessEntityName: Scalars['String']['output'];
  businessState?: Maybe<Scalars['String']['output']>;
  businessWebsite?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eurcRedemptionAmount?: Maybe<Scalars['Float']['output']>;
  expectedUsdcMintingVolume?: Maybe<Scalars['String']['output']>;
  natureOfBusiness?: Maybe<Scalars['String']['output']>;
  state: PreQualificationState;
  usdcRedemptionAmount?: Maybe<Scalars['Float']['output']>;
}

export enum PreQualificationState {
  APPROVED = 'APPROVED',
  PENDING_CONFIRM = 'PENDING_CONFIRM',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED'
}

/** Product interests */
export enum ProductInterest {
  account = 'account',
  api = 'api'
}

export interface Proposal {
  approverGroup: ApproverUserGroup;
  createdAt: Scalars['DateTime']['output'];
  events: Array<ProposalEvent>;
  id: Scalars['String']['output'];
  initiator: UserGroupMember;
  requires: ApprovalPolicyQuorumType;
  status: ProposalStatusType;
  type: ProposalType;
}

export interface ProposalEvent {
  __typename?: 'ProposalEvent';
  createdAt: Scalars['DateTime']['output'];
  performedBy: UserGroupMember;
  type: ProposalEventType;
}

export enum ProposalEventType {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT'
}

export enum ProposalStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED'
}

export enum ProposalStatusType {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum ProposalType {
  DELETE_GROUP = 'DELETE_GROUP'
}

export interface Proposals {
  __typename?: 'Proposals';
  deleteGroup?: Maybe<Array<DeleteGroupProposal>>;
}

export interface ProposalsInput {
  status: ProposalStatusType;
  type: ProposalType;
}

export enum ProviderNetwork {
  TRUST = 'TRUST'
}

/** QualificationProgress types */
export interface QualificationProgress {
  __typename?: 'QualificationProgress';
  state: QualificationUiState;
}

export enum QualificationType {
  kyb = 'kyb',
  kyc = 'kyc',
  periodic_review = 'periodic_review'
}

export enum QualificationUiState {
  beforeSubmission = 'beforeSubmission',
  cancelled = 'cancelled',
  confirmed = 'confirmed',
  error = 'error',
  incomplete = 'incomplete',
  notFound = 'notFound',
  pendingReview = 'pendingReview',
  pendingRevision = 'pendingRevision',
  pendingSignature = 'pendingSignature',
  pendingSubmission = 'pendingSubmission',
  rejected = 'rejected'
}

export interface QualificationsSummary {
  __typename?: 'QualificationsSummary';
  kyb: KybSummary;
  kyc: KycSummary;
}

export interface Query {
  __typename?: 'Query';
  accountSetupInfo: AccountSetupInfo;
  aceBlockchainDepositAddress?: Maybe<BlockchainDepositAddress>;
  activeWalletApprovalPolicy?: Maybe<WalletApprovalPolicy>;
  addressBook: AddressBook;
  addressBookProposal: AddressBookProposal;
  adminApprovalsSettings: Array<AdminApprovalsPolicy>;
  allInAppNotifications: InAppNotifications;
  apiKey: ApiKey;
  apiKeySettings: ApiKeySettings;
  apiKeys: Array<ApiKey>;
  apiLogs: ApiLogs;
  approvalPolicies: ApprovalPolicies;
  balances: Balances;
  bankAccounts: Array<BankAccount>;
  billingProfile?: Maybe<BillingProfileDetails>;
  blockchainAssets: Array<BlockchainAsset>;
  blockchainDepositAddress: BlockchainDepositAddress;
  blockchainDepositAddresses: Array<BlockchainDepositAddress>;
  blockchainRecipientAddressWithMetadata?: Maybe<BlockchainRecipientAddressWithMetadata>;
  blockchainRecipientAddresses: Array<BlockchainRecipientAddress>;
  blockchainRecipientAddressesWithMetadata: Array<BlockchainRecipientAddressWithMetadata>;
  blockchains: Array<Blockchain>;
  cardPayment: CardPayment;
  cardPaymentMethodById: CardPaymentMethod;
  cardPaymentMethods: CardPaymentMethods;
  cbitBankAccount: CbitBankAccount;
  chainedTransfer: Transfer;
  circleWallets: Array<CircleWallet>;
  circleWalletsFtuStatus: CircleWalletsFtuStatus;
  clientIpAddress: ClientIpAddress;
  countries: Countries;
  cubixBankAccount: CubixBankAccount;
  custodyBalances: CustodyAmount;
  dailyLimits: Array<DailyLimit>;
  defaultPaymentMethod?: Maybe<DefaultPaymentMethod>;
  delayedWithdrawalsSettings: DelayedWithdrawalsSettings;
  deposit: Deposit;
  downloadReport: DownloadReport;
  draftWalletApprovalPolicy: WalletApprovalPolicy;
  eligibleUserFactors: Array<EligibleUserFactor>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  entity?: Maybe<Entity>;
  entityLimits?: Maybe<EntityLimits>;
  factor?: Maybe<Factor>;
  feeReports: FeeReports;
  filteredLongPollInAppNotification?: Maybe<InAppNotification>;
  fxQuote: FxQuote;
  identityChallenge: IdentityChallenge;
  incompleteChainedTransfers?: Maybe<Array<IncompleteChainedTransfer>>;
  internalAddresses: Array<InternalAddress>;
  invoiceDetail: InvoiceDetail;
  invoicePaymentDetail: InvoicePaymentDetail;
  invoices: Invoices;
  ipAllowListingIpAddresses: Array<IpAllowListingIpAddress>;
  ipAllowListingSetting: IpAllowListingSetting;
  longPollEmailVerifiedNotification?: Maybe<EmailVerifiedNotification>;
  longPollInAppNotification?: Maybe<InAppNotification>;
  manageableUsers: Array<User>;
  merchantAchBankAccount: MerchantAchBankAccount;
  merchantChargeback: MerchantChargeback;
  merchantChargebacks: MerchantChargebacks;
  merchantPayment: MerchantPayment;
  merchantPaymentIntent: MerchantPaymentIntent;
  merchantPaymentIntents: MerchantPaymentIntents;
  merchantPayments: MerchantPayments;
  merchantPayout: MerchantPayout;
  merchantPayouts: MerchantPayouts;
  merchantSepaBankAccount: MerchantSepaBankAccount;
  merchantWireBankAccount: MerchantWireBankAccount;
  notificationSubscriptions: Array<NotificationSubscription>;
  oktaVerifyActivationStatus: OktaVerifyActivationStatus;
  onboardingApplication?: Maybe<OnboardingApplication>;
  onboardingCertifications: Array<OnboardingCertification>;
  onboardingChildSections?: Maybe<Array<OnboardingChildSection>>;
  onboardingGroupDataV2: Array<OnboardingGroupDataV2>;
  onboardingMsaOperation?: Maybe<MsaOperationResponse>;
  onboardingNaturesOfBusiness: Array<OnboardingNatureOfBusiness>;
  onboardingOverviewSectionsV2?: Maybe<Array<OnboardingOverviewSection>>;
  onboardingQualifications: OnboardingQualifications;
  onboardingRfiBundle?: Maybe<OnboardingRfiBundle>;
  onboardingRfiGroupComments?: Maybe<OnboardingRfiGroupComments>;
  organizationConfigurations?: Maybe<OrganizationConfigurations>;
  paymentDetails: PaymentDetails;
  payments: Payments;
  payout: Payout;
  pciPublicKey: PciPublicKey;
  pendingOnchainReceives: Array<OnchainReceive>;
  periodicReviewLegacyQualification: PeriodicReviewLegacyQualification;
  periodicReviewQualification?: Maybe<PeriodicReviewQualification>;
  pixBankAccount: PixBankAccount;
  preQualificationData?: Maybe<PreQualificationData>;
  proposals: Proposals;
  qualificationProgress: QualificationProgress;
  qualificationsSummary?: Maybe<QualificationsSummary>;
  report: Report;
  reversal: Reversal;
  reversals: Reversals;
  rolrSettings?: Maybe<RolrSettings>;
  rtpBankAccount: RtpBankAccount;
  scaFactorInfo: ScaFactorInfo;
  senBankAccount: SenBankAccount;
  settings: Settings;
  settlement: Settlement;
  settlementCreditLines: Array<SettlementCreditLine>;
  settlementCreditTransfer: SettlementCreditTransferDetails;
  settlementCreditTransferFee: SettlementCreditTransferFee;
  settlementCreditTransferFees: SettlementCreditTransferFees;
  settlementCreditTransferValidation: Array<SettlementCreditTransferValidation>;
  settlementCreditTransfers: SettlementCreditTransfers;
  settlementCreditWireInstruction: SettlementCreditWireInstruction;
  settlements: Settlements;
  signInFactor: SignInFactor;
  signetBankAccount: SignetBankAccount;
  stablecoinExpressRoutes: Array<StablecoinExpressRoute>;
  states: States;
  submittedWalletApprovalPolicy: WalletApprovalPolicy;
  subscriptions: Subscriptions;
  trade: Trade;
  tradeByJobId: Trade;
  transfer: Transfer;
  transferInstruction: TransferInstruction;
  transfers: Transfers;
  travelRuleSpePii: TravelRulePii;
  travelRuleSpeReview: TravelRuleSpeReview;
  unreadInAppNotifications: InAppNotifications;
  unreadInAppNotificationsCount: Scalars['Int']['output'];
  user: User;
  userActivation: UserActivation;
  userGroup: UserGroup;
  userGroups: Array<UserGroup>;
  users: Array<User>;
  verifiedUsers: Array<User>;
  walletApprovalPendingTransactions: WalletApprovalTransactions;
  walletApprovalPolicy?: Maybe<WalletApprovalPolicy>;
  walletApprovalPolicyDefaultUserLimits: Array<WalletApprovalPolicyUserLimit>;
  walletApprovalSubmittedPolicyProgress: WalletApprovalSubmittedPolicyProgress;
  walletApprovalTransactionDetail?: Maybe<WalletApprovalTransactionDetail>;
  walletApprovalTransactionDetailByJobId?: Maybe<WalletApprovalTransactionDetail>;
  walletApprovalTransactionPendingProposalCount: WalletApprovalTransactionPendingProposalCount;
  walletPaymentMethods: Array<WalletPaymentMethod>;
  walletProviders: Array<WalletProvider>;
  walletReports: WalletReports;
  watchlist: Watchlist;
  watchlistAllowReasons: Array<WatchlistAllowReason>;
  watchlistBlockReasons: Array<WatchlistBlockReason>;
  watchlistEntities?: Maybe<Array<WatchlistEntity>>;
  watchlistTypes: Array<WatchlistType>;
  wireBankAccount: WireBankAccount;
  wireTransferLimit?: Maybe<WireTransferLimit>;
  xpayBankAccount: XpayBankAccount;
}


export interface QueryActiveWalletApprovalPolicyArgs {
  currency: Currency;
}


export interface QueryAddressBookArgs {
  id: Scalars['ID']['input'];
}


export interface QueryAddressBookProposalArgs {
  id: Scalars['ID']['input'];
}


export interface QueryAllInAppNotificationsArgs {
  page?: InputMaybe<PaginationInput>;
}


export interface QueryApiKeyArgs {
  keyId: Scalars['ID']['input'];
}


export interface QueryApiLogsArgs {
  input: ApiLogSearchInput;
}


export interface QueryApprovalPoliciesArgs {
  input?: InputMaybe<ApprovalPoliciesInput>;
}


export interface QueryBalancesArgs {
  currency?: InputMaybe<Currency>;
}


export interface QueryBankAccountsArgs {
  types?: InputMaybe<Array<BankAccountType>>;
}


export interface QueryBlockchainAssetsArgs {
  chain?: InputMaybe<BlockchainAbbreviation>;
}


export interface QueryBlockchainDepositAddressArgs {
  input: AddBlockchainDepositAddressInput;
}


export interface QueryBlockchainDepositAddressesArgs {
  input?: InputMaybe<BlockchainAddressFilterInput>;
}


export interface QueryBlockchainRecipientAddressWithMetadataArgs {
  id: Scalars['ID']['input'];
}


export interface QueryBlockchainRecipientAddressesArgs {
  input?: InputMaybe<BlockchainAddressFilterInput>;
}


export interface QueryBlockchainRecipientAddressesWithMetadataArgs {
  filter?: InputMaybe<BlockchainRecipientAddressesWithMetadataInput>;
}


export interface QueryBlockchainsArgs {
  input: BlockchainsFilterInput;
}


export interface QueryCardPaymentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCardPaymentMethodByIdArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCardPaymentMethodsArgs {
  page?: InputMaybe<PaginationInput>;
}


export interface QueryCbitBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryChainedTransferArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCountriesArgs {
  filter?: InputMaybe<CountriesInput>;
}


export interface QueryCubixBankAccountArgs {
  accountId: Scalars['ID']['input'];
}


export interface QueryDepositArgs {
  id: Scalars['ID']['input'];
}


export interface QueryDownloadReportArgs {
  reportId: Scalars['String']['input'];
}


export interface QueryDraftWalletApprovalPolicyArgs {
  currency: Currency;
}


export interface QueryEntityArgs {
  entityId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryEntityLimitsArgs {
  currency: Currency;
  type: WireTransferTypeEnum;
}


export interface QueryFactorArgs {
  factorType: FactorType;
}


export interface QueryFeeReportsArgs {
  filter?: InputMaybe<FeeReportsFilterInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryFilteredLongPollInAppNotificationArgs {
  input: FilteredLongPollInAppNotificationInput;
}


export interface QueryFxQuoteArgs {
  input: GetFxQuoteInput;
}


export interface QueryIdentityChallengeArgs {
  addressId: Scalars['ID']['input'];
}


export interface QueryInternalAddressesArgs {
  filter?: InputMaybe<InternalAddressInput>;
}


export interface QueryInvoiceDetailArgs {
  id: Scalars['ID']['input'];
}


export interface QueryInvoicePaymentDetailArgs {
  id: Scalars['ID']['input'];
}


export interface QueryInvoicesArgs {
  page?: InputMaybe<PaginationInput>;
}


export interface QueryMerchantAchBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryMerchantChargebackArgs {
  id: Scalars['ID']['input'];
}


export interface QueryMerchantChargebacksArgs {
  category?: InputMaybe<ChargebackCategory>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryMerchantPaymentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryMerchantPaymentIntentArgs {
  id: Scalars['ID']['input'];
}


export interface QueryMerchantPaymentIntentsArgs {
  filter?: InputMaybe<MerchantPaymentIntentsFilterInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryMerchantPaymentsArgs {
  filter?: InputMaybe<MerchantPaymentFilterInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryMerchantPayoutArgs {
  id: Scalars['ID']['input'];
}


export interface QueryMerchantPayoutsArgs {
  destination?: InputMaybe<MerchantPayoutType>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<MerchantPayoutStatus>;
}


export interface QueryMerchantSepaBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryMerchantWireBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryOktaVerifyActivationStatusArgs {
  input: OktaVerifyActivationStatusInput;
}


export interface QueryOnboardingCertificationsArgs {
  onboardingId: Scalars['ID']['input'];
}


export interface QueryOnboardingChildSectionsArgs {
  filter?: InputMaybe<OnboardingGroupSectionFilter>;
}


export interface QueryOnboardingGroupDataV2Args {
  input: OnboardingGroupDataV2Input;
}


export interface QueryOnboardingMsaOperationArgs {
  input: MsaOperationInput;
}


export interface QueryOnboardingNaturesOfBusinessArgs {
  input?: InputMaybe<OnboardingNaturesOfBusinessInput>;
}


export interface QueryOnboardingOverviewSectionsV2Args {
  operationId: Scalars['ID']['input'];
}


export interface QueryOnboardingRfiBundleArgs {
  input: OnboardingRfiBundleInput;
}


export interface QueryOnboardingRfiGroupCommentsArgs {
  input: OnboardingRfiGroupCommentsInput;
}


export interface QueryPaymentDetailsArgs {
  id: Scalars['ID']['input'];
}


export interface QueryPaymentsArgs {
  filter?: InputMaybe<PaymentInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryPayoutArgs {
  id: Scalars['ID']['input'];
}


export interface QueryPendingOnchainReceivesArgs {
  currency?: InputMaybe<Currency>;
  dedupe?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryPixBankAccountArgs {
  accountId: Scalars['ID']['input'];
}


export interface QueryProposalsArgs {
  input: ProposalsInput;
}


export interface QueryQualificationProgressArgs {
  type: QualificationType;
}


export interface QueryReportArgs {
  input: ReportInput;
}


export interface QueryReversalArgs {
  id: Scalars['ID']['input'];
}


export interface QueryReversalsArgs {
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<MerchantPaymentStatus>;
}


export interface QueryRtpBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QuerySenBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QuerySettlementArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySettlementCreditTransferArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySettlementCreditTransferFeeArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySettlementCreditTransferFeesArgs {
  page?: InputMaybe<PaginationInput>;
  settlementCreditTransferId: Scalars['ID']['input'];
}


export interface QuerySettlementCreditTransferValidationArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySettlementCreditTransfersArgs {
  filter?: InputMaybe<SettlementCreditTransfersInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QuerySettlementCreditWireInstructionArgs {
  id: Scalars['String']['input'];
}


export interface QuerySettlementsArgs {
  page?: InputMaybe<PaginationInput>;
}


export interface QuerySignetBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryStatesArgs {
  filter: StatesInput;
}


export interface QuerySubmittedWalletApprovalPolicyArgs {
  currency: Currency;
}


export interface QueryTradeArgs {
  id: Scalars['ID']['input'];
}


export interface QueryTradeByJobIdArgs {
  jobId: Scalars['ID']['input'];
}


export interface QueryTransferArgs {
  id: Scalars['ID']['input'];
}


export interface QueryTransferInstructionArgs {
  input: TransferInstructionInput;
}


export interface QueryTransfersArgs {
  destinationWalletId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<PaginationInput>;
  sourceWalletId?: InputMaybe<Scalars['ID']['input']>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryTravelRuleSpePiiArgs {
  linkId: Scalars['String']['input'];
}


export interface QueryTravelRuleSpeReviewArgs {
  linkId: Scalars['String']['input'];
}


export interface QueryUnreadInAppNotificationsArgs {
  page?: InputMaybe<PaginationInput>;
}


export interface QueryUserArgs {
  userId?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryUserActivationArgs {
  token: Scalars['String']['input'];
}


export interface QueryUserGroupArgs {
  id: Scalars['String']['input'];
}


export interface QueryVerifiedUsersArgs {
  filter?: InputMaybe<VerifiedUsersFilterInput>;
}


export interface QueryWalletApprovalPendingTransactionsArgs {
  filter?: InputMaybe<WalletApprovalTransactionFilterInput>;
  page?: InputMaybe<PaginationInput>;
}


export interface QueryWalletApprovalPolicyArgs {
  currency: Currency;
}


export interface QueryWalletApprovalSubmittedPolicyProgressArgs {
  policyId: Scalars['ID']['input'];
}


export interface QueryWalletApprovalTransactionDetailArgs {
  proposalId: Scalars['ID']['input'];
}


export interface QueryWalletApprovalTransactionDetailByJobIdArgs {
  jobId: Scalars['ID']['input'];
}


export interface QueryWalletApprovalTransactionPendingProposalCountArgs {
  currency: Currency;
}


export interface QueryWalletProvidersArgs {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryWalletReportsArgs {
  page?: InputMaybe<PaginationInput>;
  walletReportType?: InputMaybe<WalletReportType>;
}


export interface QueryWatchlistArgs {
  type?: InputMaybe<WatchlistTypes>;
}


export interface QueryWatchlistEntitiesArgs {
  type: WatchlistTypes;
}


export interface QueryWatchlistTypesArgs {
  variant: WatchLists;
}


export interface QueryWireBankAccountArgs {
  accountId: Scalars['String']['input'];
}


export interface QueryWireTransferLimitArgs {
  currency: Currency;
  type: WireTransferTypeEnum;
}


export interface QueryXpayBankAccountArgs {
  accountId: Scalars['String']['input'];
}

export interface RailLimitType {
  __typename?: 'RailLimitType';
  currency: Currency;
  limit: Scalars['String']['output'];
}

export enum RailType {
  cbit = 'cbit',
  cubix = 'cubix',
  pix = 'pix',
  rtgs = 'rtgs',
  rtp = 'rtp',
  sepa = 'sepa',
  sepa_instant = 'sepa_instant',
  wire = 'wire'
}

export interface ReceiveLocation {
  __typename?: 'ReceiveLocation';
  id: Scalars['ID']['output'];
  type: LocationType;
}

export enum RecipientAddressFilterBy {
  ALL_ADDRESSES = 'ALL_ADDRESSES',
  NON_VAULT_ADDRESSES = 'NON_VAULT_ADDRESSES',
  VAULT_ADDRESSES = 'VAULT_ADDRESSES'
}

export enum RedemptionFeeType {
  redemption_fee_gross = 'redemption_fee_gross',
  redemption_fee_net = 'redemption_fee_net'
}

export type Report = ReportComplete | ReportIncomplete;

export interface ReportComplete {
  __typename?: 'ReportComplete';
  downloadUrl: Scalars['String']['output'];
  status: ReportStatus;
}

export interface ReportIncomplete {
  __typename?: 'ReportIncomplete';
  status: ReportStatus;
}

export interface ReportInput {
  currency?: InputMaybe<Currency>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReportType;
  year?: InputMaybe<Scalars['Int']['input']>;
}

export enum ReportStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export enum ReportType {
  transaction = 'transaction'
}

export interface ResetMfaRequestInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface Reversal extends PaginatedType {
  __typename?: 'Reversal';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  paymentId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  status: MerchantPaymentStatus;
  updateDate: Scalars['DateTime']['output'];
}

export interface Reversals extends PaginationExtends {
  __typename?: 'Reversals';
  links: PaginationLinks;
  list: Array<Reversal>;
}

export enum RfiBundleStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  RESPONDED = 'RESPONDED',
  SUBMITTED = 'SUBMITTED'
}

export enum RfiElementType {
  DATUM = 'DATUM',
  GROUP = 'GROUP'
}

export enum RfiFieldStatus {
  NOT_ASKED = 'NOT_ASKED',
  PENDING = 'PENDING',
  RESPONDED = 'RESPONDED'
}

export enum RfiStatus {
  DRAFT = 'DRAFT',
  RESOLVED = 'RESOLVED',
  SUBMITTED = 'SUBMITTED'
}

export enum RfiType {
  COLLECT_DOCUMENT = 'COLLECT_DOCUMENT',
  NEW_FIELD = 'NEW_FIELD',
  NOTE = 'NOTE',
  UPDATE_FIELD = 'UPDATE_FIELD'
}

export interface RiskEvaluation {
  __typename?: 'RiskEvaluation';
  decision?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
}

export interface RolrSettings {
  __typename?: 'RolrSettings';
  accountClosureDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface RtpBankAccount {
  __typename?: 'RtpBankAccount';
  billingDetails?: Maybe<BillingDetails>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  virtualAccountEnabled?: Maybe<Scalars['Boolean']['output']>;
}

export interface RtpReceive {
  __typename?: 'RtpReceive';
  payment: Payment;
  source?: Maybe<RtpBankAccount>;
}

export enum RtpTransactionType {
  rtp_receive = 'rtp_receive',
  rtp_withdrawal = 'rtp_withdrawal'
}

export interface RtpTransferInstruction {
  __typename?: 'RtpTransferInstruction';
  beneficiary: WireBeneficiary;
  beneficiaryBank: WireBeneficiaryBank;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  virtualAccountEnabled: Scalars['Boolean']['output'];
}

export interface RtpWithdrawal {
  __typename?: 'RtpWithdrawal';
  destination?: Maybe<RtpBankAccount>;
  payment: Payment;
}

export interface SandboxSignupInput {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface ScaFactorInfo {
  __typename?: 'ScaFactorInfo';
  isScaRequired: Scalars['Boolean']['output'];
  oktaVerify?: Maybe<EligibleUserFactor>;
  pinCode?: Maybe<EligibleUserFactor>;
}

export interface SenBankAccount {
  __typename?: 'SenBankAccount';
  createDate: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  userConfirmedWireSend?: Maybe<Scalars['Boolean']['output']>;
}

export interface SenReceive {
  __typename?: 'SenReceive';
  fees?: Maybe<Amount>;
  payment: Payment;
  source?: Maybe<BankLocation>;
}

export interface SenTransferInstruction {
  __typename?: 'SenTransferInstruction';
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
}

export interface SenWithdrawal {
  __typename?: 'SenWithdrawal';
  destination?: Maybe<BankLocation>;
  fees?: Maybe<Amount>;
  payment: Payment;
}

export interface SepaInstantReceive {
  __typename?: 'SepaInstantReceive';
  fees?: Maybe<Amount>;
  payment: Payment;
  source?: Maybe<WireBankAccount>;
}

export enum SepaInstantTransactionType {
  sepa_instant_receive = 'sepa_instant_receive',
  sepa_instant_withdrawal = 'sepa_instant_withdrawal'
}

export interface SepaInstantWithdrawal {
  __typename?: 'SepaInstantWithdrawal';
  destination?: Maybe<WireBankAccount>;
  fees?: Maybe<Amount>;
  payment: Payment;
}

export interface SepaReceive {
  __typename?: 'SepaReceive';
  fees?: Maybe<Amount>;
  payment: Payment;
  source?: Maybe<WireBankAccount>;
}

export enum SepaTransactionType {
  sepa_receive = 'sepa_receive',
  sepa_withdrawal = 'sepa_withdrawal'
}

export interface SepaWithdrawal {
  __typename?: 'SepaWithdrawal';
  destination?: Maybe<WireBankAccount>;
  fees?: Maybe<Amount>;
  payment: Payment;
}

export interface SetBlockchainRecipientAddressWithMetadataInput {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  owner?: InputMaybe<BlockchainRecipientAddressOwner>;
}

export interface SetMerchantCreditCardInput {
  cardId: Scalars['String']['input'];
  cvv: Scalars['String']['input'];
  expMonth: Scalars['String']['input'];
  expYear: Scalars['String']['input'];
}

export interface SetProductInterestsInput {
  productInterests: Array<ProductInterest>;
}

export interface SetRecipientAddressAdditionalInfoInput {
  id: Scalars['ID']['input'];
  vasp?: InputMaybe<VaspInput>;
  walletType: WalletType;
}

export interface SetRecipientAddressBeneficiaryInfoInput {
  businessName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  type: BeneficiaryType;
}

export interface SetWatchListEntry {
  __typename?: 'SetWatchListEntry';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: WatchLists;
}

export interface SetWatchListEntryInput {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  type: WatchLists;
}

export interface SetWireBankAccountMetadataInput {
  metadata: BankAccountMetadataInput;
  wireBankAccountId: Scalars['String']['input'];
}

export interface Settings {
  __typename?: 'Settings';
  features?: Maybe<SettingsFeatures>;
}

export interface SettingsFeatures {
  __typename?: 'SettingsFeatures';
  burnFeeAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  custodyTour?: Maybe<Scalars['Boolean']['output']>;
  featureTour?: Maybe<Scalars['Boolean']['output']>;
  productTour?: Maybe<Scalars['Boolean']['output']>;
}

export enum SettingsFeaturesType {
  burnFeeAnnouncement = 'burnFeeAnnouncement',
  custodyTour = 'custodyTour',
  featureTour = 'featureTour',
  productTour = 'productTour'
}

export interface Settlement extends PaginatedType {
  __typename?: 'Settlement';
  chargebackFees: Amount;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  merchantWalletId?: Maybe<Scalars['String']['output']>;
  paymentFees: Amount;
  totalCredits: Amount;
  totalDebits: Amount;
  updateDate: Scalars['DateTime']['output'];
}

export interface SettlementCreditFee {
  __typename?: 'SettlementCreditFee';
  payment: SettlementCreditFeePayment;
}

export interface SettlementCreditFeePayment extends PaginatedType {
  __typename?: 'SettlementCreditFeePayment';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: FeeLocation;
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  type: TransactionType;
  updateDate: Scalars['DateTime']['output'];
}

export interface SettlementCreditLine {
  __typename?: 'SettlementCreditLine';
  createDate: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  limit: Amount;
  settings: SettlementCreditLineSettings;
  status: SettlementCreditLineStatus;
  type: SettlementCreditLineType;
  updateDate: Scalars['DateTime']['output'];
  usage: SettlementCreditLineUsage;
  walletId: Scalars['ID']['output'];
}

export interface SettlementCreditLineSettings {
  __typename?: 'SettlementCreditLineSettings';
  autoApproval: Scalars['Boolean']['output'];
}

export enum SettlementCreditLineStatus {
  active = 'active',
  inactive = 'inactive'
}

export enum SettlementCreditLineType {
  lineOfCredit = 'lineOfCredit',
  settlementAdvance = 'settlementAdvance'
}

export interface SettlementCreditLineUsage {
  __typename?: 'SettlementCreditLineUsage';
  available: Scalars['String']['output'];
  outstandingTransfers: Scalars['Int']['output'];
  used: Scalars['String']['output'];
}

export interface SettlementCreditReceive {
  __typename?: 'SettlementCreditReceive';
  payment: SettlementCreditReceivePayment;
}

export interface SettlementCreditReceivePayment extends PaginatedType {
  __typename?: 'SettlementCreditReceivePayment';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: ReceiveLocation;
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  type: TransactionType;
  updateDate: Scalars['DateTime']['output'];
}

export interface SettlementCreditTransfer extends PaginatedType {
  __typename?: 'SettlementCreditTransfer';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hasPendingFee: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  receiveJobId?: Maybe<Scalars['ID']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: SettlementCreditTransferStatus;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  transferJobId?: Maybe<Scalars['ID']['output']>;
  updateDate: Scalars['DateTime']['output'];
}

export interface SettlementCreditTransferDetails {
  __typename?: 'SettlementCreditTransferDetails';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  outstandingBalance?: Maybe<Amount>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  pendingFees?: Maybe<Amount>;
  receiveJobId?: Maybe<Scalars['ID']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: SettlementCreditTransferStatus;
  totalFees?: Maybe<Amount>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  transferJobId?: Maybe<Scalars['ID']['output']>;
  updateDate: Scalars['DateTime']['output'];
}

export enum SettlementCreditTransferErrorCodes {
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
  OVERDUE_TRANSFERS = 'OVERDUE_TRANSFERS',
  PENDING_FEES = 'PENDING_FEES'
}

export interface SettlementCreditTransferFee extends PaginatedType {
  __typename?: 'SettlementCreditTransferFee';
  accruedDate: Scalars['DateTime']['output'];
  amount: Amount;
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  settlementCreditTransferId: Scalars['ID']['output'];
  status: SettlementCreditTransferFeeStatus;
}

export enum SettlementCreditTransferFeeStatus {
  created = 'created',
  failed = 'failed',
  paid = 'paid'
}

export interface SettlementCreditTransferFees extends PaginationExtends {
  __typename?: 'SettlementCreditTransferFees';
  links: PaginationLinks;
  list: Array<SettlementCreditTransferFee>;
}

export interface SettlementCreditTransferInput {
  amount: AmountInput;
  fileContent?: InputMaybe<Scalars['Upload']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  settlementCreditLineId: Scalars['ID']['input'];
}

export enum SettlementCreditTransferStatus {
  advanced = 'advanced',
  paid = 'paid',
  pastDue = 'pastDue',
  rejected = 'rejected',
  requested = 'requested'
}

export interface SettlementCreditTransferValidation {
  __typename?: 'SettlementCreditTransferValidation';
  code: SettlementCreditTransferErrorCodes;
  message: Scalars['String']['output'];
}

export interface SettlementCreditTransfers extends PaginationExtends {
  __typename?: 'SettlementCreditTransfers';
  links: PaginationLinks;
  list: Array<SettlementCreditTransfer>;
}

export interface SettlementCreditTransfersInput {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  receiveJobId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SettlementCreditTransferStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface SettlementCreditWireInstruction {
  __typename?: 'SettlementCreditWireInstruction';
  beneficiary: WireInstructionBeneficiary;
  beneficiaryBank: WireInstructionBeneficiaryBank;
  trackingRef: Scalars['ID']['output'];
  virtualAccountEnabled: Scalars['Boolean']['output'];
}

export interface Settlements extends PaginationExtends {
  __typename?: 'Settlements';
  links: PaginationLinks;
  list: Array<Settlement>;
}

export interface SignInCredential {
  __typename?: 'SignInCredential';
  sessionToken?: Maybe<Scalars['String']['output']>;
}

export interface SignInFactor {
  __typename?: 'SignInFactor';
  enrolled: Scalars['Boolean']['output'];
}

export interface SignetBankAccount {
  __typename?: 'SignetBankAccount';
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  walletAddress: Scalars['String']['output'];
}

export interface SignetReceive {
  __typename?: 'SignetReceive';
  payment: Payment;
  source?: Maybe<SignetBankAccount>;
}

export enum SignetTransactionType {
  signet_receive = 'signet_receive',
  signet_withdrawal = 'signet_withdrawal'
}

export interface SignetTransferInstruction {
  __typename?: 'SignetTransferInstruction';
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  walletAddress: Scalars['String']['output'];
}

export interface SignetWithdrawal {
  __typename?: 'SignetWithdrawal';
  destination?: Maybe<SignetBankAccount>;
  payment: Payment;
}

export type StablecoinExpressBankLocation = CbitBankAccount | CubixBankAccount | PixBankAccount | RtpBankAccount | SenBankAccount | SignetBankAccount | WireBankAccount | XpayBankAccount;

export type StablecoinExpressBlockchainLocation = BlockchainDepositAddress | BlockchainRecipientAddress;

/** Convert Fiat to USDC */
export interface StablecoinExpressDepositRoute {
  __typename?: 'StablecoinExpressDepositRoute';
  createDate: Scalars['DateTime']['output'];
  /** Blockchain Destination */
  destination: StablecoinExpressBlockchainLocation;
  enabled: Scalars['Boolean']['output'];
  fromCurrency: Currency;
  id: Scalars['ID']['output'];
  /** Bank Account Source */
  source: StablecoinExpressBankLocation;
  toCurrency: Currency;
  type: StablecoinExpressType;
  updateDate: Scalars['DateTime']['output'];
}

export type StablecoinExpressRoute = StablecoinExpressDepositRoute | StablecoinExpressWithdrawalRoute;

export interface StablecoinExpressRouteInput {
  id: Scalars['ID']['input'];
}

export enum StablecoinExpressType {
  /** Convert Fiat to USDC */
  DEPOSIT = 'DEPOSIT',
  /** Convert USDC to Fiat */
  WITHDRAWAL = 'WITHDRAWAL'
}

/** Convert USDC to Fiat */
export interface StablecoinExpressWithdrawalRoute {
  __typename?: 'StablecoinExpressWithdrawalRoute';
  createDate: Scalars['DateTime']['output'];
  /** Bank Account Destination */
  destination: StablecoinExpressBankLocation;
  enabled: Scalars['Boolean']['output'];
  fromCurrency: Currency;
  id: Scalars['ID']['output'];
  /** Blockchain Source */
  source: StablecoinExpressBlockchainLocation;
  toCurrency: Currency;
  type: StablecoinExpressType;
  updateDate: Scalars['DateTime']['output'];
}

/** Single State */
export interface State {
  __typename?: 'State';
  /** ISO2 Code */
  code: StateCode;
}

/** State codes of all the states */
export enum StateCode {
  /** Alberta, CA */
  AB = 'AB',
  /** Alaska, US */
  AK = 'AK',
  /** Alabama, US */
  AL = 'AL',
  /** Arkansas, US */
  AR = 'AR',
  /** Arizona, US */
  AZ = 'AZ',
  /** British Columbia, CA */
  BC = 'BC',
  /** California, US */
  CA = 'CA',
  /** Colorado, US */
  CO = 'CO',
  /** Connecticut, US */
  CT = 'CT',
  /** District of Columbia, US */
  DC = 'DC',
  /** Delaware, US */
  DE = 'DE',
  /** Florid, US */
  FL = 'FL',
  /** Georgia, US */
  GA = 'GA',
  /** Hawaii, US */
  HI = 'HI',
  /** Iowa, US */
  IA = 'IA',
  /** Idaho, US */
  ID = 'ID',
  /** Illinois, US */
  IL = 'IL',
  /** Indiana, US */
  IN = 'IN',
  /** Kansas, US */
  KS = 'KS',
  /** Kentucky, US */
  KY = 'KY',
  /** Louisiana, US */
  LA = 'LA',
  /** Massachusetts, US */
  MA = 'MA',
  /** Manitoba, CA */
  MB = 'MB',
  /** Maryland, US */
  MD = 'MD',
  /** Maine, US */
  ME = 'ME',
  /** Michigan, US */
  MI = 'MI',
  /** Minnesota, US */
  MN = 'MN',
  /** Missouri, US */
  MO = 'MO',
  /** Mississippi, US */
  MS = 'MS',
  /** Montana, US */
  MT = 'MT',
  /** New Brunswick, CA */
  NB = 'NB',
  /** North Carolina, US */
  NC = 'NC',
  /** North Dakota, US */
  ND = 'ND',
  /** Nebraska, US */
  NE = 'NE',
  /** New Hampshire, US */
  NH = 'NH',
  /** New Jersey, US */
  NJ = 'NJ',
  /** Newfoundland and Labrador, CA */
  NL = 'NL',
  /** New Mexico, US */
  NM = 'NM',
  /** Nova Scotia, CA */
  NS = 'NS',
  /** Northwest Territories, CA */
  NT = 'NT',
  /** Nunavut, CA */
  NU = 'NU',
  /** Nevada, US */
  NV = 'NV',
  /** New York, US */
  NY = 'NY',
  /** Ohio, US */
  OH = 'OH',
  /** Oklahoma, US */
  OK = 'OK',
  /** Ontario, CA */
  ON = 'ON',
  /** Oregon, US */
  OR = 'OR',
  /** Pennsylvania, US */
  PA = 'PA',
  /** Prince Edward Island, CA */
  PE = 'PE',
  /** Quebec, CA */
  QC = 'QC',
  /** Rhode Island, US */
  RI = 'RI',
  /** South Carolina, US */
  SC = 'SC',
  /** South Dakota, US */
  SD = 'SD',
  /** Saskatchewan, CA */
  SK = 'SK',
  /** Tennessee, US */
  TN = 'TN',
  /** Texas, US */
  TX = 'TX',
  /** Utah, US */
  UT = 'UT',
  /** Virginia, US */
  VA = 'VA',
  /** Vermont, US */
  VT = 'VT',
  /** Washington, US */
  WA = 'WA',
  /** Wisconsin, US */
  WI = 'WI',
  /** West Virginia, US */
  WV = 'WV',
  /** Wyoming, US */
  WY = 'WY',
  /** Yukon, CA */
  YT = 'YT'
}

/** Allow Linking Bank Account for? */
export interface StateLink {
  /** Allowed where the bank is located in this state? */
  locatedIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allowed to open an account where holder is registered in this state? */
  registeredIn?: InputMaybe<Scalars['Boolean']['input']>;
}

/** List of states */
export interface States {
  __typename?: 'States';
  /** Array of codes from the list */
  codes: Array<StateCode>;
  /** List of states */
  list: Array<State>;
}

/** States Filter */
export interface StatesInput {
  codes?: InputMaybe<Array<StateCode>>;
  country: CountryCode;
  link?: InputMaybe<StateLink>;
}

export interface SubmitAddressBookApprovalVoteInput {
  isApproved: Scalars['Boolean']['input'];
  proposalId: Scalars['String']['input'];
}

export interface SubmitEmailApprovalVoteInput {
  isApproved: Scalars['Boolean']['input'];
  proposalId: Scalars['String']['input'];
}

export interface Subscriptions {
  __typename?: 'Subscriptions';
  automaticPaymentEnabled: Scalars['Boolean']['output'];
}

export interface Trade {
  __typename?: 'Trade';
  createDate: Scalars['DateTime']['output'];
  from: PartialAmount;
  id: Scalars['ID']['output'];
  quoteId?: Maybe<Scalars['ID']['output']>;
  settlementId?: Maybe<Scalars['ID']['output']>;
  status: TradeStatus;
  to: PartialAmount;
  updateDate: Scalars['DateTime']['output'];
}

export enum TradeStatus {
  complete = 'complete',
  confirmed = 'confirmed',
  failed = 'failed',
  pending = 'pending',
  pending_confirmed = 'pending_confirmed',
  pending_settlement = 'pending_settlement'
}

export enum TradeTransactionType {
  trade_mint = 'trade_mint',
  trade_withdrawal = 'trade_withdrawal'
}

export enum TransactionStatus {
  complete = 'complete',
  failed = 'failed',
  incomplete = 'incomplete',
  pending = 'pending'
}

export enum TransactionType {
  cbit_receive = 'cbit_receive',
  cbit_withdrawal = 'cbit_withdrawal',
  convert_mint = 'convert_mint',
  convert_withdrawal = 'convert_withdrawal',
  cubix_receive = 'cubix_receive',
  cubix_withdrawal = 'cubix_withdrawal',
  onchain_receive = 'onchain_receive',
  onchain_send = 'onchain_send',
  pix_receive = 'pix_receive',
  pix_withdrawal = 'pix_withdrawal',
  redemption_fee_gross = 'redemption_fee_gross',
  redemption_fee_net = 'redemption_fee_net',
  rtgs_receive = 'rtgs_receive',
  rtgs_withdrawal = 'rtgs_withdrawal',
  rtp_receive = 'rtp_receive',
  rtp_withdrawal = 'rtp_withdrawal',
  sen_receive = 'sen_receive',
  sen_withdrawal = 'sen_withdrawal',
  sepa_instant_receive = 'sepa_instant_receive',
  sepa_instant_withdrawal = 'sepa_instant_withdrawal',
  sepa_receive = 'sepa_receive',
  sepa_withdrawal = 'sepa_withdrawal',
  settlement_credit_fee = 'settlement_credit_fee',
  settlement_credit_overrepayment_refund = 'settlement_credit_overrepayment_refund',
  settlement_credit_receive = 'settlement_credit_receive',
  signet_receive = 'signet_receive',
  signet_withdrawal = 'signet_withdrawal',
  trade_mint = 'trade_mint',
  trade_withdrawal = 'trade_withdrawal',
  wire_receive = 'wire_receive',
  wire_withdrawal = 'wire_withdrawal',
  xpay_receive = 'xpay_receive',
  xpay_withdrawal = 'xpay_withdrawal'
}

export interface Transfer extends PaginatedType {
  __typename?: 'Transfer';
  amount: Amount;
  createDate: Scalars['DateTime']['output'];
  destination: TransferLocation;
  errorCode?: Maybe<Scalars['String']['output']>;
  explorerLink?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Amount>;
  id: Scalars['ID']['output'];
  source: TransferLocation;
  status: TransferStatus;
  totalAmount?: Maybe<Amount>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  type: TransferType;
}

export type TransferInstruction = CbitTransferInstruction | CubixTransferInstruction | PixTransferInstruction | RtpTransferInstruction | SenTransferInstruction | SignetTransferInstruction | WireTransferInstruction | XpayTransferInstruction;

export interface TransferInstructionInput {
  bankAccountId: Scalars['ID']['input'];
  currency: Currency;
  type: BankAccountType;
}

export type TransferLocation = BlockchainLocation | ChainedBlockchainLocation | WalletLocation;

export enum TransferLocationType {
  blockchain = 'blockchain',
  verified_blockchain = 'verified_blockchain',
  wallet = 'wallet'
}

export enum TransferStatus {
  complete = 'complete',
  failed = 'failed',
  pending = 'pending'
}

export enum TransferType {
  internal = 'internal',
  receive = 'receive',
  send = 'send'
}

export interface TransferTypes {
  __typename?: 'TransferTypes';
  currencies: Array<Currency>;
  transactionLimits?: Maybe<Array<RailLimitType>>;
  type: RailType;
}

export interface Transfers extends PaginationExtends {
  __typename?: 'Transfers';
  links: PaginationLinks;
  list: Array<Transfer>;
}

export interface TravelRuleAddress {
  __typename?: 'TravelRuleAddress';
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
}

export interface TravelRuleAddressInput {
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: CountryCode;
  postalCode: Scalars['String']['input'];
  stateProvince: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
}

export interface TravelRuleLegalPerson extends TravelRulePersonBase {
  __typename?: 'TravelRuleLegalPerson';
  address?: Maybe<TravelRuleAddress>;
  leiOrEquivalent?: Maybe<Scalars['String']['output']>;
  registeredName: Scalars['String']['output'];
  type: TravelRulePersonType;
}

export interface TravelRuleLegalPersonInput {
  address?: InputMaybe<TravelRuleAddressInput>;
  leiOrEquivalent?: InputMaybe<Scalars['String']['input']>;
  registeredName: Scalars['String']['input'];
}

export interface TravelRuleNaturalPerson extends TravelRulePersonBase {
  __typename?: 'TravelRuleNaturalPerson';
  additionalIdentifier?: Maybe<Scalars['String']['output']>;
  address?: Maybe<TravelRuleAddress>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  officialDocumentNumber?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  type: TravelRulePersonType;
}

export interface TravelRuleNaturalPersonInput {
  additionalIdentifier?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<TravelRuleAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  officialDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
}

export type TravelRulePerson = TravelRuleLegalPerson | TravelRuleNaturalPerson;

export interface TravelRulePersonBase {
  address?: Maybe<TravelRuleAddress>;
  type: TravelRulePersonType;
}

export interface TravelRulePersonInput {
  legal?: InputMaybe<TravelRuleLegalPersonInput>;
  natural?: InputMaybe<TravelRuleNaturalPersonInput>;
  type: TravelRulePersonType;
}

export enum TravelRulePersonType {
  LEGAL = 'LEGAL',
  NATURAL = 'NATURAL'
}

export interface TravelRulePii {
  __typename?: 'TravelRulePii';
  beneficiary?: Maybe<TravelRulePerson>;
  beneficiaryDistributedLedgerAddress?: Maybe<Scalars['String']['output']>;
  originator: TravelRulePerson;
  originatorDistributedLedgerAddress?: Maybe<Scalars['String']['output']>;
}

export enum TravelRuleSpeRequestType {
  COLLECT = 'COLLECT',
  SHARE = 'SHARE'
}

export interface TravelRuleSpeReview {
  __typename?: 'TravelRuleSpeReview';
  address: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  requestType: TravelRuleSpeRequestType;
  token: Currency;
  txHash: Scalars['String']['output'];
}

export interface TravelRuleSubmitSpePiiInput {
  beneficiary: TravelRulePersonInput;
  beneficiaryDistributedLedgerAddress: Scalars['String']['input'];
  linkId: Scalars['String']['input'];
  originator: TravelRulePersonInput;
  originatorDistributedLedgerAddress: Scalars['String']['input'];
}

export interface UpdateApiKeyInput {
  ipAllowList: Array<Scalars['String']['input']>;
  keyId: Scalars['ID']['input'];
  keyName: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
}

export interface UpdateBillingProfileInput {
  billingAddress?: InputMaybe<BillingAddressInput>;
  billingContact?: InputMaybe<BillingContactInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCardPaymentMethodBillingDetailsInput {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  district: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
}

export interface UpdateCardPaymentMethodInput {
  billingDetails: UpdateCardPaymentMethodBillingDetailsInput;
}

export interface UpdateOnboardingDataInput {
  businessInfoConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingCompanyInfo?: InputMaybe<OnboardingCompanyInfo>;
}

export interface UpdatePinCodeInput {
  factorId: Scalars['ID']['input'];
  newPinCode: Scalars['String']['input'];
  oldPinCode: Scalars['String']['input'];
}

export interface UpsertWalletApprovalPolicyInput {
  approvalWorkflow?: InputMaybe<UpsertWalletApprovalWorkflowInput>;
  currency: Currency;
  policyLimits?: InputMaybe<UpsertWalletApprovalPolicyLimitsInput>;
  settings: UpsertWalletApprovalPolicySettings;
  userLimits?: InputMaybe<Array<UpsertWalletApprovalUserLimitInput>>;
  userRoles: Array<UpsertWalletApprovalUserRoleInput>;
}

export interface UpsertWalletApprovalPolicyLimitsInput {
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxTransactions?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpsertWalletApprovalPolicySettings {
  allowInitiatorToApproveTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  applyToApi?: InputMaybe<Scalars['Boolean']['input']>;
  proposalApprovalMethod?: InputMaybe<WalletApprovalProposalApprovalMethod>;
  vetoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpsertWalletApprovalUserLimitInput {
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxTransactions?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
}

export interface UpsertWalletApprovalUserRoleInput {
  role: WalletApprovalPolicyRole;
  userId: Scalars['String']['input'];
}

export interface UpsertWalletApprovalWorkflowInput {
  approvalsNeeded: Scalars['Int']['input'];
  votingUserIds: Array<Scalars['String']['input']>;
}

export interface UsBankAddressInput {
  bankName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
}

export interface User {
  __typename?: 'User';
  created?: Maybe<Scalars['DateTime']['output']>;
  current: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAuthorizedRepresentative?: Maybe<Scalars['Boolean']['output']>;
  isMasterUser?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  passwordChanged?: Maybe<Scalars['DateTime']['output']>;
  permissionGroup?: Maybe<UserRoleGroupType>;
  proposalId?: Maybe<Scalars['String']['output']>;
  status: UserStatusType;
}

export interface UserActivation {
  __typename?: 'UserActivation';
  email?: Maybe<Scalars['String']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  stateToken?: Maybe<Scalars['String']['output']>;
  tokenConsumed?: Maybe<Scalars['Boolean']['output']>;
}

export interface UserGroup {
  __typename?: 'UserGroup';
  id: Scalars['String']['output'];
  members: Array<UserGroupMember>;
  name: Scalars['String']['output'];
  status: UserGroupStatus;
}

export interface UserGroupMember {
  __typename?: 'UserGroupMember';
  email?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<UserRoleGroupType>;
  id: Scalars['String']['output'];
  initial?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export enum UserGroupStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

/** Admin approvals user proposal: type */
export enum UserProposalType {
  USER_INVITE = 'USER_INVITE',
  USER_REMOVE = 'USER_REMOVE'
}

export enum UserRoleGroupType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  AGENT = 'AGENT',
  ORGANIZATION = 'ORGANIZATION',
  USER_DEFINED = 'USER_DEFINED',
  VIEWER = 'VIEWER'
}

export enum UserState {
  ACTIVATED = 'ACTIVATED',
  APPROVED = 'APPROVED',
  CREATED = 'CREATED',
  REJECTED = 'REJECTED'
}

export interface UserStatus {
  __typename?: 'UserStatus';
  label: UserStatusLabel;
  type: UserStatusType;
}

export enum UserStatusLabel {
  Active = 'Active',
  Inactive = 'Inactive',
  InviteExpired = 'InviteExpired',
  Pending = 'Pending',
  PendingApprovalForInvite = 'PendingApprovalForInvite',
  PendingApprovalForRemoval = 'PendingApprovalForRemoval'
}

export enum UserStatusType {
  ACTIVE = 'ACTIVE',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  PENDING = 'PENDING',
  PENDING_INVITE_APPROVAL = 'PENDING_INVITE_APPROVAL',
  PENDING_REMOVE_APPROVAL = 'PENDING_REMOVE_APPROVAL'
}

export interface VaspInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  network?: InputMaybe<ProviderNetwork>;
}

export interface VendorMetadata {
  __typename?: 'VendorMetadata';
  externalId: Scalars['ID']['output'];
  externalSource: Scalars['String']['output'];
}

export interface VerifiedUsersFilterInput {
  groupType?: InputMaybe<Array<UserRoleGroupType>>;
  omitCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface WalletApprovalOnchainTransactionDetail {
  __typename?: 'WalletApprovalOnchainTransactionDetail';
  amount: Scalars['Float']['output'];
  approvalsNeeded: Scalars['Float']['output'];
  approvedBy: Array<User>;
  awaitingApproval: Array<User>;
  currency: Currency;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator?: Maybe<Scalars['String']['output']>;
  recipientAddress: BlockchainRecipientAddressWithMetadata;
  rejectedBy: Array<User>;
  showCancelAction: Scalars['Boolean']['output'];
  showVoteAction: Scalars['Boolean']['output'];
  status: WalletApprovalTransactionStatus;
  transferId?: Maybe<Scalars['ID']['output']>;
  type: WalletApprovalTransactionType;
  votingUsers: Array<User>;
}

export interface WalletApprovalPayoutTransactionDetail {
  __typename?: 'WalletApprovalPayoutTransactionDetail';
  amount: Scalars['Float']['output'];
  approvalsNeeded: Scalars['Float']['output'];
  approvedBy: Array<User>;
  awaitingApproval: Array<User>;
  currency: Currency;
  date: Scalars['DateTime']['output'];
  fiatAccount: BankAccount;
  id: Scalars['ID']['output'];
  initiator?: Maybe<Scalars['String']['output']>;
  rejectedBy: Array<User>;
  showCancelAction: Scalars['Boolean']['output'];
  showVoteAction: Scalars['Boolean']['output'];
  status: WalletApprovalTransactionStatus;
  transferId?: Maybe<Scalars['ID']['output']>;
  type: WalletApprovalTransactionType;
  votingUsers: Array<User>;
}

export interface WalletApprovalPolicy {
  __typename?: 'WalletApprovalPolicy';
  approvalWorkflow?: Maybe<WalletApprovalPolicyApprovalLevel>;
  canDeposit: Scalars['Boolean']['output'];
  canTransfer: Scalars['Boolean']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  policyLimits?: Maybe<WalletApprovalPolicyLimits>;
  settings: WalletApprovalPolicySettings;
  showVoteAction: Scalars['Boolean']['output'];
  state: WalletApprovalPolicyState;
  userLimits?: Maybe<Array<WalletApprovalPolicyUserLimit>>;
}

export interface WalletApprovalPolicyApprovalLevel {
  __typename?: 'WalletApprovalPolicyApprovalLevel';
  approvers: Array<User>;
  minNeedConfirmed: Scalars['String']['output'];
}

export interface WalletApprovalPolicyLimits {
  __typename?: 'WalletApprovalPolicyLimits';
  maxAmount?: Maybe<Scalars['String']['output']>;
  maxTransactions?: Maybe<Scalars['String']['output']>;
}

export enum WalletApprovalPolicyRole {
  APPROVER = 'APPROVER',
  OPERATOR = 'OPERATOR'
}

export interface WalletApprovalPolicySettings {
  __typename?: 'WalletApprovalPolicySettings';
  allowInitiatorToApproveTransfer: Scalars['Boolean']['output'];
  applyToApi: Scalars['Boolean']['output'];
  proposalApprovalMethod?: Maybe<WalletApprovalProposalApprovalMethod>;
}

export enum WalletApprovalPolicyState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

export interface WalletApprovalPolicyUserLimit {
  __typename?: 'WalletApprovalPolicyUserLimit';
  maxAmount?: Maybe<Scalars['String']['output']>;
  maxTransactions?: Maybe<Scalars['String']['output']>;
  permissions: Array<WalletApprovalPolicyRole>;
  user: User;
}

export enum WalletApprovalProposalApprovalMethod {
  EMAIL = 'EMAIL',
  MOBILE_APP = 'MOBILE_APP',
  WEB_APP = 'WEB_APP'
}

export interface WalletApprovalSubmittedPolicyProgress {
  __typename?: 'WalletApprovalSubmittedPolicyProgress';
  approvedByUser: Array<WalletApprovalSubmittedPolicyProgressUser>;
  pendingApprovalsUser: Array<WalletApprovalSubmittedPolicyProgressUser>;
  policyId: Scalars['ID']['output'];
  rejectedByUser: Array<WalletApprovalSubmittedPolicyProgressUser>;
}

export interface WalletApprovalSubmittedPolicyProgressUser {
  __typename?: 'WalletApprovalSubmittedPolicyProgressUser';
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
}

export interface WalletApprovalTransaction extends PaginatedType {
  __typename?: 'WalletApprovalTransaction';
  amount: Scalars['Float']['output'];
  currency: Currency;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator?: Maybe<Scalars['String']['output']>;
  status: WalletApprovalTransactionStatus;
  type: WalletApprovalTransactionType;
}

export type WalletApprovalTransactionDetail = WalletApprovalOnchainTransactionDetail | WalletApprovalPayoutTransactionDetail;

export interface WalletApprovalTransactionFilterInput {
  currency?: InputMaybe<Currency>;
  status?: InputMaybe<Array<WalletApprovalTransactionStatus>>;
  type?: InputMaybe<Array<WalletApprovalTransactionType>>;
}

export interface WalletApprovalTransactionPendingProposalCount {
  __typename?: 'WalletApprovalTransactionPendingProposalCount';
  count: Scalars['Float']['output'];
}

export enum WalletApprovalTransactionStatus {
  CANCELLED_BY_INITIATOR = 'CANCELLED_BY_INITIATOR',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  REJECTED_BY_USER = 'REJECTED_BY_USER'
}

export enum WalletApprovalTransactionType {
  ONCHAIN = 'ONCHAIN',
  PAYOUT = 'PAYOUT'
}

export interface WalletApprovalTransactions extends PaginationExtends {
  __typename?: 'WalletApprovalTransactions';
  links: PaginationLinks;
  list: Array<WalletApprovalTransaction>;
}

export interface WalletLocation {
  __typename?: 'WalletLocation';
  address?: Maybe<Scalars['String']['output']>;
  addressTag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: TransferLocationType;
}

export interface WalletPaymentMethod {
  __typename?: 'WalletPaymentMethod';
  balance: Amount;
  isDefault: Scalars['Boolean']['output'];
}

export interface WalletProvider {
  __typename?: 'WalletProvider';
  active: Scalars['Boolean']['output'];
  externalVendorMetadata?: Maybe<Array<VendorMetadata>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  network?: Maybe<ProviderNetwork>;
}

export interface WalletReport extends PaginatedType {
  __typename?: 'WalletReport';
  createDate: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportExecutionId: Scalars['String']['output'];
  reportFrequency: WalletReportFrequency;
  reportMonth: Scalars['Int']['output'];
  reportName: Scalars['String']['output'];
  reportType: WalletReportType;
  reportYear: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  state: WalletReportState;
  updateDate: Scalars['DateTime']['output'];
}

export enum WalletReportFrequency {
  monthly = 'monthly'
}

export enum WalletReportState {
  failed = 'failed',
  processed = 'processed',
  processing = 'processing',
  unprocessed = 'unprocessed'
}

export enum WalletReportType {
  merchant_chargebacks = 'merchant_chargebacks',
  merchant_payment_intents = 'merchant_payment_intents',
  merchant_payments = 'merchant_payments',
  merchant_payouts = 'merchant_payouts',
  merchant_settled_transactions = 'merchant_settled_transactions',
  merchant_settlements = 'merchant_settlements',
  merchant_wallet_statements = 'merchant_wallet_statements'
}

export interface WalletReports extends PaginationExtends {
  __typename?: 'WalletReports';
  links: PaginationLinks;
  list: Array<WalletReport>;
}

export enum WalletType {
  HOSTED = 'HOSTED',
  SELF_HOSTED = 'SELF_HOSTED'
}

export enum WatchLists {
  allow = 'allow',
  block = 'block'
}

export interface Watchlist {
  __typename?: 'Watchlist';
  allow: Array<WatchlistEntry>;
  block: Array<WatchlistEntry>;
}

export enum WatchlistAccountType {
  ach = 'ach',
  credit_card = 'credit_card',
  wire = 'wire'
}

export interface WatchlistAllowReason {
  __typename?: 'WatchlistAllowReason';
  value: AllowEntityReason;
}

export enum WatchlistAvsCode {
  A = 'A',
  B = 'B',
  C = 'C',
  G = 'G',
  I = 'I',
  N = 'N',
  P = 'P',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  W = 'W',
  X = 'X',
  Z = 'Z'
}

export interface WatchlistBlockReason {
  __typename?: 'WatchlistBlockReason';
  value: BlockEntityReason;
}

export enum WatchlistCardClass {
  B = 'B',
  C = 'C',
  P = 'P',
  T = 'T'
}

export enum WatchlistCardType {
  mastercard = 'mastercard',
  visa = 'visa'
}

export enum WatchlistCreatedBy {
  circle = 'circle',
  customer = 'customer'
}

export enum WatchlistCvvCode {
  N = 'N',
  P = 'P',
  S = 'S',
  U = 'U'
}

export interface WatchlistEntity {
  __typename?: 'WatchlistEntity';
  value: Scalars['String']['output'];
}

export interface WatchlistEntry {
  __typename?: 'WatchlistEntry';
  active: Scalars['Boolean']['output'];
  createDate: Scalars['DateTime']['output'];
  createdBy: WatchlistCreatedBy;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  type: WatchlistTypes;
  updateDate: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
}

export enum WatchlistFundingSource {
  C = 'C',
  D = 'D',
  H = 'H',
  P = 'P',
  S = 'S'
}

export interface WatchlistType {
  __typename?: 'WatchlistType';
  header: Scalars['Boolean']['output'];
  value: WatchlistTypes;
}

export enum WatchlistTypes {
  aba_rtn = 'aba_rtn',
  account_type = 'account_type',
  avs_code = 'avs_code',
  billing_country = 'billing_country',
  billing_district = 'billing_district',
  billing_postal_code = 'billing_postal_code',
  card = 'card',
  card_class = 'card_class',
  card_type = 'card_type',
  customer = 'customer',
  cvv_code = 'cvv_code',
  email_address = 'email_address',
  email_domain = 'email_domain',
  fiat_billing = 'fiat_billing',
  fiat_general = 'fiat_general',
  fiat_issuer = 'fiat_issuer',
  fingerprint = 'fingerprint',
  funding_source = 'funding_source',
  iin = 'iin',
  ip_address = 'ip_address',
  issuer_country = 'issuer_country',
  issuer_district = 'issuer_district',
  phone_number = 'phone_number'
}

export interface WireBankAccount {
  __typename?: 'WireBankAccount';
  bankAddress?: Maybe<BankAddress>;
  billingDetails?: Maybe<BillingDetails>;
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ffcMemo?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  supportedRails?: Maybe<Array<Maybe<RailType>>>;
  trackingRef: Scalars['String']['output'];
  transferTypes?: Maybe<Array<Maybe<TransferTypes>>>;
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  userConfirmedWireSend?: Maybe<Scalars['Boolean']['output']>;
  virtualAccountEnabled?: Maybe<Scalars['Boolean']['output']>;
}

export interface WireBeneficiary {
  __typename?: 'WireBeneficiary';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface WireBeneficiaryBank {
  __typename?: 'WireBeneficiaryBank';
  accountNumber: Scalars['String']['output'];
  address: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  swiftCode?: Maybe<Scalars['String']['output']>;
}

export interface WireInstructionBeneficiary {
  __typename?: 'WireInstructionBeneficiary';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface WireInstructionBeneficiaryBank {
  __typename?: 'WireInstructionBeneficiaryBank';
  accountNumber: Scalars['String']['output'];
  address: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  currency: Currency;
  name: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  routingNumber: Scalars['String']['output'];
  swiftCode: Scalars['String']['output'];
}

export interface WireReceive {
  __typename?: 'WireReceive';
  fees?: Maybe<Amount>;
  payment: Payment;
  source?: Maybe<BankLocation>;
}

export interface WireTransferInstruction {
  __typename?: 'WireTransferInstruction';
  beneficiary: WireBeneficiary;
  beneficiaryBank: WireBeneficiaryBank;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  virtualAccountEnabled: Scalars['Boolean']['output'];
}

export interface WireTransferLimit {
  __typename?: 'WireTransferLimit';
  available: Amount;
  cap: Amount;
  duration: WireTransferLimitDurationEnum;
  id: Scalars['ID']['output'];
  used: Amount;
}

export enum WireTransferLimitDurationEnum {
  daily = 'daily',
  weekly = 'weekly'
}

export enum WireTransferTypeEnum {
  deposit = 'deposit',
  withdrawal = 'withdrawal'
}

export interface WireWithdrawal {
  __typename?: 'WireWithdrawal';
  destination?: Maybe<BankLocation>;
  fees?: Maybe<Amount>;
  payment: Payment;
}

export interface XpayBankAccount {
  __typename?: 'XpayBankAccount';
  createDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  status: BankAccountStatus;
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
}

export interface XpayReceive {
  __typename?: 'XpayReceive';
  payment: Payment;
  source?: Maybe<XpayBankAccount>;
}

export enum XpayTransactionType {
  xpay_receive = 'xpay_receive',
  xpay_withdrawal = 'xpay_withdrawal'
}

export interface XpayTransferInstruction {
  __typename?: 'XpayTransferInstruction';
  accountNumber: Scalars['String']['output'];
  trackingRef: Scalars['String']['output'];
  type: BankAccountType;
  virtualAccountEnabled: Scalars['Boolean']['output'];
}

export interface XpayWithdrawal {
  __typename?: 'XpayWithdrawal';
  destination?: Maybe<XpayBankAccount>;
  payment: Payment;
}

export type ApiKeyInfoFragment = { __typename?: 'APIKey', keyId: string, keyName?: string | null, keyPrefix: string, ipAllowList: Array<string>, roles: Array<string>, expiresOn: Date, createDate: Date, updateDate: Date, lastUsedDate?: Date | null };

export type ApiKeyQueryVariables = Exact<{
  keyId: Scalars['ID']['input'];
}>;


export type ApiKeyQuery = { __typename?: 'Query', apiKey: { __typename?: 'APIKey', keyId: string, keyName?: string | null, keyPrefix: string, ipAllowList: Array<string>, roles: Array<string>, expiresOn: Date, createDate: Date, updateDate: Date, lastUsedDate?: Date | null } };

export type ApiKeySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeySettingsQuery = { __typename?: 'Query', apiKeySettings: { __typename?: 'APIKeySettings', apiKeysLimit: number } };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'APIKey', keyId: string, keyName?: string | null, keyPrefix: string, ipAllowList: Array<string>, roles: Array<string>, expiresOn: Date, createDate: Date, updateDate: Date, lastUsedDate?: Date | null }> };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createAPIKey: { __typename?: 'CreateAPIKey', access_token: string, expires_in: number } };

export type RevokeApiKeyMutationVariables = Exact<{
  keyId: Scalars['ID']['input'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeAPIKey?: void | null };

export type UpdateApiKeyMutationVariables = Exact<{
  input: UpdateApiKeyInput;
}>;


export type UpdateApiKeyMutation = { __typename?: 'Mutation', updateAPIKey?: void | null };

export type ApiLogInfoFragment = { __typename?: 'APILog', id: string, timestamp: Date, method: ApiLogMethod, path: string, status: number, requestId?: string | null, resourceId?: string | null, idempotencyKey?: string | null, userAgent?: string | null, origin?: string | null, request?: Object | null, response?: Object | null };

export type ApiLogsInfoFragment = { __typename?: 'APILogs', list: Array<{ __typename?: 'APILog', id: string, timestamp: Date, method: ApiLogMethod, path: string, status: number, requestId?: string | null, resourceId?: string | null, idempotencyKey?: string | null, userAgent?: string | null, origin?: string | null, request?: Object | null, response?: Object | null }> };

export type ApiLogsQueryVariables = Exact<{
  input: ApiLogSearchInput;
}>;


export type ApiLogsQuery = { __typename?: 'Query', apiLogs: { __typename?: 'APILogs', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'APILog', id: string, timestamp: Date, method: ApiLogMethod, path: string, status: number, requestId?: string | null, resourceId?: string | null, idempotencyKey?: string | null, userAgent?: string | null, origin?: string | null, request?: Object | null, response?: Object | null }> } };

export type AddressBookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AddressBookQuery = { __typename?: 'Query', addressBook: { __typename?: 'AddressBook', id: string, chain: BlockchainAbbreviation, address: string, addressTag?: string | null, status: AddressBookStatus, createDate: Date, updateDate?: Date | null, metadata: { __typename?: 'AddressBookMetadata', nickname?: string | null, email?: string | null, bns?: string | null }, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null } };

export type AddressBookProposalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AddressBookProposalQuery = { __typename?: 'Query', addressBookProposal: { __typename?: 'AddressBookProposal', id: string, status: ProposalStatus, externalAddress: { __typename?: 'ExternalAddress', entityId: string, address: string, chain: BlockchainAbbreviation, currency: Currency, nickname: string, createDate: Date } } };

export type SubmitAddressBookApprovalVoteMutationVariables = Exact<{
  input: SubmitAddressBookApprovalVoteInput;
}>;


export type SubmitAddressBookApprovalVoteMutation = { __typename?: 'Mutation', submitAddressBookApprovalVote?: void | null };

export type AdminApprovalsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminApprovalsSettingsQuery = { __typename?: 'Query', adminApprovalsSettings: Array<{ __typename?: 'AdminApprovalsPolicy', approvalsNeeded: number, enabled: boolean, isSubmitted: boolean, policyId: string, proposerId: string, type: AdminApprovalPolicyType }> };

export type CancelPendingUserProposalMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;


export type CancelPendingUserProposalMutation = { __typename?: 'Mutation', cancelPendingUserProposal?: void | null };

export type CancelSubmittedSettingsChangeMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type CancelSubmittedSettingsChangeMutation = { __typename?: 'Mutation', cancelSubmittedSettingsChange?: void | null };

export type InviteUserWithAdminApprovalMutationVariables = Exact<{
  input: AdminApprovalsUserInvite;
}>;


export type InviteUserWithAdminApprovalMutation = { __typename?: 'Mutation', inviteUserWithAdminApproval?: void | null };

export type RemoveUserWithAdminApprovalMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RemoveUserWithAdminApprovalMutation = { __typename?: 'Mutation', removeUserWithAdminApproval?: void | null };

export type SetAdminApprovalsSettingsMutationVariables = Exact<{
  input: AdminApprovalsSettingsInput;
}>;


export type SetAdminApprovalsSettingsMutation = { __typename?: 'Mutation', setAdminApprovalsSettings?: void | null };

export type AmountInfoFragment = { __typename?: 'Amount', amount: string, currency: Currency };

export type PartialAmountInfoFragment = { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null };

export type ApprovalPoliciesQueryVariables = Exact<{
  input?: InputMaybe<ApprovalPoliciesInput>;
}>;


export type ApprovalPoliciesQuery = { __typename?: 'Query', approvalPolicies: { __typename?: 'ApprovalPolicies', userRemoval?: { __typename?: 'BaseApprovalPolicy', id: string, enabled: boolean, requires?: ApprovalPolicyQuorumType | null, type: ApprovalPolicyType, approverGroup?: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } | null } | null, userInvite?: { __typename?: 'BaseApprovalPolicy', id: string, enabled: boolean, requires?: ApprovalPolicyQuorumType | null, type: ApprovalPolicyType, approverGroup?: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } | null } | null, apiKey?: { __typename?: 'BaseApprovalPolicy', id: string, enabled: boolean, requires?: ApprovalPolicyQuorumType | null, type: ApprovalPolicyType, approverGroup?: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } | null } | null, blockchainAddress?: { __typename?: 'BaseApprovalPolicy', id: string, enabled: boolean, requires?: ApprovalPolicyQuorumType | null, type: ApprovalPolicyType, approverGroup?: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } | null } | null } };

export type BaseApprovalPolicyInfoFragment = { __typename?: 'BaseApprovalPolicy', id: string, enabled: boolean, requires?: ApprovalPolicyQuorumType | null, type: ApprovalPolicyType, approverGroup?: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } | null };

export type BalancesInfoFragment = { __typename?: 'Balances', total?: { __typename?: 'BalancesTotal', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null, main?: { __typename?: 'BalancesMain', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null };

export type BalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type BalancesQuery = { __typename?: 'Query', balances: { __typename?: 'Balances', total?: { __typename?: 'BalancesTotal', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null, main?: { __typename?: 'BalancesMain', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null } };

export type BalancesMainInfoFragment = { __typename?: 'BalancesMain', balance: { __typename?: 'Amount', amount: string, currency: Currency } };

export type BalancesMainQueryVariables = Exact<{
  currency?: InputMaybe<Currency>;
}>;


export type BalancesMainQuery = { __typename?: 'Query', balances: { __typename?: 'Balances', main?: { __typename?: 'BalancesMain', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null } };

export type BalancesTotalInfoFragment = { __typename?: 'BalancesTotal', balance: { __typename?: 'Amount', amount: string, currency: Currency } };

export type BalancesTotalQueryVariables = Exact<{
  currency?: InputMaybe<Currency>;
}>;


export type BalancesTotalQuery = { __typename?: 'Query', balances: { __typename?: 'Balances', total?: { __typename?: 'BalancesTotal', balance: { __typename?: 'Amount', amount: string, currency: Currency } } | null } };

export type AddCaBankAccountMutationVariables = Exact<{
  bankAccount: AddCaBankAccountInput;
}>;


export type AddCaBankAccountMutation = { __typename?: 'Mutation', addCaBankAccount: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type AddCbitBankAccountMutationVariables = Exact<{
  input: AddCbitBankAccountInput;
}>;


export type AddCbitBankAccountMutation = { __typename?: 'Mutation', addCbitBankAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type AddCubixBankAccountMutationVariables = Exact<{
  input: AddCubixBankAccountInput;
}>;


export type AddCubixBankAccountMutation = { __typename?: 'Mutation', addCubixBankAccount: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type AddIbanBankAccountMutationVariables = Exact<{
  bankAccount: AddIbanBankAccountInput;
}>;


export type AddIbanBankAccountMutation = { __typename?: 'Mutation', addIbanBankAccount: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type AddOtherBankAccountMutationVariables = Exact<{
  bankAccount: AddOtherBankAccountInput;
}>;


export type AddOtherBankAccountMutation = { __typename?: 'Mutation', addOtherBankAccount: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type AddPixBankAccountMutationVariables = Exact<{
  input: AddPixBankAccountInput;
}>;


export type AddPixBankAccountMutation = { __typename?: 'Mutation', addPixBankAccount: { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type AddRtpBankAccountMutationVariables = Exact<{
  input: AddRtpBankAccountInput;
}>;


export type AddRtpBankAccountMutation = { __typename?: 'Mutation', addRtpBankAccount: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } };

export type AddUsBankAccountMutationVariables = Exact<{
  bankAccount: AddUsBankAccountInput;
}>;


export type AddUsBankAccountMutation = { __typename?: 'Mutation', addUsBankAccount: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type AddXpayBankAccountMutationVariables = Exact<{
  input: AddXpayBankAccountInput;
}>;


export type AddXpayBankAccountMutation = { __typename?: 'Mutation', addXpayBankAccount: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

type BankAccountInfo_CbitBankAccount_Fragment = { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type BankAccountInfo_CubixBankAccount_Fragment = { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type BankAccountInfo_PixBankAccount_Fragment = { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

type BankAccountInfo_RtpBankAccount_Fragment = { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null };

type BankAccountInfo_SenBankAccount_Fragment = { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null };

type BankAccountInfo_SignetBankAccount_Fragment = { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type BankAccountInfo_WireBankAccount_Fragment = { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

type BankAccountInfo_XpayBankAccount_Fragment = { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type BankAccountInfoFragment = BankAccountInfo_CbitBankAccount_Fragment | BankAccountInfo_CubixBankAccount_Fragment | BankAccountInfo_PixBankAccount_Fragment | BankAccountInfo_RtpBankAccount_Fragment | BankAccountInfo_SenBankAccount_Fragment | BankAccountInfo_SignetBankAccount_Fragment | BankAccountInfo_WireBankAccount_Fragment | BankAccountInfo_XpayBankAccount_Fragment;

export type BankAccountsQueryVariables = Exact<{
  types?: InputMaybe<Array<BankAccountType> | BankAccountType>;
}>;


export type BankAccountsQuery = { __typename?: 'Query', bankAccounts: Array<{ __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }> };

export type BankSettingsInfoFragment = { __typename?: 'BankSettings', fiatAccountId?: string | null, createDate?: Date | null, nickname?: string | null, updateDate?: Date | null, metadata?: { __typename?: 'BankAccountMetadata', userConfirmedWireSend?: boolean | null } | null };

export type CbitBankAccountInfoFragment = { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type CbitBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type CbitBankAccountQuery = { __typename?: 'Query', cbitBankAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type CubixBankAccountInfoFragment = { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type CubixBankAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type CubixBankAccountQuery = { __typename?: 'Query', cubixBankAccount: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type MerchantAchBankAccountInfoFragment = { __typename?: 'MerchantAchBankAccount', id: string, status: BankAccountStatus, accountNumber: string, routingNumber?: string | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> };

export type MerchantAchBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type MerchantAchBankAccountQuery = { __typename?: 'Query', merchantAchBankAccount: { __typename?: 'MerchantAchBankAccount', id: string, status: BankAccountStatus, accountNumber: string, routingNumber?: string | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> } };

export type MerchantSepaBankAccountInfoFragment = { __typename?: 'MerchantSepaBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> };

export type MerchantSepaBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type MerchantSepaBankAccountQuery = { __typename?: 'Query', merchantSepaBankAccount: { __typename?: 'MerchantSepaBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> } };

export type MerchantWireBankAccountInfoFragment = { __typename?: 'MerchantWireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend: boolean, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> };

export type PixBankAccountInfoFragment = { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

export type PixBankAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type PixBankAccountQuery = { __typename?: 'Query', pixBankAccount: { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type RtpBankAccountInfoFragment = { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null };

export type RtpBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type RtpBankAccountQuery = { __typename?: 'Query', rtpBankAccount: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } };

export type SenBankAccountInfoFragment = { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null };

export type SenBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type SenBankAccountQuery = { __typename?: 'Query', senBankAccount: { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } };

export type SetBankAccountNicknameMutationVariables = Exact<{
  bankAccountId: Scalars['ID']['input'];
  accountType: BankAccountType;
  nickname: Scalars['String']['input'];
}>;


export type SetBankAccountNicknameMutation = { __typename?: 'Mutation', setBankAccountNickname: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type SetWireBankAccountMetadataMutationVariables = Exact<{
  input: SetWireBankAccountMetadataInput;
}>;


export type SetWireBankAccountMetadataMutation = { __typename?: 'Mutation', setWireBankAccountMetadata: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type SignetBankAccountInfoFragment = { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type SignetBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type SignetBankAccountQuery = { __typename?: 'Query', signetBankAccount: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type TransferTypesInfoFragment = { __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null };

export type WireBankAccountInfoFragment = { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

export type WireBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type WireBankAccountQuery = { __typename?: 'Query', wireBankAccount: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } };

export type XpayBankAccountInfoFragment = { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type XpayBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type XpayBankAccountQuery = { __typename?: 'Query', xpayBankAccount: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type AceBlockchainDepositAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type AceBlockchainDepositAddressQuery = { __typename?: 'Query', aceBlockchainDepositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null };

export type AddBlockchainDepositAddressesMutationVariables = Exact<{
  input: Array<AddBlockchainDepositAddressInput> | AddBlockchainDepositAddressInput;
}>;


export type AddBlockchainDepositAddressesMutation = { __typename?: 'Mutation', addBlockchainDepositAddresses: Array<{ __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null }> };

export type AddBlockchainRecipientAddressMutationVariables = Exact<{
  input: AddBlockchainRecipientAddressInput;
}>;


export type AddBlockchainRecipientAddressMutation = { __typename?: 'Mutation', addBlockchainRecipientAddress?: { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } | null };

export type BlockchainInfoFragment = { __typename?: 'Blockchain', chain: BlockchainAbbreviation, name: string, icon: AssetIcon, isBridged: boolean, isTRMSupported: boolean, isAceSupported: boolean, chainId?: number | null };

export type BlockchainAssetInfoFragment = { __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null };

export type BlockchainAssetsQueryVariables = Exact<{
  chain?: InputMaybe<BlockchainAbbreviation>;
}>;


export type BlockchainAssetsQuery = { __typename?: 'Query', blockchainAssets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> };

export type BlockchainDepositAddressInfoFragment = { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null };

export type BlockchainDepositAddressQueryVariables = Exact<{
  input: AddBlockchainDepositAddressInput;
}>;


export type BlockchainDepositAddressQuery = { __typename?: 'Query', blockchainDepositAddress: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } };

export type BlockchainDepositAddressesQueryVariables = Exact<{
  input?: InputMaybe<BlockchainAddressFilterInput>;
}>;


export type BlockchainDepositAddressesQuery = { __typename?: 'Query', blockchainDepositAddresses: Array<{ __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null }> };

export type BlockchainRecipientAddressInfoFragment = { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null };

export type BlockchainRecipientAddressLocationInfoFragment = { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null };

export type BlockchainRecipientAddressWithMetadataInfoFragment = { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> };

export type BlockchainRecipientAddressWithMetadataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BlockchainRecipientAddressWithMetadataQuery = { __typename?: 'Query', blockchainRecipientAddressWithMetadata?: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } | null };

export type BlockchainRecipientAddressesQueryVariables = Exact<{
  input?: InputMaybe<BlockchainAddressFilterInput>;
}>;


export type BlockchainRecipientAddressesQuery = { __typename?: 'Query', blockchainRecipientAddresses: Array<{ __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }> };

export type BlockchainRecipientAddressesWithMetadataQueryVariables = Exact<{
  filter?: InputMaybe<BlockchainRecipientAddressesWithMetadataInput>;
}>;


export type BlockchainRecipientAddressesWithMetadataQuery = { __typename?: 'Query', blockchainRecipientAddressesWithMetadata: Array<{ __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> }> };

export type BlockchainsQueryVariables = Exact<{
  input: BlockchainsFilterInput;
}>;


export type BlockchainsQuery = { __typename?: 'Query', blockchains: Array<{ __typename?: 'Blockchain', chain: BlockchainAbbreviation, name: string, icon: AssetIcon, isBridged: boolean, isTRMSupported: boolean, isAceSupported: boolean, chainId?: number | null }> };

export type CircleInternalAddressInfoFragment = { __typename?: 'CircleInternalAddress', id: string, addressRefId?: string | null, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, currency: Currency, icon: AssetIcon, state: InternalAddressState };

export type CreateBlockchainRecipientAddressWithMetadataMutationVariables = Exact<{
  input: CreateBlockchainRecipientAddressWithMetadataInput;
}>;


export type CreateBlockchainRecipientAddressWithMetadataMutation = { __typename?: 'Mutation', createBlockchainRecipientAddressWithMetadata: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } };

export type DirectInternalAddressInfoFragment = { __typename?: 'DirectInternalAddress', id: string, name: string, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, state: InternalAddressState, vaultId: string, asset: { __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null } };

type InternalAddressInfo_CircleInternalAddress_Fragment = { __typename?: 'CircleInternalAddress', id: string, addressRefId?: string | null, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, currency: Currency, icon: AssetIcon, state: InternalAddressState };

type InternalAddressInfo_DirectInternalAddress_Fragment = { __typename?: 'DirectInternalAddress', id: string, name: string, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, state: InternalAddressState, vaultId: string, asset: { __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null } };

export type InternalAddressInfoFragment = InternalAddressInfo_CircleInternalAddress_Fragment | InternalAddressInfo_DirectInternalAddress_Fragment;

export type InternalAddressesQueryVariables = Exact<{
  filter?: InputMaybe<InternalAddressInput>;
}>;


export type InternalAddressesQuery = { __typename?: 'Query', internalAddresses: Array<{ __typename?: 'CircleInternalAddress', id: string, addressRefId?: string | null, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, currency: Currency, icon: AssetIcon, state: InternalAddressState } | { __typename?: 'DirectInternalAddress', id: string, name: string, address?: string | null, type: InternalAddressType, blockchain: BlockchainAbbreviation, state: InternalAddressState, vaultId: string, asset: { __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null } }> };

export type OwnerTypeQueryVariables = Exact<{
  transactionId: Scalars['ID']['input'];
  addressId: Scalars['ID']['input'];
}>;


export type OwnerTypeQuery = { __typename?: 'Query', paymentDetails: { __typename?: 'CbitReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CbitWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CubixReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CubixWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'GrossRedemptionFee', payment: { __typename?: 'GrossRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } } | { __typename?: 'NetRedemptionFee', payment: { __typename?: 'NetRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } } | { __typename?: 'OnchainReceive', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null } | { __typename?: 'OnchainSend', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null } | { __typename?: 'RtpReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null } | { __typename?: 'RtpWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null } | { __typename?: 'SenReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SenWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaInstantReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaInstantWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SettlementCreditFee', payment: { __typename?: 'SettlementCreditFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } } | { __typename?: 'SettlementCreditReceive', payment: { __typename?: 'SettlementCreditReceivePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'ReceiveLocation', type: LocationType, id: string } } } | { __typename?: 'SignetReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'SignetWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'WireReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'WireWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'XpayReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'XpayWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null }, blockchainRecipientAddressWithMetadata?: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } | null };

export type RemoveBlockchainRecipientAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type RemoveBlockchainRecipientAddressMutation = { __typename?: 'Mutation', removeBlockchainRecipientAddress?: void | null };

export type SetBlockchainRecipientAddressAdditionalInfoMutationVariables = Exact<{
  input: SetRecipientAddressAdditionalInfoInput;
}>;


export type SetBlockchainRecipientAddressAdditionalInfoMutation = { __typename?: 'Mutation', setBlockchainRecipientAddressAdditionalInfo: { __typename?: 'AddressStatusResponse', state: BlockchainAddressStatus } };

export type SetBlockchainRecipientAddressBeneficiaryInfoMutationVariables = Exact<{
  input: SetRecipientAddressBeneficiaryInfoInput;
}>;


export type SetBlockchainRecipientAddressBeneficiaryInfoMutation = { __typename?: 'Mutation', setBlockchainRecipientAddressBeneficiaryInfo?: void | null };

export type SetBlockchainRecipientAddressWithMetadataMutationVariables = Exact<{
  input: SetBlockchainRecipientAddressWithMetadataInput;
}>;


export type SetBlockchainRecipientAddressWithMetadataMutation = { __typename?: 'Mutation', setBlockchainRecipientAddressWithMetadata: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } };

export type WalletProvidersInfoFragment = { __typename?: 'WalletProvider', id: string, name: string, network?: ProviderNetwork | null, active: boolean, externalVendorMetadata?: Array<{ __typename?: 'VendorMetadata', externalId: string, externalSource: string }> | null };

export type WalletProvidersQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WalletProvidersQuery = { __typename?: 'Query', walletProviders: Array<{ __typename?: 'WalletProvider', id: string, name: string, network?: ProviderNetwork | null, active: boolean, externalVendorMetadata?: Array<{ __typename?: 'VendorMetadata', externalId: string, externalSource: string }> | null }> };

export type CircleWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type CircleWalletsQuery = { __typename?: 'Query', circleWallets: Array<{ __typename?: 'CircleWallet', name: string, icon: AssetIcon, balance: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type CircleWalletsFtuStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CircleWalletsFtuStatusQuery = { __typename?: 'Query', circleWalletsFtuStatus: { __typename?: 'CircleWalletsFtuStatus', linkStatus: BankAccountFtuLinkStatus, hasDepositedOnce: boolean } };

export type CountriesInfoFragment = { __typename?: 'Countries', codes: Array<CountryCode>, list: Array<{ __typename?: 'Country', code: CountryCode, link: { __typename?: 'CountryLink', locatedIn: boolean, registeredIn: boolean }, support: { __typename?: 'CountrySupport', iban?: boolean | null, nonIban?: boolean | null }, onboarding: { __typename?: 'CountryOnboarding', eea?: boolean | null } }> };

export type CountriesQueryVariables = Exact<{
  filter?: InputMaybe<CountriesInput>;
}>;


export type CountriesQuery = { __typename?: 'Query', countries: { __typename?: 'Countries', codes: Array<CountryCode>, list: Array<{ __typename?: 'Country', code: CountryCode, link: { __typename?: 'CountryLink', locatedIn: boolean, registeredIn: boolean }, support: { __typename?: 'CountrySupport', iban?: boolean | null, nonIban?: boolean | null }, onboarding: { __typename?: 'CountryOnboarding', eea?: boolean | null } }> } };

export type CreateDeleteUserGroupProposalMutationVariables = Exact<{
  input: CreateDeleteUserGroupProposalInput;
}>;


export type CreateDeleteUserGroupProposalMutation = { __typename?: 'Mutation', createDeleteUserGroupProposal?: void | null };

export type CreateUpdateUserGroupProposalMutationVariables = Exact<{
  input: CreateUpdateUserGroupProposalInput;
}>;


export type CreateUpdateUserGroupProposalMutation = { __typename?: 'Mutation', createUpdateUserGroupProposal?: void | null };

export type CustodyAmountInfoFragment = { __typename?: 'CustodyAmount', amount: string, asset: { __typename?: 'CustodyAssetMetadata', symbol: string, icon: AssetIcon, name: string, decimals: number } };

export type CustodyAssetMetadataInfoFragment = { __typename?: 'CustodyAssetMetadata', symbol: string, icon: AssetIcon, name: string, decimals: number };

export type CustodyBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustodyBalancesQuery = { __typename?: 'Query', custodyBalances: { __typename?: 'CustodyAmount', amount: string, asset: { __typename?: 'CustodyAssetMetadata', symbol: string, icon: AssetIcon, name: string, decimals: number } } };

export type RolrSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RolrSettingsQuery = { __typename?: 'Query', rolrSettings?: { __typename?: 'RolrSettings', accountClosureDate?: Date | null } | null };

export type DelayedWithdrawalsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type DelayedWithdrawalsSettingsQuery = { __typename?: 'Query', delayedWithdrawalsSettings: { __typename?: 'DelayedWithdrawalsSettings', enabled: boolean, disabledAfterHours?: number | null, delayHours?: number | null } };

export type SetDelayedWithdrawalsSettingsMutationVariables = Exact<{
  input: DelayedWithdrawalsSettingsInput;
}>;


export type SetDelayedWithdrawalsSettingsMutation = { __typename?: 'Mutation', setDelayedWithdrawalsSettings: { __typename?: 'DelayedWithdrawalsSettings', enabled: boolean, disabledAfterHours?: number | null, delayHours?: number | null } };

export type DepositInfoFragment = { __typename?: 'Deposit', id: string, status?: DepositStatus | null, createDate: Date, updateDate: Date, source?: { __typename?: 'DepositSource', id: string, type: string, name?: string | null } | null, destination?: { __typename?: 'DepositDestination', id: string, type?: string | null } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null };

export type DepositQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DepositQuery = { __typename?: 'Query', deposit: { __typename?: 'Deposit', id: string, status?: DepositStatus | null, createDate: Date, updateDate: Date, source?: { __typename?: 'DepositSource', id: string, type: string, name?: string | null } | null, destination?: { __typename?: 'DepositDestination', id: string, type?: string | null } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null } };

export type DepositDestinationInfoFragment = { __typename?: 'DepositDestination', id: string, type?: string | null };

export type DepositSourceInfoFragment = { __typename?: 'DepositSource', id: string, type: string, name?: string | null };

export type SubmitEmailApprovalVoteMutationVariables = Exact<{
  input: SubmitEmailApprovalVoteInput;
}>;


export type SubmitEmailApprovalVoteMutation = { __typename?: 'Mutation', submitEmailApprovalVote?: void | null };

export type EntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type EntitiesQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Entity', entityId: string, entityType: string, institutionName: string, group: string, country?: CountryCode | null, district?: string | null, entityAccountNumber?: string | null, legalEntity?: string | null, accountType?: string | null } | null> | null };

export type EntityInfoFragment = { __typename?: 'Entity', entityId: string, entityType: string, institutionName: string, group: string, country?: CountryCode | null, district?: string | null, entityAccountNumber?: string | null, legalEntity?: string | null, accountType?: string | null };

export type EntityQueryVariables = Exact<{
  entityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EntityQuery = { __typename?: 'Query', entity?: { __typename?: 'Entity', entityId: string, entityType: string, institutionName: string, group: string, country?: CountryCode | null, district?: string | null, entityAccountNumber?: string | null, legalEntity?: string | null, accountType?: string | null } | null };

export type EntityLimitsQueryVariables = Exact<{
  currency: Currency;
  type: WireTransferTypeEnum;
}>;


export type EntityLimitsQuery = { __typename?: 'Query', entityLimits?: { __typename?: 'EntityLimits', currency: Currency, total: string, used: string, available: string, duration: WireTransferLimitDurationEnum } | null };

export type ActivateMfaMutationVariables = Exact<{
  factorId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type ActivateMfaMutation = { __typename?: 'Mutation', activateMfa?: void | null };

export type EligibleUserFactorsQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleUserFactorsQuery = { __typename?: 'Query', eligibleUserFactors: Array<{ __typename?: 'EligibleUserFactor', type: FactorType, provider: FactorProvider, status: FactorStatus }> };

export type EnrollInOktaVerifyMfaMutationVariables = Exact<{ [key: string]: never; }>;


export type EnrollInOktaVerifyMfaMutation = { __typename?: 'Mutation', enrollInOktaVerifyMfa: { __typename?: 'EnrolledFactorInfo', id: string, qrHref: string } };

export type EnrollInTotpMfaMutationVariables = Exact<{ [key: string]: never; }>;


export type EnrollInTotpMfaMutation = { __typename?: 'Mutation', enrollInTotpMfa: { __typename?: 'EnrolledFactorInfo', id: string, qrHref: string, sharedSecret?: string | null } };

export type FactorInfoFragment = { __typename?: 'Factor', id: string, type: FactorType, provider: FactorProvider, status: FactorStatus, dateCreated?: Date | null };

export type FactorQueryVariables = Exact<{
  factorType: FactorType;
}>;


export type FactorQuery = { __typename?: 'Query', factor?: { __typename?: 'Factor', id: string, type: FactorType, provider: FactorProvider, status: FactorStatus, dateCreated?: Date | null } | null };

export type OktaVerifyActivationStatusQueryVariables = Exact<{
  input: OktaVerifyActivationStatusInput;
}>;


export type OktaVerifyActivationStatusQuery = { __typename?: 'Query', oktaVerifyActivationStatus: { __typename?: 'OktaVerifyActivationStatus', status: FactorActivationStatus } };

export type ScaFactorInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ScaFactorInfoQuery = { __typename?: 'Query', scaFactorInfo: { __typename?: 'ScaFactorInfo', isScaRequired: boolean, oktaVerify?: { __typename?: 'EligibleUserFactor', status: FactorStatus } | null, pinCode?: { __typename?: 'EligibleUserFactor', status: FactorStatus } | null } };

export type SetMfaRequiredMutationVariables = Exact<{ [key: string]: never; }>;


export type SetMfaRequiredMutation = { __typename?: 'Mutation', setMfaRequired?: void | null };

export type SignInFactorQueryVariables = Exact<{ [key: string]: never; }>;


export type SignInFactorQuery = { __typename?: 'Query', signInFactor: { __typename?: 'SignInFactor', enrolled: boolean } };

export type FeeReportInfoFragment = { __typename?: 'FeeReport', id: string, status: FeeStatus, valueDate: Date, createDate: Date, thresholdResetTimestamp: Date, fee: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPayoutAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPaymentAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedNetAmount: { __typename?: 'Amount', amount: string, currency: Currency } };

export type FeeReportsInfoFragment = { __typename?: 'FeeReports', list: Array<{ __typename?: 'FeeReport', id: string, status: FeeStatus, valueDate: Date, createDate: Date, thresholdResetTimestamp: Date, fee: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPayoutAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPaymentAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedNetAmount: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type FeeReportsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<FeeReportsFilterInput>;
}>;


export type FeeReportsQuery = { __typename?: 'Query', feeReports: { __typename?: 'FeeReports', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'FeeReport', id: string, status: FeeStatus, valueDate: Date, createDate: Date, thresholdResetTimestamp: Date, fee: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPayoutAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedPaymentAmount: { __typename?: 'Amount', amount: string, currency: Currency }, cumulatedNetAmount: { __typename?: 'Amount', amount: string, currency: Currency } }> } };

export type FxQuoteQueryVariables = Exact<{
  input: GetFxQuoteInput;
}>;


export type FxQuoteQuery = { __typename?: 'Query', fxQuote: { __typename?: 'FxQuote', id: string, rate: number, expiry?: Date | null, from: { __typename?: 'Amount', amount: string, currency: Currency }, to: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type FxQuoteInputInfoFragment = { __typename?: 'FxQuote', id: string, rate: number, expiry?: Date | null, from: { __typename?: 'Amount', amount: string, currency: Currency }, to: { __typename?: 'Amount', amount: string, currency: Currency } };

export type IdentityChallengeQueryVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type IdentityChallengeQuery = { __typename?: 'Query', identityChallenge: { __typename?: 'IdentityChallenge', id: string, addressId: string, sourceAddress: string, destinationAddress: string, chain: BlockchainAbbreviation, paymentId?: string | null, status: IdentityChallengeStatus, createDate: Date, updateDate?: Date | null, expiryDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type AllInAppNotificationsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type AllInAppNotificationsQuery = { __typename?: 'Query', allInAppNotifications: { __typename?: 'InAppNotifications', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } } | { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } } | { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } }> } };

type BaseInAppNotificationInfo_EmailVerifiedNotification_Fragment = { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType };

type BaseInAppNotificationInfo_MainWalletPendingTransactionApprovalRequestNotification_Fragment = { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType };

type BaseInAppNotificationInfo_MainWalletPolicyApprovalRequestNotification_Fragment = { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType };

type BaseInAppNotificationInfo_PreQualAutoApprovedNotification_Fragment = { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType };

export type BaseInAppNotificationInfoFragment = BaseInAppNotificationInfo_EmailVerifiedNotification_Fragment | BaseInAppNotificationInfo_MainWalletPendingTransactionApprovalRequestNotification_Fragment | BaseInAppNotificationInfo_MainWalletPolicyApprovalRequestNotification_Fragment | BaseInAppNotificationInfo_PreQualAutoApprovedNotification_Fragment;

export type EmailVerifiedNotificationInfoFragment = { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } };

export type FilteredLongPollInAppNotificationQueryVariables = Exact<{
  input: FilteredLongPollInAppNotificationInput;
}>;


export type FilteredLongPollInAppNotificationQuery = { __typename?: 'Query', filteredLongPollInAppNotification?: { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } } | { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } } | { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } } | null };

type InAppNotificationInfo_EmailVerifiedNotification_Fragment = { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } };

type InAppNotificationInfo_MainWalletPendingTransactionApprovalRequestNotification_Fragment = { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } };

type InAppNotificationInfo_MainWalletPolicyApprovalRequestNotification_Fragment = { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } };

type InAppNotificationInfo_PreQualAutoApprovedNotification_Fragment = { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } };

export type InAppNotificationInfoFragment = InAppNotificationInfo_EmailVerifiedNotification_Fragment | InAppNotificationInfo_MainWalletPendingTransactionApprovalRequestNotification_Fragment | InAppNotificationInfo_MainWalletPolicyApprovalRequestNotification_Fragment | InAppNotificationInfo_PreQualAutoApprovedNotification_Fragment;

export type InAppNotificationsInfoFragment = { __typename?: 'InAppNotifications', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } } | { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } } | { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } }> };

export type LongPollEmailVerifiedNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type LongPollEmailVerifiedNotificationQuery = { __typename?: 'Query', longPollEmailVerifiedNotification?: { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | null };

export type LongPollInAppNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type LongPollInAppNotificationQuery = { __typename?: 'Query', longPollInAppNotification?: { __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } } | { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } } | { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } } | null };

export type MainWalletPendingTransactionApprovalRequestNotificationInfoFragment = { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } };

export type MainWalletPolicyApprovalRequestNotificationInfoFragment = { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } };

export type MarkInAppNotificationsAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkInAppNotificationsAsReadMutation = { __typename?: 'Mutation', markInAppNotificationsAsRead?: void | null };

export type PreQualAutoApprovedNotificationInfoFragment = { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } };

export type TestPushInAppNotificationMessageMutationVariables = Exact<{ [key: string]: never; }>;


export type TestPushInAppNotificationMessageMutation = { __typename?: 'Mutation', testPushInAppNotificationMessage?: void | null };

export type UnreadInAppNotificationsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type UnreadInAppNotificationsQuery = { __typename?: 'Query', unreadInAppNotifications: { __typename?: 'InAppNotifications', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'EmailVerifiedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'EmailVerifiedNotificationPayload', emailVerified: boolean } } | { __typename?: 'MainWalletPendingTransactionApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPendingTransactionApprovalRequestPayload', id: string, type: WalletApprovalTransactionType, amount: number, currency: Currency, initiatorFullName: string, initiatorEmail: string } } | { __typename?: 'MainWalletPolicyApprovalRequestNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'MainWalletPolicyApprovalRequestNotificationPayload', policyId: string, policyName: string, currency: Currency, policyCreator: string } } | { __typename?: 'PreQualAutoApprovedNotification', id: string, createDate: Date, isRead: boolean, type: InAppNotificationType, payload: { __typename?: 'PreQualAutoApprovedNotificationPayload', approved: boolean } }> } };

export type UnreadInAppNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadInAppNotificationsCountQuery = { __typename?: 'Query', unreadInAppNotificationsCount: number };

export type BillingProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingProfileQuery = { __typename?: 'Query', billingProfile?: { __typename?: 'BillingProfileDetails', phoneNumber?: string | null, vatNumber?: string | null, billingContact?: { __typename?: 'BillingContact', email?: string | null } | null, billingAddress?: { __typename?: 'BillingAddress', line1?: string | null, line2?: string | null, city?: string | null, district?: string | null, postalCode?: string | null, country?: string | null } | null } | null };

export type InvoiceInfoFragment = { __typename?: 'Invoice', id: string, invoiceDate: Date, invoiceNumber: string, status: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency } };

export type InvoiceDetailInfoFragment = { __typename?: 'InvoiceDetail', id: string, invoiceDate: Date, invoiceNumber: string, status: InvoiceStatus, invoiceLink: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency } };

export type InvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InvoiceDetailQuery = { __typename?: 'Query', invoiceDetail: { __typename?: 'InvoiceDetail', id: string, invoiceDate: Date, invoiceNumber: string, status: InvoiceStatus, invoiceLink: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type InvoicePaymentInfoFragment = { __typename?: 'InvoicePayment', id: string, paymentId: string, type: InvoicePaymentType, status: InvoiceStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } };

export type InvoicePaymentMutationVariables = Exact<{
  invoicePaymentInput: InvoicePaymentInput;
}>;


export type InvoicePaymentMutation = { __typename?: 'Mutation', invoicePayment: { __typename?: 'InvoicePayment', id: string, paymentId: string, type: InvoicePaymentType, status: InvoiceStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type InvoicePaymentDetailInfoFragment = { __typename?: 'InvoicePaymentDetail', id: string, invoiceDate: Date, invoiceNumber: string, status: InvoiceStatus, invoiceLink: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency }, latestPaymentDetails?: { __typename?: 'InvoicePayment', id: string, paymentId: string, type: InvoicePaymentType, status: InvoiceStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } | null };

export type InvoicePaymentDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InvoicePaymentDetailQuery = { __typename?: 'Query', invoicePaymentDetail: { __typename?: 'InvoicePaymentDetail', id: string, invoiceDate: Date, invoiceNumber: string, status: InvoiceStatus, invoiceLink: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency }, latestPaymentDetails?: { __typename?: 'InvoicePayment', id: string, paymentId: string, type: InvoicePaymentType, status: InvoiceStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } | null } };

export type InvoicesInfoFragment = { __typename?: 'Invoices', list: Array<{ __typename?: 'Invoice', id: string, invoiceDate: Date, invoiceNumber: string, status: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type InvoicesQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'Invoices', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'Invoice', id: string, invoiceDate: Date, invoiceNumber: string, status: string, amountTotal: { __typename?: 'Amount', amount: string, currency: Currency }, amountDue: { __typename?: 'Amount', amount: string, currency: Currency }, amountPaid: { __typename?: 'Amount', amount: string, currency: Currency } }> } };

export type UpdateBillingProfileMutationVariables = Exact<{
  input: UpdateBillingProfileInput;
}>;


export type UpdateBillingProfileMutation = { __typename?: 'Mutation', updateBillingProfile?: void | null };

export type ClientIpAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientIpAddressQuery = { __typename?: 'Query', clientIpAddress: { __typename?: 'ClientIpAddress', ip?: string | null } };

export type CreateIpAllowListingIpAddressMutationVariables = Exact<{
  input: CreateIpAllowListingIpAddressInput;
}>;


export type CreateIpAllowListingIpAddressMutation = { __typename?: 'Mutation', createIpAllowListingIpAddress: boolean };

export type IpAllowListingIpAddressInfoFragment = { __typename?: 'IpAllowListingIpAddress', id: string, type: IpAllowListingIpAddressType, value: string, createDate: Date };

export type IpAllowListingIpAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type IpAllowListingIpAddressesQuery = { __typename?: 'Query', ipAllowListingIpAddresses: Array<{ __typename?: 'IpAllowListingIpAddress', id: string, type: IpAllowListingIpAddressType, value: string, createDate: Date }> };

export type IpAllowListingSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type IpAllowListingSettingQuery = { __typename?: 'Query', ipAllowListingSetting: { __typename?: 'IpAllowListingSetting', enabled: boolean } };

export type RemoveIpAllowListingIpAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveIpAllowListingIpAddressMutation = { __typename?: 'Mutation', removeIpAllowListingIpAddress: boolean };

export type SetIpAllowListingSettingMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SetIpAllowListingSettingMutation = { __typename?: 'Mutation', setIpAllowListingSetting: boolean };

export type ChargebackHistoryInfoFragment = { __typename?: 'ChargebackHistory', type: string, description?: string | null, settlementId?: string | null, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fee?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type MerchantChargebackInfoFragment = { __typename?: 'MerchantChargeback', id: string, type: string, description?: string | null, category: string, paymentId: string, merchantId: string, reasonCode: string, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fees: { __typename?: 'Amount', amount: string, currency: Currency }, history: Array<{ __typename?: 'ChargebackHistory', type: string, description?: string | null, settlementId?: string | null, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fee?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> };

export type MerchantChargebackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantChargebackQuery = { __typename?: 'Query', merchantChargeback: { __typename?: 'MerchantChargeback', id: string, type: string, description?: string | null, category: string, paymentId: string, merchantId: string, reasonCode: string, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fees: { __typename?: 'Amount', amount: string, currency: Currency }, history: Array<{ __typename?: 'ChargebackHistory', type: string, description?: string | null, settlementId?: string | null, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fee?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> } };

export type MerchantChargebacksInfoFragment = { __typename?: 'MerchantChargebacks', list: Array<{ __typename?: 'MerchantChargeback', id: string, type: string, description?: string | null, category: string, paymentId: string, merchantId: string, reasonCode: string, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fees: { __typename?: 'Amount', amount: string, currency: Currency }, history: Array<{ __typename?: 'ChargebackHistory', type: string, description?: string | null, settlementId?: string | null, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fee?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> }> };

export type MerchantChargebacksQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  category?: InputMaybe<ChargebackCategory>;
}>;


export type MerchantChargebacksQuery = { __typename?: 'Query', merchantChargebacks: { __typename?: 'MerchantChargebacks', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'MerchantChargeback', id: string, type: string, description?: string | null, category: string, paymentId: string, merchantId: string, reasonCode: string, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fees: { __typename?: 'Amount', amount: string, currency: Currency }, history: Array<{ __typename?: 'ChargebackHistory', type: string, description?: string | null, settlementId?: string | null, createDate: Date, chargebackAmount: { __typename?: 'Amount', amount: string, currency: Currency }, fee?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> }> } };

export type AddMerchantCreditCardMutationVariables = Exact<{
  merchantCreditCardInput: MerchantCreditCardInput;
}>;


export type AddMerchantCreditCardMutation = { __typename?: 'Mutation', addMerchantCreditCard: { __typename?: 'MerchantCreditCard', createDate?: Date | null, errorCode?: string | null, expMonth: string, expYear: string, id: string, last4: string, network: string, verification?: { __typename?: 'MerchantCardVerification', avs?: string | null, cvv?: string | null } | null } };

export type MerchantCardVerificationInfoFragment = { __typename?: 'MerchantCardVerification', avs?: string | null, cvv?: string | null };

export type MerchantCreditCardInfoFragment = { __typename?: 'MerchantCreditCard', createDate?: Date | null, errorCode?: string | null, expMonth: string, expYear: string, id: string, last4: string, network: string, verification?: { __typename?: 'MerchantCardVerification', avs?: string | null, cvv?: string | null } | null };

export type RemoveMerchantCreditCardMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveMerchantCreditCardMutation = { __typename?: 'Mutation', removeMerchantCreditCard: { __typename?: 'MerchantCreditCardRemoval', id: string } };

export type SetMerchantCreditCardMutationVariables = Exact<{
  setMerchantCreditCardInput: SetMerchantCreditCardInput;
}>;


export type SetMerchantCreditCardMutation = { __typename?: 'Mutation', setMerchantCreditCard: { __typename?: 'MerchantCreditCard', createDate?: Date | null, errorCode?: string | null, expMonth: string, expYear: string, id: string, last4: string, network: string, verification?: { __typename?: 'MerchantCardVerification', avs?: string | null, cvv?: string | null } | null } };

export type MerchantPaymentInfoFragment = { __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null };

export type MerchantPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantPaymentQuery = { __typename?: 'Query', merchantPayment: { __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null } };

export type MerchantPaymentCancellationMutationVariables = Exact<{
  input: MerchantPaymentCancellationInput;
}>;


export type MerchantPaymentCancellationMutation = { __typename?: 'Mutation', merchantPaymentCancellation: { __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null } };

export type MerchantPaymentNetworkFeeInfoFragment = { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer };

export type MerchantPaymentOperationStatusInfoFragment = { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date };

export type MerchantPaymentRefundInfoFragment = { __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type MerchantPaymentRefundMutationVariables = Exact<{
  input: MerchantPaymentRefundInput;
}>;


export type MerchantPaymentRefundMutation = { __typename?: 'Mutation', merchantPaymentRefund: { __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null } };

export type MerchantPaymentSourceInfoFragment = { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType };

export type MerchantPaymentsInfoFragment = { __typename?: 'MerchantPayments', list: Array<{ __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null }> };

export type MerchantPaymentsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<MerchantPaymentFilterInput>;
}>;


export type MerchantPaymentsQuery = { __typename?: 'Query', merchantPayments: { __typename?: 'MerchantPayments', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null }> } };

export type MerchantPaymentIntentInfoFragment = { __typename?: 'MerchantPaymentIntent', id: string, settlementCurrency: Currency, paymentIds?: Array<string> | null, status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, createDate: Date, updateDate: Date, expiresOn?: Date | null, currency?: Currency | null, type?: MerchantPaymentIntentType | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountPaid?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountRefunded?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: Array<{ __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null> | null, totalPaymentFees?: { __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null, paymentMethods: Array<{ __typename?: 'MerchantPaymentIntentPaymentMethod', type: MerchantPaymentIntentPaymentMethodType, chain: BlockchainAbbreviation, address?: string | null } | null>, timeline: Array<{ __typename?: 'MerchantPaymentIntentTimelineItem', status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, time: Date }> };

export type MerchantPaymentIntentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantPaymentIntentQuery = { __typename?: 'Query', merchantPaymentIntent: { __typename?: 'MerchantPaymentIntent', id: string, settlementCurrency: Currency, paymentIds?: Array<string> | null, status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, createDate: Date, updateDate: Date, expiresOn?: Date | null, currency?: Currency | null, type?: MerchantPaymentIntentType | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountPaid?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountRefunded?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: Array<{ __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null> | null, totalPaymentFees?: { __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null, paymentMethods: Array<{ __typename?: 'MerchantPaymentIntentPaymentMethod', type: MerchantPaymentIntentPaymentMethodType, chain: BlockchainAbbreviation, address?: string | null } | null>, timeline: Array<{ __typename?: 'MerchantPaymentIntentTimelineItem', status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, time: Date }> } };

export type MerchantPaymentIntentFeeInfoFragment = { __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency };

export type MerchantPaymentIntentPaymentMethodInfoFragment = { __typename?: 'MerchantPaymentIntentPaymentMethod', type: MerchantPaymentIntentPaymentMethodType, chain: BlockchainAbbreviation, address?: string | null };

export type MerchantPaymentIntentRefundMutationVariables = Exact<{
  input: MerchantPaymentIntentRefundInput;
}>;


export type MerchantPaymentIntentRefundMutation = { __typename?: 'Mutation', merchantPaymentIntentRefund: { __typename?: 'MerchantPayment', id: string, type: MerchantPaymentOperationType, merchantId: string, merchantWalletId: string, paymentIntentId?: string | null, description?: string | null, status: MerchantPaymentStatus, errorCode?: MerchantPaymentErrorCode | null, reason?: MerchantPaymentCancellationReason | null, isRefundable: boolean, isCancellable: boolean, allowEntityToBeBlocked: boolean, createDate: Date, updateDate: Date, transactionHash?: string | null, metadata?: { __typename?: 'Metadata', email?: string | null, phoneNumber?: string | null } | null, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fromAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, originalPayment?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, cancel?: { __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date } | null, refunds?: Array<{ __typename?: 'MerchantPaymentRefund', id: string, type: MerchantPaymentOperationType, merchantId?: string | null, description?: string | null, status: MerchantPaymentStatus, reason?: MerchantPaymentCancellationReason | null, createDate: Date, updateDate: Date, source?: { __typename?: 'MerchantPaymentSource', id: string, type: MerchantPaymentSourceType } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> | null, relatedTransactions: Array<{ __typename?: 'MerchantPaymentOperationStatus', id: string, type: MerchantPaymentOperationType, status: MerchantPaymentStatus, createDate: Date, updateDate: Date }>, settlementAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, depositAddress?: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | null, networkFees?: { __typename?: 'MerchantPaymentNetworkFee', amount: string, currency: Currency, feePayer: NetworkFeePayer } | null } };

export type MerchantPaymentIntentTimelineItemInfoFragment = { __typename?: 'MerchantPaymentIntentTimelineItem', status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, time: Date };

export type MerchantPaymentIntentsInfoFragment = { __typename?: 'MerchantPaymentIntents', list: Array<{ __typename?: 'MerchantPaymentIntent', id: string, settlementCurrency: Currency, paymentIds?: Array<string> | null, status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, createDate: Date, updateDate: Date, expiresOn?: Date | null, currency?: Currency | null, type?: MerchantPaymentIntentType | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountPaid?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountRefunded?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: Array<{ __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null> | null, totalPaymentFees?: { __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null, paymentMethods: Array<{ __typename?: 'MerchantPaymentIntentPaymentMethod', type: MerchantPaymentIntentPaymentMethodType, chain: BlockchainAbbreviation, address?: string | null } | null>, timeline: Array<{ __typename?: 'MerchantPaymentIntentTimelineItem', status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, time: Date }> }> };

export type MerchantPaymentIntentsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<MerchantPaymentIntentsFilterInput>;
}>;


export type MerchantPaymentIntentsQuery = { __typename?: 'Query', merchantPaymentIntents: { __typename?: 'MerchantPaymentIntents', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'MerchantPaymentIntent', id: string, settlementCurrency: Currency, paymentIds?: Array<string> | null, status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, createDate: Date, updateDate: Date, expiresOn?: Date | null, currency?: Currency | null, type?: MerchantPaymentIntentType | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountPaid?: { __typename?: 'Amount', amount: string, currency: Currency } | null, amountRefunded?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: Array<{ __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null> | null, totalPaymentFees?: { __typename?: 'MerchantPaymentIntentFee', type: MerchantPaymentIntentFeeType, amount: string, currency: Currency } | null, paymentMethods: Array<{ __typename?: 'MerchantPaymentIntentPaymentMethod', type: MerchantPaymentIntentPaymentMethodType, chain: BlockchainAbbreviation, address?: string | null } | null>, timeline: Array<{ __typename?: 'MerchantPaymentIntentTimelineItem', status: MerchantPaymentIntentTimelineItemStatus, context?: MerchantPaymentIntentTimelineItemContext | null, time: Date }> }> } };

export type IdentityInfoFragment = { __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null };

export type MerchantPayoutInfoFragment = { __typename?: 'MerchantPayout', id: string, status: MerchantPayoutStatus, sourceWalletId: string, errorCode?: MerchantPayoutErrorCode | null, trackingRef?: string | null, description?: string | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, destination: { __typename?: 'MerchantPayoutDestination', id: string, name?: string | null, type: MerchantPayoutType }, return?: { __typename?: 'MerchantPayoutReturn', id: string, payoutId: string, status: MerchantPayoutStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'MerchantPayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, bankFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, source?: { __typename?: 'MerchantPayoutSource', id: string, type: CryptoPayoutSourceType, identities?: Array<{ __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null } | null> | null } | null, metadata?: { __typename?: 'MerchantPayoutMetadata', beneficiaryEmail: string } | null };

export type MerchantPayoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantPayoutQuery = { __typename?: 'Query', merchantPayout: { __typename?: 'MerchantPayout', externalRef?: string | null, id: string, status: MerchantPayoutStatus, sourceWalletId: string, errorCode?: MerchantPayoutErrorCode | null, trackingRef?: string | null, description?: string | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, destination: { __typename?: 'MerchantPayoutDestination', id: string, name?: string | null, type: MerchantPayoutType }, return?: { __typename?: 'MerchantPayoutReturn', id: string, payoutId: string, status: MerchantPayoutStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'MerchantPayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, bankFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, source?: { __typename?: 'MerchantPayoutSource', id: string, type: CryptoPayoutSourceType, identities?: Array<{ __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null } | null> | null } | null, metadata?: { __typename?: 'MerchantPayoutMetadata', beneficiaryEmail: string } | null } };

export type MerchantPayoutAdjustmentsInfoFragment = { __typename?: 'MerchantPayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, bankFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type MerchantPayoutDestinationInfoFragment = { __typename?: 'MerchantPayoutDestination', id: string, name?: string | null, type: MerchantPayoutType };

export type MerchantPayoutMetadataInfoFragment = { __typename?: 'MerchantPayoutMetadata', beneficiaryEmail: string };

export type MerchantPayoutReturnInfoFragment = { __typename?: 'MerchantPayoutReturn', id: string, payoutId: string, status: MerchantPayoutStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type MerchantPayoutSourceInfoFragment = { __typename?: 'MerchantPayoutSource', id: string, type: CryptoPayoutSourceType, identities?: Array<{ __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null } | null> | null };

export type MerchantPayoutsInfoFragment = { __typename?: 'MerchantPayouts', list: Array<{ __typename?: 'MerchantPayout', id: string, status: MerchantPayoutStatus, sourceWalletId: string, errorCode?: MerchantPayoutErrorCode | null, trackingRef?: string | null, description?: string | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, destination: { __typename?: 'MerchantPayoutDestination', id: string, name?: string | null, type: MerchantPayoutType }, return?: { __typename?: 'MerchantPayoutReturn', id: string, payoutId: string, status: MerchantPayoutStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'MerchantPayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, bankFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, source?: { __typename?: 'MerchantPayoutSource', id: string, type: CryptoPayoutSourceType, identities?: Array<{ __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null } | null> | null } | null, metadata?: { __typename?: 'MerchantPayoutMetadata', beneficiaryEmail: string } | null }> };

export type MerchantPayoutsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<MerchantPayoutStatus>;
  destination?: InputMaybe<MerchantPayoutType>;
}>;


export type MerchantPayoutsQuery = { __typename?: 'Query', merchantPayouts: { __typename?: 'MerchantPayouts', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'MerchantPayout', id: string, status: MerchantPayoutStatus, sourceWalletId: string, errorCode?: MerchantPayoutErrorCode | null, trackingRef?: string | null, description?: string | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, destination: { __typename?: 'MerchantPayoutDestination', id: string, name?: string | null, type: MerchantPayoutType }, return?: { __typename?: 'MerchantPayoutReturn', id: string, payoutId: string, status: MerchantPayoutStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'MerchantPayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, bankFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, source?: { __typename?: 'MerchantPayoutSource', id: string, type: CryptoPayoutSourceType, identities?: Array<{ __typename?: 'Identity', type?: string | null, name: string, addresses?: Array<{ __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }> | null } | null> | null } | null, metadata?: { __typename?: 'MerchantPayoutMetadata', beneficiaryEmail: string } | null }> } };

export type MerchantWireBankAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type MerchantWireBankAccountQuery = { __typename?: 'Query', merchantWireBankAccount: { __typename?: 'MerchantWireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend: boolean, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, pairEntries: Array<{ __typename?: 'MerchantPairEntries', type: WatchlistTypes, entity: string }> } };

export type MockStepUpMutationVariables = Exact<{ [key: string]: never; }>;


export type MockStepUpMutation = { __typename?: 'Mutation', mockStepUp: boolean };

export type CreateNotificationSubscriptionMutationVariables = Exact<{
  input: CreateNotificationSubscriptionInput;
}>;


export type CreateNotificationSubscriptionMutation = { __typename?: 'Mutation', createNotificationSubscription?: { __typename?: 'NotificationSubscription', id: string, endpoint: URL, status: NotificationSubscriptionStatus, subscriptionDetails: Array<{ __typename?: 'NotificationSubscriptionDetail', url: URL, status: NotificationSubscriptionStatus }> } | null };

export type DeleteNotificationSubscriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNotificationSubscriptionMutation = { __typename?: 'Mutation', deleteNotificationSubscription?: void | null };

export type NotificationSubscriptionInfoFragment = { __typename?: 'NotificationSubscription', id: string, endpoint: URL, status: NotificationSubscriptionStatus, subscriptionDetails: Array<{ __typename?: 'NotificationSubscriptionDetail', url: URL, status: NotificationSubscriptionStatus }> };

export type NotificationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationSubscriptionsQuery = { __typename?: 'Query', notificationSubscriptions: Array<{ __typename?: 'NotificationSubscription', id: string, endpoint: URL, status: NotificationSubscriptionStatus, subscriptionDetails: Array<{ __typename?: 'NotificationSubscriptionDetail', url: URL, status: NotificationSubscriptionStatus }> }> };

export type AccountSetupInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSetupInfoQuery = { __typename?: 'Query', accountSetupInfo: { __typename?: 'AccountSetupInfo', hasConfirmedDetails: boolean, hasCompletedAllVerifications: boolean, isNonAuthorizedRep: boolean, isOnboardingInitiator: boolean, isRolrUser: boolean, isCOPBusinessOnboardingInProgress: boolean } };

export type CompleteInviteMutationVariables = Exact<{
  input: CompleteInviteInput;
}>;


export type CompleteInviteMutation = { __typename?: 'Mutation', completeInvite?: { __typename?: 'SignInCredential', sessionToken?: string | null } | null };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'SignInCredential', sessionToken?: string | null } | null };

export type CreateRolrAccountMutationVariables = Exact<{
  input: CreateRolrAccountInput;
}>;


export type CreateRolrAccountMutation = { __typename?: 'Mutation', createRolrAccount?: { __typename?: 'SignInCredential', sessionToken?: string | null } | null };

export type PreQualificationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PreQualificationDataQuery = { __typename?: 'Query', preQualificationData?: { __typename?: 'PreQualificationData', state: PreQualificationState, businessEntityName: string, businessCountry: CountryCode, businessState?: string | null, businessWebsite?: string | null, entityType?: string | null, natureOfBusiness?: string | null, expectedUsdcMintingVolume?: string | null, activeUsersOnPlatform?: string | null, usdcRedemptionAmount?: number | null, eurcRedemptionAmount?: number | null } | null };

export type SetProductInterestsMutationVariables = Exact<{
  input: SetProductInterestsInput;
}>;


export type SetProductInterestsMutation = { __typename?: 'Mutation', setProductInterests: boolean };

export type UpdateOnboardingDataMutationVariables = Exact<{
  input: UpdateOnboardingDataInput;
}>;


export type UpdateOnboardingDataMutation = { __typename?: 'Mutation', updateOnboardingData: boolean };

export type OnboardingApplicationInfoFragment = { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType };

export type OnboardingApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingApplicationQuery = { __typename?: 'Query', onboardingApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null };

export type OnboardingCertificationInfoFragment = { __typename?: 'OnboardingCertification', id: string, content: string, type: OnboardingCertificationType };

export type OnboardingCertificationsQueryVariables = Exact<{
  onboardingId: Scalars['ID']['input'];
}>;


export type OnboardingCertificationsQuery = { __typename?: 'Query', onboardingCertifications: Array<{ __typename?: 'OnboardingCertification', id: string, content: string, type: OnboardingCertificationType }> };

export type OnboardingChildSectionInfoFragment = { __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean };

export type OnboardingChildSectionWithDataInfoFragment = { __typename?: 'OnboardingChildSection', overviewGroups?: Array<L3OnboardingFlowGroup> | null, id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean, data?: Array<{ __typename?: 'OnboardingGroupDataV2', id: string, groupName: string, groupSchema: Array<{ __typename?: 'OnboardingSchemaFieldV2', id: string, name: string, readOnly: boolean }>, groupValues: Array<{ __typename?: 'OnboardingGroupValueV2', groupId: string, refId: string, fields: Array<{ __typename?: 'OnboardingFieldValueV2', id: string, name: string, value: string }> }> }> | null, rfiBundle?: { __typename?: 'OnboardingRfiBundle', id: string, status?: RfiBundleStatus | null, createDate: Date, fields?: Array<{ __typename?: 'OnboardingRfiField', id: string, fieldId: string, refId: string, rfiType: RfiType, responded: boolean, groupIds?: Array<string | null> | null, groupNames?: Array<string | null> | null, elementType: RfiElementType, elementName: string }> | null } | null, rfiComments?: Array<{ __typename?: 'OnboardingRfiComment', id?: string | null, authorType: CommentAuthorType, rfiId?: string | null, content?: string | null }> | null };

export type OnboardingChildSectionsQueryVariables = Exact<{
  filter?: InputMaybe<OnboardingGroupSectionFilter>;
}>;


export type OnboardingChildSectionsQuery = { __typename?: 'Query', onboardingChildSections?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean }> | null };

export type OnboardingCreateMsaOperationMutationVariables = Exact<{
  input: MsaOperationInput;
}>;


export type OnboardingCreateMsaOperationMutation = { __typename?: 'Mutation', onboardingCreateMsaOperation?: { __typename?: 'MsaOperationResponse', operation: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType }, certification?: { __typename?: 'OnboardingCertification', id: string, content: string, type: OnboardingCertificationType } | null } | null };

export type OnboardingCreateRfiUserCommentMutationVariables = Exact<{
  input: OnboardingCreateRfiUserCommentInput;
}>;


export type OnboardingCreateRfiUserCommentMutation = { __typename?: 'Mutation', onboardingCreateRfiUserComment?: void | null };

export type OnboardingDeleteGroupValueMutationVariables = Exact<{
  input: OnboardingDeleteGroupValueInput;
}>;


export type OnboardingDeleteGroupValueMutation = { __typename?: 'Mutation', onboardingDeleteGroupValue?: void | null };

export type OnboardingFlowNavigatorQueryVariables = Exact<{
  operationId: Scalars['ID']['input'];
}>;


export type OnboardingFlowNavigatorQuery = { __typename?: 'Query', onboardingOverviewSectionsV2?: Array<{ __typename?: 'OnboardingOverviewSection', id: string, name: L3OnboardingFlowGroup, hidden: boolean, groups: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean, groups?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean, groups?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean } | null> | null } | null> | null }> }> | null };

export type OnboardingGroupDataV2InfoFragment = { __typename?: 'OnboardingGroupDataV2', id: string, groupName: string, groupSchema: Array<{ __typename?: 'OnboardingSchemaFieldV2', id: string, name: string, readOnly: boolean, type: FieldType }>, groupValues: Array<{ __typename?: 'OnboardingGroupValueV2', groupId: string, refId: string, fields: Array<{ __typename?: 'OnboardingFieldValueV2', id: string, name: string, value: string, rfiId?: string | null, rfiStatus: RfiFieldStatus, rfiComment?: string | null }> }> };

export type OnboardingGroupDataV2QueryVariables = Exact<{
  input: OnboardingGroupDataV2Input;
}>;


export type OnboardingGroupDataV2Query = { __typename?: 'Query', onboardingGroupDataV2: Array<{ __typename?: 'OnboardingGroupDataV2', id: string, groupName: string, groupSchema: Array<{ __typename?: 'OnboardingSchemaFieldV2', id: string, name: string, readOnly: boolean, type: FieldType }>, groupValues: Array<{ __typename?: 'OnboardingGroupValueV2', groupId: string, refId: string, fields: Array<{ __typename?: 'OnboardingFieldValueV2', id: string, name: string, value: string, rfiId?: string | null, rfiStatus: RfiFieldStatus, rfiComment?: string | null }> }> }> };

export type OnboardingInitiateKycApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type OnboardingInitiateKycApplicationMutation = { __typename?: 'Mutation', onboardingInitiateKycApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null };

export type OnboardingInitiateRolrApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type OnboardingInitiateRolrApplicationMutation = { __typename?: 'Mutation', onboardingInitiateRolrApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null };

export type OnboardingL3ProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingL3ProviderQuery = { __typename?: 'Query', onboardingApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null, onboardingChildSections?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean }> | null };

export type OnboardingMarkRfisAsRespondedMutationVariables = Exact<{
  input: OnboardingMarkRfisAsRespondedInput;
}>;


export type OnboardingMarkRfisAsRespondedMutation = { __typename?: 'Mutation', onboardingMarkRfisAsResponded?: void | null };

export type OnboardingMsaOperationQueryVariables = Exact<{
  input: MsaOperationInput;
}>;


export type OnboardingMsaOperationQuery = { __typename?: 'Query', onboardingMsaOperation?: { __typename?: 'MsaOperationResponse', operation: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType }, certification?: { __typename?: 'OnboardingCertification', id: string, content: string, type: OnboardingCertificationType } | null } | null };

export type OnboardingNaturesOfBusinessInfoFragment = { __typename?: 'OnboardingNatureOfBusiness', name: string, value: string, prohibited: boolean };

export type OnboardingNaturesOfBusinessQueryVariables = Exact<{
  input?: InputMaybe<OnboardingNaturesOfBusinessInput>;
}>;


export type OnboardingNaturesOfBusinessQuery = { __typename?: 'Query', onboardingNaturesOfBusiness: Array<{ __typename?: 'OnboardingNatureOfBusiness', name: string, value: string, prohibited: boolean }> };

export type OnboardingOverviewGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingOverviewGroupQuery = { __typename?: 'Query', onboardingApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null };

export type OnboardingOverviewSectionInfoFragment = { __typename?: 'OnboardingOverviewSection', id: string, name: L3OnboardingFlowGroup, hidden: boolean };

export type OnboardingOverviewV2QueryVariables = Exact<{
  operationId: Scalars['ID']['input'];
}>;


export type OnboardingOverviewV2Query = { __typename?: 'Query', onboardingOverviewSectionsV2?: Array<{ __typename?: 'OnboardingOverviewSection', id: string, name: L3OnboardingFlowGroup, hidden: boolean, groups: Array<{ __typename?: 'OnboardingChildSection', overviewGroups?: Array<L3OnboardingFlowGroup> | null, id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean, groups?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean } | null> | null }> }> | null, onboardingApplication?: { __typename?: 'OnboardingApplication', applicableJurisdiction: Jurisdiction, onboardingId: string, status: OnboardingApplicationStatus, operationType: OnboardingApplicationOperationType } | null, onboardingChildSections?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean }> | null };

export type OnboardingSaveFieldValuesV2MutationVariables = Exact<{
  input: OnboardingSaveFieldValuesV2Input;
}>;


export type OnboardingSaveFieldValuesV2Mutation = { __typename?: 'Mutation', onboardingSaveFieldValuesV2: Array<{ __typename?: 'OnboardingGroupValueV2', groupId: string, refId: string, fields: Array<{ __typename?: 'OnboardingFieldValueV2', id: string, name: string, value: string, rfiId?: string | null, rfiStatus: RfiFieldStatus, rfiComment?: string | null }> }> };

export type OnboardingSideRailQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingSideRailQuery = { __typename?: 'Query', signInFactor: { __typename?: 'SignInFactor', enrolled: boolean }, qualificationsSummary?: { __typename?: 'QualificationsSummary', kyb: { __typename?: 'KybSummary', isComplete: boolean, isAuthorizedRepresentative: boolean }, kyc: { __typename?: 'KycSummary', isComplete: boolean } } | null, onboardingApplication?: { __typename?: 'OnboardingApplication', onboardingId: string, operationType: OnboardingApplicationOperationType, status: OnboardingApplicationStatus } | null, onboardingNaturesOfBusiness: Array<{ __typename?: 'OnboardingNatureOfBusiness', name: string, value: string, prohibited: boolean }>, onboardingChildSections?: Array<{ __typename?: 'OnboardingChildSection', id: string, name: L3OnboardingFlowGroup, status?: L3OnboardingOverviewGroupStatus | null, hidden: boolean }> | null };

export type OnboardingStatusSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingStatusSummaryQuery = { __typename?: 'Query', signInFactor: { __typename?: 'SignInFactor', enrolled: boolean }, qualificationsSummary?: { __typename?: 'QualificationsSummary', kyb: { __typename?: 'KybSummary', isComplete: boolean, isAuthorizedRepresentative: boolean }, kyc: { __typename?: 'KycSummary', isComplete: boolean } } | null, onboardingApplication?: { __typename?: 'OnboardingApplication', onboardingId: string, operationType: OnboardingApplicationOperationType, status: OnboardingApplicationStatus } | null };

export type OnboardingSubmitApplicationInfoFragment = { __typename?: 'OnboardingApplicationSubmission', onboardingId: string, status: OnboardingApplicationStatus };

export type OnboardingSubmitApplicationMutationVariables = Exact<{
  input: OnboardingApplicationSubmissionInput;
}>;


export type OnboardingSubmitApplicationMutation = { __typename?: 'Mutation', onboardingSubmitApplication: { __typename?: 'OnboardingApplicationSubmission', onboardingId: string, status: OnboardingApplicationStatus } };

export type OnboardingUploadDocumentResponseInfoFragment = { __typename?: 'OnboardingUploadDocumentResponse', documentId: string, uploadDate: string, fileSize: number, fileName: string, entityId: string, description: string, documentType: DocumentType, issuedCountry?: CountryCode | null, fileType: string };

export type OnboardingUploadDocumentWithoutLinkingMutationVariables = Exact<{
  onboardingId: Scalars['ID']['input'];
  document: OnboardingUploadDocumentWithoutLinkingInput;
}>;


export type OnboardingUploadDocumentWithoutLinkingMutation = { __typename?: 'Mutation', onboardingUploadDocumentWithoutLinking: { __typename?: 'OnboardingUploadDocumentResponse', documentId: string, uploadDate: string, fileSize: number, fileName: string, entityId: string, description: string, documentType: DocumentType, issuedCountry?: CountryCode | null, fileType: string } };

export type OnboardingRfiBundleQueryVariables = Exact<{
  input: OnboardingRfiBundleInput;
}>;


export type OnboardingRfiBundleQuery = { __typename?: 'Query', onboardingRfiBundle?: { __typename?: 'OnboardingRfiBundle', id: string, status?: RfiBundleStatus | null, createDate: Date, fields?: Array<{ __typename?: 'OnboardingRfiField', id: string, fieldId: string, refId: string, rfiType: RfiType, responded: boolean, groupIds?: Array<string | null> | null, groupNames?: Array<string | null> | null, elementType: RfiElementType, elementName: string }> | null } | null };

export type OnboardingRfiGroupCommentsQueryVariables = Exact<{
  input: OnboardingRfiGroupCommentsInput;
}>;


export type OnboardingRfiGroupCommentsQuery = { __typename?: 'Query', onboardingRfiGroupComments?: { __typename?: 'OnboardingRfiGroupComments', circleComment?: { __typename?: 'OnboardingRfiComment', id?: string | null, authorType: CommentAuthorType, rfiId?: string | null, content?: string | null } | null, userComment?: { __typename?: 'OnboardingRfiComment', id?: string | null, authorType: CommentAuthorType, rfiId?: string | null, content?: string | null } | null } | null };

export type OrganizationConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationConfigurationsQuery = { __typename?: 'Query', organizationConfigurations?: { __typename?: 'OrganizationConfigurations', userLimit?: number | null } | null };

export type PciPublicKeyInfoFragment = { __typename?: 'PciPublicKey', publicKey?: string | null, keyId?: string | null };

export type PciPublicKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type PciPublicKeyQuery = { __typename?: 'Query', pciPublicKey: { __typename?: 'PciPublicKey', publicKey?: string | null, keyId?: string | null } };

type PaginationInfo_ApiLogs_Fragment = { __typename?: 'APILogs', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_CardPaymentMethods_Fragment = { __typename?: 'CardPaymentMethods', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_FeeReports_Fragment = { __typename?: 'FeeReports', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_Invoices_Fragment = { __typename?: 'Invoices', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_MerchantChargebacks_Fragment = { __typename?: 'MerchantChargebacks', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_MerchantPaymentIntents_Fragment = { __typename?: 'MerchantPaymentIntents', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_MerchantPayments_Fragment = { __typename?: 'MerchantPayments', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_MerchantPayouts_Fragment = { __typename?: 'MerchantPayouts', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_Payments_Fragment = { __typename?: 'Payments', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_Reversals_Fragment = { __typename?: 'Reversals', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_SettlementCreditTransferFees_Fragment = { __typename?: 'SettlementCreditTransferFees', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_SettlementCreditTransfers_Fragment = { __typename?: 'SettlementCreditTransfers', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_Settlements_Fragment = { __typename?: 'Settlements', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_Transfers_Fragment = { __typename?: 'Transfers', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_WalletApprovalTransactions_Fragment = { __typename?: 'WalletApprovalTransactions', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

type PaginationInfo_WalletReports_Fragment = { __typename?: 'WalletReports', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } };

export type PaginationInfoFragment = PaginationInfo_ApiLogs_Fragment | PaginationInfo_CardPaymentMethods_Fragment | PaginationInfo_FeeReports_Fragment | PaginationInfo_Invoices_Fragment | PaginationInfo_MerchantChargebacks_Fragment | PaginationInfo_MerchantPaymentIntents_Fragment | PaginationInfo_MerchantPayments_Fragment | PaginationInfo_MerchantPayouts_Fragment | PaginationInfo_Payments_Fragment | PaginationInfo_Reversals_Fragment | PaginationInfo_SettlementCreditTransferFees_Fragment | PaginationInfo_SettlementCreditTransfers_Fragment | PaginationInfo_Settlements_Fragment | PaginationInfo_Transfers_Fragment | PaginationInfo_WalletApprovalTransactions_Fragment | PaginationInfo_WalletReports_Fragment;

export type PaginationLinksInfoFragment = { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null };

export type BankLocationInfoFragment = { __typename?: 'BankLocation', nickname?: string | null, description?: string | null };

export type CbitReceiveInfoFragment = { __typename?: 'CbitReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type CbitWithdrawalInfoFragment = { __typename?: 'CbitWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type CubixReceiveInfoFragment = { __typename?: 'CubixReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type CubixWithdrawalInfoFragment = { __typename?: 'CubixWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type DestinationInfoFragment = { __typename?: 'Destination', id: string, type: BankAccountType, name?: string | null };

export type FeeLocationInfoFragment = { __typename?: 'FeeLocation', type: LocationType, id: string };

export type GrossRedemptionFeeInfoFragment = { __typename?: 'GrossRedemptionFee', payment: { __typename?: 'GrossRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } };

export type NetRedemptionFeeInfoFragment = { __typename?: 'NetRedemptionFee', payment: { __typename?: 'NetRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type OnchainReceiveInfoFragment = { __typename?: 'OnchainReceive', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null };

export type OnchainSendInfoFragment = { __typename?: 'OnchainSend', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null };

export type PaymentInfoFragment = { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } };

type PaymentDetailsInfo_CbitReceive_Fragment = { __typename?: 'CbitReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_CbitWithdrawal_Fragment = { __typename?: 'CbitWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_CubixReceive_Fragment = { __typename?: 'CubixReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_CubixWithdrawal_Fragment = { __typename?: 'CubixWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_GrossRedemptionFee_Fragment = { __typename?: 'GrossRedemptionFee', payment: { __typename?: 'GrossRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } };

type PaymentDetailsInfo_NetRedemptionFee_Fragment = { __typename?: 'NetRedemptionFee', payment: { __typename?: 'NetRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

type PaymentDetailsInfo_OnchainReceive_Fragment = { __typename?: 'OnchainReceive', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null };

type PaymentDetailsInfo_OnchainSend_Fragment = { __typename?: 'OnchainSend', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null };

type PaymentDetailsInfo_RtpReceive_Fragment = { __typename?: 'RtpReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null };

type PaymentDetailsInfo_RtpWithdrawal_Fragment = { __typename?: 'RtpWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null };

type PaymentDetailsInfo_SenReceive_Fragment = { __typename?: 'SenReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SenWithdrawal_Fragment = { __typename?: 'SenWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SepaInstantReceive_Fragment = { __typename?: 'SepaInstantReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SepaInstantWithdrawal_Fragment = { __typename?: 'SepaInstantWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SepaReceive_Fragment = { __typename?: 'SepaReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SepaWithdrawal_Fragment = { __typename?: 'SepaWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_SettlementCreditFee_Fragment = { __typename?: 'SettlementCreditFee', payment: { __typename?: 'SettlementCreditFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } };

type PaymentDetailsInfo_SettlementCreditReceive_Fragment = { __typename?: 'SettlementCreditReceive', payment: { __typename?: 'SettlementCreditReceivePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'ReceiveLocation', type: LocationType, id: string } } };

type PaymentDetailsInfo_SignetReceive_Fragment = { __typename?: 'SignetReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_SignetWithdrawal_Fragment = { __typename?: 'SignetWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_WireReceive_Fragment = { __typename?: 'WireReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_WireWithdrawal_Fragment = { __typename?: 'WireWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

type PaymentDetailsInfo_XpayReceive_Fragment = { __typename?: 'XpayReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

type PaymentDetailsInfo_XpayWithdrawal_Fragment = { __typename?: 'XpayWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type PaymentDetailsInfoFragment = PaymentDetailsInfo_CbitReceive_Fragment | PaymentDetailsInfo_CbitWithdrawal_Fragment | PaymentDetailsInfo_CubixReceive_Fragment | PaymentDetailsInfo_CubixWithdrawal_Fragment | PaymentDetailsInfo_GrossRedemptionFee_Fragment | PaymentDetailsInfo_NetRedemptionFee_Fragment | PaymentDetailsInfo_OnchainReceive_Fragment | PaymentDetailsInfo_OnchainSend_Fragment | PaymentDetailsInfo_RtpReceive_Fragment | PaymentDetailsInfo_RtpWithdrawal_Fragment | PaymentDetailsInfo_SenReceive_Fragment | PaymentDetailsInfo_SenWithdrawal_Fragment | PaymentDetailsInfo_SepaInstantReceive_Fragment | PaymentDetailsInfo_SepaInstantWithdrawal_Fragment | PaymentDetailsInfo_SepaReceive_Fragment | PaymentDetailsInfo_SepaWithdrawal_Fragment | PaymentDetailsInfo_SettlementCreditFee_Fragment | PaymentDetailsInfo_SettlementCreditReceive_Fragment | PaymentDetailsInfo_SignetReceive_Fragment | PaymentDetailsInfo_SignetWithdrawal_Fragment | PaymentDetailsInfo_WireReceive_Fragment | PaymentDetailsInfo_WireWithdrawal_Fragment | PaymentDetailsInfo_XpayReceive_Fragment | PaymentDetailsInfo_XpayWithdrawal_Fragment;

export type PaymentDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PaymentDetailsQuery = { __typename?: 'Query', paymentDetails: { __typename?: 'CbitReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CbitWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CubixReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'CubixWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'GrossRedemptionFee', payment: { __typename?: 'GrossRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } } | { __typename?: 'NetRedemptionFee', payment: { __typename?: 'NetRedemptionFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } } } | { __typename?: 'OnchainReceive', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null } | { __typename?: 'OnchainSend', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null } | { __typename?: 'RtpReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null } | { __typename?: 'RtpWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null } | { __typename?: 'SenReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SenWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaInstantReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaInstantWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SepaWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'SettlementCreditFee', payment: { __typename?: 'SettlementCreditFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } } | { __typename?: 'SettlementCreditReceive', payment: { __typename?: 'SettlementCreditReceivePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'ReceiveLocation', type: LocationType, id: string } } } | { __typename?: 'SignetReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'SignetWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'WireReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'WireWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | { __typename?: 'XpayReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } | { __typename?: 'XpayWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null } };

export type PaymentsInfoFragment = { __typename?: 'Payments', list: Array<{ __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type PaymentsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<PaymentInput>;
}>;


export type PaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'Payments', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> } };

export type PendingOnchainReceivesQueryVariables = Exact<{
  currency?: InputMaybe<Currency>;
  dedupe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PendingOnchainReceivesQuery = { __typename?: 'Query', pendingOnchainReceives: Array<{ __typename?: 'OnchainReceive', transactionHash?: string | null, explorerLink?: string | null, payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BlockchainRecipientAddressLocation', addressId?: string | null, address?: string | null, addressTag?: string | null, chain?: BlockchainAbbreviation | null, currency?: Currency | null, description?: string | null, owner?: BlockchainRecipientAddressOwner | null, email?: string | null } | null }> };

export type ReceiveLocationInfoFragment = { __typename?: 'ReceiveLocation', type: LocationType, id: string };

export type RiskEvaluationInfoFragment = { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null };

export type RtpReceiveInfoFragment = { __typename?: 'RtpReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null };

export type RtpWithdrawalInfoFragment = { __typename?: 'RtpWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | null };

export type SenReceiveInfoFragment = { __typename?: 'SenReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SenWithdrawalInfoFragment = { __typename?: 'SenWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SepaInstantReceiveInfoFragment = { __typename?: 'SepaInstantReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SepaInstantWithdrawalInfoFragment = { __typename?: 'SepaInstantWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SepaReceiveInfoFragment = { __typename?: 'SepaReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SepaWithdrawalInfoFragment = { __typename?: 'SepaWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SettlementCreditFeeInfoFragment = { __typename?: 'SettlementCreditFee', payment: { __typename?: 'SettlementCreditFeePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'FeeLocation', type: LocationType, id: string } } };

export type SettlementCreditReceiveInfoFragment = { __typename?: 'SettlementCreditReceive', payment: { __typename?: 'SettlementCreditReceivePayment', id: string, type: TransactionType, createDate: Date, updateDate: Date, status: TransactionStatus, relatedTransactionId?: string | null, amount: { __typename?: 'Amount', amount: string, currency: Currency }, location: { __typename?: 'ReceiveLocation', type: LocationType, id: string } } };

export type SignetReceiveInfoFragment = { __typename?: 'SignetReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type SignetWithdrawalInfoFragment = { __typename?: 'SignetWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type WireReceiveInfoFragment = { __typename?: 'WireReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type WireWithdrawalInfoFragment = { __typename?: 'WireWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'BankLocation', nickname?: string | null, description?: string | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type XpayReceiveInfoFragment = { __typename?: 'XpayReceive', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, source?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type XpayWithdrawalInfoFragment = { __typename?: 'XpayWithdrawal', payment: { __typename?: 'Payment', id: string, type: TransactionType, createDate: Date, updateDate: Date, fiatTransactionType?: FiatTransactionType | null, status: TransactionStatus, amount: { __typename?: 'Amount', amount: string, currency: Currency } }, destination?: { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | null };

export type AddPaymentMethodMutationVariables = Exact<{
  isDefault: Scalars['Boolean']['input'];
  paymentProviderPaymentMethodId: Scalars['String']['input'];
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod?: void | null };

export type BillingDetailsInfoFragment = { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null };

export type CardPaymentInfoFragment = { __typename?: 'CardPayment', id: string, status?: MerchantPaymentStatus | null, last4: string, expMonth: string, expYear: string, network: string, bin: string, issuerCountry: string, fundingType: string, fingerprint: string, createDate: Date, updateDate: Date, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null }, metadata?: { __typename?: 'Metadata', phoneNumber?: string | null, email?: string | null } | null, pairEntries: Array<{ __typename?: 'CardPaymentPairEntries', type: WatchlistTypes, entity: string }> };

export type CardPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CardPaymentQuery = { __typename?: 'Query', cardPayment: { __typename?: 'CardPayment', id: string, status?: MerchantPaymentStatus | null, last4: string, expMonth: string, expYear: string, network: string, bin: string, issuerCountry: string, fundingType: string, fingerprint: string, createDate: Date, updateDate: Date, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null }, metadata?: { __typename?: 'Metadata', phoneNumber?: string | null, email?: string | null } | null, pairEntries: Array<{ __typename?: 'CardPaymentPairEntries', type: WatchlistTypes, entity: string }> } };

export type CardPaymentMetadataInfoFragment = { __typename?: 'Metadata', phoneNumber?: string | null, email?: string | null };

export type CardPaymentMethodInfoFragment = { __typename?: 'CardPaymentMethod', id: string, last4: string, expMonth: string, expYear: string, network: string, createDate: Date, errorCode?: string | null, isDefault?: boolean | null, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification?: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null } | null, metadata?: { __typename?: 'CardPaymentMethodMetadata', email?: string | null } | null };

export type CardPaymentMethodByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CardPaymentMethodByIdQuery = { __typename?: 'Query', cardPaymentMethodById: { __typename?: 'CardPaymentMethod', id: string, last4: string, expMonth: string, expYear: string, network: string, createDate: Date, errorCode?: string | null, isDefault?: boolean | null, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification?: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null } | null, metadata?: { __typename?: 'CardPaymentMethodMetadata', email?: string | null } | null } };

export type CardPaymentMethodMetadataInfoFragment = { __typename?: 'CardPaymentMethodMetadata', email?: string | null };

export type CardPaymentMethodsInfoFragment = { __typename?: 'CardPaymentMethods', list: Array<{ __typename?: 'CardPaymentMethod', id: string, last4: string, expMonth: string, expYear: string, network: string, createDate: Date, errorCode?: string | null, isDefault?: boolean | null, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification?: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null } | null, metadata?: { __typename?: 'CardPaymentMethodMetadata', email?: string | null } | null }> };

export type CardPaymentMethodsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type CardPaymentMethodsQuery = { __typename?: 'Query', cardPaymentMethods: { __typename?: 'CardPaymentMethods', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'CardPaymentMethod', id: string, last4: string, expMonth: string, expYear: string, network: string, createDate: Date, errorCode?: string | null, isDefault?: boolean | null, billingDetails: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null }, verification?: { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null } | null, metadata?: { __typename?: 'CardPaymentMethodMetadata', email?: string | null } | null }> } };

export type CardPaymentVerificationInfoFragment = { __typename?: 'CardPaymentVerification', cvvStatus?: CardPaymentCvvStatus | null, avs?: string | null };

export type CreateCardSetupMutationVariables = Exact<{
  userEmail: Scalars['String']['input'];
}>;


export type CreateCardSetupMutation = { __typename?: 'Mutation', createCardSetup: { __typename?: 'CardSetup', clientSecret: string, accountId?: string | null } };

export type DefaultPaymentMethodInfoFragment = { __typename?: 'DefaultPaymentMethod', id: string, entityId: string, type: PaymentMethodType, isDefault: boolean, createDate: Date };

export type DefaultPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultPaymentMethodQuery = { __typename?: 'Query', defaultPaymentMethod?: { __typename?: 'DefaultPaymentMethod', id: string, entityId: string, type: PaymentMethodType, isDefault: boolean, createDate: Date } | null };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  defaultPaymentMethodInput: DefaultPaymentMethodInput;
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: boolean };

export type UpdateCardPaymentMethodMutationVariables = Exact<{
  cardId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  updateCardPaymentMethodInput: UpdateCardPaymentMethodInput;
}>;


export type UpdateCardPaymentMethodMutation = { __typename?: 'Mutation', updateCardPaymentMethod?: void | null };

export type WalletPaymentMethodInfoFragment = { __typename?: 'WalletPaymentMethod', isDefault: boolean, balance: { __typename?: 'Amount', amount: string, currency: Currency } };

export type WalletPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletPaymentMethodQuery = { __typename?: 'Query', walletPaymentMethods: Array<{ __typename?: 'WalletPaymentMethod', isDefault: boolean, balance: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type CreatePayoutMutationVariables = Exact<{
  input: CreatePayoutInput;
}>;


export type CreatePayoutMutation = { __typename?: 'Mutation', createPayout?: { __typename?: 'Payout', id: string, sourceWalletId?: string | null, status?: PayoutStatus | null, trackingRef?: string | null, errorCode?: PayoutErrorCode | null, createDate: Date, updateDate: Date, destination?: { __typename?: 'PayoutDestination', id: string, type: string, name?: string | null } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, return?: { __typename?: 'PayoutReturn', id: string, payoutId: string, reason?: string | null, status?: PayoutStatus | null, createDate?: Date | null, updateDate?: Date | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'PayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null } | null };

export type PayoutInfoFragment = { __typename?: 'Payout', id: string, sourceWalletId?: string | null, status?: PayoutStatus | null, trackingRef?: string | null, errorCode?: PayoutErrorCode | null, createDate: Date, updateDate: Date, destination?: { __typename?: 'PayoutDestination', id: string, type: string, name?: string | null } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, return?: { __typename?: 'PayoutReturn', id: string, payoutId: string, reason?: string | null, status?: PayoutStatus | null, createDate?: Date | null, updateDate?: Date | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'PayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null };

export type PayoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PayoutQuery = { __typename?: 'Query', payout: { __typename?: 'Payout', id: string, sourceWalletId?: string | null, status?: PayoutStatus | null, trackingRef?: string | null, errorCode?: PayoutErrorCode | null, createDate: Date, updateDate: Date, destination?: { __typename?: 'PayoutDestination', id: string, type: string, name?: string | null } | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, toAmount?: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, riskEvaluation?: { __typename?: 'RiskEvaluation', decision?: string | null, reason?: string | null } | null, return?: { __typename?: 'PayoutReturn', id: string, payoutId: string, reason?: string | null, status?: PayoutStatus | null, createDate?: Date | null, updateDate?: Date | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null, adjustments?: { __typename?: 'PayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null } | null } };

export type PayoutAdjustmentsInfoFragment = { __typename?: 'PayoutAdjustments', fxCredit?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fxDebit?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type PayoutDestinationInfoFragment = { __typename?: 'PayoutDestination', id: string, type: string, name?: string | null };

export type PayoutReturnInfoFragment = { __typename?: 'PayoutReturn', id: string, payoutId: string, reason?: string | null, status?: PayoutStatus | null, createDate?: Date | null, updateDate?: Date | null, amount?: { __typename?: 'Amount', amount: string, currency: Currency } | null, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type ProposalInfoFragment = { __typename?: 'DeleteGroupProposal', id: string, type: ProposalType, requires: ApprovalPolicyQuorumType, createdAt: Date, status: ProposalStatusType, initiator: { __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }, approverGroup: { __typename?: 'ApproverUserGroup', id: string, name?: string | null, members?: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> | null }, events: Array<{ __typename?: 'ProposalEvent', createdAt: Date, type: ProposalEventType, performedBy: { __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null } }> };

export type ProposalsQueryVariables = Exact<{
  input: ProposalsInput;
}>;


export type ProposalsQuery = { __typename?: 'Query', proposals: { __typename?: 'Proposals', deleteGroup?: Array<{ __typename?: 'DeleteGroupProposal', id: string, type: ProposalType, requires: ApprovalPolicyQuorumType, createdAt: Date, status: ProposalStatusType, data: { __typename?: 'DeleteGroupProposalData', groupId: string, name?: string | null, members?: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> | null }, initiator: { __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }, approverGroup: { __typename?: 'ApproverUserGroup', id: string, name?: string | null, members?: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> | null }, events: Array<{ __typename?: 'ProposalEvent', createdAt: Date, type: ProposalEventType, performedBy: { __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null } }> }> | null } };

export type KybInfoFragment = { __typename?: 'KybQualificationDetail', state: QualificationUiState, properties: { __typename?: 'KybProperties', userEmail: string, entityId: string, businessName: string, businessCountry: CountryCode, businessState: string, businessWebsite?: string | null, entityType: string, natureOfBusiness: string, businessInfoConfirmed?: boolean | null, productInterests?: Array<ProductInterest | null> | null, isAuthorizedRepresentative: boolean, isOnboardingInitiator: boolean, awaitingBusinessReview: boolean, expectedUsdcMintingVolume?: string | null, activeUsersOnPlatform?: string | null } };

export type OnboardingQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQualificationsQuery = { __typename?: 'Query', onboardingQualifications: { __typename?: 'OnboardingQualifications', kyb?: { __typename?: 'KybQualificationDetail', state: QualificationUiState, properties: { __typename?: 'KybProperties', userEmail: string, entityId: string, businessName: string, businessCountry: CountryCode, businessState: string, businessWebsite?: string | null, entityType: string, natureOfBusiness: string, businessInfoConfirmed?: boolean | null, productInterests?: Array<ProductInterest | null> | null, isAuthorizedRepresentative: boolean, isOnboardingInitiator: boolean, awaitingBusinessReview: boolean, expectedUsdcMintingVolume?: string | null, activeUsersOnPlatform?: string | null } } | null, kyc?: { __typename?: 'KycQualificationDetail', state: QualificationUiState } | null } };

export type QualificationsSummaryInfoFragment = { __typename?: 'QualificationsSummary', kyb: { __typename?: 'KybSummary', isComplete: boolean, isAuthorizedRepresentative: boolean }, kyc: { __typename?: 'KycSummary', isComplete: boolean } };

export type QualificationsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type QualificationsSummaryQuery = { __typename?: 'Query', qualificationsSummary?: { __typename?: 'QualificationsSummary', kyb: { __typename?: 'KybSummary', isComplete: boolean, isAuthorizedRepresentative: boolean }, kyc: { __typename?: 'KycSummary', isComplete: boolean } } | null };

export type PeriodicReviewLegacyQualificationQueryVariables = Exact<{ [key: string]: never; }>;


export type PeriodicReviewLegacyQualificationQuery = { __typename?: 'Query', periodicReviewLegacyQualification: { __typename?: 'PeriodicReviewLegacyQualification', state?: QualificationUiState | null, properties?: { __typename?: 'PeriodicReviewProperties', dueDate?: number | null } | null } };

export type PeriodicReviewQualificationQueryVariables = Exact<{ [key: string]: never; }>;


export type PeriodicReviewQualificationQuery = { __typename?: 'Query', periodicReviewQualification?: { __typename?: 'PeriodicReviewQualification', dueDate?: Date | null, dayRemaining?: number | null, inProgress: boolean, actionRequired: boolean } | null };

export type QualificationProgressQueryVariables = Exact<{
  type: QualificationType;
}>;


export type QualificationProgressQuery = { __typename?: 'Query', qualificationProgress: { __typename?: 'QualificationProgress', state: QualificationUiState } };

export type ReportQueryVariables = Exact<{
  input: ReportInput;
}>;


export type ReportQuery = { __typename?: 'Query', report: { __typename?: 'ReportComplete', downloadUrl: string, status: ReportStatus } | { __typename?: 'ReportIncomplete', status: ReportStatus } };

export type ReportCompleteInfoFragment = { __typename?: 'ReportComplete', downloadUrl: string, status: ReportStatus };

export type ReportIncompleteInfoFragment = { __typename?: 'ReportIncomplete', status: ReportStatus };

export type ReversalInfoFragment = { __typename?: 'Reversal', id: string, paymentId: string, description: string, status: MerchantPaymentStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type ReversalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReversalQuery = { __typename?: 'Query', reversal: { __typename?: 'Reversal', id: string, paymentId: string, description: string, status: MerchantPaymentStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null } };

export type ReversalsInfoFragment = { __typename?: 'Reversals', list: Array<{ __typename?: 'Reversal', id: string, paymentId: string, description: string, status: MerchantPaymentStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> };

export type ReversalsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<MerchantPaymentStatus>;
}>;


export type ReversalsQuery = { __typename?: 'Query', reversals: { __typename?: 'Reversals', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'Reversal', id: string, paymentId: string, description: string, status: MerchantPaymentStatus, reason: string, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> } };

export type SandboxSignupMutationVariables = Exact<{
  input: SandboxSignupInput;
}>;


export type SandboxSignupMutation = { __typename?: 'Mutation', sandboxSignup: boolean };

export type SetSettingsFeatureMutationVariables = Exact<{
  type: SettingsFeaturesType;
}>;


export type SetSettingsFeatureMutation = { __typename?: 'Mutation', setSettingsFeature: { __typename?: 'Settings', features?: { __typename?: 'SettingsFeatures', featureTour?: boolean | null, productTour?: boolean | null, custodyTour?: boolean | null, burnFeeAnnouncement?: boolean | null } | null } };

export type SettingsFeaturesInfoFragment = { __typename?: 'SettingsFeatures', featureTour?: boolean | null, productTour?: boolean | null, custodyTour?: boolean | null, burnFeeAnnouncement?: boolean | null };

export type SettingsFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsFeaturesQuery = { __typename?: 'Query', settings: { __typename?: 'Settings', features?: { __typename?: 'SettingsFeatures', featureTour?: boolean | null, productTour?: boolean | null, custodyTour?: boolean | null, burnFeeAnnouncement?: boolean | null } | null } };

export type CreateSettlementCreditTransferMutationVariables = Exact<{
  input: SettlementCreditTransferInput;
}>;


export type CreateSettlementCreditTransferMutation = { __typename?: 'Mutation', createSettlementCreditTransfer: { __typename?: 'SettlementCreditTransfer', id: string, reference?: string | null, transferJobId?: string | null, receiveJobId?: string | null, status: SettlementCreditTransferStatus, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, hasPendingFee: boolean, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type SettlementCreditLineInfoFragment = { __typename?: 'SettlementCreditLine', id: string, entityId: string, type: SettlementCreditLineType, walletId: string, status: SettlementCreditLineStatus, createDate: Date, updateDate: Date, usage: { __typename?: 'SettlementCreditLineUsage', used: string, available: string, outstandingTransfers: number }, limit: { __typename?: 'Amount', amount: string, currency: Currency }, settings: { __typename?: 'SettlementCreditLineSettings', autoApproval: boolean } };

export type SettlementCreditLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type SettlementCreditLinesQuery = { __typename?: 'Query', settlementCreditLines: Array<{ __typename?: 'SettlementCreditLine', id: string, entityId: string, type: SettlementCreditLineType, walletId: string, status: SettlementCreditLineStatus, createDate: Date, updateDate: Date, usage: { __typename?: 'SettlementCreditLineUsage', used: string, available: string, outstandingTransfers: number }, limit: { __typename?: 'Amount', amount: string, currency: Currency }, settings: { __typename?: 'SettlementCreditLineSettings', autoApproval: boolean } }> };

export type SettlementCreditTransferInfoFragment = { __typename?: 'SettlementCreditTransfer', id: string, reference?: string | null, transferJobId?: string | null, receiveJobId?: string | null, status: SettlementCreditTransferStatus, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, hasPendingFee: boolean, amount: { __typename?: 'Amount', amount: string, currency: Currency } };

export type SettlementCreditTransfersInfoFragment = { __typename?: 'SettlementCreditTransfers', list: Array<{ __typename?: 'SettlementCreditTransfer', id: string, reference?: string | null, transferJobId?: string | null, receiveJobId?: string | null, status: SettlementCreditTransferStatus, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, hasPendingFee: boolean, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type SettlementCreditTransferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SettlementCreditTransferQuery = { __typename?: 'Query', settlementCreditTransfer: { __typename?: 'SettlementCreditTransferDetails', id: string, entityId: string, reference?: string | null, status: SettlementCreditTransferStatus, transferJobId?: string | null, receiveJobId?: string | null, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, pendingFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, outstandingBalance?: { __typename?: 'Amount', amount: string, currency: Currency } | null } };

export type SettlementCreditTransferDetailsInfoFragment = { __typename?: 'SettlementCreditTransferDetails', id: string, entityId: string, reference?: string | null, status: SettlementCreditTransferStatus, transferJobId?: string | null, receiveJobId?: string | null, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency }, pendingFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalFees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, outstandingBalance?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type SettlementCreditTransferFeeInfoFragment = { __typename?: 'SettlementCreditTransferFee', id: string, settlementCreditTransferId: string, status: SettlementCreditTransferFeeStatus, effectiveDate: Date, accruedDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency } };

export type SettlementCreditTransferFeesInfoFragment = { __typename?: 'SettlementCreditTransferFees', list: Array<{ __typename?: 'SettlementCreditTransferFee', id: string, settlementCreditTransferId: string, status: SettlementCreditTransferFeeStatus, effectiveDate: Date, accruedDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type SettlementCreditTransferFeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SettlementCreditTransferFeeQuery = { __typename?: 'Query', settlementCreditTransferFee: { __typename?: 'SettlementCreditTransferFee', id: string, settlementCreditTransferId: string, status: SettlementCreditTransferFeeStatus, effectiveDate: Date, accruedDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type SettlementCreditTransferFeesQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  settlementCreditTransferId: Scalars['ID']['input'];
}>;


export type SettlementCreditTransferFeesQuery = { __typename?: 'Query', settlementCreditTransferFees: { __typename?: 'SettlementCreditTransferFees', list: Array<{ __typename?: 'SettlementCreditTransferFee', id: string, settlementCreditTransferId: string, status: SettlementCreditTransferFeeStatus, effectiveDate: Date, accruedDate: Date, amount: { __typename?: 'Amount', amount: string, currency: Currency } }>, links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null } } };

export type SettlementCreditTransferValidationInfoFragment = { __typename?: 'SettlementCreditTransferValidation', code: SettlementCreditTransferErrorCodes, message: string };

export type SettlementCreditTransferValidationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SettlementCreditTransferValidationQuery = { __typename?: 'Query', settlementCreditTransferValidation: Array<{ __typename?: 'SettlementCreditTransferValidation', code: SettlementCreditTransferErrorCodes, message: string }> };

export type SettlementCreditTransfersQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<SettlementCreditTransfersInput>;
}>;


export type SettlementCreditTransfersQuery = { __typename?: 'Query', settlementCreditTransfers: { __typename?: 'SettlementCreditTransfers', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'SettlementCreditTransfer', id: string, reference?: string | null, transferJobId?: string | null, receiveJobId?: string | null, status: SettlementCreditTransferStatus, dueDate?: Date | null, transferDate?: Date | null, paidDate?: Date | null, createDate: Date, updateDate: Date, hasPendingFee: boolean, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> } };

export type SettlementCreditWireInstructionInfoFragment = { __typename?: 'SettlementCreditWireInstruction', trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireInstructionBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireInstructionBeneficiaryBank', swiftCode: string, routingNumber: string, accountNumber: string, currency: Currency, name: string, address: string, city?: string | null, postcode?: string | null, country: string } };

export type SettlementCreditWireInstructionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SettlementCreditWireInstructionQuery = { __typename?: 'Query', settlementCreditWireInstruction: { __typename?: 'SettlementCreditWireInstruction', trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireInstructionBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireInstructionBeneficiaryBank', swiftCode: string, routingNumber: string, accountNumber: string, currency: Currency, name: string, address: string, city?: string | null, postcode?: string | null, country: string } } };

export type WireInstructionBeneficiaryInfoFragment = { __typename?: 'WireInstructionBeneficiary', name: string, address1: string, address2: string };

export type WireInstructionBeneficiaryBankInfoFragment = { __typename?: 'WireInstructionBeneficiaryBank', swiftCode: string, routingNumber: string, accountNumber: string, currency: Currency, name: string, address: string, city?: string | null, postcode?: string | null, country: string };

export type SettlementInfoFragment = { __typename?: 'Settlement', id: string, createDate: Date, updateDate: Date, merchantWalletId?: string | null, totalDebits: { __typename?: 'Amount', amount: string, currency: Currency }, totalCredits: { __typename?: 'Amount', amount: string, currency: Currency }, paymentFees: { __typename?: 'Amount', amount: string, currency: Currency }, chargebackFees: { __typename?: 'Amount', amount: string, currency: Currency } };

export type SettlementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SettlementQuery = { __typename?: 'Query', settlement: { __typename?: 'Settlement', id: string, createDate: Date, updateDate: Date, merchantWalletId?: string | null, totalDebits: { __typename?: 'Amount', amount: string, currency: Currency }, totalCredits: { __typename?: 'Amount', amount: string, currency: Currency }, paymentFees: { __typename?: 'Amount', amount: string, currency: Currency }, chargebackFees: { __typename?: 'Amount', amount: string, currency: Currency } } };

export type SettlementsInfoFragment = { __typename?: 'Settlements', list: Array<{ __typename?: 'Settlement', id: string, createDate: Date, updateDate: Date, merchantWalletId?: string | null, totalDebits: { __typename?: 'Amount', amount: string, currency: Currency }, totalCredits: { __typename?: 'Amount', amount: string, currency: Currency }, paymentFees: { __typename?: 'Amount', amount: string, currency: Currency }, chargebackFees: { __typename?: 'Amount', amount: string, currency: Currency } }> };

export type SettlementsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type SettlementsQuery = { __typename?: 'Query', settlements: { __typename?: 'Settlements', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'Settlement', id: string, createDate: Date, updateDate: Date, merchantWalletId?: string | null, totalDebits: { __typename?: 'Amount', amount: string, currency: Currency }, totalCredits: { __typename?: 'Amount', amount: string, currency: Currency }, paymentFees: { __typename?: 'Amount', amount: string, currency: Currency }, chargebackFees: { __typename?: 'Amount', amount: string, currency: Currency } }> } };

export type CreateStablecoinExpressDepositRouteMutationVariables = Exact<{
  input: CreateStablecoinExpressDepositRouteInput;
}>;


export type CreateStablecoinExpressDepositRouteMutation = { __typename?: 'Mutation', createStablecoinExpressDepositRoute: { __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } } | { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } } };

export type CreateStablecoinExpressWithdrawalRouteMutationVariables = Exact<{
  input: CreateStablecoinExpressWithdrawalRouteInput;
}>;


export type CreateStablecoinExpressWithdrawalRouteMutation = { __typename?: 'Mutation', createStablecoinExpressWithdrawalRoute: { __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } } | { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } } };

export type SetStablecoinExpressRouteMutationVariables = Exact<{
  input: StablecoinExpressRouteInput;
}>;


export type SetStablecoinExpressRouteMutation = { __typename?: 'Mutation', setStablecoinExpressRoute: { __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } } | { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } } };

type StablecoinExpressBankLocationInfo_CbitBankAccount_Fragment = { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type StablecoinExpressBankLocationInfo_CubixBankAccount_Fragment = { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type StablecoinExpressBankLocationInfo_PixBankAccount_Fragment = { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

type StablecoinExpressBankLocationInfo_RtpBankAccount_Fragment = { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null };

type StablecoinExpressBankLocationInfo_SenBankAccount_Fragment = { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null };

type StablecoinExpressBankLocationInfo_SignetBankAccount_Fragment = { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

type StablecoinExpressBankLocationInfo_WireBankAccount_Fragment = { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null };

type StablecoinExpressBankLocationInfo_XpayBankAccount_Fragment = { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null };

export type StablecoinExpressBankLocationInfoFragment = StablecoinExpressBankLocationInfo_CbitBankAccount_Fragment | StablecoinExpressBankLocationInfo_CubixBankAccount_Fragment | StablecoinExpressBankLocationInfo_PixBankAccount_Fragment | StablecoinExpressBankLocationInfo_RtpBankAccount_Fragment | StablecoinExpressBankLocationInfo_SenBankAccount_Fragment | StablecoinExpressBankLocationInfo_SignetBankAccount_Fragment | StablecoinExpressBankLocationInfo_WireBankAccount_Fragment | StablecoinExpressBankLocationInfo_XpayBankAccount_Fragment;

type StablecoinExpressBlockchainLocationInfo_BlockchainDepositAddress_Fragment = { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null };

type StablecoinExpressBlockchainLocationInfo_BlockchainRecipientAddress_Fragment = { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null };

export type StablecoinExpressBlockchainLocationInfoFragment = StablecoinExpressBlockchainLocationInfo_BlockchainDepositAddress_Fragment | StablecoinExpressBlockchainLocationInfo_BlockchainRecipientAddress_Fragment;

export type StablecoinExpressDepositRouteInfoFragment = { __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } };

type StablecoinExpressRouteInfo_StablecoinExpressDepositRoute_Fragment = { __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } };

type StablecoinExpressRouteInfo_StablecoinExpressWithdrawalRoute_Fragment = { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type StablecoinExpressRouteInfoFragment = StablecoinExpressRouteInfo_StablecoinExpressDepositRoute_Fragment | StablecoinExpressRouteInfo_StablecoinExpressWithdrawalRoute_Fragment;

export type StablecoinExpressRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type StablecoinExpressRoutesQuery = { __typename?: 'Query', stablecoinExpressRoutes: Array<{ __typename?: 'StablecoinExpressDepositRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null }, destination: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null } } | { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } }> };

export type StablecoinExpressWithdrawalRouteInfoFragment = { __typename?: 'StablecoinExpressWithdrawalRoute', id: string, enabled: boolean, updateDate: Date, createDate: Date, type: StablecoinExpressType, fromCurrency: Currency, toCurrency: Currency, source: { __typename?: 'BlockchainDepositAddress', address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null } | { __typename?: 'BlockchainRecipientAddress', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, currency?: Currency | null, description?: string | null }, destination: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type StatesInfoFragment = { __typename?: 'States', codes: Array<StateCode>, list: Array<{ __typename?: 'State', code: StateCode }> };

export type StatesQueryVariables = Exact<{
  filter: StatesInput;
}>;


export type StatesQuery = { __typename?: 'Query', states: { __typename?: 'States', codes: Array<StateCode>, list: Array<{ __typename?: 'State', code: StateCode }> } };

export type SubscriptionInfoFragment = { __typename?: 'Subscriptions', automaticPaymentEnabled: boolean };

export type SubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'Subscriptions', automaticPaymentEnabled: boolean } };

export type UpdateAutoPayMutationVariables = Exact<{
  automaticPaymentEnabled: Scalars['Boolean']['input'];
}>;


export type UpdateAutoPayMutation = { __typename?: 'Mutation', updateAutoPay: boolean };

export type TakeoverInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type TakeoverInfoQuery = { __typename?: 'Query', periodicReviewQualification?: { __typename?: 'PeriodicReviewQualification', dueDate?: Date | null, dayRemaining?: number | null, inProgress: boolean, actionRequired: boolean } | null, scaFactorInfo: { __typename?: 'ScaFactorInfo', pinCode?: { __typename?: 'EligibleUserFactor', status: FactorStatus } | null } };

export type CreateTradeMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;


export type CreateTradeMutation = { __typename?: 'Mutation', createTrade: { __typename?: 'Trade', id: string, quoteId?: string | null, settlementId?: string | null, status: TradeStatus, createDate: Date, updateDate: Date, from: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null }, to: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } } };

export type DailyLimitsInfoFragment = { __typename?: 'DailyLimit', currency: Currency, limit: { __typename?: 'Limit', limit: number, usage: number, available: number } };

export type DailyLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type DailyLimitsQuery = { __typename?: 'Query', dailyLimits: Array<{ __typename?: 'DailyLimit', currency: Currency, limit: { __typename?: 'Limit', limit: number, usage: number, available: number } }> };

export type TradeInfoFragment = { __typename?: 'Trade', id: string, quoteId?: string | null, settlementId?: string | null, status: TradeStatus, createDate: Date, updateDate: Date, from: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null }, to: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } };

export type TradeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TradeQuery = { __typename?: 'Query', trade: { __typename?: 'Trade', id: string, quoteId?: string | null, settlementId?: string | null, status: TradeStatus, createDate: Date, updateDate: Date, from: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null }, to: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } } };

export type TradeByJobIdQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type TradeByJobIdQuery = { __typename?: 'Query', tradeByJobId: { __typename?: 'Trade', id: string, quoteId?: string | null, settlementId?: string | null, status: TradeStatus, createDate: Date, updateDate: Date, from: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null }, to: { __typename?: 'PartialAmount', amount?: string | null, currency?: Currency | null } } };

export type ChainedTransferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChainedTransferQuery = { __typename?: 'Query', chainedTransfer: { __typename?: 'Transfer', id: string, type: TransferType, transactionHash?: string | null, explorerLink?: string | null, status: TransferStatus, errorCode?: string | null, createDate: Date, source: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null } };

export type IncompleteChainedTransfersQueryVariables = Exact<{ [key: string]: never; }>;


export type IncompleteChainedTransfersQuery = { __typename?: 'Query', incompleteChainedTransfers?: Array<{ __typename?: 'IncompleteChainedTransfer', id: string, status: TransferStatus, chainedBlockchainTransferStatus: ChainedTransferStatus, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency } }> | null };

export type TransferInfoFragment = { __typename?: 'Transfer', id: string, type: TransferType, transactionHash?: string | null, explorerLink?: string | null, status: TransferStatus, errorCode?: string | null, createDate: Date, source: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null };

export type TransferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransferQuery = { __typename?: 'Query', transfer: { __typename?: 'Transfer', id: string, type: TransferType, transactionHash?: string | null, explorerLink?: string | null, status: TransferStatus, errorCode?: string | null, createDate: Date, source: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null } };

type TransferLocationInfo_BlockchainLocation_Fragment = { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null };

type TransferLocationInfo_ChainedBlockchainLocation_Fragment = { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null };

type TransferLocationInfo_WalletLocation_Fragment = { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null };

export type TransferLocationInfoFragment = TransferLocationInfo_BlockchainLocation_Fragment | TransferLocationInfo_ChainedBlockchainLocation_Fragment | TransferLocationInfo_WalletLocation_Fragment;

export type TransfersInfoFragment = { __typename?: 'Transfers', list: Array<{ __typename?: 'Transfer', id: string, type: TransferType, transactionHash?: string | null, explorerLink?: string | null, status: TransferStatus, errorCode?: string | null, createDate: Date, source: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> };

export type TransfersQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
  sourceWalletId?: InputMaybe<Scalars['ID']['input']>;
  destinationWalletId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TransfersQuery = { __typename?: 'Query', transfers: { __typename?: 'Transfers', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'Transfer', id: string, type: TransferType, transactionHash?: string | null, explorerLink?: string | null, status: TransferStatus, errorCode?: string | null, createDate: Date, source: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, destination: { __typename?: 'BlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null } | { __typename?: 'ChainedBlockchainLocation', type: TransferLocationType, chain: string, address?: string | null, addressTag?: string | null, description?: string | null, isCompleteAceTransfer?: boolean | null, metadata?: { __typename?: 'BlockchainLocationMetadata', transactionHash?: string | null, status?: string | null, domain?: number | null, attestation?: string | null, message?: string | null } | null } | { __typename?: 'WalletLocation', type: TransferLocationType, id: string, address?: string | null, addressTag?: string | null }, amount: { __typename?: 'Amount', amount: string, currency: Currency }, fees?: { __typename?: 'Amount', amount: string, currency: Currency } | null, totalAmount?: { __typename?: 'Amount', amount: string, currency: Currency } | null }> } };

export type TravelRuleAddressInfoFragment = { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null };

type TravelRulePersonInfo_TravelRuleLegalPerson_Fragment = { __typename?: 'TravelRuleLegalPerson', type: TravelRulePersonType, registeredName: string, leiOrEquivalent?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null };

type TravelRulePersonInfo_TravelRuleNaturalPerson_Fragment = { __typename?: 'TravelRuleNaturalPerson', type: TravelRulePersonType, firstName: string, lastName: string, dateOfBirth?: string | null, placeOfBirth?: string | null, officialDocumentNumber?: string | null, additionalIdentifier?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null };

export type TravelRulePersonInfoFragment = TravelRulePersonInfo_TravelRuleLegalPerson_Fragment | TravelRulePersonInfo_TravelRuleNaturalPerson_Fragment;

export type TravelRulePiiInfoFragment = { __typename?: 'TravelRulePii', originatorDistributedLedgerAddress?: string | null, beneficiaryDistributedLedgerAddress?: string | null, originator: { __typename?: 'TravelRuleLegalPerson', type: TravelRulePersonType, registeredName: string, leiOrEquivalent?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | { __typename?: 'TravelRuleNaturalPerson', type: TravelRulePersonType, firstName: string, lastName: string, dateOfBirth?: string | null, placeOfBirth?: string | null, officialDocumentNumber?: string | null, additionalIdentifier?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null }, beneficiary?: { __typename?: 'TravelRuleLegalPerson', type: TravelRulePersonType, registeredName: string, leiOrEquivalent?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | { __typename?: 'TravelRuleNaturalPerson', type: TravelRulePersonType, firstName: string, lastName: string, dateOfBirth?: string | null, placeOfBirth?: string | null, officialDocumentNumber?: string | null, additionalIdentifier?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | null };

export type TravelRuleSpeDisputeMutationVariables = Exact<{
  linkId: Scalars['String']['input'];
}>;


export type TravelRuleSpeDisputeMutation = { __typename?: 'Mutation', travelRuleSpeDispute?: void | null };

export type TravelRuleSpePiiQueryVariables = Exact<{
  linkId: Scalars['String']['input'];
}>;


export type TravelRuleSpePiiQuery = { __typename?: 'Query', travelRuleSpePii: { __typename?: 'TravelRulePii', originatorDistributedLedgerAddress?: string | null, beneficiaryDistributedLedgerAddress?: string | null, originator: { __typename?: 'TravelRuleLegalPerson', type: TravelRulePersonType, registeredName: string, leiOrEquivalent?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | { __typename?: 'TravelRuleNaturalPerson', type: TravelRulePersonType, firstName: string, lastName: string, dateOfBirth?: string | null, placeOfBirth?: string | null, officialDocumentNumber?: string | null, additionalIdentifier?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null }, beneficiary?: { __typename?: 'TravelRuleLegalPerson', type: TravelRulePersonType, registeredName: string, leiOrEquivalent?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | { __typename?: 'TravelRuleNaturalPerson', type: TravelRulePersonType, firstName: string, lastName: string, dateOfBirth?: string | null, placeOfBirth?: string | null, officialDocumentNumber?: string | null, additionalIdentifier?: string | null, address?: { __typename?: 'TravelRuleAddress', country?: CountryCode | null, streetAddress?: string | null, addressLine2?: string | null, city?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | null } };

export type TravelRuleSpeRequestOtpMutationVariables = Exact<{
  linkId: Scalars['String']['input'];
}>;


export type TravelRuleSpeRequestOtpMutation = { __typename?: 'Mutation', travelRuleSpeRequestOtp?: void | null };

export type TravelRuleSpeReviewQueryVariables = Exact<{
  linkId: Scalars['String']['input'];
}>;


export type TravelRuleSpeReviewQuery = { __typename?: 'Query', travelRuleSpeReview: { __typename?: 'TravelRuleSpeReview', requestType: TravelRuleSpeRequestType, txHash: string, date: Date, amount: string, token: Currency, address: string } };

export type TravelRuleSpeVerifyOtpMutationVariables = Exact<{
  linkId: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type TravelRuleSpeVerifyOtpMutation = { __typename?: 'Mutation', travelRuleSpeVerifyOtp?: void | null };

export type TravelRuleSubmitSpePiiMutationVariables = Exact<{
  input: TravelRuleSubmitSpePiiInput;
}>;


export type TravelRuleSubmitSpePiiMutation = { __typename?: 'Mutation', travelRuleSubmitSpePii?: void | null };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type EnrollPinCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type EnrollPinCodeMutation = { __typename?: 'Mutation', enrollPinCode?: void | null };

export type InviteAuthorizedRepMutationVariables = Exact<{
  input: InviteAuthorizedRepInput;
}>;


export type InviteAuthorizedRepMutation = { __typename?: 'Mutation', inviteAuthorizedRep?: void | null };

export type InviteUserMutationVariables = Exact<{
  invitee: InviteeInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: void | null };

export type ManageableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageableUsersQuery = { __typename?: 'Query', manageableUsers: Array<{ __typename?: 'User', proposalId?: string | null, isAuthorizedRepresentative?: boolean | null, id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> };

export type RemoveUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser?: void | null };

export type ResendInviteMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite?: void | null };

export type ResendUserActivationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendUserActivationMutation = { __typename?: 'Mutation', resendUserActivation: boolean };

export type ResetMfaRequestMutationVariables = Exact<{
  input: ResetMfaRequestInput;
}>;


export type ResetMfaRequestMutation = { __typename?: 'Mutation', resetMfaRequest?: void | null };

export type ResetPinCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetPinCodeMutation = { __typename?: 'Mutation', resetPinCode?: void | null };

export type UpdateAndReturnEmailVerifiedMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateAndReturnEmailVerifiedMutation = { __typename?: 'Mutation', updateAndReturnEmailVerified: boolean };

export type UpdatePinCodeMutationVariables = Exact<{
  input: UpdatePinCodeInput;
}>;


export type UpdatePinCodeMutation = { __typename?: 'Mutation', updatePinCode?: void | null };

export type UserInfoFragment = { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null };

export type UserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } };

export type UserActivationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UserActivationQuery = { __typename?: 'Query', userActivation: { __typename?: 'UserActivation', stateToken?: string | null, institutionName?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, existingUser?: boolean | null, tokenConsumed?: boolean | null } };

export type UserStatusInfoFragment = { __typename?: 'UserStatus', type: UserStatusType, label: UserStatusLabel };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> };

export type VerifiedUsersQueryVariables = Exact<{
  filter?: InputMaybe<VerifiedUsersFilterInput>;
}>;


export type VerifiedUsersQuery = { __typename?: 'Query', verifiedUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> };

export type CreateUserGroupMutationVariables = Exact<{
  input: CreateUserGroupInput;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup: { __typename?: 'CreateUserGroupResponse', id: string } };

export type UserGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserGroupQuery = { __typename?: 'Query', userGroup: { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> } };

export type UserGroupInfoFragment = { __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> };

export type UserGroupMemberInfoFragment = { __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null };

export type UserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, members: Array<{ __typename?: 'UserGroupMember', id: string, initial?: string | null, groupType?: UserRoleGroupType | null, name?: string | null, email?: string | null }> }> };

export type VerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type VerificationQuery = { __typename?: 'Query', signInFactor: { __typename?: 'SignInFactor', enrolled: boolean }, preQualificationData?: { __typename?: 'PreQualificationData', businessEntityName: string, businessCountry: CountryCode, businessState?: string | null, entityType?: string | null, natureOfBusiness?: string | null, expectedUsdcMintingVolume?: string | null, activeUsersOnPlatform?: string | null } | null };

export type ActiveWalletApprovalPolicyQueryVariables = Exact<{
  currency: Currency;
}>;


export type ActiveWalletApprovalPolicyQuery = { __typename?: 'Query', activeWalletApprovalPolicy?: { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } } | null };

export type CancelWalletApprovalPendingTransactionMutationVariables = Exact<{
  proposalId: Scalars['String']['input'];
}>;


export type CancelWalletApprovalPendingTransactionMutation = { __typename?: 'Mutation', cancelWalletApprovalPendingTransaction?: void | null };

export type CancelWalletApprovalSubmittedPolicyMutationVariables = Exact<{
  input: ManageWalletApprovalPolicyInput;
}>;


export type CancelWalletApprovalSubmittedPolicyMutation = { __typename?: 'Mutation', cancelWalletApprovalSubmittedPolicy?: void | null };

export type DiscardWalletApprovalDraftPolicyMutationVariables = Exact<{
  input: ManageWalletApprovalPolicyInput;
}>;


export type DiscardWalletApprovalDraftPolicyMutation = { __typename?: 'Mutation', discardWalletApprovalDraftPolicy?: void | null };

export type DraftWalletApprovalPolicyQueryVariables = Exact<{
  currency: Currency;
}>;


export type DraftWalletApprovalPolicyQuery = { __typename?: 'Query', draftWalletApprovalPolicy: { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } } };

export type SubmitWalletApprovalDraftPolicyMutationVariables = Exact<{
  input: ManageWalletApprovalPolicyInput;
}>;


export type SubmitWalletApprovalDraftPolicyMutation = { __typename?: 'Mutation', submitWalletApprovalDraftPolicy?: void | null };

export type SubmittedWalletApprovalPolicyQueryVariables = Exact<{
  currency: Currency;
}>;


export type SubmittedWalletApprovalPolicyQuery = { __typename?: 'Query', submittedWalletApprovalPolicy: { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } } };

export type UpsertWalletApprovalDraftPolicyMutationVariables = Exact<{
  input: UpsertWalletApprovalPolicyInput;
}>;


export type UpsertWalletApprovalDraftPolicyMutation = { __typename?: 'Mutation', upsertWalletApprovalDraftPolicy?: void | null };

export type WalletApprovalCreateOnchainTransferMutationVariables = Exact<{
  input: CreateTransferInput;
}>;


export type WalletApprovalCreateOnchainTransferMutation = { __typename?: 'Mutation', walletApprovalCreateOnchainTransfer?: { __typename?: 'CreateTransferResponse', proposalId?: string | null, transferId?: string | null } | null };

export type WalletApprovalCreatePayoutTransferMutationVariables = Exact<{
  input: CreatePayoutInput;
}>;


export type WalletApprovalCreatePayoutTransferMutation = { __typename?: 'Mutation', walletApprovalCreatePayoutTransfer?: void | null };

export type WalletApprovalOnchainTransactionDetailInfoFragment = { __typename?: 'WalletApprovalOnchainTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, recipientAddress: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } };

export type WalletApprovalPayoutTransactionDetailInfoFragment = { __typename?: 'WalletApprovalPayoutTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, fiatAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type WalletApprovalPendingTransactionsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<WalletApprovalTransactionFilterInput>;
}>;


export type WalletApprovalPendingTransactionsQuery = { __typename?: 'Query', walletApprovalPendingTransactions: { __typename?: 'WalletApprovalTransactions', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'WalletApprovalTransaction', id: string, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null }> } };

export type WalletApprovalPolicyInfoFragment = { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } };

export type WalletApprovalPolicyQueryVariables = Exact<{
  currency: Currency;
}>;


export type WalletApprovalPolicyQuery = { __typename?: 'Query', walletApprovalPolicy?: { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } } | null };

export type WalletApprovalPolicySettingsInfoFragment = { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean };

export type WalletApprovalPolicyUserLimitInfoFragment = { __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } };

export type WalletApprovalSubmittedPolicyProgressQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type WalletApprovalSubmittedPolicyProgressQuery = { __typename?: 'Query', walletApprovalSubmittedPolicyProgress: { __typename?: 'WalletApprovalSubmittedPolicyProgress', policyId: string, approvedByUser: Array<{ __typename?: 'WalletApprovalSubmittedPolicyProgressUser', name: string }>, rejectedByUser: Array<{ __typename?: 'WalletApprovalSubmittedPolicyProgressUser', name: string }>, pendingApprovalsUser: Array<{ __typename?: 'WalletApprovalSubmittedPolicyProgressUser', name: string }> } };

export type WalletApprovalTransactionInfoFragment = { __typename?: 'WalletApprovalTransaction', id: string, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null };

type WalletApprovalTransactionDetailInfo_WalletApprovalOnchainTransactionDetail_Fragment = { __typename?: 'WalletApprovalOnchainTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, recipientAddress: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } };

type WalletApprovalTransactionDetailInfo_WalletApprovalPayoutTransactionDetail_Fragment = { __typename?: 'WalletApprovalPayoutTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, fiatAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } };

export type WalletApprovalTransactionDetailInfoFragment = WalletApprovalTransactionDetailInfo_WalletApprovalOnchainTransactionDetail_Fragment | WalletApprovalTransactionDetailInfo_WalletApprovalPayoutTransactionDetail_Fragment;

export type WalletApprovalTransactionDetailQueryVariables = Exact<{
  proposalId: Scalars['ID']['input'];
}>;


export type WalletApprovalTransactionDetailQuery = { __typename?: 'Query', walletApprovalTransactionDetail?: { __typename?: 'WalletApprovalOnchainTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, recipientAddress: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } } | { __typename?: 'WalletApprovalPayoutTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, fiatAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } } | null };

export type WalletApprovalTransactionDetailByJobIdQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type WalletApprovalTransactionDetailByJobIdQuery = { __typename?: 'Query', walletApprovalTransactionDetailByJobId?: { __typename?: 'WalletApprovalOnchainTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, recipientAddress: { __typename?: 'BlockchainRecipientAddressWithMetadata', id: string, address: string, addressTag?: string | null, chain: BlockchainAbbreviation, icon: AssetIcon, currency?: Currency | null, description?: string | null, owner: BlockchainRecipientAddressOwner, email?: string | null, isVaultAddress?: boolean | null, status: BlockchainAddressStatus, createDate: Date, updateDate: Date, delayedWithdrawalInfo?: { __typename?: 'DelayedWithdrawalInfo', enabled: boolean, withdrawalEnabledAfterHours?: number | null } | null, assets: Array<{ __typename?: 'BlockchainAsset', name?: string | null, symbol: string, icon: AssetIcon, txcoreCurrency?: string | null }> } } | { __typename?: 'WalletApprovalPayoutTransactionDetail', id: string, transferId?: string | null, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null, approvalsNeeded: number, showCancelAction: boolean, showVoteAction: boolean, votingUsers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, approvedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, rejectedBy: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, awaitingApproval: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }>, fiatAccount: { __typename?: 'CbitBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'CubixBankAccount', id: string, accountId: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'PixBankAccount', id: string, type: BankAccountType, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, label: string, nickname?: string | null, createDate: Date, updateDate?: Date | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'RtpBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null } | { __typename?: 'SenBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, fingerprint?: string | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, userConfirmedWireSend?: boolean | null, label: string, currency?: Currency | null } | { __typename?: 'SignetBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, walletAddress: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } | { __typename?: 'WireBankAccount', id: string, status: BankAccountStatus, description?: string | null, trackingRef: string, virtualAccountEnabled?: boolean | null, fingerprint?: string | null, supportedRails?: Array<RailType | null> | null, createDate: Date, updateDate?: Date | null, type: BankAccountType, nickname?: string | null, ffcMemo?: string | null, userConfirmedWireSend?: boolean | null, label: string, billingDetails?: { __typename?: 'BillingDetails', name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, district?: string | null, country?: string | null } | null, bankAddress?: { __typename?: 'BankAddress', bankName?: string | null, city?: string | null, line1?: string | null, line2?: string | null, district?: string | null, country?: string | null } | null, transferTypes?: Array<{ __typename?: 'TransferTypes', type: RailType, currencies: Array<Currency>, transactionLimits?: Array<{ __typename?: 'RailLimitType', currency: Currency, limit: string }> | null } | null> | null } | { __typename?: 'XpayBankAccount', id: string, status: BankAccountStatus, type: BankAccountType, trackingRef: string, createDate: Date, updateDate?: Date | null, nickname?: string | null, label: string, description?: string | null } } | null };

export type WalletApprovalTransactionPendingProposalCountQueryVariables = Exact<{
  currency: Currency;
}>;


export type WalletApprovalTransactionPendingProposalCountQuery = { __typename?: 'Query', walletApprovalTransactionPendingProposalCount: { __typename?: 'WalletApprovalTransactionPendingProposalCount', count: number } };

export type WalletApprovalTransactionsInfoFragment = { __typename?: 'WalletApprovalTransactions', list: Array<{ __typename?: 'WalletApprovalTransaction', id: string, type: WalletApprovalTransactionType, currency: Currency, amount: number, date: Date, status: WalletApprovalTransactionStatus, initiator?: string | null }> };

export type WalletApprovalWorkflowDashboardQueryVariables = Exact<{
  currency: Currency;
}>;


export type WalletApprovalWorkflowDashboardQuery = { __typename?: 'Query', walletApprovalPolicy?: { __typename?: 'WalletApprovalPolicy', id: string, name: string, state: WalletApprovalPolicyState, currency: Currency, canTransfer: boolean, canDeposit: boolean, showVoteAction: boolean, owner?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } | null, policyLimits?: { __typename?: 'WalletApprovalPolicyLimits', maxAmount?: string | null, maxTransactions?: string | null } | null, userLimits?: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> | null, approvalWorkflow?: { __typename?: 'WalletApprovalPolicyApprovalLevel', minNeedConfirmed: string, approvers: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null }> } | null, settings: { __typename?: 'WalletApprovalPolicySettings', allowInitiatorToApproveTransfer: boolean, proposalApprovalMethod?: WalletApprovalProposalApprovalMethod | null, applyToApi: boolean } } | null, walletApprovalPolicyDefaultUserLimits: Array<{ __typename?: 'WalletApprovalPolicyUserLimit', permissions: Array<WalletApprovalPolicyRole>, maxAmount?: string | null, maxTransactions?: string | null, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, name: string, email: string, permissionGroup?: UserRoleGroupType | null, status: UserStatusType, current: boolean, lastLogin?: Date | null, passwordChanged?: Date | null, created?: Date | null } }> };

export type DownloadReportInfoFragment = { __typename?: 'DownloadReport', reportExecutionId: string, reportType: WalletReportType, downloadUrl: string };

export type DownloadReportQueryVariables = Exact<{
  reportId: Scalars['String']['input'];
}>;


export type DownloadReportQuery = { __typename?: 'Query', downloadReport: { __typename?: 'DownloadReport', reportExecutionId: string, reportType: WalletReportType, downloadUrl: string } };

export type WalletReportInfoFragment = { __typename?: 'WalletReport', id: string, entityId: string, reportName: string, reportType: WalletReportType, reportFrequency: WalletReportFrequency, reportYear: number, reportMonth: number, retryCount: number, startDate: Date, endDate: Date, reportExecutionId: string, state: WalletReportState, createDate: Date, updateDate: Date };

export type WalletReportsInfoFragment = { __typename?: 'WalletReports', list: Array<{ __typename?: 'WalletReport', id: string, entityId: string, reportName: string, reportType: WalletReportType, reportFrequency: WalletReportFrequency, reportYear: number, reportMonth: number, retryCount: number, startDate: Date, endDate: Date, reportExecutionId: string, state: WalletReportState, createDate: Date, updateDate: Date }> };

export type WalletReportsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  walletReportType?: InputMaybe<WalletReportType>;
}>;


export type WalletReportsQuery = { __typename?: 'Query', walletReports: { __typename?: 'WalletReports', links: { __typename?: 'PaginationLinks', prev?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null, next?: { __typename?: 'PaginationLink', pageSize: number, to?: Date | null, from?: Date | null, pageAfter?: string | null, pageBefore?: string | null } | null }, list: Array<{ __typename?: 'WalletReport', id: string, entityId: string, reportName: string, reportType: WalletReportType, reportFrequency: WalletReportFrequency, reportYear: number, reportMonth: number, retryCount: number, startDate: Date, endDate: Date, reportExecutionId: string, state: WalletReportState, createDate: Date, updateDate: Date }> } };

export type AddEntriesToWatchListMutationVariables = Exact<{
  input: AddEntriesToWatchListInput;
}>;


export type AddEntriesToWatchListMutation = { __typename?: 'Mutation', addEntriesToWatchList: Array<{ __typename?: 'WatchlistEntry', id: string, type: WatchlistTypes, value: string, active: boolean, reason: string, createdBy: WatchlistCreatedBy, createDate: Date, updateDate: Date }> };

export type SetWatchListEntryInfoFragment = { __typename?: 'SetWatchListEntry', id: string, type: WatchLists, active: boolean };

export type SetWatchListEntryMutationVariables = Exact<{
  input: SetWatchListEntryInput;
}>;


export type SetWatchListEntryMutation = { __typename?: 'Mutation', setWatchListEntry: { __typename?: 'SetWatchListEntry', id: string, type: WatchLists, active: boolean } };

export type WatchlistAllowReasonInfoFragment = { __typename?: 'WatchlistAllowReason', value: AllowEntityReason };

export type WatchlistAllowReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchlistAllowReasonsQuery = { __typename?: 'Query', watchlistAllowReasons: Array<{ __typename?: 'WatchlistAllowReason', value: AllowEntityReason }> };

export type WatchlistBlockReasonInfoFragment = { __typename?: 'WatchlistBlockReason', value: BlockEntityReason };

export type WatchlistBlockReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchlistBlockReasonsQuery = { __typename?: 'Query', watchlistBlockReasons: Array<{ __typename?: 'WatchlistBlockReason', value: BlockEntityReason }> };

export type WatchlistEntitiesQueryVariables = Exact<{
  type: WatchlistTypes;
}>;


export type WatchlistEntitiesQuery = { __typename?: 'Query', watchlistEntities?: Array<{ __typename?: 'WatchlistEntity', value: string }> | null };

export type WatchlistEntityInfoFragment = { __typename?: 'WatchlistEntity', value: string };

export type WatchlistTypeInfoFragment = { __typename?: 'WatchlistType', value: WatchlistTypes, header: boolean };

export type WatchlistTypesQueryVariables = Exact<{
  variant: WatchLists;
}>;


export type WatchlistTypesQuery = { __typename?: 'Query', watchlistTypes: Array<{ __typename?: 'WatchlistType', value: WatchlistTypes, header: boolean }> };

export type WatchlistQueryVariables = Exact<{
  type?: InputMaybe<WatchlistTypes>;
}>;


export type WatchlistQuery = { __typename?: 'Query', watchlist: { __typename?: 'Watchlist', allow: Array<{ __typename?: 'WatchlistEntry', id: string, type: WatchlistTypes, value: string, active: boolean, reason: string, createdBy: WatchlistCreatedBy, createDate: Date, updateDate: Date }>, block: Array<{ __typename?: 'WatchlistEntry', id: string, type: WatchlistTypes, value: string, active: boolean, reason: string, createdBy: WatchlistCreatedBy, createDate: Date, updateDate: Date }> } };

export type WatchlistEntryInfoFragment = { __typename?: 'WatchlistEntry', id: string, type: WatchlistTypes, value: string, active: boolean, reason: string, createdBy: WatchlistCreatedBy, createDate: Date, updateDate: Date };

export type CbitTransferInstructionInfoFragment = { __typename?: 'CbitTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string };

export type CubixTransferInstructionInfoFragment = { __typename?: 'CubixTransferInstruction', type: BankAccountType, trackingRef: string, accountId: string };

export type PixTransferInstructionInfoFragment = { __typename?: 'PixTransferInstruction', type: BankAccountType, ispb?: string | null, branchCode?: string | null, accountNumber: string, name?: string | null, accountType?: string | null, taxId?: string | null, trackingRef: string, compe?: string | null };

export type RtpTransferInstructionInfoFragment = { __typename?: 'RtpTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } };

export type SenTransferInstructionInfoFragment = { __typename?: 'SenTransferInstruction', type: BankAccountType, trackingRef: string };

export type SignetTransferInstructionInfoFragment = { __typename?: 'SignetTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string };

type TransferInstructionInfo_CbitTransferInstruction_Fragment = { __typename?: 'CbitTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string };

type TransferInstructionInfo_CubixTransferInstruction_Fragment = { __typename?: 'CubixTransferInstruction', type: BankAccountType, trackingRef: string, accountId: string };

type TransferInstructionInfo_PixTransferInstruction_Fragment = { __typename?: 'PixTransferInstruction', type: BankAccountType, ispb?: string | null, branchCode?: string | null, accountNumber: string, name?: string | null, accountType?: string | null, taxId?: string | null, trackingRef: string, compe?: string | null };

type TransferInstructionInfo_RtpTransferInstruction_Fragment = { __typename?: 'RtpTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } };

type TransferInstructionInfo_SenTransferInstruction_Fragment = { __typename?: 'SenTransferInstruction', type: BankAccountType, trackingRef: string };

type TransferInstructionInfo_SignetTransferInstruction_Fragment = { __typename?: 'SignetTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string };

type TransferInstructionInfo_WireTransferInstruction_Fragment = { __typename?: 'WireTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } };

type TransferInstructionInfo_XpayTransferInstruction_Fragment = { __typename?: 'XpayTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, accountNumber: string };

export type TransferInstructionInfoFragment = TransferInstructionInfo_CbitTransferInstruction_Fragment | TransferInstructionInfo_CubixTransferInstruction_Fragment | TransferInstructionInfo_PixTransferInstruction_Fragment | TransferInstructionInfo_RtpTransferInstruction_Fragment | TransferInstructionInfo_SenTransferInstruction_Fragment | TransferInstructionInfo_SignetTransferInstruction_Fragment | TransferInstructionInfo_WireTransferInstruction_Fragment | TransferInstructionInfo_XpayTransferInstruction_Fragment;

export type TransferInstructionQueryVariables = Exact<{
  input: TransferInstructionInput;
}>;


export type TransferInstructionQuery = { __typename?: 'Query', transferInstruction: { __typename?: 'CbitTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string } | { __typename?: 'CubixTransferInstruction', type: BankAccountType, trackingRef: string, accountId: string } | { __typename?: 'PixTransferInstruction', type: BankAccountType, ispb?: string | null, branchCode?: string | null, accountNumber: string, name?: string | null, accountType?: string | null, taxId?: string | null, trackingRef: string, compe?: string | null } | { __typename?: 'RtpTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } } | { __typename?: 'SenTransferInstruction', type: BankAccountType, trackingRef: string } | { __typename?: 'SignetTransferInstruction', type: BankAccountType, trackingRef: string, walletAddress: string } | { __typename?: 'WireTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } } | { __typename?: 'XpayTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, accountNumber: string } };

export type WireBeneficiaryInfoFragment = { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string };

export type WireBeneficiaryBankInfoFragment = { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string };

export type WireTransferInstructionInfoFragment = { __typename?: 'WireTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, beneficiary: { __typename?: 'WireBeneficiary', name: string, address1: string, address2: string }, beneficiaryBank: { __typename?: 'WireBeneficiaryBank', name: string, swiftCode?: string | null, routingNumber: string, accountNumber: string, address: string, city?: string | null, postalCode: string, country: string } };

export type WireTransferLimitInfoFragment = { __typename?: 'WireTransferLimit', id: string, duration: WireTransferLimitDurationEnum, cap: { __typename?: 'Amount', amount: string, currency: Currency }, used: { __typename?: 'Amount', amount: string, currency: Currency }, available: { __typename?: 'Amount', amount: string, currency: Currency } };

export type WireTransferLimitQueryVariables = Exact<{
  currency: Currency;
  type: WireTransferTypeEnum;
}>;


export type WireTransferLimitQuery = { __typename?: 'Query', wireTransferLimit?: { __typename?: 'WireTransferLimit', id: string, duration: WireTransferLimitDurationEnum, cap: { __typename?: 'Amount', amount: string, currency: Currency }, used: { __typename?: 'Amount', amount: string, currency: Currency }, available: { __typename?: 'Amount', amount: string, currency: Currency } } | null };

export type XpayTransferInstructionInfoFragment = { __typename?: 'XpayTransferInstruction', type: BankAccountType, trackingRef: string, virtualAccountEnabled: boolean, accountNumber: string };

export const ApiKeyInfoFragmentDoc = gql`
    fragment APIKeyInfo on APIKey {
  keyId
  keyName
  keyPrefix
  ipAllowList
  roles
  expiresOn
  createDate
  updateDate
  lastUsedDate
}
    `;
export const ApiLogInfoFragmentDoc = gql`
    fragment APILogInfo on APILog {
  id
  timestamp
  method
  path
  status
  requestId
  resourceId
  idempotencyKey
  userAgent
  origin
  request
  response
}
    `;
export const ApiLogsInfoFragmentDoc = gql`
    fragment APILogsInfo on APILogs {
  list {
    ...APILogInfo
  }
}
    ${ApiLogInfoFragmentDoc}`;
export const UserGroupMemberInfoFragmentDoc = gql`
    fragment UserGroupMemberInfo on UserGroupMember {
  id
  initial
  groupType
  name
  email
}
    `;
export const UserGroupInfoFragmentDoc = gql`
    fragment UserGroupInfo on UserGroup {
  id
  name
  members {
    ...UserGroupMemberInfo
  }
}
    ${UserGroupMemberInfoFragmentDoc}`;
export const BaseApprovalPolicyInfoFragmentDoc = gql`
    fragment BaseApprovalPolicyInfo on BaseApprovalPolicy {
  id
  enabled
  requires
  type
  approverGroup {
    ...UserGroupInfo
  }
}
    ${UserGroupInfoFragmentDoc}`;
export const AmountInfoFragmentDoc = gql`
    fragment AmountInfo on Amount {
  amount
  currency
}
    `;
export const BalancesTotalInfoFragmentDoc = gql`
    fragment BalancesTotalInfo on BalancesTotal {
  balance {
    ...AmountInfo
  }
}
    ${AmountInfoFragmentDoc}`;
export const BalancesMainInfoFragmentDoc = gql`
    fragment BalancesMainInfo on BalancesMain {
  balance {
    ...AmountInfo
  }
}
    ${AmountInfoFragmentDoc}`;
export const BalancesInfoFragmentDoc = gql`
    fragment BalancesInfo on Balances {
  total {
    ...BalancesTotalInfo
  }
  main {
    ...BalancesMainInfo
  }
}
    ${BalancesTotalInfoFragmentDoc}
${BalancesMainInfoFragmentDoc}`;
export const BankSettingsInfoFragmentDoc = gql`
    fragment BankSettingsInfo on BankSettings {
  fiatAccountId
  createDate
  nickname
  updateDate
  metadata {
    userConfirmedWireSend
  }
}
    `;
export const MerchantAchBankAccountInfoFragmentDoc = gql`
    fragment MerchantAchBankAccountInfo on MerchantAchBankAccount {
  id
  status
  accountNumber
  routingNumber
  fingerprint
  billingDetails {
    name
    line1
    line2
    city
    postalCode
    district
    country
  }
  bankAddress {
    bankName
    city
    line1
    line2
    district
    country
  }
  riskEvaluation {
    decision
    reason
  }
  metadata {
    email
    phoneNumber
  }
  pairEntries {
    type
    entity
  }
  createDate
  updateDate
}
    `;
export const MerchantSepaBankAccountInfoFragmentDoc = gql`
    fragment MerchantSepaBankAccountInfo on MerchantSepaBankAccount {
  id
  status
  description
  trackingRef
  fingerprint
  billingDetails {
    name
    line1
    line2
    city
    postalCode
    district
    country
  }
  pairEntries {
    type
    entity
  }
  createDate
  updateDate
}
    `;
export const MerchantWireBankAccountInfoFragmentDoc = gql`
    fragment MerchantWireBankAccountInfo on MerchantWireBankAccount {
  id
  status
  description
  trackingRef
  fingerprint
  billingDetails {
    name
    line1
    line2
    city
    postalCode
    district
    country
  }
  bankAddress {
    bankName
    city
    line1
    line2
    district
    country
  }
  pairEntries {
    type
    entity
  }
  createDate
  updateDate
  type
  nickname
  userConfirmedWireSend
}
    `;
export const BlockchainInfoFragmentDoc = gql`
    fragment BlockchainInfo on Blockchain {
  chain
  name
  icon
  isBridged
  isTRMSupported
  isAceSupported
  chainId
}
    `;
export const CircleInternalAddressInfoFragmentDoc = gql`
    fragment CircleInternalAddressInfo on CircleInternalAddress {
  id
  addressRefId
  address
  type
  blockchain
  currency
  icon
  state
}
    `;
export const BlockchainAssetInfoFragmentDoc = gql`
    fragment BlockchainAssetInfo on BlockchainAsset {
  name
  symbol
  icon
  txcoreCurrency
}
    `;
export const DirectInternalAddressInfoFragmentDoc = gql`
    fragment DirectInternalAddressInfo on DirectInternalAddress {
  id
  name
  address
  type
  blockchain
  asset {
    ...BlockchainAssetInfo
  }
  state
  vaultId
}
    ${BlockchainAssetInfoFragmentDoc}`;
export const InternalAddressInfoFragmentDoc = gql`
    fragment InternalAddressInfo on InternalAddress {
  ...CircleInternalAddressInfo
  ...DirectInternalAddressInfo
}
    ${CircleInternalAddressInfoFragmentDoc}
${DirectInternalAddressInfoFragmentDoc}`;
export const WalletProvidersInfoFragmentDoc = gql`
    fragment WalletProvidersInfo on WalletProvider {
  id
  name
  network
  externalVendorMetadata {
    externalId
    externalSource
  }
  active
}
    `;
export const CountriesInfoFragmentDoc = gql`
    fragment CountriesInfo on Countries {
  codes
  list {
    code
    link {
      locatedIn
      registeredIn
    }
    support {
      iban
      nonIban
    }
    onboarding {
      eea
    }
  }
}
    `;
export const CustodyAssetMetadataInfoFragmentDoc = gql`
    fragment CustodyAssetMetadataInfo on CustodyAssetMetadata {
  symbol
  icon
  name
  decimals
}
    `;
export const CustodyAmountInfoFragmentDoc = gql`
    fragment CustodyAmountInfo on CustodyAmount {
  amount
  asset {
    ...CustodyAssetMetadataInfo
  }
}
    ${CustodyAssetMetadataInfoFragmentDoc}`;
export const DepositSourceInfoFragmentDoc = gql`
    fragment DepositSourceInfo on DepositSource {
  id
  type
  name
}
    `;
export const DepositDestinationInfoFragmentDoc = gql`
    fragment DepositDestinationInfo on DepositDestination {
  id
  type
}
    `;
export const RiskEvaluationInfoFragmentDoc = gql`
    fragment RiskEvaluationInfo on RiskEvaluation {
  decision
  reason
}
    `;
export const DepositInfoFragmentDoc = gql`
    fragment DepositInfo on Deposit {
  id
  source {
    ...DepositSourceInfo
  }
  destination {
    ...DepositDestinationInfo
  }
  amount {
    ...AmountInfo
  }
  fromAmount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  status
  riskEvaluation {
    ...RiskEvaluationInfo
  }
  createDate
  updateDate
}
    ${DepositSourceInfoFragmentDoc}
${DepositDestinationInfoFragmentDoc}
${AmountInfoFragmentDoc}
${RiskEvaluationInfoFragmentDoc}`;
export const EntityInfoFragmentDoc = gql`
    fragment EntityInfo on Entity {
  entityId
  entityType
  institutionName
  group
  country
  district
  entityAccountNumber
  legalEntity
  accountType
}
    `;
export const FactorInfoFragmentDoc = gql`
    fragment FactorInfo on Factor {
  id
  type
  provider
  status
  dateCreated
}
    `;
export const FeeReportInfoFragmentDoc = gql`
    fragment FeeReportInfo on FeeReport {
  id
  fee {
    ...AmountInfo
  }
  status
  cumulatedPayoutAmount {
    ...AmountInfo
  }
  cumulatedPaymentAmount {
    ...AmountInfo
  }
  cumulatedNetAmount {
    ...AmountInfo
  }
  valueDate
  createDate
  thresholdResetTimestamp
}
    ${AmountInfoFragmentDoc}`;
export const FeeReportsInfoFragmentDoc = gql`
    fragment FeeReportsInfo on FeeReports {
  list {
    ...FeeReportInfo
  }
}
    ${FeeReportInfoFragmentDoc}`;
export const FxQuoteInputInfoFragmentDoc = gql`
    fragment FxQuoteInputInfo on FxQuote {
  id
  rate
  from {
    ...AmountInfo
  }
  to {
    ...AmountInfo
  }
  expiry
}
    ${AmountInfoFragmentDoc}`;
export const PaginationLinksInfoFragmentDoc = gql`
    fragment PaginationLinksInfo on PaginationLinks {
  prev {
    pageSize
    to
    from
    pageAfter
    pageBefore
  }
  next {
    pageSize
    to
    from
    pageAfter
    pageBefore
  }
}
    `;
export const BaseInAppNotificationInfoFragmentDoc = gql`
    fragment BaseInAppNotificationInfo on BaseInAppNotification {
  id
  createDate
  isRead
  type
}
    `;
export const EmailVerifiedNotificationInfoFragmentDoc = gql`
    fragment EmailVerifiedNotificationInfo on EmailVerifiedNotification {
  ...BaseInAppNotificationInfo
  payload {
    emailVerified
  }
}
    ${BaseInAppNotificationInfoFragmentDoc}`;
export const MainWalletPolicyApprovalRequestNotificationInfoFragmentDoc = gql`
    fragment MainWalletPolicyApprovalRequestNotificationInfo on MainWalletPolicyApprovalRequestNotification {
  ...BaseInAppNotificationInfo
  payload {
    policyId
    policyName
    currency
    policyCreator
  }
}
    ${BaseInAppNotificationInfoFragmentDoc}`;
export const MainWalletPendingTransactionApprovalRequestNotificationInfoFragmentDoc = gql`
    fragment MainWalletPendingTransactionApprovalRequestNotificationInfo on MainWalletPendingTransactionApprovalRequestNotification {
  ...BaseInAppNotificationInfo
  payload {
    id
    type
    amount
    currency
    initiatorFullName
    initiatorEmail
  }
}
    ${BaseInAppNotificationInfoFragmentDoc}`;
export const PreQualAutoApprovedNotificationInfoFragmentDoc = gql`
    fragment PreQualAutoApprovedNotificationInfo on PreQualAutoApprovedNotification {
  ...BaseInAppNotificationInfo
  payload {
    approved
  }
}
    ${BaseInAppNotificationInfoFragmentDoc}`;
export const InAppNotificationInfoFragmentDoc = gql`
    fragment InAppNotificationInfo on InAppNotification {
  ...EmailVerifiedNotificationInfo
  ...MainWalletPolicyApprovalRequestNotificationInfo
  ...MainWalletPendingTransactionApprovalRequestNotificationInfo
  ...PreQualAutoApprovedNotificationInfo
}
    ${EmailVerifiedNotificationInfoFragmentDoc}
${MainWalletPolicyApprovalRequestNotificationInfoFragmentDoc}
${MainWalletPendingTransactionApprovalRequestNotificationInfoFragmentDoc}
${PreQualAutoApprovedNotificationInfoFragmentDoc}`;
export const InAppNotificationsInfoFragmentDoc = gql`
    fragment InAppNotificationsInfo on InAppNotifications {
  links {
    ...PaginationLinksInfo
  }
  list {
    ...InAppNotificationInfo
  }
}
    ${PaginationLinksInfoFragmentDoc}
${InAppNotificationInfoFragmentDoc}`;
export const InvoiceDetailInfoFragmentDoc = gql`
    fragment InvoiceDetailInfo on InvoiceDetail {
  id
  invoiceDate
  invoiceNumber
  amountTotal {
    ...AmountInfo
  }
  amountDue {
    ...AmountInfo
  }
  amountPaid {
    ...AmountInfo
  }
  status
  invoiceLink
}
    ${AmountInfoFragmentDoc}`;
export const InvoicePaymentInfoFragmentDoc = gql`
    fragment InvoicePaymentInfo on InvoicePayment {
  id
  paymentId
  type
  status
  amount {
    ...AmountInfo
  }
}
    ${AmountInfoFragmentDoc}`;
export const InvoicePaymentDetailInfoFragmentDoc = gql`
    fragment InvoicePaymentDetailInfo on InvoicePaymentDetail {
  id
  invoiceDate
  invoiceNumber
  amountTotal {
    ...AmountInfo
  }
  amountDue {
    ...AmountInfo
  }
  amountPaid {
    ...AmountInfo
  }
  status
  invoiceLink
  latestPaymentDetails {
    id
    paymentId
    type
    status
    amount {
      ...AmountInfo
    }
  }
}
    ${AmountInfoFragmentDoc}`;
export const InvoiceInfoFragmentDoc = gql`
    fragment InvoiceInfo on Invoice {
  id
  invoiceDate
  invoiceNumber
  amountTotal {
    ...AmountInfo
  }
  amountDue {
    ...AmountInfo
  }
  amountPaid {
    ...AmountInfo
  }
  status
}
    ${AmountInfoFragmentDoc}`;
export const InvoicesInfoFragmentDoc = gql`
    fragment InvoicesInfo on Invoices {
  list {
    ...InvoiceInfo
  }
}
    ${InvoiceInfoFragmentDoc}`;
export const IpAllowListingIpAddressInfoFragmentDoc = gql`
    fragment IpAllowListingIpAddressInfo on IpAllowListingIpAddress {
  id
  type
  value
  createDate
}
    `;
export const ChargebackHistoryInfoFragmentDoc = gql`
    fragment ChargebackHistoryInfo on ChargebackHistory {
  type
  chargebackAmount {
    ...AmountInfo
  }
  fee {
    ...AmountInfo
  }
  description
  settlementId
  createDate
}
    ${AmountInfoFragmentDoc}`;
export const MerchantChargebackInfoFragmentDoc = gql`
    fragment MerchantChargebackInfo on MerchantChargeback {
  id
  type
  chargebackAmount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  description
  category
  paymentId
  merchantId
  reasonCode
  createDate
  history {
    ...ChargebackHistoryInfo
  }
}
    ${AmountInfoFragmentDoc}
${ChargebackHistoryInfoFragmentDoc}`;
export const MerchantChargebacksInfoFragmentDoc = gql`
    fragment MerchantChargebacksInfo on MerchantChargebacks {
  list {
    ...MerchantChargebackInfo
  }
}
    ${MerchantChargebackInfoFragmentDoc}`;
export const MerchantCardVerificationInfoFragmentDoc = gql`
    fragment MerchantCardVerificationInfo on MerchantCardVerification {
  avs
  cvv
}
    `;
export const MerchantCreditCardInfoFragmentDoc = gql`
    fragment MerchantCreditCardInfo on MerchantCreditCard {
  createDate
  errorCode
  expMonth
  expYear
  id
  last4
  network
  verification {
    ...MerchantCardVerificationInfo
  }
}
    ${MerchantCardVerificationInfoFragmentDoc}`;
export const MerchantPaymentSourceInfoFragmentDoc = gql`
    fragment MerchantPaymentSourceInfo on MerchantPaymentSource {
  id
  type
}
    `;
export const MerchantPaymentOperationStatusInfoFragmentDoc = gql`
    fragment MerchantPaymentOperationStatusInfo on MerchantPaymentOperationStatus {
  id
  type
  status
  createDate
  updateDate
}
    `;
export const MerchantPaymentRefundInfoFragmentDoc = gql`
    fragment MerchantPaymentRefundInfo on MerchantPaymentRefund {
  id
  type
  merchantId
  source {
    ...MerchantPaymentSourceInfo
  }
  description
  amount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  status
  reason
  createDate
  updateDate
}
    ${MerchantPaymentSourceInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const BlockchainDepositAddressInfoFragmentDoc = gql`
    fragment BlockchainDepositAddressInfo on BlockchainDepositAddress {
  address
  addressTag
  chain
  currency
}
    `;
export const MerchantPaymentNetworkFeeInfoFragmentDoc = gql`
    fragment MerchantPaymentNetworkFeeInfo on MerchantPaymentNetworkFee {
  amount
  currency
  feePayer
}
    `;
export const MerchantPaymentInfoFragmentDoc = gql`
    fragment MerchantPaymentInfo on MerchantPayment {
  id
  type
  merchantId
  merchantWalletId
  paymentIntentId
  metadata {
    email
    phoneNumber
  }
  description
  status
  errorCode
  reason
  source {
    ...MerchantPaymentSourceInfo
  }
  amount {
    ...AmountInfo
  }
  fromAmount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  originalPayment {
    ...MerchantPaymentOperationStatusInfo
  }
  cancel {
    ...MerchantPaymentOperationStatusInfo
  }
  refunds {
    ...MerchantPaymentRefundInfo
  }
  isRefundable
  isCancellable
  allowEntityToBeBlocked
  relatedTransactions {
    ...MerchantPaymentOperationStatusInfo
  }
  createDate
  updateDate
  settlementAmount {
    ...AmountInfo
  }
  depositAddress {
    ...BlockchainDepositAddressInfo
  }
  transactionHash
  networkFees {
    ...MerchantPaymentNetworkFeeInfo
  }
}
    ${MerchantPaymentSourceInfoFragmentDoc}
${AmountInfoFragmentDoc}
${MerchantPaymentOperationStatusInfoFragmentDoc}
${MerchantPaymentRefundInfoFragmentDoc}
${BlockchainDepositAddressInfoFragmentDoc}
${MerchantPaymentNetworkFeeInfoFragmentDoc}`;
export const MerchantPaymentsInfoFragmentDoc = gql`
    fragment MerchantPaymentsInfo on MerchantPayments {
  list {
    ...MerchantPaymentInfo
  }
}
    ${MerchantPaymentInfoFragmentDoc}`;
export const MerchantPaymentIntentFeeInfoFragmentDoc = gql`
    fragment MerchantPaymentIntentFeeInfo on MerchantPaymentIntentFee {
  type
  amount
  currency
}
    `;
export const MerchantPaymentIntentPaymentMethodInfoFragmentDoc = gql`
    fragment MerchantPaymentIntentPaymentMethodInfo on MerchantPaymentIntentPaymentMethod {
  type
  chain
  address
}
    `;
export const MerchantPaymentIntentTimelineItemInfoFragmentDoc = gql`
    fragment MerchantPaymentIntentTimelineItemInfo on MerchantPaymentIntentTimelineItem {
  status
  context
  time
}
    `;
export const MerchantPaymentIntentInfoFragmentDoc = gql`
    fragment MerchantPaymentIntentInfo on MerchantPaymentIntent {
  id
  amount {
    ...AmountInfo
  }
  amountPaid {
    ...AmountInfo
  }
  amountRefunded {
    ...AmountInfo
  }
  fees {
    ...MerchantPaymentIntentFeeInfo
  }
  totalPaymentFees {
    ...MerchantPaymentIntentFeeInfo
  }
  settlementCurrency
  paymentMethods {
    ...MerchantPaymentIntentPaymentMethodInfo
  }
  paymentIds
  timeline {
    ...MerchantPaymentIntentTimelineItemInfo
  }
  status
  context
  createDate
  updateDate
  expiresOn
  currency
  type
}
    ${AmountInfoFragmentDoc}
${MerchantPaymentIntentFeeInfoFragmentDoc}
${MerchantPaymentIntentPaymentMethodInfoFragmentDoc}
${MerchantPaymentIntentTimelineItemInfoFragmentDoc}`;
export const MerchantPaymentIntentsInfoFragmentDoc = gql`
    fragment MerchantPaymentIntentsInfo on MerchantPaymentIntents {
  list {
    ...MerchantPaymentIntentInfo
  }
}
    ${MerchantPaymentIntentInfoFragmentDoc}`;
export const MerchantPayoutDestinationInfoFragmentDoc = gql`
    fragment MerchantPayoutDestinationInfo on MerchantPayoutDestination {
  id
  name
  type
}
    `;
export const MerchantPayoutReturnInfoFragmentDoc = gql`
    fragment MerchantPayoutReturnInfo on MerchantPayoutReturn {
  id
  payoutId
  amount {
    ...AmountInfo
  }
  status
  fees {
    ...AmountInfo
  }
  reason
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}`;
export const MerchantPayoutAdjustmentsInfoFragmentDoc = gql`
    fragment MerchantPayoutAdjustmentsInfo on MerchantPayoutAdjustments {
  fxCredit {
    ...AmountInfo
  }
  fxDebit {
    ...AmountInfo
  }
  bankFees {
    ...AmountInfo
  }
}
    ${AmountInfoFragmentDoc}`;
export const BillingDetailsInfoFragmentDoc = gql`
    fragment BillingDetailsInfo on BillingDetails {
  name
  line1
  line2
  city
  postalCode
  district
  country
}
    `;
export const IdentityInfoFragmentDoc = gql`
    fragment IdentityInfo on Identity {
  type
  name
  addresses {
    ...BillingDetailsInfo
  }
}
    ${BillingDetailsInfoFragmentDoc}`;
export const MerchantPayoutSourceInfoFragmentDoc = gql`
    fragment MerchantPayoutSourceInfo on MerchantPayoutSource {
  id
  type
  identities {
    ...IdentityInfo
  }
}
    ${IdentityInfoFragmentDoc}`;
export const MerchantPayoutMetadataInfoFragmentDoc = gql`
    fragment MerchantPayoutMetadataInfo on MerchantPayoutMetadata {
  beneficiaryEmail
}
    `;
export const MerchantPayoutInfoFragmentDoc = gql`
    fragment MerchantPayoutInfo on MerchantPayout {
  id
  amount {
    ...AmountInfo
  }
  status
  sourceWalletId
  errorCode
  trackingRef
  riskEvaluation {
    ...RiskEvaluationInfo
  }
  destination {
    ...MerchantPayoutDestinationInfo
  }
  return {
    ...MerchantPayoutReturnInfo
  }
  adjustments {
    ...MerchantPayoutAdjustmentsInfo
  }
  fees {
    ...AmountInfo
  }
  toAmount {
    ...AmountInfo
  }
  source {
    ...MerchantPayoutSourceInfo
  }
  metadata {
    ...MerchantPayoutMetadataInfo
  }
  description
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}
${RiskEvaluationInfoFragmentDoc}
${MerchantPayoutDestinationInfoFragmentDoc}
${MerchantPayoutReturnInfoFragmentDoc}
${MerchantPayoutAdjustmentsInfoFragmentDoc}
${MerchantPayoutSourceInfoFragmentDoc}
${MerchantPayoutMetadataInfoFragmentDoc}`;
export const MerchantPayoutsInfoFragmentDoc = gql`
    fragment MerchantPayoutsInfo on MerchantPayouts {
  list {
    ...MerchantPayoutInfo
  }
}
    ${MerchantPayoutInfoFragmentDoc}`;
export const NotificationSubscriptionInfoFragmentDoc = gql`
    fragment NotificationSubscriptionInfo on NotificationSubscription {
  id
  endpoint
  status
  subscriptionDetails {
    ... on NotificationSubscriptionDetail {
      url
      status
    }
  }
}
    `;
export const OnboardingApplicationInfoFragmentDoc = gql`
    fragment OnboardingApplicationInfo on OnboardingApplication {
  applicableJurisdiction
  onboardingId
  status
  operationType
}
    `;
export const OnboardingCertificationInfoFragmentDoc = gql`
    fragment OnboardingCertificationInfo on OnboardingCertification {
  id
  content
  type
}
    `;
export const OnboardingChildSectionInfoFragmentDoc = gql`
    fragment OnboardingChildSectionInfo on OnboardingChildSection {
  id
  name
  status
  hidden
}
    `;
export const OnboardingChildSectionWithDataInfoFragmentDoc = gql`
    fragment OnboardingChildSectionWithDataInfo on OnboardingChildSection {
  ...OnboardingChildSectionInfo
  overviewGroups
  data {
    id
    groupName
    groupSchema {
      id
      name
      readOnly
    }
    groupValues {
      groupId
      refId
      fields {
        id
        name
        value
      }
    }
  }
  rfiBundle {
    id
    status
    createDate
    fields {
      id
      fieldId
      refId
      rfiType
      responded
      groupIds
      groupNames
      elementType
      elementName
    }
  }
  rfiComments {
    id
    authorType
    rfiId
    content
  }
}
    ${OnboardingChildSectionInfoFragmentDoc}`;
export const OnboardingGroupDataV2InfoFragmentDoc = gql`
    fragment OnboardingGroupDataV2Info on OnboardingGroupDataV2 {
  id
  groupName
  groupSchema {
    id
    name
    readOnly
    type
  }
  groupValues {
    groupId
    refId
    fields {
      id
      name
      value
      rfiId
      rfiStatus
      rfiComment
    }
  }
}
    `;
export const OnboardingNaturesOfBusinessInfoFragmentDoc = gql`
    fragment OnboardingNaturesOfBusinessInfo on OnboardingNatureOfBusiness {
  name
  value
  prohibited
}
    `;
export const OnboardingOverviewSectionInfoFragmentDoc = gql`
    fragment OnboardingOverviewSectionInfo on OnboardingOverviewSection {
  id
  name
  hidden
}
    `;
export const OnboardingSubmitApplicationInfoFragmentDoc = gql`
    fragment OnboardingSubmitApplicationInfo on OnboardingApplicationSubmission {
  onboardingId
  status
}
    `;
export const OnboardingUploadDocumentResponseInfoFragmentDoc = gql`
    fragment OnboardingUploadDocumentResponseInfo on OnboardingUploadDocumentResponse {
  documentId
  uploadDate
  fileSize
  fileName
  entityId
  description
  documentType
  issuedCountry
  fileType
}
    `;
export const PciPublicKeyInfoFragmentDoc = gql`
    fragment PciPublicKeyInfo on PciPublicKey {
  publicKey
  keyId
}
    `;
export const PaginationInfoFragmentDoc = gql`
    fragment PaginationInfo on PaginationExtends {
  links {
    ...PaginationLinksInfo
  }
}
    ${PaginationLinksInfoFragmentDoc}`;
export const DestinationInfoFragmentDoc = gql`
    fragment DestinationInfo on Destination {
  id
  type
  name
}
    `;
export const PaymentInfoFragmentDoc = gql`
    fragment PaymentInfo on Payment {
  id
  type
  amount {
    amount
    currency
  }
  createDate
  updateDate
  fiatTransactionType
  status
}
    `;
export const BankLocationInfoFragmentDoc = gql`
    fragment BankLocationInfo on BankLocation {
  nickname
  description
}
    `;
export const WireWithdrawalInfoFragmentDoc = gql`
    fragment WireWithdrawalInfo on WireWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...BankLocationInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BankLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const WireReceiveInfoFragmentDoc = gql`
    fragment WireReceiveInfo on WireReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...BankLocationInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BankLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const SenWithdrawalInfoFragmentDoc = gql`
    fragment SenWithdrawalInfo on SenWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...BankLocationInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BankLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const SenReceiveInfoFragmentDoc = gql`
    fragment SenReceiveInfo on SenReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...BankLocationInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BankLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const BlockchainRecipientAddressLocationInfoFragmentDoc = gql`
    fragment BlockchainRecipientAddressLocationInfo on BlockchainRecipientAddressLocation {
  addressId
  address
  addressTag
  chain
  currency
  description
  owner
  email
}
    `;
export const OnchainSendInfoFragmentDoc = gql`
    fragment OnchainSendInfo on OnchainSend {
  transactionHash
  explorerLink
  payment {
    ...PaymentInfo
  }
  destination {
    ...BlockchainRecipientAddressLocationInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BlockchainRecipientAddressLocationInfoFragmentDoc}`;
export const OnchainReceiveInfoFragmentDoc = gql`
    fragment OnchainReceiveInfo on OnchainReceive {
  transactionHash
  explorerLink
  payment {
    ...PaymentInfo
  }
  source {
    ...BlockchainRecipientAddressLocationInfo
  }
}
    ${PaymentInfoFragmentDoc}
${BlockchainRecipientAddressLocationInfoFragmentDoc}`;
export const SignetBankAccountInfoFragmentDoc = gql`
    fragment SignetBankAccountInfo on SignetBankAccount {
  id
  status
  type
  trackingRef
  walletAddress
  createDate
  updateDate
  nickname
  label
  description
}
    `;
export const SignetWithdrawalInfoFragmentDoc = gql`
    fragment SignetWithdrawalInfo on SignetWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...SignetBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${SignetBankAccountInfoFragmentDoc}`;
export const SignetReceiveInfoFragmentDoc = gql`
    fragment SignetReceiveInfo on SignetReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...SignetBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${SignetBankAccountInfoFragmentDoc}`;
export const CbitBankAccountInfoFragmentDoc = gql`
    fragment CbitBankAccountInfo on CbitBankAccount {
  id
  status
  type
  trackingRef
  walletAddress
  createDate
  updateDate
  nickname
  label
  description
}
    `;
export const CbitWithdrawalInfoFragmentDoc = gql`
    fragment CbitWithdrawalInfo on CbitWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...CbitBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${CbitBankAccountInfoFragmentDoc}`;
export const CbitReceiveInfoFragmentDoc = gql`
    fragment CbitReceiveInfo on CbitReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...CbitBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${CbitBankAccountInfoFragmentDoc}`;
export const XpayBankAccountInfoFragmentDoc = gql`
    fragment XpayBankAccountInfo on XpayBankAccount {
  id
  status
  type
  trackingRef
  createDate
  updateDate
  nickname
  label
  description
}
    `;
export const XpayWithdrawalInfoFragmentDoc = gql`
    fragment XpayWithdrawalInfo on XpayWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...XpayBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${XpayBankAccountInfoFragmentDoc}`;
export const XpayReceiveInfoFragmentDoc = gql`
    fragment XpayReceiveInfo on XpayReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...XpayBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${XpayBankAccountInfoFragmentDoc}`;
export const RtpBankAccountInfoFragmentDoc = gql`
    fragment RtpBankAccountInfo on RtpBankAccount {
  id
  status
  description
  trackingRef
  virtualAccountEnabled
  fingerprint
  billingDetails {
    name
    line1
    line2
    city
    postalCode
    district
    country
  }
  createDate
  updateDate
  type
  nickname
  label
}
    `;
export const RtpWithdrawalInfoFragmentDoc = gql`
    fragment RtpWithdrawalInfo on RtpWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...RtpBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${RtpBankAccountInfoFragmentDoc}`;
export const RtpReceiveInfoFragmentDoc = gql`
    fragment RtpReceiveInfo on RtpReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...RtpBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${RtpBankAccountInfoFragmentDoc}`;
export const TransferTypesInfoFragmentDoc = gql`
    fragment TransferTypesInfo on TransferTypes {
  type
  currencies
  transactionLimits {
    currency
    limit
  }
}
    `;
export const WireBankAccountInfoFragmentDoc = gql`
    fragment WireBankAccountInfo on WireBankAccount {
  id
  status
  description
  trackingRef
  virtualAccountEnabled
  fingerprint
  billingDetails {
    name
    line1
    line2
    city
    postalCode
    district
    country
  }
  bankAddress {
    bankName
    city
    line1
    line2
    district
    country
  }
  supportedRails
  transferTypes {
    ...TransferTypesInfo
  }
  createDate
  updateDate
  type
  nickname
  ffcMemo
  userConfirmedWireSend
  label
}
    ${TransferTypesInfoFragmentDoc}`;
export const SepaWithdrawalInfoFragmentDoc = gql`
    fragment SepaWithdrawalInfo on SepaWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...WireBankAccountInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${WireBankAccountInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const SepaReceiveInfoFragmentDoc = gql`
    fragment SepaReceiveInfo on SepaReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...WireBankAccountInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${WireBankAccountInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const SepaInstantWithdrawalInfoFragmentDoc = gql`
    fragment SepaInstantWithdrawalInfo on SepaInstantWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...WireBankAccountInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${WireBankAccountInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const SepaInstantReceiveInfoFragmentDoc = gql`
    fragment SepaInstantReceiveInfo on SepaInstantReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...WireBankAccountInfo
  }
  fees {
    ...AmountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${WireBankAccountInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const FeeLocationInfoFragmentDoc = gql`
    fragment FeeLocationInfo on FeeLocation {
  type
  id
}
    `;
export const SettlementCreditFeeInfoFragmentDoc = gql`
    fragment SettlementCreditFeeInfo on SettlementCreditFee {
  payment {
    id
    type
    amount {
      ...AmountInfo
    }
    createDate
    updateDate
    status
    relatedTransactionId
    location {
      ...FeeLocationInfo
    }
  }
}
    ${AmountInfoFragmentDoc}
${FeeLocationInfoFragmentDoc}`;
export const ReceiveLocationInfoFragmentDoc = gql`
    fragment ReceiveLocationInfo on ReceiveLocation {
  type
  id
}
    `;
export const SettlementCreditReceiveInfoFragmentDoc = gql`
    fragment SettlementCreditReceiveInfo on SettlementCreditReceive {
  payment {
    id
    type
    amount {
      ...AmountInfo
    }
    createDate
    updateDate
    status
    relatedTransactionId
    location {
      ...ReceiveLocationInfo
    }
  }
}
    ${AmountInfoFragmentDoc}
${ReceiveLocationInfoFragmentDoc}`;
export const GrossRedemptionFeeInfoFragmentDoc = gql`
    fragment GrossRedemptionFeeInfo on GrossRedemptionFee {
  payment {
    id
    type
    amount {
      ...AmountInfo
    }
    createDate
    updateDate
    status
    relatedTransactionId
    location {
      ...FeeLocationInfo
    }
  }
}
    ${AmountInfoFragmentDoc}
${FeeLocationInfoFragmentDoc}`;
export const NetRedemptionFeeInfoFragmentDoc = gql`
    fragment NetRedemptionFeeInfo on NetRedemptionFee {
  payment {
    id
    type
    amount {
      ...AmountInfo
    }
    createDate
    updateDate
    status
  }
}
    ${AmountInfoFragmentDoc}`;
export const CubixBankAccountInfoFragmentDoc = gql`
    fragment CubixBankAccountInfo on CubixBankAccount {
  id
  accountId
  status
  type
  trackingRef
  createDate
  updateDate
  nickname
  label
  description
}
    `;
export const CubixWithdrawalInfoFragmentDoc = gql`
    fragment CubixWithdrawalInfo on CubixWithdrawal {
  payment {
    ...PaymentInfo
  }
  destination {
    ...CubixBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${CubixBankAccountInfoFragmentDoc}`;
export const CubixReceiveInfoFragmentDoc = gql`
    fragment CubixReceiveInfo on CubixReceive {
  payment {
    ...PaymentInfo
  }
  source {
    ...CubixBankAccountInfo
  }
}
    ${PaymentInfoFragmentDoc}
${CubixBankAccountInfoFragmentDoc}`;
export const PaymentDetailsInfoFragmentDoc = gql`
    fragment PaymentDetailsInfo on PaymentDetails {
  ... on WireWithdrawal {
    ...WireWithdrawalInfo
  }
  ... on WireReceive {
    ...WireReceiveInfo
  }
  ... on SenWithdrawal {
    ...SenWithdrawalInfo
  }
  ... on SenReceive {
    ...SenReceiveInfo
  }
  ... on OnchainSend {
    ...OnchainSendInfo
  }
  ... on OnchainReceive {
    ...OnchainReceiveInfo
  }
  ... on SignetWithdrawal {
    ...SignetWithdrawalInfo
  }
  ... on SignetReceive {
    ...SignetReceiveInfo
  }
  ... on CbitWithdrawal {
    ...CbitWithdrawalInfo
  }
  ... on CbitReceive {
    ...CbitReceiveInfo
  }
  ... on XpayWithdrawal {
    ...XpayWithdrawalInfo
  }
  ... on XpayReceive {
    ...XpayReceiveInfo
  }
  ... on RtpWithdrawal {
    ...RtpWithdrawalInfo
  }
  ... on RtpReceive {
    ...RtpReceiveInfo
  }
  ... on SepaWithdrawal {
    ...SepaWithdrawalInfo
  }
  ... on SepaReceive {
    ...SepaReceiveInfo
  }
  ... on SepaInstantWithdrawal {
    ...SepaInstantWithdrawalInfo
  }
  ... on SepaInstantReceive {
    ...SepaInstantReceiveInfo
  }
  ... on SettlementCreditFee {
    ...SettlementCreditFeeInfo
  }
  ... on SettlementCreditReceive {
    ...SettlementCreditReceiveInfo
  }
  ... on GrossRedemptionFee {
    ...GrossRedemptionFeeInfo
  }
  ... on NetRedemptionFee {
    ...NetRedemptionFeeInfo
  }
  ... on CubixWithdrawal {
    ...CubixWithdrawalInfo
  }
  ... on CubixReceive {
    ...CubixReceiveInfo
  }
}
    ${WireWithdrawalInfoFragmentDoc}
${WireReceiveInfoFragmentDoc}
${SenWithdrawalInfoFragmentDoc}
${SenReceiveInfoFragmentDoc}
${OnchainSendInfoFragmentDoc}
${OnchainReceiveInfoFragmentDoc}
${SignetWithdrawalInfoFragmentDoc}
${SignetReceiveInfoFragmentDoc}
${CbitWithdrawalInfoFragmentDoc}
${CbitReceiveInfoFragmentDoc}
${XpayWithdrawalInfoFragmentDoc}
${XpayReceiveInfoFragmentDoc}
${RtpWithdrawalInfoFragmentDoc}
${RtpReceiveInfoFragmentDoc}
${SepaWithdrawalInfoFragmentDoc}
${SepaReceiveInfoFragmentDoc}
${SepaInstantWithdrawalInfoFragmentDoc}
${SepaInstantReceiveInfoFragmentDoc}
${SettlementCreditFeeInfoFragmentDoc}
${SettlementCreditReceiveInfoFragmentDoc}
${GrossRedemptionFeeInfoFragmentDoc}
${NetRedemptionFeeInfoFragmentDoc}
${CubixWithdrawalInfoFragmentDoc}
${CubixReceiveInfoFragmentDoc}`;
export const PaymentsInfoFragmentDoc = gql`
    fragment PaymentsInfo on Payments {
  list {
    ...PaymentInfo
  }
}
    ${PaymentInfoFragmentDoc}`;
export const CardPaymentVerificationInfoFragmentDoc = gql`
    fragment CardPaymentVerificationInfo on CardPaymentVerification {
  cvvStatus
  avs
}
    `;
export const CardPaymentMetadataInfoFragmentDoc = gql`
    fragment CardPaymentMetadataInfo on Metadata {
  phoneNumber
  email
}
    `;
export const CardPaymentInfoFragmentDoc = gql`
    fragment CardPaymentInfo on CardPayment {
  id
  status
  last4
  billingDetails {
    ...BillingDetailsInfo
  }
  expMonth
  expYear
  network
  bin
  issuerCountry
  fundingType
  fingerprint
  verification {
    ...CardPaymentVerificationInfo
  }
  metadata {
    ...CardPaymentMetadataInfo
  }
  pairEntries {
    type
    entity
  }
  createDate
  updateDate
}
    ${BillingDetailsInfoFragmentDoc}
${CardPaymentVerificationInfoFragmentDoc}
${CardPaymentMetadataInfoFragmentDoc}`;
export const CardPaymentMethodMetadataInfoFragmentDoc = gql`
    fragment CardPaymentMethodMetadataInfo on CardPaymentMethodMetadata {
  email
}
    `;
export const CardPaymentMethodInfoFragmentDoc = gql`
    fragment CardPaymentMethodInfo on CardPaymentMethod {
  id
  last4
  billingDetails {
    ...BillingDetailsInfo
  }
  expMonth
  expYear
  network
  verification {
    ...CardPaymentVerificationInfo
  }
  metadata {
    ...CardPaymentMethodMetadataInfo
  }
  createDate
  errorCode
  isDefault
}
    ${BillingDetailsInfoFragmentDoc}
${CardPaymentVerificationInfoFragmentDoc}
${CardPaymentMethodMetadataInfoFragmentDoc}`;
export const CardPaymentMethodsInfoFragmentDoc = gql`
    fragment CardPaymentMethodsInfo on CardPaymentMethods {
  list {
    ...CardPaymentMethodInfo
  }
}
    ${CardPaymentMethodInfoFragmentDoc}`;
export const DefaultPaymentMethodInfoFragmentDoc = gql`
    fragment DefaultPaymentMethodInfo on DefaultPaymentMethod {
  id
  entityId
  type
  isDefault
  createDate
}
    `;
export const WalletPaymentMethodInfoFragmentDoc = gql`
    fragment WalletPaymentMethodInfo on WalletPaymentMethod {
  balance {
    ...AmountInfo
  }
  isDefault
}
    ${AmountInfoFragmentDoc}`;
export const PayoutDestinationInfoFragmentDoc = gql`
    fragment PayoutDestinationInfo on PayoutDestination {
  id
  type
  name
}
    `;
export const PartialAmountInfoFragmentDoc = gql`
    fragment PartialAmountInfo on PartialAmount {
  amount
  currency
}
    `;
export const PayoutReturnInfoFragmentDoc = gql`
    fragment PayoutReturnInfo on PayoutReturn {
  id
  payoutId
  amount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  reason
  status
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}`;
export const PayoutAdjustmentsInfoFragmentDoc = gql`
    fragment PayoutAdjustmentsInfo on PayoutAdjustments {
  fxCredit {
    ...AmountInfo
  }
  fxDebit {
    ...AmountInfo
  }
}
    ${AmountInfoFragmentDoc}`;
export const PayoutInfoFragmentDoc = gql`
    fragment PayoutInfo on Payout {
  id
  sourceWalletId
  destination {
    ...PayoutDestinationInfo
  }
  amount {
    ...AmountInfo
  }
  toAmount {
    ...PartialAmountInfo
  }
  fees {
    ...AmountInfo
  }
  status
  trackingRef
  errorCode
  riskEvaluation {
    ...RiskEvaluationInfo
  }
  return {
    ...PayoutReturnInfo
  }
  adjustments {
    ...PayoutAdjustmentsInfo
  }
  createDate
  updateDate
}
    ${PayoutDestinationInfoFragmentDoc}
${AmountInfoFragmentDoc}
${PartialAmountInfoFragmentDoc}
${RiskEvaluationInfoFragmentDoc}
${PayoutReturnInfoFragmentDoc}
${PayoutAdjustmentsInfoFragmentDoc}`;
export const ProposalInfoFragmentDoc = gql`
    fragment ProposalInfo on Proposal {
  id
  type
  requires
  createdAt
  initiator {
    ...UserGroupMemberInfo
  }
  approverGroup {
    id
    name
    members {
      ...UserGroupMemberInfo
    }
  }
  status
  events {
    createdAt
    type
    performedBy {
      ...UserGroupMemberInfo
    }
  }
}
    ${UserGroupMemberInfoFragmentDoc}`;
export const KybInfoFragmentDoc = gql`
    fragment KybInfo on KybQualificationDetail {
  state
  properties {
    userEmail
    entityId
    businessName
    businessCountry
    businessState
    businessWebsite
    entityType
    natureOfBusiness
    businessInfoConfirmed
    productInterests
    isAuthorizedRepresentative
    isOnboardingInitiator
    awaitingBusinessReview
    expectedUsdcMintingVolume
    activeUsersOnPlatform
  }
}
    `;
export const QualificationsSummaryInfoFragmentDoc = gql`
    fragment QualificationsSummaryInfo on QualificationsSummary {
  kyb {
    isComplete
    isAuthorizedRepresentative
  }
  kyc {
    isComplete
  }
}
    `;
export const ReportCompleteInfoFragmentDoc = gql`
    fragment ReportCompleteInfo on ReportComplete {
  downloadUrl
  status
}
    `;
export const ReportIncompleteInfoFragmentDoc = gql`
    fragment ReportIncompleteInfo on ReportIncomplete {
  status
}
    `;
export const ReversalInfoFragmentDoc = gql`
    fragment ReversalInfo on Reversal {
  id
  paymentId
  amount {
    ...AmountInfo
  }
  description
  status
  reason
  fees {
    ...AmountInfo
  }
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}`;
export const ReversalsInfoFragmentDoc = gql`
    fragment ReversalsInfo on Reversals {
  list {
    ...ReversalInfo
  }
}
    ${ReversalInfoFragmentDoc}`;
export const SettingsFeaturesInfoFragmentDoc = gql`
    fragment SettingsFeaturesInfo on SettingsFeatures {
  featureTour
  productTour
  custodyTour
  burnFeeAnnouncement
}
    `;
export const SettlementCreditLineInfoFragmentDoc = gql`
    fragment SettlementCreditLineInfo on SettlementCreditLine {
  id
  entityId
  usage {
    used
    available
    outstandingTransfers
  }
  limit {
    ...AmountInfo
  }
  type
  settings {
    autoApproval
  }
  walletId
  status
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}`;
export const SettlementCreditTransferInfoFragmentDoc = gql`
    fragment SettlementCreditTransferInfo on SettlementCreditTransfer {
  id
  amount {
    ...AmountInfo
  }
  reference
  transferJobId
  receiveJobId
  status
  dueDate
  transferDate
  paidDate
  createDate
  updateDate
  hasPendingFee
}
    ${AmountInfoFragmentDoc}`;
export const SettlementCreditTransfersInfoFragmentDoc = gql`
    fragment SettlementCreditTransfersInfo on SettlementCreditTransfers {
  list {
    ...SettlementCreditTransferInfo
  }
}
    ${SettlementCreditTransferInfoFragmentDoc}`;
export const SettlementCreditTransferDetailsInfoFragmentDoc = gql`
    fragment SettlementCreditTransferDetailsInfo on SettlementCreditTransferDetails {
  id
  entityId
  amount {
    ...AmountInfo
  }
  reference
  status
  transferJobId
  receiveJobId
  pendingFees {
    ...AmountInfo
  }
  totalFees {
    ...AmountInfo
  }
  outstandingBalance {
    ...AmountInfo
  }
  dueDate
  transferDate
  paidDate
  createDate
  updateDate
}
    ${AmountInfoFragmentDoc}`;
export const SettlementCreditTransferFeeInfoFragmentDoc = gql`
    fragment SettlementCreditTransferFeeInfo on SettlementCreditTransferFee {
  id
  amount {
    ...AmountInfo
  }
  settlementCreditTransferId
  status
  effectiveDate
  accruedDate
}
    ${AmountInfoFragmentDoc}`;
export const SettlementCreditTransferFeesInfoFragmentDoc = gql`
    fragment SettlementCreditTransferFeesInfo on SettlementCreditTransferFees {
  list {
    ...SettlementCreditTransferFeeInfo
  }
}
    ${SettlementCreditTransferFeeInfoFragmentDoc}`;
export const SettlementCreditTransferValidationInfoFragmentDoc = gql`
    fragment SettlementCreditTransferValidationInfo on SettlementCreditTransferValidation {
  code
  message
}
    `;
export const WireInstructionBeneficiaryInfoFragmentDoc = gql`
    fragment WireInstructionBeneficiaryInfo on WireInstructionBeneficiary {
  name
  address1
  address2
}
    `;
export const WireInstructionBeneficiaryBankInfoFragmentDoc = gql`
    fragment WireInstructionBeneficiaryBankInfo on WireInstructionBeneficiaryBank {
  swiftCode
  routingNumber
  accountNumber
  currency
  name
  address
  city
  postcode
  country
}
    `;
export const SettlementCreditWireInstructionInfoFragmentDoc = gql`
    fragment SettlementCreditWireInstructionInfo on SettlementCreditWireInstruction {
  trackingRef
  beneficiary {
    ...WireInstructionBeneficiaryInfo
  }
  virtualAccountEnabled
  beneficiaryBank {
    ...WireInstructionBeneficiaryBankInfo
  }
}
    ${WireInstructionBeneficiaryInfoFragmentDoc}
${WireInstructionBeneficiaryBankInfoFragmentDoc}`;
export const SettlementInfoFragmentDoc = gql`
    fragment SettlementInfo on Settlement {
  id
  createDate
  updateDate
  totalDebits {
    amount
    currency
  }
  totalCredits {
    amount
    currency
  }
  paymentFees {
    amount
    currency
  }
  chargebackFees {
    amount
    currency
  }
  merchantWalletId
}
    `;
export const SettlementsInfoFragmentDoc = gql`
    fragment SettlementsInfo on Settlements {
  list {
    ...SettlementInfo
  }
}
    ${SettlementInfoFragmentDoc}`;
export const SenBankAccountInfoFragmentDoc = gql`
    fragment SenBankAccountInfo on SenBankAccount {
  id
  status
  description
  trackingRef
  fingerprint
  createDate
  updateDate
  type
  nickname
  userConfirmedWireSend
  label
  currency
}
    `;
export const PixBankAccountInfoFragmentDoc = gql`
    fragment PixBankAccountInfo on PixBankAccount {
  id
  type
  status
  description
  trackingRef
  fingerprint
  label
  nickname
  createDate
  updateDate
  transferTypes {
    ...TransferTypesInfo
  }
}
    ${TransferTypesInfoFragmentDoc}`;
export const StablecoinExpressBankLocationInfoFragmentDoc = gql`
    fragment StablecoinExpressBankLocationInfo on StablecoinExpressBankLocation {
  ... on WireBankAccount {
    ...WireBankAccountInfo
  }
  ... on SignetBankAccount {
    ...SignetBankAccountInfo
  }
  ... on SenBankAccount {
    ...SenBankAccountInfo
  }
  ... on CbitBankAccount {
    ...CbitBankAccountInfo
  }
  ... on XpayBankAccount {
    ...XpayBankAccountInfo
  }
  ... on RtpBankAccount {
    ...RtpBankAccountInfo
  }
  ... on PixBankAccount {
    ...PixBankAccountInfo
  }
  ... on CubixBankAccount {
    ...CubixBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}
${SignetBankAccountInfoFragmentDoc}
${SenBankAccountInfoFragmentDoc}
${CbitBankAccountInfoFragmentDoc}
${XpayBankAccountInfoFragmentDoc}
${RtpBankAccountInfoFragmentDoc}
${PixBankAccountInfoFragmentDoc}
${CubixBankAccountInfoFragmentDoc}`;
export const BlockchainRecipientAddressInfoFragmentDoc = gql`
    fragment BlockchainRecipientAddressInfo on BlockchainRecipientAddress {
  id
  address
  addressTag
  chain
  currency
  description
}
    `;
export const StablecoinExpressBlockchainLocationInfoFragmentDoc = gql`
    fragment StablecoinExpressBlockchainLocationInfo on StablecoinExpressBlockchainLocation {
  ... on BlockchainDepositAddress {
    ...BlockchainDepositAddressInfo
  }
  ... on BlockchainRecipientAddress {
    ...BlockchainRecipientAddressInfo
  }
}
    ${BlockchainDepositAddressInfoFragmentDoc}
${BlockchainRecipientAddressInfoFragmentDoc}`;
export const StablecoinExpressDepositRouteInfoFragmentDoc = gql`
    fragment StablecoinExpressDepositRouteInfo on StablecoinExpressDepositRoute {
  id
  source {
    ...StablecoinExpressBankLocationInfo
  }
  destination {
    ...StablecoinExpressBlockchainLocationInfo
  }
  enabled
  updateDate
  createDate
  type
  fromCurrency
  toCurrency
}
    ${StablecoinExpressBankLocationInfoFragmentDoc}
${StablecoinExpressBlockchainLocationInfoFragmentDoc}`;
export const StablecoinExpressWithdrawalRouteInfoFragmentDoc = gql`
    fragment StablecoinExpressWithdrawalRouteInfo on StablecoinExpressWithdrawalRoute {
  id
  source {
    ...StablecoinExpressBlockchainLocationInfo
  }
  destination {
    ...StablecoinExpressBankLocationInfo
  }
  enabled
  updateDate
  createDate
  type
  fromCurrency
  toCurrency
}
    ${StablecoinExpressBlockchainLocationInfoFragmentDoc}
${StablecoinExpressBankLocationInfoFragmentDoc}`;
export const StablecoinExpressRouteInfoFragmentDoc = gql`
    fragment StablecoinExpressRouteInfo on StablecoinExpressRoute {
  ... on StablecoinExpressDepositRoute {
    ...StablecoinExpressDepositRouteInfo
  }
  ... on StablecoinExpressWithdrawalRoute {
    ...StablecoinExpressWithdrawalRouteInfo
  }
}
    ${StablecoinExpressDepositRouteInfoFragmentDoc}
${StablecoinExpressWithdrawalRouteInfoFragmentDoc}`;
export const StatesInfoFragmentDoc = gql`
    fragment StatesInfo on States {
  codes
  list {
    code
  }
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on Subscriptions {
  automaticPaymentEnabled
}
    `;
export const DailyLimitsInfoFragmentDoc = gql`
    fragment DailyLimitsInfo on DailyLimit {
  currency
  limit {
    limit
    usage
    available
  }
}
    `;
export const TradeInfoFragmentDoc = gql`
    fragment TradeInfo on Trade {
  id
  quoteId
  settlementId
  from {
    ...PartialAmountInfo
  }
  to {
    ...PartialAmountInfo
  }
  status
  createDate
  updateDate
}
    ${PartialAmountInfoFragmentDoc}`;
export const TransferLocationInfoFragmentDoc = gql`
    fragment TransferLocationInfo on TransferLocation {
  ... on WalletLocation {
    type
    id
    address
    addressTag
  }
  ... on BlockchainLocation {
    type
    chain
    address
    addressTag
  }
  ... on ChainedBlockchainLocation {
    type
    chain
    address
    addressTag
    description
    isCompleteAceTransfer
    metadata {
      transactionHash
      status
      domain
      attestation
      message
    }
  }
}
    `;
export const TransferInfoFragmentDoc = gql`
    fragment TransferInfo on Transfer {
  id
  type
  source {
    ...TransferLocationInfo
  }
  destination {
    ...TransferLocationInfo
  }
  amount {
    ...AmountInfo
  }
  fees {
    ...AmountInfo
  }
  totalAmount {
    ...AmountInfo
  }
  transactionHash
  explorerLink
  status
  errorCode
  createDate
}
    ${TransferLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;
export const TransfersInfoFragmentDoc = gql`
    fragment TransfersInfo on Transfers {
  list {
    ...TransferInfo
  }
}
    ${TransferInfoFragmentDoc}`;
export const TravelRuleAddressInfoFragmentDoc = gql`
    fragment TravelRuleAddressInfo on TravelRuleAddress {
  country
  streetAddress
  addressLine2
  city
  stateProvince
  postalCode
}
    `;
export const TravelRulePersonInfoFragmentDoc = gql`
    fragment TravelRulePersonInfo on TravelRulePerson {
  ... on TravelRuleNaturalPerson {
    type
    address {
      ...TravelRuleAddressInfo
    }
    firstName
    lastName
    dateOfBirth
    placeOfBirth
    officialDocumentNumber
    additionalIdentifier
  }
  ... on TravelRuleLegalPerson {
    type
    address {
      ...TravelRuleAddressInfo
    }
    registeredName
    leiOrEquivalent
  }
}
    ${TravelRuleAddressInfoFragmentDoc}`;
export const TravelRulePiiInfoFragmentDoc = gql`
    fragment TravelRulePiiInfo on TravelRulePii {
  originator {
    ...TravelRulePersonInfo
  }
  beneficiary {
    ...TravelRulePersonInfo
  }
  originatorDistributedLedgerAddress
  beneficiaryDistributedLedgerAddress
}
    ${TravelRulePersonInfoFragmentDoc}`;
export const UserStatusInfoFragmentDoc = gql`
    fragment UserStatusInfo on UserStatus {
  type
  label
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  id
  firstName
  lastName
  name
  email
  permissionGroup
  status
  current
  lastLogin
  passwordChanged
  created
}
    `;
export const WalletApprovalPolicyUserLimitInfoFragmentDoc = gql`
    fragment WalletApprovalPolicyUserLimitInfo on WalletApprovalPolicyUserLimit {
  user {
    ...UserInfo
  }
  permissions
  maxAmount
  maxTransactions
}
    ${UserInfoFragmentDoc}`;
export const WalletApprovalPolicySettingsInfoFragmentDoc = gql`
    fragment WalletApprovalPolicySettingsInfo on WalletApprovalPolicySettings {
  allowInitiatorToApproveTransfer
  proposalApprovalMethod
  applyToApi
}
    `;
export const WalletApprovalPolicyInfoFragmentDoc = gql`
    fragment WalletApprovalPolicyInfo on WalletApprovalPolicy {
  id
  name
  state
  currency
  owner {
    ...UserInfo
  }
  policyLimits {
    maxAmount
    maxTransactions
  }
  userLimits {
    ...WalletApprovalPolicyUserLimitInfo
  }
  approvalWorkflow {
    minNeedConfirmed
    approvers {
      ...UserInfo
    }
  }
  canTransfer
  canDeposit
  settings {
    ...WalletApprovalPolicySettingsInfo
  }
  showVoteAction
}
    ${UserInfoFragmentDoc}
${WalletApprovalPolicyUserLimitInfoFragmentDoc}
${WalletApprovalPolicySettingsInfoFragmentDoc}`;
export const BankAccountInfoFragmentDoc = gql`
    fragment BankAccountInfo on BankAccount {
  ...WireBankAccountInfo
  ...SenBankAccountInfo
  ...SignetBankAccountInfo
  ...CbitBankAccountInfo
  ...XpayBankAccountInfo
  ...RtpBankAccountInfo
  ...PixBankAccountInfo
  ...CubixBankAccountInfo
}
    ${WireBankAccountInfoFragmentDoc}
${SenBankAccountInfoFragmentDoc}
${SignetBankAccountInfoFragmentDoc}
${CbitBankAccountInfoFragmentDoc}
${XpayBankAccountInfoFragmentDoc}
${RtpBankAccountInfoFragmentDoc}
${PixBankAccountInfoFragmentDoc}
${CubixBankAccountInfoFragmentDoc}`;
export const WalletApprovalPayoutTransactionDetailInfoFragmentDoc = gql`
    fragment WalletApprovalPayoutTransactionDetailInfo on WalletApprovalPayoutTransactionDetail {
  id
  transferId
  type
  currency
  amount
  date
  status
  initiator
  approvalsNeeded
  votingUsers {
    ...UserInfo
  }
  approvedBy {
    ...UserInfo
  }
  rejectedBy {
    ...UserInfo
  }
  awaitingApproval {
    ...UserInfo
  }
  fiatAccount {
    ...BankAccountInfo
  }
  showCancelAction
  showVoteAction
}
    ${UserInfoFragmentDoc}
${BankAccountInfoFragmentDoc}`;
export const BlockchainRecipientAddressWithMetadataInfoFragmentDoc = gql`
    fragment BlockchainRecipientAddressWithMetadataInfo on BlockchainRecipientAddressWithMetadata {
  id
  address
  addressTag
  chain
  icon
  currency
  description
  owner
  email
  delayedWithdrawalInfo {
    enabled
    withdrawalEnabledAfterHours
  }
  assets {
    ...BlockchainAssetInfo
  }
  isVaultAddress
  status
  createDate
  updateDate
}
    ${BlockchainAssetInfoFragmentDoc}`;
export const WalletApprovalOnchainTransactionDetailInfoFragmentDoc = gql`
    fragment WalletApprovalOnchainTransactionDetailInfo on WalletApprovalOnchainTransactionDetail {
  id
  transferId
  type
  currency
  amount
  date
  status
  initiator
  approvalsNeeded
  votingUsers {
    ...UserInfo
  }
  approvedBy {
    ...UserInfo
  }
  rejectedBy {
    ...UserInfo
  }
  awaitingApproval {
    ...UserInfo
  }
  recipientAddress {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
  showCancelAction
  showVoteAction
}
    ${UserInfoFragmentDoc}
${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;
export const WalletApprovalTransactionDetailInfoFragmentDoc = gql`
    fragment WalletApprovalTransactionDetailInfo on WalletApprovalTransactionDetail {
  ...WalletApprovalPayoutTransactionDetailInfo
  ...WalletApprovalOnchainTransactionDetailInfo
}
    ${WalletApprovalPayoutTransactionDetailInfoFragmentDoc}
${WalletApprovalOnchainTransactionDetailInfoFragmentDoc}`;
export const WalletApprovalTransactionInfoFragmentDoc = gql`
    fragment WalletApprovalTransactionInfo on WalletApprovalTransaction {
  id
  type
  currency
  amount
  date
  status
  initiator
}
    `;
export const WalletApprovalTransactionsInfoFragmentDoc = gql`
    fragment WalletApprovalTransactionsInfo on WalletApprovalTransactions {
  list {
    ...WalletApprovalTransactionInfo
  }
}
    ${WalletApprovalTransactionInfoFragmentDoc}`;
export const DownloadReportInfoFragmentDoc = gql`
    fragment DownloadReportInfo on DownloadReport {
  reportExecutionId
  reportType
  downloadUrl
}
    `;
export const WalletReportInfoFragmentDoc = gql`
    fragment WalletReportInfo on WalletReport {
  id
  entityId
  reportName
  reportType
  reportFrequency
  reportYear
  reportMonth
  retryCount
  startDate
  endDate
  reportExecutionId
  state
  createDate
  updateDate
}
    `;
export const WalletReportsInfoFragmentDoc = gql`
    fragment WalletReportsInfo on WalletReports {
  list {
    ...WalletReportInfo
  }
}
    ${WalletReportInfoFragmentDoc}`;
export const SetWatchListEntryInfoFragmentDoc = gql`
    fragment SetWatchListEntryInfo on SetWatchListEntry {
  id
  type
  active
}
    `;
export const WatchlistAllowReasonInfoFragmentDoc = gql`
    fragment WatchlistAllowReasonInfo on WatchlistAllowReason {
  value
}
    `;
export const WatchlistBlockReasonInfoFragmentDoc = gql`
    fragment WatchlistBlockReasonInfo on WatchlistBlockReason {
  value
}
    `;
export const WatchlistEntityInfoFragmentDoc = gql`
    fragment WatchlistEntityInfo on WatchlistEntity {
  value
}
    `;
export const WatchlistTypeInfoFragmentDoc = gql`
    fragment WatchlistTypeInfo on WatchlistType {
  value
  header
}
    `;
export const WatchlistEntryInfoFragmentDoc = gql`
    fragment WatchlistEntryInfo on WatchlistEntry {
  id
  type
  value
  active
  reason
  createdBy
  createDate
  updateDate
}
    `;
export const SignetTransferInstructionInfoFragmentDoc = gql`
    fragment SignetTransferInstructionInfo on SignetTransferInstruction {
  type
  trackingRef
  walletAddress
}
    `;
export const CbitTransferInstructionInfoFragmentDoc = gql`
    fragment CbitTransferInstructionInfo on CbitTransferInstruction {
  type
  trackingRef
  walletAddress
}
    `;
export const WireBeneficiaryInfoFragmentDoc = gql`
    fragment WireBeneficiaryInfo on WireBeneficiary {
  name
  address1
  address2
}
    `;
export const WireBeneficiaryBankInfoFragmentDoc = gql`
    fragment WireBeneficiaryBankInfo on WireBeneficiaryBank {
  name
  swiftCode
  routingNumber
  accountNumber
  address
  city
  postalCode
  country
}
    `;
export const WireTransferInstructionInfoFragmentDoc = gql`
    fragment WireTransferInstructionInfo on WireTransferInstruction {
  type
  trackingRef
  virtualAccountEnabled
  beneficiary {
    ...WireBeneficiaryInfo
  }
  beneficiaryBank {
    ...WireBeneficiaryBankInfo
  }
}
    ${WireBeneficiaryInfoFragmentDoc}
${WireBeneficiaryBankInfoFragmentDoc}`;
export const SenTransferInstructionInfoFragmentDoc = gql`
    fragment SenTransferInstructionInfo on SenTransferInstruction {
  type
  trackingRef
}
    `;
export const XpayTransferInstructionInfoFragmentDoc = gql`
    fragment XpayTransferInstructionInfo on XpayTransferInstruction {
  type
  trackingRef
  virtualAccountEnabled
  accountNumber
}
    `;
export const RtpTransferInstructionInfoFragmentDoc = gql`
    fragment RtpTransferInstructionInfo on RtpTransferInstruction {
  type
  trackingRef
  virtualAccountEnabled
  beneficiary {
    ...WireBeneficiaryInfo
  }
  beneficiaryBank {
    ...WireBeneficiaryBankInfo
  }
}
    ${WireBeneficiaryInfoFragmentDoc}
${WireBeneficiaryBankInfoFragmentDoc}`;
export const PixTransferInstructionInfoFragmentDoc = gql`
    fragment PixTransferInstructionInfo on PixTransferInstruction {
  type
  ispb
  branchCode
  accountNumber
  name
  accountType
  taxId
  trackingRef
  compe
}
    `;
export const CubixTransferInstructionInfoFragmentDoc = gql`
    fragment CubixTransferInstructionInfo on CubixTransferInstruction {
  type
  trackingRef
  accountId
}
    `;
export const TransferInstructionInfoFragmentDoc = gql`
    fragment TransferInstructionInfo on TransferInstruction {
  ...SignetTransferInstructionInfo
  ...CbitTransferInstructionInfo
  ...WireTransferInstructionInfo
  ...SenTransferInstructionInfo
  ...XpayTransferInstructionInfo
  ...RtpTransferInstructionInfo
  ...PixTransferInstructionInfo
  ...CubixTransferInstructionInfo
}
    ${SignetTransferInstructionInfoFragmentDoc}
${CbitTransferInstructionInfoFragmentDoc}
${WireTransferInstructionInfoFragmentDoc}
${SenTransferInstructionInfoFragmentDoc}
${XpayTransferInstructionInfoFragmentDoc}
${RtpTransferInstructionInfoFragmentDoc}
${PixTransferInstructionInfoFragmentDoc}
${CubixTransferInstructionInfoFragmentDoc}`;
export const WireTransferLimitInfoFragmentDoc = gql`
    fragment WireTransferLimitInfo on WireTransferLimit {
  id
  cap {
    ...AmountInfo
  }
  used {
    ...AmountInfo
  }
  available {
    ...AmountInfo
  }
  duration
}
    ${AmountInfoFragmentDoc}`;
export const ApiKeyDocument = gql`
    query APIKey($keyId: ID!) {
  apiKey(keyId: $keyId) {
    ...APIKeyInfo
  }
}
    ${ApiKeyInfoFragmentDoc}`;

/**
 * __useApiKeyQuery__
 *
 * To run a query within a React component, call `useApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyQuery({
 *   variables: {
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useApiKeyQuery(baseOptions: Apollo.QueryHookOptions<ApiKeyQuery, ApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyQuery, ApiKeyQueryVariables>(ApiKeyDocument, options);
      }
export function useApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyQuery, ApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyQuery, ApiKeyQueryVariables>(ApiKeyDocument, options);
        }
export function useApiKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeyQuery, ApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyQuery, ApiKeyQueryVariables>(ApiKeyDocument, options);
        }
export type ApiKeyQueryHookResult = ReturnType<typeof useApiKeyQuery>;
export type ApiKeyLazyQueryHookResult = ReturnType<typeof useApiKeyLazyQuery>;
export type ApiKeySuspenseQueryHookResult = ReturnType<typeof useApiKeySuspenseQuery>;
export type ApiKeyQueryResult = Apollo.QueryResult<ApiKeyQuery, ApiKeyQueryVariables>;
export const ApiKeySettingsDocument = gql`
    query APIKeySettings {
  apiKeySettings {
    apiKeysLimit
  }
}
    `;

/**
 * __useApiKeySettingsQuery__
 *
 * To run a query within a React component, call `useApiKeySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeySettingsQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>(ApiKeySettingsDocument, options);
      }
export function useApiKeySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>(ApiKeySettingsDocument, options);
        }
export function useApiKeySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>(ApiKeySettingsDocument, options);
        }
export type ApiKeySettingsQueryHookResult = ReturnType<typeof useApiKeySettingsQuery>;
export type ApiKeySettingsLazyQueryHookResult = ReturnType<typeof useApiKeySettingsLazyQuery>;
export type ApiKeySettingsSuspenseQueryHookResult = ReturnType<typeof useApiKeySettingsSuspenseQuery>;
export type ApiKeySettingsQueryResult = Apollo.QueryResult<ApiKeySettingsQuery, ApiKeySettingsQueryVariables>;
export const ApiKeysDocument = gql`
    query APIKeys {
  apiKeys {
    ...APIKeyInfo
  }
}
    ${ApiKeyInfoFragmentDoc}`;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateAPIKey($input: CreateAPIKeyInput!) {
  createAPIKey(input: $input) {
    access_token
    expires_in
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const RevokeApiKeyDocument = gql`
    mutation RevokeAPIKey($keyId: ID!) {
  revokeAPIKey(keyId: $keyId)
}
    `;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, options);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateAPIKey($input: UpdateAPIKeyInput!) {
  updateAPIKey(input: $input)
}
    `;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const ApiLogsDocument = gql`
    query APILogs($input: APILogSearchInput!) {
  apiLogs(input: $input) {
    ...PaginationInfo
    ...APILogsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${ApiLogsInfoFragmentDoc}`;

/**
 * __useApiLogsQuery__
 *
 * To run a query within a React component, call `useApiLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiLogsQuery(baseOptions: Apollo.QueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
      }
export function useApiLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
        }
export function useApiLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiLogsQuery, ApiLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiLogsQuery, ApiLogsQueryVariables>(ApiLogsDocument, options);
        }
export type ApiLogsQueryHookResult = ReturnType<typeof useApiLogsQuery>;
export type ApiLogsLazyQueryHookResult = ReturnType<typeof useApiLogsLazyQuery>;
export type ApiLogsSuspenseQueryHookResult = ReturnType<typeof useApiLogsSuspenseQuery>;
export type ApiLogsQueryResult = Apollo.QueryResult<ApiLogsQuery, ApiLogsQueryVariables>;
export const AddressBookDocument = gql`
    query AddressBook($id: ID!) {
  addressBook(id: $id) {
    id
    chain
    address
    addressTag
    metadata {
      nickname
      email
      bns
    }
    status
    riskEvaluation {
      ...RiskEvaluationInfo
    }
    createDate
    updateDate
  }
}
    ${RiskEvaluationInfoFragmentDoc}`;

/**
 * __useAddressBookQuery__
 *
 * To run a query within a React component, call `useAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressBookQuery(baseOptions: Apollo.QueryHookOptions<AddressBookQuery, AddressBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressBookQuery, AddressBookQueryVariables>(AddressBookDocument, options);
      }
export function useAddressBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressBookQuery, AddressBookQueryVariables>(AddressBookDocument, options);
        }
export function useAddressBookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressBookQuery, AddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressBookQuery, AddressBookQueryVariables>(AddressBookDocument, options);
        }
export type AddressBookQueryHookResult = ReturnType<typeof useAddressBookQuery>;
export type AddressBookLazyQueryHookResult = ReturnType<typeof useAddressBookLazyQuery>;
export type AddressBookSuspenseQueryHookResult = ReturnType<typeof useAddressBookSuspenseQuery>;
export type AddressBookQueryResult = Apollo.QueryResult<AddressBookQuery, AddressBookQueryVariables>;
export const AddressBookProposalDocument = gql`
    query AddressBookProposal($id: ID!) {
  addressBookProposal(id: $id) {
    id
    status
    externalAddress {
      entityId
      address
      chain
      currency
      nickname
      createDate
    }
  }
}
    `;

/**
 * __useAddressBookProposalQuery__
 *
 * To run a query within a React component, call `useAddressBookProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressBookProposalQuery(baseOptions: Apollo.QueryHookOptions<AddressBookProposalQuery, AddressBookProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressBookProposalQuery, AddressBookProposalQueryVariables>(AddressBookProposalDocument, options);
      }
export function useAddressBookProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressBookProposalQuery, AddressBookProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressBookProposalQuery, AddressBookProposalQueryVariables>(AddressBookProposalDocument, options);
        }
export function useAddressBookProposalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressBookProposalQuery, AddressBookProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressBookProposalQuery, AddressBookProposalQueryVariables>(AddressBookProposalDocument, options);
        }
export type AddressBookProposalQueryHookResult = ReturnType<typeof useAddressBookProposalQuery>;
export type AddressBookProposalLazyQueryHookResult = ReturnType<typeof useAddressBookProposalLazyQuery>;
export type AddressBookProposalSuspenseQueryHookResult = ReturnType<typeof useAddressBookProposalSuspenseQuery>;
export type AddressBookProposalQueryResult = Apollo.QueryResult<AddressBookProposalQuery, AddressBookProposalQueryVariables>;
export const SubmitAddressBookApprovalVoteDocument = gql`
    mutation SubmitAddressBookApprovalVote($input: SubmitAddressBookApprovalVoteInput!) {
  submitAddressBookApprovalVote(input: $input)
}
    `;
export type SubmitAddressBookApprovalVoteMutationFn = Apollo.MutationFunction<SubmitAddressBookApprovalVoteMutation, SubmitAddressBookApprovalVoteMutationVariables>;

/**
 * __useSubmitAddressBookApprovalVoteMutation__
 *
 * To run a mutation, you first call `useSubmitAddressBookApprovalVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAddressBookApprovalVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAddressBookApprovalVoteMutation, { data, loading, error }] = useSubmitAddressBookApprovalVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAddressBookApprovalVoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAddressBookApprovalVoteMutation, SubmitAddressBookApprovalVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAddressBookApprovalVoteMutation, SubmitAddressBookApprovalVoteMutationVariables>(SubmitAddressBookApprovalVoteDocument, options);
      }
export type SubmitAddressBookApprovalVoteMutationHookResult = ReturnType<typeof useSubmitAddressBookApprovalVoteMutation>;
export type SubmitAddressBookApprovalVoteMutationResult = Apollo.MutationResult<SubmitAddressBookApprovalVoteMutation>;
export type SubmitAddressBookApprovalVoteMutationOptions = Apollo.BaseMutationOptions<SubmitAddressBookApprovalVoteMutation, SubmitAddressBookApprovalVoteMutationVariables>;
export const AdminApprovalsSettingsDocument = gql`
    query AdminApprovalsSettings {
  adminApprovalsSettings {
    approvalsNeeded
    enabled
    isSubmitted
    policyId
    proposerId
    type
  }
}
    `;

/**
 * __useAdminApprovalsSettingsQuery__
 *
 * To run a query within a React component, call `useAdminApprovalsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminApprovalsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminApprovalsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminApprovalsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>(AdminApprovalsSettingsDocument, options);
      }
export function useAdminApprovalsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>(AdminApprovalsSettingsDocument, options);
        }
export function useAdminApprovalsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>(AdminApprovalsSettingsDocument, options);
        }
export type AdminApprovalsSettingsQueryHookResult = ReturnType<typeof useAdminApprovalsSettingsQuery>;
export type AdminApprovalsSettingsLazyQueryHookResult = ReturnType<typeof useAdminApprovalsSettingsLazyQuery>;
export type AdminApprovalsSettingsSuspenseQueryHookResult = ReturnType<typeof useAdminApprovalsSettingsSuspenseQuery>;
export type AdminApprovalsSettingsQueryResult = Apollo.QueryResult<AdminApprovalsSettingsQuery, AdminApprovalsSettingsQueryVariables>;
export const CancelPendingUserProposalDocument = gql`
    mutation CancelPendingUserProposal($proposalId: String!) {
  cancelPendingUserProposal(proposalId: $proposalId)
}
    `;
export type CancelPendingUserProposalMutationFn = Apollo.MutationFunction<CancelPendingUserProposalMutation, CancelPendingUserProposalMutationVariables>;

/**
 * __useCancelPendingUserProposalMutation__
 *
 * To run a mutation, you first call `useCancelPendingUserProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingUserProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPendingUserProposalMutation, { data, loading, error }] = useCancelPendingUserProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCancelPendingUserProposalMutation(baseOptions?: Apollo.MutationHookOptions<CancelPendingUserProposalMutation, CancelPendingUserProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPendingUserProposalMutation, CancelPendingUserProposalMutationVariables>(CancelPendingUserProposalDocument, options);
      }
export type CancelPendingUserProposalMutationHookResult = ReturnType<typeof useCancelPendingUserProposalMutation>;
export type CancelPendingUserProposalMutationResult = Apollo.MutationResult<CancelPendingUserProposalMutation>;
export type CancelPendingUserProposalMutationOptions = Apollo.BaseMutationOptions<CancelPendingUserProposalMutation, CancelPendingUserProposalMutationVariables>;
export const CancelSubmittedSettingsChangeDocument = gql`
    mutation CancelSubmittedSettingsChange($policyId: ID!) {
  cancelSubmittedSettingsChange(policyId: $policyId)
}
    `;
export type CancelSubmittedSettingsChangeMutationFn = Apollo.MutationFunction<CancelSubmittedSettingsChangeMutation, CancelSubmittedSettingsChangeMutationVariables>;

/**
 * __useCancelSubmittedSettingsChangeMutation__
 *
 * To run a mutation, you first call `useCancelSubmittedSettingsChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubmittedSettingsChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubmittedSettingsChangeMutation, { data, loading, error }] = useCancelSubmittedSettingsChangeMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useCancelSubmittedSettingsChangeMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubmittedSettingsChangeMutation, CancelSubmittedSettingsChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubmittedSettingsChangeMutation, CancelSubmittedSettingsChangeMutationVariables>(CancelSubmittedSettingsChangeDocument, options);
      }
export type CancelSubmittedSettingsChangeMutationHookResult = ReturnType<typeof useCancelSubmittedSettingsChangeMutation>;
export type CancelSubmittedSettingsChangeMutationResult = Apollo.MutationResult<CancelSubmittedSettingsChangeMutation>;
export type CancelSubmittedSettingsChangeMutationOptions = Apollo.BaseMutationOptions<CancelSubmittedSettingsChangeMutation, CancelSubmittedSettingsChangeMutationVariables>;
export const InviteUserWithAdminApprovalDocument = gql`
    mutation InviteUserWithAdminApproval($input: AdminApprovalsUserInvite!) {
  inviteUserWithAdminApproval(input: $input)
}
    `;
export type InviteUserWithAdminApprovalMutationFn = Apollo.MutationFunction<InviteUserWithAdminApprovalMutation, InviteUserWithAdminApprovalMutationVariables>;

/**
 * __useInviteUserWithAdminApprovalMutation__
 *
 * To run a mutation, you first call `useInviteUserWithAdminApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserWithAdminApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserWithAdminApprovalMutation, { data, loading, error }] = useInviteUserWithAdminApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserWithAdminApprovalMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserWithAdminApprovalMutation, InviteUserWithAdminApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserWithAdminApprovalMutation, InviteUserWithAdminApprovalMutationVariables>(InviteUserWithAdminApprovalDocument, options);
      }
export type InviteUserWithAdminApprovalMutationHookResult = ReturnType<typeof useInviteUserWithAdminApprovalMutation>;
export type InviteUserWithAdminApprovalMutationResult = Apollo.MutationResult<InviteUserWithAdminApprovalMutation>;
export type InviteUserWithAdminApprovalMutationOptions = Apollo.BaseMutationOptions<InviteUserWithAdminApprovalMutation, InviteUserWithAdminApprovalMutationVariables>;
export const RemoveUserWithAdminApprovalDocument = gql`
    mutation RemoveUserWithAdminApproval($userId: String!) {
  removeUserWithAdminApproval(userId: $userId)
}
    `;
export type RemoveUserWithAdminApprovalMutationFn = Apollo.MutationFunction<RemoveUserWithAdminApprovalMutation, RemoveUserWithAdminApprovalMutationVariables>;

/**
 * __useRemoveUserWithAdminApprovalMutation__
 *
 * To run a mutation, you first call `useRemoveUserWithAdminApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserWithAdminApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserWithAdminApprovalMutation, { data, loading, error }] = useRemoveUserWithAdminApprovalMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserWithAdminApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserWithAdminApprovalMutation, RemoveUserWithAdminApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserWithAdminApprovalMutation, RemoveUserWithAdminApprovalMutationVariables>(RemoveUserWithAdminApprovalDocument, options);
      }
export type RemoveUserWithAdminApprovalMutationHookResult = ReturnType<typeof useRemoveUserWithAdminApprovalMutation>;
export type RemoveUserWithAdminApprovalMutationResult = Apollo.MutationResult<RemoveUserWithAdminApprovalMutation>;
export type RemoveUserWithAdminApprovalMutationOptions = Apollo.BaseMutationOptions<RemoveUserWithAdminApprovalMutation, RemoveUserWithAdminApprovalMutationVariables>;
export const SetAdminApprovalsSettingsDocument = gql`
    mutation SetAdminApprovalsSettings($input: AdminApprovalsSettingsInput!) {
  setAdminApprovalsSettings(input: $input)
}
    `;
export type SetAdminApprovalsSettingsMutationFn = Apollo.MutationFunction<SetAdminApprovalsSettingsMutation, SetAdminApprovalsSettingsMutationVariables>;

/**
 * __useSetAdminApprovalsSettingsMutation__
 *
 * To run a mutation, you first call `useSetAdminApprovalsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdminApprovalsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdminApprovalsSettingsMutation, { data, loading, error }] = useSetAdminApprovalsSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAdminApprovalsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetAdminApprovalsSettingsMutation, SetAdminApprovalsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdminApprovalsSettingsMutation, SetAdminApprovalsSettingsMutationVariables>(SetAdminApprovalsSettingsDocument, options);
      }
export type SetAdminApprovalsSettingsMutationHookResult = ReturnType<typeof useSetAdminApprovalsSettingsMutation>;
export type SetAdminApprovalsSettingsMutationResult = Apollo.MutationResult<SetAdminApprovalsSettingsMutation>;
export type SetAdminApprovalsSettingsMutationOptions = Apollo.BaseMutationOptions<SetAdminApprovalsSettingsMutation, SetAdminApprovalsSettingsMutationVariables>;
export const ApprovalPoliciesDocument = gql`
    query ApprovalPolicies($input: ApprovalPoliciesInput) {
  approvalPolicies(input: $input) {
    userRemoval {
      ...BaseApprovalPolicyInfo
    }
    userInvite {
      ...BaseApprovalPolicyInfo
    }
    apiKey {
      ...BaseApprovalPolicyInfo
    }
    blockchainAddress {
      ...BaseApprovalPolicyInfo
    }
  }
}
    ${BaseApprovalPolicyInfoFragmentDoc}`;

/**
 * __useApprovalPoliciesQuery__
 *
 * To run a query within a React component, call `useApprovalPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalPoliciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovalPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>(ApprovalPoliciesDocument, options);
      }
export function useApprovalPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>(ApprovalPoliciesDocument, options);
        }
export function useApprovalPoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>(ApprovalPoliciesDocument, options);
        }
export type ApprovalPoliciesQueryHookResult = ReturnType<typeof useApprovalPoliciesQuery>;
export type ApprovalPoliciesLazyQueryHookResult = ReturnType<typeof useApprovalPoliciesLazyQuery>;
export type ApprovalPoliciesSuspenseQueryHookResult = ReturnType<typeof useApprovalPoliciesSuspenseQuery>;
export type ApprovalPoliciesQueryResult = Apollo.QueryResult<ApprovalPoliciesQuery, ApprovalPoliciesQueryVariables>;
export const BalancesDocument = gql`
    query Balances {
  balances {
    ...BalancesInfo
  }
}
    ${BalancesInfoFragmentDoc}`;

/**
 * __useBalancesQuery__
 *
 * To run a query within a React component, call `useBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalancesQuery(baseOptions?: Apollo.QueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
      }
export function useBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
        }
export function useBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
        }
export type BalancesQueryHookResult = ReturnType<typeof useBalancesQuery>;
export type BalancesLazyQueryHookResult = ReturnType<typeof useBalancesLazyQuery>;
export type BalancesSuspenseQueryHookResult = ReturnType<typeof useBalancesSuspenseQuery>;
export type BalancesQueryResult = Apollo.QueryResult<BalancesQuery, BalancesQueryVariables>;
export const BalancesMainDocument = gql`
    query BalancesMain($currency: Currency) {
  balances(currency: $currency) {
    main {
      ...BalancesMainInfo
    }
  }
}
    ${BalancesMainInfoFragmentDoc}`;

/**
 * __useBalancesMainQuery__
 *
 * To run a query within a React component, call `useBalancesMainQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesMainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesMainQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useBalancesMainQuery(baseOptions?: Apollo.QueryHookOptions<BalancesMainQuery, BalancesMainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalancesMainQuery, BalancesMainQueryVariables>(BalancesMainDocument, options);
      }
export function useBalancesMainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalancesMainQuery, BalancesMainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalancesMainQuery, BalancesMainQueryVariables>(BalancesMainDocument, options);
        }
export function useBalancesMainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalancesMainQuery, BalancesMainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalancesMainQuery, BalancesMainQueryVariables>(BalancesMainDocument, options);
        }
export type BalancesMainQueryHookResult = ReturnType<typeof useBalancesMainQuery>;
export type BalancesMainLazyQueryHookResult = ReturnType<typeof useBalancesMainLazyQuery>;
export type BalancesMainSuspenseQueryHookResult = ReturnType<typeof useBalancesMainSuspenseQuery>;
export type BalancesMainQueryResult = Apollo.QueryResult<BalancesMainQuery, BalancesMainQueryVariables>;
export const BalancesTotalDocument = gql`
    query BalancesTotal($currency: Currency) {
  balances(currency: $currency) {
    total {
      ...BalancesTotalInfo
    }
  }
}
    ${BalancesTotalInfoFragmentDoc}`;

/**
 * __useBalancesTotalQuery__
 *
 * To run a query within a React component, call `useBalancesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesTotalQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useBalancesTotalQuery(baseOptions?: Apollo.QueryHookOptions<BalancesTotalQuery, BalancesTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalancesTotalQuery, BalancesTotalQueryVariables>(BalancesTotalDocument, options);
      }
export function useBalancesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalancesTotalQuery, BalancesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalancesTotalQuery, BalancesTotalQueryVariables>(BalancesTotalDocument, options);
        }
export function useBalancesTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalancesTotalQuery, BalancesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalancesTotalQuery, BalancesTotalQueryVariables>(BalancesTotalDocument, options);
        }
export type BalancesTotalQueryHookResult = ReturnType<typeof useBalancesTotalQuery>;
export type BalancesTotalLazyQueryHookResult = ReturnType<typeof useBalancesTotalLazyQuery>;
export type BalancesTotalSuspenseQueryHookResult = ReturnType<typeof useBalancesTotalSuspenseQuery>;
export type BalancesTotalQueryResult = Apollo.QueryResult<BalancesTotalQuery, BalancesTotalQueryVariables>;
export const AddCaBankAccountDocument = gql`
    mutation AddCaBankAccount($bankAccount: AddCaBankAccountInput!) {
  addCaBankAccount(bankAccount: $bankAccount) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;
export type AddCaBankAccountMutationFn = Apollo.MutationFunction<AddCaBankAccountMutation, AddCaBankAccountMutationVariables>;

/**
 * __useAddCaBankAccountMutation__
 *
 * To run a mutation, you first call `useAddCaBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaBankAccountMutation, { data, loading, error }] = useAddCaBankAccountMutation({
 *   variables: {
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useAddCaBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddCaBankAccountMutation, AddCaBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaBankAccountMutation, AddCaBankAccountMutationVariables>(AddCaBankAccountDocument, options);
      }
export type AddCaBankAccountMutationHookResult = ReturnType<typeof useAddCaBankAccountMutation>;
export type AddCaBankAccountMutationResult = Apollo.MutationResult<AddCaBankAccountMutation>;
export type AddCaBankAccountMutationOptions = Apollo.BaseMutationOptions<AddCaBankAccountMutation, AddCaBankAccountMutationVariables>;
export const AddCbitBankAccountDocument = gql`
    mutation AddCbitBankAccount($input: AddCbitBankAccountInput!) {
  addCbitBankAccount(input: $input) {
    ...CbitBankAccountInfo
  }
}
    ${CbitBankAccountInfoFragmentDoc}`;
export type AddCbitBankAccountMutationFn = Apollo.MutationFunction<AddCbitBankAccountMutation, AddCbitBankAccountMutationVariables>;

/**
 * __useAddCbitBankAccountMutation__
 *
 * To run a mutation, you first call `useAddCbitBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCbitBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCbitBankAccountMutation, { data, loading, error }] = useAddCbitBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCbitBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddCbitBankAccountMutation, AddCbitBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCbitBankAccountMutation, AddCbitBankAccountMutationVariables>(AddCbitBankAccountDocument, options);
      }
export type AddCbitBankAccountMutationHookResult = ReturnType<typeof useAddCbitBankAccountMutation>;
export type AddCbitBankAccountMutationResult = Apollo.MutationResult<AddCbitBankAccountMutation>;
export type AddCbitBankAccountMutationOptions = Apollo.BaseMutationOptions<AddCbitBankAccountMutation, AddCbitBankAccountMutationVariables>;
export const AddCubixBankAccountDocument = gql`
    mutation AddCubixBankAccount($input: AddCubixBankAccountInput!) {
  addCubixBankAccount(input: $input) {
    ...CubixBankAccountInfo
  }
}
    ${CubixBankAccountInfoFragmentDoc}`;
export type AddCubixBankAccountMutationFn = Apollo.MutationFunction<AddCubixBankAccountMutation, AddCubixBankAccountMutationVariables>;

/**
 * __useAddCubixBankAccountMutation__
 *
 * To run a mutation, you first call `useAddCubixBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCubixBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCubixBankAccountMutation, { data, loading, error }] = useAddCubixBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCubixBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddCubixBankAccountMutation, AddCubixBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCubixBankAccountMutation, AddCubixBankAccountMutationVariables>(AddCubixBankAccountDocument, options);
      }
export type AddCubixBankAccountMutationHookResult = ReturnType<typeof useAddCubixBankAccountMutation>;
export type AddCubixBankAccountMutationResult = Apollo.MutationResult<AddCubixBankAccountMutation>;
export type AddCubixBankAccountMutationOptions = Apollo.BaseMutationOptions<AddCubixBankAccountMutation, AddCubixBankAccountMutationVariables>;
export const AddIbanBankAccountDocument = gql`
    mutation AddIbanBankAccount($bankAccount: AddIbanBankAccountInput!) {
  addIbanBankAccount(bankAccount: $bankAccount) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;
export type AddIbanBankAccountMutationFn = Apollo.MutationFunction<AddIbanBankAccountMutation, AddIbanBankAccountMutationVariables>;

/**
 * __useAddIbanBankAccountMutation__
 *
 * To run a mutation, you first call `useAddIbanBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIbanBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIbanBankAccountMutation, { data, loading, error }] = useAddIbanBankAccountMutation({
 *   variables: {
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useAddIbanBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddIbanBankAccountMutation, AddIbanBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIbanBankAccountMutation, AddIbanBankAccountMutationVariables>(AddIbanBankAccountDocument, options);
      }
export type AddIbanBankAccountMutationHookResult = ReturnType<typeof useAddIbanBankAccountMutation>;
export type AddIbanBankAccountMutationResult = Apollo.MutationResult<AddIbanBankAccountMutation>;
export type AddIbanBankAccountMutationOptions = Apollo.BaseMutationOptions<AddIbanBankAccountMutation, AddIbanBankAccountMutationVariables>;
export const AddOtherBankAccountDocument = gql`
    mutation AddOtherBankAccount($bankAccount: AddOtherBankAccountInput!) {
  addOtherBankAccount(bankAccount: $bankAccount) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;
export type AddOtherBankAccountMutationFn = Apollo.MutationFunction<AddOtherBankAccountMutation, AddOtherBankAccountMutationVariables>;

/**
 * __useAddOtherBankAccountMutation__
 *
 * To run a mutation, you first call `useAddOtherBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOtherBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOtherBankAccountMutation, { data, loading, error }] = useAddOtherBankAccountMutation({
 *   variables: {
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useAddOtherBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddOtherBankAccountMutation, AddOtherBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOtherBankAccountMutation, AddOtherBankAccountMutationVariables>(AddOtherBankAccountDocument, options);
      }
export type AddOtherBankAccountMutationHookResult = ReturnType<typeof useAddOtherBankAccountMutation>;
export type AddOtherBankAccountMutationResult = Apollo.MutationResult<AddOtherBankAccountMutation>;
export type AddOtherBankAccountMutationOptions = Apollo.BaseMutationOptions<AddOtherBankAccountMutation, AddOtherBankAccountMutationVariables>;
export const AddPixBankAccountDocument = gql`
    mutation AddPixBankAccount($input: AddPixBankAccountInput!) {
  addPixBankAccount(input: $input) {
    ...PixBankAccountInfo
  }
}
    ${PixBankAccountInfoFragmentDoc}`;
export type AddPixBankAccountMutationFn = Apollo.MutationFunction<AddPixBankAccountMutation, AddPixBankAccountMutationVariables>;

/**
 * __useAddPixBankAccountMutation__
 *
 * To run a mutation, you first call `useAddPixBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPixBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPixBankAccountMutation, { data, loading, error }] = useAddPixBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPixBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddPixBankAccountMutation, AddPixBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPixBankAccountMutation, AddPixBankAccountMutationVariables>(AddPixBankAccountDocument, options);
      }
export type AddPixBankAccountMutationHookResult = ReturnType<typeof useAddPixBankAccountMutation>;
export type AddPixBankAccountMutationResult = Apollo.MutationResult<AddPixBankAccountMutation>;
export type AddPixBankAccountMutationOptions = Apollo.BaseMutationOptions<AddPixBankAccountMutation, AddPixBankAccountMutationVariables>;
export const AddRtpBankAccountDocument = gql`
    mutation AddRtpBankAccount($input: AddRtpBankAccountInput!) {
  addRtpBankAccount(input: $input) {
    ...RtpBankAccountInfo
  }
}
    ${RtpBankAccountInfoFragmentDoc}`;
export type AddRtpBankAccountMutationFn = Apollo.MutationFunction<AddRtpBankAccountMutation, AddRtpBankAccountMutationVariables>;

/**
 * __useAddRtpBankAccountMutation__
 *
 * To run a mutation, you first call `useAddRtpBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRtpBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRtpBankAccountMutation, { data, loading, error }] = useAddRtpBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRtpBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddRtpBankAccountMutation, AddRtpBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRtpBankAccountMutation, AddRtpBankAccountMutationVariables>(AddRtpBankAccountDocument, options);
      }
export type AddRtpBankAccountMutationHookResult = ReturnType<typeof useAddRtpBankAccountMutation>;
export type AddRtpBankAccountMutationResult = Apollo.MutationResult<AddRtpBankAccountMutation>;
export type AddRtpBankAccountMutationOptions = Apollo.BaseMutationOptions<AddRtpBankAccountMutation, AddRtpBankAccountMutationVariables>;
export const AddUsBankAccountDocument = gql`
    mutation AddUsBankAccount($bankAccount: AddUsBankAccountInput!) {
  addUsBankAccount(bankAccount: $bankAccount) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;
export type AddUsBankAccountMutationFn = Apollo.MutationFunction<AddUsBankAccountMutation, AddUsBankAccountMutationVariables>;

/**
 * __useAddUsBankAccountMutation__
 *
 * To run a mutation, you first call `useAddUsBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsBankAccountMutation, { data, loading, error }] = useAddUsBankAccountMutation({
 *   variables: {
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useAddUsBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddUsBankAccountMutation, AddUsBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsBankAccountMutation, AddUsBankAccountMutationVariables>(AddUsBankAccountDocument, options);
      }
export type AddUsBankAccountMutationHookResult = ReturnType<typeof useAddUsBankAccountMutation>;
export type AddUsBankAccountMutationResult = Apollo.MutationResult<AddUsBankAccountMutation>;
export type AddUsBankAccountMutationOptions = Apollo.BaseMutationOptions<AddUsBankAccountMutation, AddUsBankAccountMutationVariables>;
export const AddXpayBankAccountDocument = gql`
    mutation AddXpayBankAccount($input: AddXpayBankAccountInput!) {
  addXpayBankAccount(input: $input) {
    ...XpayBankAccountInfo
  }
}
    ${XpayBankAccountInfoFragmentDoc}`;
export type AddXpayBankAccountMutationFn = Apollo.MutationFunction<AddXpayBankAccountMutation, AddXpayBankAccountMutationVariables>;

/**
 * __useAddXpayBankAccountMutation__
 *
 * To run a mutation, you first call `useAddXpayBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddXpayBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addXpayBankAccountMutation, { data, loading, error }] = useAddXpayBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddXpayBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddXpayBankAccountMutation, AddXpayBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddXpayBankAccountMutation, AddXpayBankAccountMutationVariables>(AddXpayBankAccountDocument, options);
      }
export type AddXpayBankAccountMutationHookResult = ReturnType<typeof useAddXpayBankAccountMutation>;
export type AddXpayBankAccountMutationResult = Apollo.MutationResult<AddXpayBankAccountMutation>;
export type AddXpayBankAccountMutationOptions = Apollo.BaseMutationOptions<AddXpayBankAccountMutation, AddXpayBankAccountMutationVariables>;
export const BankAccountsDocument = gql`
    query BankAccounts($types: [BankAccountType!]) {
  bankAccounts(types: $types) {
    ...BankAccountInfo
  }
}
    ${BankAccountInfoFragmentDoc}`;

/**
 * __useBankAccountsQuery__
 *
 * To run a query within a React component, call `useBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useBankAccountsQuery(baseOptions?: Apollo.QueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
      }
export function useBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
export function useBankAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
export type BankAccountsQueryHookResult = ReturnType<typeof useBankAccountsQuery>;
export type BankAccountsLazyQueryHookResult = ReturnType<typeof useBankAccountsLazyQuery>;
export type BankAccountsSuspenseQueryHookResult = ReturnType<typeof useBankAccountsSuspenseQuery>;
export type BankAccountsQueryResult = Apollo.QueryResult<BankAccountsQuery, BankAccountsQueryVariables>;
export const CbitBankAccountDocument = gql`
    query CbitBankAccount($accountId: String!) {
  cbitBankAccount(accountId: $accountId) {
    ...CbitBankAccountInfo
  }
}
    ${CbitBankAccountInfoFragmentDoc}`;

/**
 * __useCbitBankAccountQuery__
 *
 * To run a query within a React component, call `useCbitBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbitBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCbitBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCbitBankAccountQuery(baseOptions: Apollo.QueryHookOptions<CbitBankAccountQuery, CbitBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CbitBankAccountQuery, CbitBankAccountQueryVariables>(CbitBankAccountDocument, options);
      }
export function useCbitBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CbitBankAccountQuery, CbitBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CbitBankAccountQuery, CbitBankAccountQueryVariables>(CbitBankAccountDocument, options);
        }
export function useCbitBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CbitBankAccountQuery, CbitBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CbitBankAccountQuery, CbitBankAccountQueryVariables>(CbitBankAccountDocument, options);
        }
export type CbitBankAccountQueryHookResult = ReturnType<typeof useCbitBankAccountQuery>;
export type CbitBankAccountLazyQueryHookResult = ReturnType<typeof useCbitBankAccountLazyQuery>;
export type CbitBankAccountSuspenseQueryHookResult = ReturnType<typeof useCbitBankAccountSuspenseQuery>;
export type CbitBankAccountQueryResult = Apollo.QueryResult<CbitBankAccountQuery, CbitBankAccountQueryVariables>;
export const CubixBankAccountDocument = gql`
    query CubixBankAccount($accountId: ID!) {
  cubixBankAccount(accountId: $accountId) {
    ...CubixBankAccountInfo
  }
}
    ${CubixBankAccountInfoFragmentDoc}`;

/**
 * __useCubixBankAccountQuery__
 *
 * To run a query within a React component, call `useCubixBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCubixBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCubixBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCubixBankAccountQuery(baseOptions: Apollo.QueryHookOptions<CubixBankAccountQuery, CubixBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CubixBankAccountQuery, CubixBankAccountQueryVariables>(CubixBankAccountDocument, options);
      }
export function useCubixBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CubixBankAccountQuery, CubixBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CubixBankAccountQuery, CubixBankAccountQueryVariables>(CubixBankAccountDocument, options);
        }
export function useCubixBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CubixBankAccountQuery, CubixBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CubixBankAccountQuery, CubixBankAccountQueryVariables>(CubixBankAccountDocument, options);
        }
export type CubixBankAccountQueryHookResult = ReturnType<typeof useCubixBankAccountQuery>;
export type CubixBankAccountLazyQueryHookResult = ReturnType<typeof useCubixBankAccountLazyQuery>;
export type CubixBankAccountSuspenseQueryHookResult = ReturnType<typeof useCubixBankAccountSuspenseQuery>;
export type CubixBankAccountQueryResult = Apollo.QueryResult<CubixBankAccountQuery, CubixBankAccountQueryVariables>;
export const MerchantAchBankAccountDocument = gql`
    query MerchantAchBankAccount($accountId: String!) {
  merchantAchBankAccount(accountId: $accountId) {
    ...MerchantAchBankAccountInfo
  }
}
    ${MerchantAchBankAccountInfoFragmentDoc}`;

/**
 * __useMerchantAchBankAccountQuery__
 *
 * To run a query within a React component, call `useMerchantAchBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantAchBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantAchBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMerchantAchBankAccountQuery(baseOptions: Apollo.QueryHookOptions<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>(MerchantAchBankAccountDocument, options);
      }
export function useMerchantAchBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>(MerchantAchBankAccountDocument, options);
        }
export function useMerchantAchBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>(MerchantAchBankAccountDocument, options);
        }
export type MerchantAchBankAccountQueryHookResult = ReturnType<typeof useMerchantAchBankAccountQuery>;
export type MerchantAchBankAccountLazyQueryHookResult = ReturnType<typeof useMerchantAchBankAccountLazyQuery>;
export type MerchantAchBankAccountSuspenseQueryHookResult = ReturnType<typeof useMerchantAchBankAccountSuspenseQuery>;
export type MerchantAchBankAccountQueryResult = Apollo.QueryResult<MerchantAchBankAccountQuery, MerchantAchBankAccountQueryVariables>;
export const MerchantSepaBankAccountDocument = gql`
    query MerchantSepaBankAccount($accountId: String!) {
  merchantSepaBankAccount(accountId: $accountId) {
    ...MerchantSepaBankAccountInfo
  }
}
    ${MerchantSepaBankAccountInfoFragmentDoc}`;

/**
 * __useMerchantSepaBankAccountQuery__
 *
 * To run a query within a React component, call `useMerchantSepaBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantSepaBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantSepaBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMerchantSepaBankAccountQuery(baseOptions: Apollo.QueryHookOptions<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>(MerchantSepaBankAccountDocument, options);
      }
export function useMerchantSepaBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>(MerchantSepaBankAccountDocument, options);
        }
export function useMerchantSepaBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>(MerchantSepaBankAccountDocument, options);
        }
export type MerchantSepaBankAccountQueryHookResult = ReturnType<typeof useMerchantSepaBankAccountQuery>;
export type MerchantSepaBankAccountLazyQueryHookResult = ReturnType<typeof useMerchantSepaBankAccountLazyQuery>;
export type MerchantSepaBankAccountSuspenseQueryHookResult = ReturnType<typeof useMerchantSepaBankAccountSuspenseQuery>;
export type MerchantSepaBankAccountQueryResult = Apollo.QueryResult<MerchantSepaBankAccountQuery, MerchantSepaBankAccountQueryVariables>;
export const PixBankAccountDocument = gql`
    query PixBankAccount($accountId: ID!) {
  pixBankAccount(accountId: $accountId) {
    ...PixBankAccountInfo
  }
}
    ${PixBankAccountInfoFragmentDoc}`;

/**
 * __usePixBankAccountQuery__
 *
 * To run a query within a React component, call `usePixBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePixBankAccountQuery(baseOptions: Apollo.QueryHookOptions<PixBankAccountQuery, PixBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PixBankAccountQuery, PixBankAccountQueryVariables>(PixBankAccountDocument, options);
      }
export function usePixBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PixBankAccountQuery, PixBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PixBankAccountQuery, PixBankAccountQueryVariables>(PixBankAccountDocument, options);
        }
export function usePixBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PixBankAccountQuery, PixBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PixBankAccountQuery, PixBankAccountQueryVariables>(PixBankAccountDocument, options);
        }
export type PixBankAccountQueryHookResult = ReturnType<typeof usePixBankAccountQuery>;
export type PixBankAccountLazyQueryHookResult = ReturnType<typeof usePixBankAccountLazyQuery>;
export type PixBankAccountSuspenseQueryHookResult = ReturnType<typeof usePixBankAccountSuspenseQuery>;
export type PixBankAccountQueryResult = Apollo.QueryResult<PixBankAccountQuery, PixBankAccountQueryVariables>;
export const RtpBankAccountDocument = gql`
    query RtpBankAccount($accountId: String!) {
  rtpBankAccount(accountId: $accountId) {
    ...RtpBankAccountInfo
  }
}
    ${RtpBankAccountInfoFragmentDoc}`;

/**
 * __useRtpBankAccountQuery__
 *
 * To run a query within a React component, call `useRtpBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRtpBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRtpBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRtpBankAccountQuery(baseOptions: Apollo.QueryHookOptions<RtpBankAccountQuery, RtpBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RtpBankAccountQuery, RtpBankAccountQueryVariables>(RtpBankAccountDocument, options);
      }
export function useRtpBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RtpBankAccountQuery, RtpBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RtpBankAccountQuery, RtpBankAccountQueryVariables>(RtpBankAccountDocument, options);
        }
export function useRtpBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RtpBankAccountQuery, RtpBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RtpBankAccountQuery, RtpBankAccountQueryVariables>(RtpBankAccountDocument, options);
        }
export type RtpBankAccountQueryHookResult = ReturnType<typeof useRtpBankAccountQuery>;
export type RtpBankAccountLazyQueryHookResult = ReturnType<typeof useRtpBankAccountLazyQuery>;
export type RtpBankAccountSuspenseQueryHookResult = ReturnType<typeof useRtpBankAccountSuspenseQuery>;
export type RtpBankAccountQueryResult = Apollo.QueryResult<RtpBankAccountQuery, RtpBankAccountQueryVariables>;
export const SenBankAccountDocument = gql`
    query SenBankAccount($accountId: String!) {
  senBankAccount(accountId: $accountId) {
    ...SenBankAccountInfo
  }
}
    ${SenBankAccountInfoFragmentDoc}`;

/**
 * __useSenBankAccountQuery__
 *
 * To run a query within a React component, call `useSenBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSenBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSenBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSenBankAccountQuery(baseOptions: Apollo.QueryHookOptions<SenBankAccountQuery, SenBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SenBankAccountQuery, SenBankAccountQueryVariables>(SenBankAccountDocument, options);
      }
export function useSenBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SenBankAccountQuery, SenBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SenBankAccountQuery, SenBankAccountQueryVariables>(SenBankAccountDocument, options);
        }
export function useSenBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SenBankAccountQuery, SenBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SenBankAccountQuery, SenBankAccountQueryVariables>(SenBankAccountDocument, options);
        }
export type SenBankAccountQueryHookResult = ReturnType<typeof useSenBankAccountQuery>;
export type SenBankAccountLazyQueryHookResult = ReturnType<typeof useSenBankAccountLazyQuery>;
export type SenBankAccountSuspenseQueryHookResult = ReturnType<typeof useSenBankAccountSuspenseQuery>;
export type SenBankAccountQueryResult = Apollo.QueryResult<SenBankAccountQuery, SenBankAccountQueryVariables>;
export const SetBankAccountNicknameDocument = gql`
    mutation SetBankAccountNickname($bankAccountId: ID!, $accountType: BankAccountType!, $nickname: String!) {
  setBankAccountNickname(
    bankAccountId: $bankAccountId
    accountType: $accountType
    nickname: $nickname
  ) {
    ...BankAccountInfo
  }
}
    ${BankAccountInfoFragmentDoc}`;
export type SetBankAccountNicknameMutationFn = Apollo.MutationFunction<SetBankAccountNicknameMutation, SetBankAccountNicknameMutationVariables>;

/**
 * __useSetBankAccountNicknameMutation__
 *
 * To run a mutation, you first call `useSetBankAccountNicknameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankAccountNicknameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankAccountNicknameMutation, { data, loading, error }] = useSetBankAccountNicknameMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      accountType: // value for 'accountType'
 *      nickname: // value for 'nickname'
 *   },
 * });
 */
export function useSetBankAccountNicknameMutation(baseOptions?: Apollo.MutationHookOptions<SetBankAccountNicknameMutation, SetBankAccountNicknameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBankAccountNicknameMutation, SetBankAccountNicknameMutationVariables>(SetBankAccountNicknameDocument, options);
      }
export type SetBankAccountNicknameMutationHookResult = ReturnType<typeof useSetBankAccountNicknameMutation>;
export type SetBankAccountNicknameMutationResult = Apollo.MutationResult<SetBankAccountNicknameMutation>;
export type SetBankAccountNicknameMutationOptions = Apollo.BaseMutationOptions<SetBankAccountNicknameMutation, SetBankAccountNicknameMutationVariables>;
export const SetWireBankAccountMetadataDocument = gql`
    mutation SetWireBankAccountMetadata($input: SetWireBankAccountMetadataInput!) {
  setWireBankAccountMetadata(input: $input) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;
export type SetWireBankAccountMetadataMutationFn = Apollo.MutationFunction<SetWireBankAccountMetadataMutation, SetWireBankAccountMetadataMutationVariables>;

/**
 * __useSetWireBankAccountMetadataMutation__
 *
 * To run a mutation, you first call `useSetWireBankAccountMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWireBankAccountMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWireBankAccountMetadataMutation, { data, loading, error }] = useSetWireBankAccountMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWireBankAccountMetadataMutation(baseOptions?: Apollo.MutationHookOptions<SetWireBankAccountMetadataMutation, SetWireBankAccountMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWireBankAccountMetadataMutation, SetWireBankAccountMetadataMutationVariables>(SetWireBankAccountMetadataDocument, options);
      }
export type SetWireBankAccountMetadataMutationHookResult = ReturnType<typeof useSetWireBankAccountMetadataMutation>;
export type SetWireBankAccountMetadataMutationResult = Apollo.MutationResult<SetWireBankAccountMetadataMutation>;
export type SetWireBankAccountMetadataMutationOptions = Apollo.BaseMutationOptions<SetWireBankAccountMetadataMutation, SetWireBankAccountMetadataMutationVariables>;
export const SignetBankAccountDocument = gql`
    query SignetBankAccount($accountId: String!) {
  signetBankAccount(accountId: $accountId) {
    ...SignetBankAccountInfo
  }
}
    ${SignetBankAccountInfoFragmentDoc}`;

/**
 * __useSignetBankAccountQuery__
 *
 * To run a query within a React component, call `useSignetBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignetBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignetBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useSignetBankAccountQuery(baseOptions: Apollo.QueryHookOptions<SignetBankAccountQuery, SignetBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignetBankAccountQuery, SignetBankAccountQueryVariables>(SignetBankAccountDocument, options);
      }
export function useSignetBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignetBankAccountQuery, SignetBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignetBankAccountQuery, SignetBankAccountQueryVariables>(SignetBankAccountDocument, options);
        }
export function useSignetBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignetBankAccountQuery, SignetBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignetBankAccountQuery, SignetBankAccountQueryVariables>(SignetBankAccountDocument, options);
        }
export type SignetBankAccountQueryHookResult = ReturnType<typeof useSignetBankAccountQuery>;
export type SignetBankAccountLazyQueryHookResult = ReturnType<typeof useSignetBankAccountLazyQuery>;
export type SignetBankAccountSuspenseQueryHookResult = ReturnType<typeof useSignetBankAccountSuspenseQuery>;
export type SignetBankAccountQueryResult = Apollo.QueryResult<SignetBankAccountQuery, SignetBankAccountQueryVariables>;
export const WireBankAccountDocument = gql`
    query WireBankAccount($accountId: String!) {
  wireBankAccount(accountId: $accountId) {
    ...WireBankAccountInfo
  }
}
    ${WireBankAccountInfoFragmentDoc}`;

/**
 * __useWireBankAccountQuery__
 *
 * To run a query within a React component, call `useWireBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWireBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWireBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useWireBankAccountQuery(baseOptions: Apollo.QueryHookOptions<WireBankAccountQuery, WireBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WireBankAccountQuery, WireBankAccountQueryVariables>(WireBankAccountDocument, options);
      }
export function useWireBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WireBankAccountQuery, WireBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WireBankAccountQuery, WireBankAccountQueryVariables>(WireBankAccountDocument, options);
        }
export function useWireBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WireBankAccountQuery, WireBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WireBankAccountQuery, WireBankAccountQueryVariables>(WireBankAccountDocument, options);
        }
export type WireBankAccountQueryHookResult = ReturnType<typeof useWireBankAccountQuery>;
export type WireBankAccountLazyQueryHookResult = ReturnType<typeof useWireBankAccountLazyQuery>;
export type WireBankAccountSuspenseQueryHookResult = ReturnType<typeof useWireBankAccountSuspenseQuery>;
export type WireBankAccountQueryResult = Apollo.QueryResult<WireBankAccountQuery, WireBankAccountQueryVariables>;
export const XpayBankAccountDocument = gql`
    query XpayBankAccount($accountId: String!) {
  xpayBankAccount(accountId: $accountId) {
    ...XpayBankAccountInfo
  }
}
    ${XpayBankAccountInfoFragmentDoc}`;

/**
 * __useXpayBankAccountQuery__
 *
 * To run a query within a React component, call `useXpayBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useXpayBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXpayBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useXpayBankAccountQuery(baseOptions: Apollo.QueryHookOptions<XpayBankAccountQuery, XpayBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<XpayBankAccountQuery, XpayBankAccountQueryVariables>(XpayBankAccountDocument, options);
      }
export function useXpayBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<XpayBankAccountQuery, XpayBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<XpayBankAccountQuery, XpayBankAccountQueryVariables>(XpayBankAccountDocument, options);
        }
export function useXpayBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<XpayBankAccountQuery, XpayBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<XpayBankAccountQuery, XpayBankAccountQueryVariables>(XpayBankAccountDocument, options);
        }
export type XpayBankAccountQueryHookResult = ReturnType<typeof useXpayBankAccountQuery>;
export type XpayBankAccountLazyQueryHookResult = ReturnType<typeof useXpayBankAccountLazyQuery>;
export type XpayBankAccountSuspenseQueryHookResult = ReturnType<typeof useXpayBankAccountSuspenseQuery>;
export type XpayBankAccountQueryResult = Apollo.QueryResult<XpayBankAccountQuery, XpayBankAccountQueryVariables>;
export const AceBlockchainDepositAddressDocument = gql`
    query AceBlockchainDepositAddress {
  aceBlockchainDepositAddress {
    ...BlockchainDepositAddressInfo
  }
}
    ${BlockchainDepositAddressInfoFragmentDoc}`;

/**
 * __useAceBlockchainDepositAddressQuery__
 *
 * To run a query within a React component, call `useAceBlockchainDepositAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAceBlockchainDepositAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAceBlockchainDepositAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useAceBlockchainDepositAddressQuery(baseOptions?: Apollo.QueryHookOptions<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>(AceBlockchainDepositAddressDocument, options);
      }
export function useAceBlockchainDepositAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>(AceBlockchainDepositAddressDocument, options);
        }
export function useAceBlockchainDepositAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>(AceBlockchainDepositAddressDocument, options);
        }
export type AceBlockchainDepositAddressQueryHookResult = ReturnType<typeof useAceBlockchainDepositAddressQuery>;
export type AceBlockchainDepositAddressLazyQueryHookResult = ReturnType<typeof useAceBlockchainDepositAddressLazyQuery>;
export type AceBlockchainDepositAddressSuspenseQueryHookResult = ReturnType<typeof useAceBlockchainDepositAddressSuspenseQuery>;
export type AceBlockchainDepositAddressQueryResult = Apollo.QueryResult<AceBlockchainDepositAddressQuery, AceBlockchainDepositAddressQueryVariables>;
export const AddBlockchainDepositAddressesDocument = gql`
    mutation AddBlockchainDepositAddresses($input: [AddBlockchainDepositAddressInput!]!) {
  addBlockchainDepositAddresses(input: $input) {
    ...BlockchainDepositAddressInfo
  }
}
    ${BlockchainDepositAddressInfoFragmentDoc}`;
export type AddBlockchainDepositAddressesMutationFn = Apollo.MutationFunction<AddBlockchainDepositAddressesMutation, AddBlockchainDepositAddressesMutationVariables>;

/**
 * __useAddBlockchainDepositAddressesMutation__
 *
 * To run a mutation, you first call `useAddBlockchainDepositAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockchainDepositAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockchainDepositAddressesMutation, { data, loading, error }] = useAddBlockchainDepositAddressesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBlockchainDepositAddressesMutation(baseOptions?: Apollo.MutationHookOptions<AddBlockchainDepositAddressesMutation, AddBlockchainDepositAddressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlockchainDepositAddressesMutation, AddBlockchainDepositAddressesMutationVariables>(AddBlockchainDepositAddressesDocument, options);
      }
export type AddBlockchainDepositAddressesMutationHookResult = ReturnType<typeof useAddBlockchainDepositAddressesMutation>;
export type AddBlockchainDepositAddressesMutationResult = Apollo.MutationResult<AddBlockchainDepositAddressesMutation>;
export type AddBlockchainDepositAddressesMutationOptions = Apollo.BaseMutationOptions<AddBlockchainDepositAddressesMutation, AddBlockchainDepositAddressesMutationVariables>;
export const AddBlockchainRecipientAddressDocument = gql`
    mutation AddBlockchainRecipientAddress($input: AddBlockchainRecipientAddressInput!) {
  addBlockchainRecipientAddress(input: $input) {
    ...BlockchainRecipientAddressInfo
  }
}
    ${BlockchainRecipientAddressInfoFragmentDoc}`;
export type AddBlockchainRecipientAddressMutationFn = Apollo.MutationFunction<AddBlockchainRecipientAddressMutation, AddBlockchainRecipientAddressMutationVariables>;

/**
 * __useAddBlockchainRecipientAddressMutation__
 *
 * To run a mutation, you first call `useAddBlockchainRecipientAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockchainRecipientAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockchainRecipientAddressMutation, { data, loading, error }] = useAddBlockchainRecipientAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBlockchainRecipientAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddBlockchainRecipientAddressMutation, AddBlockchainRecipientAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlockchainRecipientAddressMutation, AddBlockchainRecipientAddressMutationVariables>(AddBlockchainRecipientAddressDocument, options);
      }
export type AddBlockchainRecipientAddressMutationHookResult = ReturnType<typeof useAddBlockchainRecipientAddressMutation>;
export type AddBlockchainRecipientAddressMutationResult = Apollo.MutationResult<AddBlockchainRecipientAddressMutation>;
export type AddBlockchainRecipientAddressMutationOptions = Apollo.BaseMutationOptions<AddBlockchainRecipientAddressMutation, AddBlockchainRecipientAddressMutationVariables>;
export const BlockchainAssetsDocument = gql`
    query BlockchainAssets($chain: BlockchainAbbreviation) {
  blockchainAssets(chain: $chain) {
    ...BlockchainAssetInfo
  }
}
    ${BlockchainAssetInfoFragmentDoc}`;

/**
 * __useBlockchainAssetsQuery__
 *
 * To run a query within a React component, call `useBlockchainAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainAssetsQuery({
 *   variables: {
 *      chain: // value for 'chain'
 *   },
 * });
 */
export function useBlockchainAssetsQuery(baseOptions?: Apollo.QueryHookOptions<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>(BlockchainAssetsDocument, options);
      }
export function useBlockchainAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>(BlockchainAssetsDocument, options);
        }
export function useBlockchainAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>(BlockchainAssetsDocument, options);
        }
export type BlockchainAssetsQueryHookResult = ReturnType<typeof useBlockchainAssetsQuery>;
export type BlockchainAssetsLazyQueryHookResult = ReturnType<typeof useBlockchainAssetsLazyQuery>;
export type BlockchainAssetsSuspenseQueryHookResult = ReturnType<typeof useBlockchainAssetsSuspenseQuery>;
export type BlockchainAssetsQueryResult = Apollo.QueryResult<BlockchainAssetsQuery, BlockchainAssetsQueryVariables>;
export const BlockchainDepositAddressDocument = gql`
    query BlockchainDepositAddress($input: AddBlockchainDepositAddressInput!) {
  blockchainDepositAddress(input: $input) {
    ...BlockchainDepositAddressInfo
  }
}
    ${BlockchainDepositAddressInfoFragmentDoc}`;

/**
 * __useBlockchainDepositAddressQuery__
 *
 * To run a query within a React component, call `useBlockchainDepositAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainDepositAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainDepositAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockchainDepositAddressQuery(baseOptions: Apollo.QueryHookOptions<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>(BlockchainDepositAddressDocument, options);
      }
export function useBlockchainDepositAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>(BlockchainDepositAddressDocument, options);
        }
export function useBlockchainDepositAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>(BlockchainDepositAddressDocument, options);
        }
export type BlockchainDepositAddressQueryHookResult = ReturnType<typeof useBlockchainDepositAddressQuery>;
export type BlockchainDepositAddressLazyQueryHookResult = ReturnType<typeof useBlockchainDepositAddressLazyQuery>;
export type BlockchainDepositAddressSuspenseQueryHookResult = ReturnType<typeof useBlockchainDepositAddressSuspenseQuery>;
export type BlockchainDepositAddressQueryResult = Apollo.QueryResult<BlockchainDepositAddressQuery, BlockchainDepositAddressQueryVariables>;
export const BlockchainDepositAddressesDocument = gql`
    query BlockchainDepositAddresses($input: BlockchainAddressFilterInput) {
  blockchainDepositAddresses(input: $input) {
    ...BlockchainDepositAddressInfo
  }
}
    ${BlockchainDepositAddressInfoFragmentDoc}`;

/**
 * __useBlockchainDepositAddressesQuery__
 *
 * To run a query within a React component, call `useBlockchainDepositAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainDepositAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainDepositAddressesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockchainDepositAddressesQuery(baseOptions?: Apollo.QueryHookOptions<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>(BlockchainDepositAddressesDocument, options);
      }
export function useBlockchainDepositAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>(BlockchainDepositAddressesDocument, options);
        }
export function useBlockchainDepositAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>(BlockchainDepositAddressesDocument, options);
        }
export type BlockchainDepositAddressesQueryHookResult = ReturnType<typeof useBlockchainDepositAddressesQuery>;
export type BlockchainDepositAddressesLazyQueryHookResult = ReturnType<typeof useBlockchainDepositAddressesLazyQuery>;
export type BlockchainDepositAddressesSuspenseQueryHookResult = ReturnType<typeof useBlockchainDepositAddressesSuspenseQuery>;
export type BlockchainDepositAddressesQueryResult = Apollo.QueryResult<BlockchainDepositAddressesQuery, BlockchainDepositAddressesQueryVariables>;
export const BlockchainRecipientAddressWithMetadataDocument = gql`
    query BlockchainRecipientAddressWithMetadata($id: ID!) {
  blockchainRecipientAddressWithMetadata(id: $id) {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
}
    ${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;

/**
 * __useBlockchainRecipientAddressWithMetadataQuery__
 *
 * To run a query within a React component, call `useBlockchainRecipientAddressWithMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainRecipientAddressWithMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainRecipientAddressWithMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockchainRecipientAddressWithMetadataQuery(baseOptions: Apollo.QueryHookOptions<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>(BlockchainRecipientAddressWithMetadataDocument, options);
      }
export function useBlockchainRecipientAddressWithMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>(BlockchainRecipientAddressWithMetadataDocument, options);
        }
export function useBlockchainRecipientAddressWithMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>(BlockchainRecipientAddressWithMetadataDocument, options);
        }
export type BlockchainRecipientAddressWithMetadataQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressWithMetadataQuery>;
export type BlockchainRecipientAddressWithMetadataLazyQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressWithMetadataLazyQuery>;
export type BlockchainRecipientAddressWithMetadataSuspenseQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressWithMetadataSuspenseQuery>;
export type BlockchainRecipientAddressWithMetadataQueryResult = Apollo.QueryResult<BlockchainRecipientAddressWithMetadataQuery, BlockchainRecipientAddressWithMetadataQueryVariables>;
export const BlockchainRecipientAddressesDocument = gql`
    query BlockchainRecipientAddresses($input: BlockchainAddressFilterInput) {
  blockchainRecipientAddresses(input: $input) {
    ...BlockchainRecipientAddressInfo
  }
}
    ${BlockchainRecipientAddressInfoFragmentDoc}`;

/**
 * __useBlockchainRecipientAddressesQuery__
 *
 * To run a query within a React component, call `useBlockchainRecipientAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainRecipientAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainRecipientAddressesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockchainRecipientAddressesQuery(baseOptions?: Apollo.QueryHookOptions<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>(BlockchainRecipientAddressesDocument, options);
      }
export function useBlockchainRecipientAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>(BlockchainRecipientAddressesDocument, options);
        }
export function useBlockchainRecipientAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>(BlockchainRecipientAddressesDocument, options);
        }
export type BlockchainRecipientAddressesQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesQuery>;
export type BlockchainRecipientAddressesLazyQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesLazyQuery>;
export type BlockchainRecipientAddressesSuspenseQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesSuspenseQuery>;
export type BlockchainRecipientAddressesQueryResult = Apollo.QueryResult<BlockchainRecipientAddressesQuery, BlockchainRecipientAddressesQueryVariables>;
export const BlockchainRecipientAddressesWithMetadataDocument = gql`
    query BlockchainRecipientAddressesWithMetadata($filter: BlockchainRecipientAddressesWithMetadataInput) {
  blockchainRecipientAddressesWithMetadata(filter: $filter) {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
}
    ${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;

/**
 * __useBlockchainRecipientAddressesWithMetadataQuery__
 *
 * To run a query within a React component, call `useBlockchainRecipientAddressesWithMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainRecipientAddressesWithMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainRecipientAddressesWithMetadataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBlockchainRecipientAddressesWithMetadataQuery(baseOptions?: Apollo.QueryHookOptions<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>(BlockchainRecipientAddressesWithMetadataDocument, options);
      }
export function useBlockchainRecipientAddressesWithMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>(BlockchainRecipientAddressesWithMetadataDocument, options);
        }
export function useBlockchainRecipientAddressesWithMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>(BlockchainRecipientAddressesWithMetadataDocument, options);
        }
export type BlockchainRecipientAddressesWithMetadataQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesWithMetadataQuery>;
export type BlockchainRecipientAddressesWithMetadataLazyQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesWithMetadataLazyQuery>;
export type BlockchainRecipientAddressesWithMetadataSuspenseQueryHookResult = ReturnType<typeof useBlockchainRecipientAddressesWithMetadataSuspenseQuery>;
export type BlockchainRecipientAddressesWithMetadataQueryResult = Apollo.QueryResult<BlockchainRecipientAddressesWithMetadataQuery, BlockchainRecipientAddressesWithMetadataQueryVariables>;
export const BlockchainsDocument = gql`
    query Blockchains($input: BlockchainsFilterInput!) {
  blockchains(input: $input) {
    ...BlockchainInfo
  }
}
    ${BlockchainInfoFragmentDoc}`;

/**
 * __useBlockchainsQuery__
 *
 * To run a query within a React component, call `useBlockchainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockchainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockchainsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBlockchainsQuery(baseOptions: Apollo.QueryHookOptions<BlockchainsQuery, BlockchainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockchainsQuery, BlockchainsQueryVariables>(BlockchainsDocument, options);
      }
export function useBlockchainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockchainsQuery, BlockchainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockchainsQuery, BlockchainsQueryVariables>(BlockchainsDocument, options);
        }
export function useBlockchainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockchainsQuery, BlockchainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockchainsQuery, BlockchainsQueryVariables>(BlockchainsDocument, options);
        }
export type BlockchainsQueryHookResult = ReturnType<typeof useBlockchainsQuery>;
export type BlockchainsLazyQueryHookResult = ReturnType<typeof useBlockchainsLazyQuery>;
export type BlockchainsSuspenseQueryHookResult = ReturnType<typeof useBlockchainsSuspenseQuery>;
export type BlockchainsQueryResult = Apollo.QueryResult<BlockchainsQuery, BlockchainsQueryVariables>;
export const CreateBlockchainRecipientAddressWithMetadataDocument = gql`
    mutation CreateBlockchainRecipientAddressWithMetadata($input: CreateBlockchainRecipientAddressWithMetadataInput!) {
  createBlockchainRecipientAddressWithMetadata(input: $input) {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
}
    ${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;
export type CreateBlockchainRecipientAddressWithMetadataMutationFn = Apollo.MutationFunction<CreateBlockchainRecipientAddressWithMetadataMutation, CreateBlockchainRecipientAddressWithMetadataMutationVariables>;

/**
 * __useCreateBlockchainRecipientAddressWithMetadataMutation__
 *
 * To run a mutation, you first call `useCreateBlockchainRecipientAddressWithMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockchainRecipientAddressWithMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockchainRecipientAddressWithMetadataMutation, { data, loading, error }] = useCreateBlockchainRecipientAddressWithMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlockchainRecipientAddressWithMetadataMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockchainRecipientAddressWithMetadataMutation, CreateBlockchainRecipientAddressWithMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockchainRecipientAddressWithMetadataMutation, CreateBlockchainRecipientAddressWithMetadataMutationVariables>(CreateBlockchainRecipientAddressWithMetadataDocument, options);
      }
export type CreateBlockchainRecipientAddressWithMetadataMutationHookResult = ReturnType<typeof useCreateBlockchainRecipientAddressWithMetadataMutation>;
export type CreateBlockchainRecipientAddressWithMetadataMutationResult = Apollo.MutationResult<CreateBlockchainRecipientAddressWithMetadataMutation>;
export type CreateBlockchainRecipientAddressWithMetadataMutationOptions = Apollo.BaseMutationOptions<CreateBlockchainRecipientAddressWithMetadataMutation, CreateBlockchainRecipientAddressWithMetadataMutationVariables>;
export const InternalAddressesDocument = gql`
    query InternalAddresses($filter: InternalAddressInput) {
  internalAddresses(filter: $filter) {
    ...InternalAddressInfo
  }
}
    ${InternalAddressInfoFragmentDoc}`;

/**
 * __useInternalAddressesQuery__
 *
 * To run a query within a React component, call `useInternalAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalAddressesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInternalAddressesQuery(baseOptions?: Apollo.QueryHookOptions<InternalAddressesQuery, InternalAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalAddressesQuery, InternalAddressesQueryVariables>(InternalAddressesDocument, options);
      }
export function useInternalAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalAddressesQuery, InternalAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalAddressesQuery, InternalAddressesQueryVariables>(InternalAddressesDocument, options);
        }
export function useInternalAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalAddressesQuery, InternalAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalAddressesQuery, InternalAddressesQueryVariables>(InternalAddressesDocument, options);
        }
export type InternalAddressesQueryHookResult = ReturnType<typeof useInternalAddressesQuery>;
export type InternalAddressesLazyQueryHookResult = ReturnType<typeof useInternalAddressesLazyQuery>;
export type InternalAddressesSuspenseQueryHookResult = ReturnType<typeof useInternalAddressesSuspenseQuery>;
export type InternalAddressesQueryResult = Apollo.QueryResult<InternalAddressesQuery, InternalAddressesQueryVariables>;
export const OwnerTypeDocument = gql`
    query OwnerType($transactionId: ID!, $addressId: ID!) {
  paymentDetails(id: $transactionId) {
    ...PaymentDetailsInfo
  }
  blockchainRecipientAddressWithMetadata(id: $addressId) {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
}
    ${PaymentDetailsInfoFragmentDoc}
${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;

/**
 * __useOwnerTypeQuery__
 *
 * To run a query within a React component, call `useOwnerTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerTypeQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useOwnerTypeQuery(baseOptions: Apollo.QueryHookOptions<OwnerTypeQuery, OwnerTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnerTypeQuery, OwnerTypeQueryVariables>(OwnerTypeDocument, options);
      }
export function useOwnerTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerTypeQuery, OwnerTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnerTypeQuery, OwnerTypeQueryVariables>(OwnerTypeDocument, options);
        }
export function useOwnerTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OwnerTypeQuery, OwnerTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnerTypeQuery, OwnerTypeQueryVariables>(OwnerTypeDocument, options);
        }
export type OwnerTypeQueryHookResult = ReturnType<typeof useOwnerTypeQuery>;
export type OwnerTypeLazyQueryHookResult = ReturnType<typeof useOwnerTypeLazyQuery>;
export type OwnerTypeSuspenseQueryHookResult = ReturnType<typeof useOwnerTypeSuspenseQuery>;
export type OwnerTypeQueryResult = Apollo.QueryResult<OwnerTypeQuery, OwnerTypeQueryVariables>;
export const RemoveBlockchainRecipientAddressDocument = gql`
    mutation RemoveBlockchainRecipientAddress($addressId: ID!) {
  removeBlockchainRecipientAddress(addressId: $addressId)
}
    `;
export type RemoveBlockchainRecipientAddressMutationFn = Apollo.MutationFunction<RemoveBlockchainRecipientAddressMutation, RemoveBlockchainRecipientAddressMutationVariables>;

/**
 * __useRemoveBlockchainRecipientAddressMutation__
 *
 * To run a mutation, you first call `useRemoveBlockchainRecipientAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockchainRecipientAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockchainRecipientAddressMutation, { data, loading, error }] = useRemoveBlockchainRecipientAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useRemoveBlockchainRecipientAddressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockchainRecipientAddressMutation, RemoveBlockchainRecipientAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockchainRecipientAddressMutation, RemoveBlockchainRecipientAddressMutationVariables>(RemoveBlockchainRecipientAddressDocument, options);
      }
export type RemoveBlockchainRecipientAddressMutationHookResult = ReturnType<typeof useRemoveBlockchainRecipientAddressMutation>;
export type RemoveBlockchainRecipientAddressMutationResult = Apollo.MutationResult<RemoveBlockchainRecipientAddressMutation>;
export type RemoveBlockchainRecipientAddressMutationOptions = Apollo.BaseMutationOptions<RemoveBlockchainRecipientAddressMutation, RemoveBlockchainRecipientAddressMutationVariables>;
export const SetBlockchainRecipientAddressAdditionalInfoDocument = gql`
    mutation SetBlockchainRecipientAddressAdditionalInfo($input: SetRecipientAddressAdditionalInfoInput!) {
  setBlockchainRecipientAddressAdditionalInfo(input: $input) {
    state
  }
}
    `;
export type SetBlockchainRecipientAddressAdditionalInfoMutationFn = Apollo.MutationFunction<SetBlockchainRecipientAddressAdditionalInfoMutation, SetBlockchainRecipientAddressAdditionalInfoMutationVariables>;

/**
 * __useSetBlockchainRecipientAddressAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useSetBlockchainRecipientAddressAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockchainRecipientAddressAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockchainRecipientAddressAdditionalInfoMutation, { data, loading, error }] = useSetBlockchainRecipientAddressAdditionalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBlockchainRecipientAddressAdditionalInfoMutation(baseOptions?: Apollo.MutationHookOptions<SetBlockchainRecipientAddressAdditionalInfoMutation, SetBlockchainRecipientAddressAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockchainRecipientAddressAdditionalInfoMutation, SetBlockchainRecipientAddressAdditionalInfoMutationVariables>(SetBlockchainRecipientAddressAdditionalInfoDocument, options);
      }
export type SetBlockchainRecipientAddressAdditionalInfoMutationHookResult = ReturnType<typeof useSetBlockchainRecipientAddressAdditionalInfoMutation>;
export type SetBlockchainRecipientAddressAdditionalInfoMutationResult = Apollo.MutationResult<SetBlockchainRecipientAddressAdditionalInfoMutation>;
export type SetBlockchainRecipientAddressAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<SetBlockchainRecipientAddressAdditionalInfoMutation, SetBlockchainRecipientAddressAdditionalInfoMutationVariables>;
export const SetBlockchainRecipientAddressBeneficiaryInfoDocument = gql`
    mutation SetBlockchainRecipientAddressBeneficiaryInfo($input: SetRecipientAddressBeneficiaryInfoInput!) {
  setBlockchainRecipientAddressBeneficiaryInfo(input: $input)
}
    `;
export type SetBlockchainRecipientAddressBeneficiaryInfoMutationFn = Apollo.MutationFunction<SetBlockchainRecipientAddressBeneficiaryInfoMutation, SetBlockchainRecipientAddressBeneficiaryInfoMutationVariables>;

/**
 * __useSetBlockchainRecipientAddressBeneficiaryInfoMutation__
 *
 * To run a mutation, you first call `useSetBlockchainRecipientAddressBeneficiaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockchainRecipientAddressBeneficiaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockchainRecipientAddressBeneficiaryInfoMutation, { data, loading, error }] = useSetBlockchainRecipientAddressBeneficiaryInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBlockchainRecipientAddressBeneficiaryInfoMutation(baseOptions?: Apollo.MutationHookOptions<SetBlockchainRecipientAddressBeneficiaryInfoMutation, SetBlockchainRecipientAddressBeneficiaryInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockchainRecipientAddressBeneficiaryInfoMutation, SetBlockchainRecipientAddressBeneficiaryInfoMutationVariables>(SetBlockchainRecipientAddressBeneficiaryInfoDocument, options);
      }
export type SetBlockchainRecipientAddressBeneficiaryInfoMutationHookResult = ReturnType<typeof useSetBlockchainRecipientAddressBeneficiaryInfoMutation>;
export type SetBlockchainRecipientAddressBeneficiaryInfoMutationResult = Apollo.MutationResult<SetBlockchainRecipientAddressBeneficiaryInfoMutation>;
export type SetBlockchainRecipientAddressBeneficiaryInfoMutationOptions = Apollo.BaseMutationOptions<SetBlockchainRecipientAddressBeneficiaryInfoMutation, SetBlockchainRecipientAddressBeneficiaryInfoMutationVariables>;
export const SetBlockchainRecipientAddressWithMetadataDocument = gql`
    mutation SetBlockchainRecipientAddressWithMetadata($input: SetBlockchainRecipientAddressWithMetadataInput!) {
  setBlockchainRecipientAddressWithMetadata(input: $input) {
    ...BlockchainRecipientAddressWithMetadataInfo
  }
}
    ${BlockchainRecipientAddressWithMetadataInfoFragmentDoc}`;
export type SetBlockchainRecipientAddressWithMetadataMutationFn = Apollo.MutationFunction<SetBlockchainRecipientAddressWithMetadataMutation, SetBlockchainRecipientAddressWithMetadataMutationVariables>;

/**
 * __useSetBlockchainRecipientAddressWithMetadataMutation__
 *
 * To run a mutation, you first call `useSetBlockchainRecipientAddressWithMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockchainRecipientAddressWithMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockchainRecipientAddressWithMetadataMutation, { data, loading, error }] = useSetBlockchainRecipientAddressWithMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBlockchainRecipientAddressWithMetadataMutation(baseOptions?: Apollo.MutationHookOptions<SetBlockchainRecipientAddressWithMetadataMutation, SetBlockchainRecipientAddressWithMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockchainRecipientAddressWithMetadataMutation, SetBlockchainRecipientAddressWithMetadataMutationVariables>(SetBlockchainRecipientAddressWithMetadataDocument, options);
      }
export type SetBlockchainRecipientAddressWithMetadataMutationHookResult = ReturnType<typeof useSetBlockchainRecipientAddressWithMetadataMutation>;
export type SetBlockchainRecipientAddressWithMetadataMutationResult = Apollo.MutationResult<SetBlockchainRecipientAddressWithMetadataMutation>;
export type SetBlockchainRecipientAddressWithMetadataMutationOptions = Apollo.BaseMutationOptions<SetBlockchainRecipientAddressWithMetadataMutation, SetBlockchainRecipientAddressWithMetadataMutationVariables>;
export const WalletProvidersDocument = gql`
    query WalletProviders($activeOnly: Boolean) {
  walletProviders(activeOnly: $activeOnly) {
    ...WalletProvidersInfo
  }
}
    ${WalletProvidersInfoFragmentDoc}`;

/**
 * __useWalletProvidersQuery__
 *
 * To run a query within a React component, call `useWalletProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletProvidersQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useWalletProvidersQuery(baseOptions?: Apollo.QueryHookOptions<WalletProvidersQuery, WalletProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletProvidersQuery, WalletProvidersQueryVariables>(WalletProvidersDocument, options);
      }
export function useWalletProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletProvidersQuery, WalletProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletProvidersQuery, WalletProvidersQueryVariables>(WalletProvidersDocument, options);
        }
export function useWalletProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletProvidersQuery, WalletProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletProvidersQuery, WalletProvidersQueryVariables>(WalletProvidersDocument, options);
        }
export type WalletProvidersQueryHookResult = ReturnType<typeof useWalletProvidersQuery>;
export type WalletProvidersLazyQueryHookResult = ReturnType<typeof useWalletProvidersLazyQuery>;
export type WalletProvidersSuspenseQueryHookResult = ReturnType<typeof useWalletProvidersSuspenseQuery>;
export type WalletProvidersQueryResult = Apollo.QueryResult<WalletProvidersQuery, WalletProvidersQueryVariables>;
export const CircleWalletsDocument = gql`
    query CircleWallets {
  circleWallets {
    name
    balance {
      ...AmountInfo
    }
    icon
  }
}
    ${AmountInfoFragmentDoc}`;

/**
 * __useCircleWalletsQuery__
 *
 * To run a query within a React component, call `useCircleWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleWalletsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCircleWalletsQuery(baseOptions?: Apollo.QueryHookOptions<CircleWalletsQuery, CircleWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircleWalletsQuery, CircleWalletsQueryVariables>(CircleWalletsDocument, options);
      }
export function useCircleWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircleWalletsQuery, CircleWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircleWalletsQuery, CircleWalletsQueryVariables>(CircleWalletsDocument, options);
        }
export function useCircleWalletsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CircleWalletsQuery, CircleWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CircleWalletsQuery, CircleWalletsQueryVariables>(CircleWalletsDocument, options);
        }
export type CircleWalletsQueryHookResult = ReturnType<typeof useCircleWalletsQuery>;
export type CircleWalletsLazyQueryHookResult = ReturnType<typeof useCircleWalletsLazyQuery>;
export type CircleWalletsSuspenseQueryHookResult = ReturnType<typeof useCircleWalletsSuspenseQuery>;
export type CircleWalletsQueryResult = Apollo.QueryResult<CircleWalletsQuery, CircleWalletsQueryVariables>;
export const CircleWalletsFtuStatusDocument = gql`
    query CircleWalletsFtuStatus {
  circleWalletsFtuStatus {
    linkStatus
    hasDepositedOnce
  }
}
    `;

/**
 * __useCircleWalletsFtuStatusQuery__
 *
 * To run a query within a React component, call `useCircleWalletsFtuStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleWalletsFtuStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleWalletsFtuStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCircleWalletsFtuStatusQuery(baseOptions?: Apollo.QueryHookOptions<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>(CircleWalletsFtuStatusDocument, options);
      }
export function useCircleWalletsFtuStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>(CircleWalletsFtuStatusDocument, options);
        }
export function useCircleWalletsFtuStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>(CircleWalletsFtuStatusDocument, options);
        }
export type CircleWalletsFtuStatusQueryHookResult = ReturnType<typeof useCircleWalletsFtuStatusQuery>;
export type CircleWalletsFtuStatusLazyQueryHookResult = ReturnType<typeof useCircleWalletsFtuStatusLazyQuery>;
export type CircleWalletsFtuStatusSuspenseQueryHookResult = ReturnType<typeof useCircleWalletsFtuStatusSuspenseQuery>;
export type CircleWalletsFtuStatusQueryResult = Apollo.QueryResult<CircleWalletsFtuStatusQuery, CircleWalletsFtuStatusQueryVariables>;
export const CountriesDocument = gql`
    query Countries($filter: CountriesInput) {
  countries(filter: $filter) {
    ...CountriesInfo
  }
}
    ${CountriesInfoFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CreateDeleteUserGroupProposalDocument = gql`
    mutation CreateDeleteUserGroupProposal($input: CreateDeleteUserGroupProposalInput!) {
  createDeleteUserGroupProposal(input: $input)
}
    `;
export type CreateDeleteUserGroupProposalMutationFn = Apollo.MutationFunction<CreateDeleteUserGroupProposalMutation, CreateDeleteUserGroupProposalMutationVariables>;

/**
 * __useCreateDeleteUserGroupProposalMutation__
 *
 * To run a mutation, you first call `useCreateDeleteUserGroupProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeleteUserGroupProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeleteUserGroupProposalMutation, { data, loading, error }] = useCreateDeleteUserGroupProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeleteUserGroupProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeleteUserGroupProposalMutation, CreateDeleteUserGroupProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeleteUserGroupProposalMutation, CreateDeleteUserGroupProposalMutationVariables>(CreateDeleteUserGroupProposalDocument, options);
      }
export type CreateDeleteUserGroupProposalMutationHookResult = ReturnType<typeof useCreateDeleteUserGroupProposalMutation>;
export type CreateDeleteUserGroupProposalMutationResult = Apollo.MutationResult<CreateDeleteUserGroupProposalMutation>;
export type CreateDeleteUserGroupProposalMutationOptions = Apollo.BaseMutationOptions<CreateDeleteUserGroupProposalMutation, CreateDeleteUserGroupProposalMutationVariables>;
export const CreateUpdateUserGroupProposalDocument = gql`
    mutation CreateUpdateUserGroupProposal($input: CreateUpdateUserGroupProposalInput!) {
  createUpdateUserGroupProposal(input: $input)
}
    `;
export type CreateUpdateUserGroupProposalMutationFn = Apollo.MutationFunction<CreateUpdateUserGroupProposalMutation, CreateUpdateUserGroupProposalMutationVariables>;

/**
 * __useCreateUpdateUserGroupProposalMutation__
 *
 * To run a mutation, you first call `useCreateUpdateUserGroupProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateUserGroupProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateUserGroupProposalMutation, { data, loading, error }] = useCreateUpdateUserGroupProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateUserGroupProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateUserGroupProposalMutation, CreateUpdateUserGroupProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateUserGroupProposalMutation, CreateUpdateUserGroupProposalMutationVariables>(CreateUpdateUserGroupProposalDocument, options);
      }
export type CreateUpdateUserGroupProposalMutationHookResult = ReturnType<typeof useCreateUpdateUserGroupProposalMutation>;
export type CreateUpdateUserGroupProposalMutationResult = Apollo.MutationResult<CreateUpdateUserGroupProposalMutation>;
export type CreateUpdateUserGroupProposalMutationOptions = Apollo.BaseMutationOptions<CreateUpdateUserGroupProposalMutation, CreateUpdateUserGroupProposalMutationVariables>;
export const CustodyBalancesDocument = gql`
    query CustodyBalances {
  custodyBalances {
    ...CustodyAmountInfo
  }
}
    ${CustodyAmountInfoFragmentDoc}`;

/**
 * __useCustodyBalancesQuery__
 *
 * To run a query within a React component, call `useCustodyBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustodyBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustodyBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustodyBalancesQuery(baseOptions?: Apollo.QueryHookOptions<CustodyBalancesQuery, CustodyBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustodyBalancesQuery, CustodyBalancesQueryVariables>(CustodyBalancesDocument, options);
      }
export function useCustodyBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustodyBalancesQuery, CustodyBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustodyBalancesQuery, CustodyBalancesQueryVariables>(CustodyBalancesDocument, options);
        }
export function useCustodyBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustodyBalancesQuery, CustodyBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustodyBalancesQuery, CustodyBalancesQueryVariables>(CustodyBalancesDocument, options);
        }
export type CustodyBalancesQueryHookResult = ReturnType<typeof useCustodyBalancesQuery>;
export type CustodyBalancesLazyQueryHookResult = ReturnType<typeof useCustodyBalancesLazyQuery>;
export type CustodyBalancesSuspenseQueryHookResult = ReturnType<typeof useCustodyBalancesSuspenseQuery>;
export type CustodyBalancesQueryResult = Apollo.QueryResult<CustodyBalancesQuery, CustodyBalancesQueryVariables>;
export const RolrSettingsDocument = gql`
    query RolrSettings {
  rolrSettings {
    accountClosureDate
  }
}
    `;

/**
 * __useRolrSettingsQuery__
 *
 * To run a query within a React component, call `useRolrSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolrSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolrSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolrSettingsQuery(baseOptions?: Apollo.QueryHookOptions<RolrSettingsQuery, RolrSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolrSettingsQuery, RolrSettingsQueryVariables>(RolrSettingsDocument, options);
      }
export function useRolrSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolrSettingsQuery, RolrSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolrSettingsQuery, RolrSettingsQueryVariables>(RolrSettingsDocument, options);
        }
export function useRolrSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolrSettingsQuery, RolrSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolrSettingsQuery, RolrSettingsQueryVariables>(RolrSettingsDocument, options);
        }
export type RolrSettingsQueryHookResult = ReturnType<typeof useRolrSettingsQuery>;
export type RolrSettingsLazyQueryHookResult = ReturnType<typeof useRolrSettingsLazyQuery>;
export type RolrSettingsSuspenseQueryHookResult = ReturnType<typeof useRolrSettingsSuspenseQuery>;
export type RolrSettingsQueryResult = Apollo.QueryResult<RolrSettingsQuery, RolrSettingsQueryVariables>;
export const DelayedWithdrawalsSettingsDocument = gql`
    query DelayedWithdrawalsSettings {
  delayedWithdrawalsSettings {
    enabled
    disabledAfterHours
    delayHours
  }
}
    `;

/**
 * __useDelayedWithdrawalsSettingsQuery__
 *
 * To run a query within a React component, call `useDelayedWithdrawalsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelayedWithdrawalsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelayedWithdrawalsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDelayedWithdrawalsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>(DelayedWithdrawalsSettingsDocument, options);
      }
export function useDelayedWithdrawalsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>(DelayedWithdrawalsSettingsDocument, options);
        }
export function useDelayedWithdrawalsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>(DelayedWithdrawalsSettingsDocument, options);
        }
export type DelayedWithdrawalsSettingsQueryHookResult = ReturnType<typeof useDelayedWithdrawalsSettingsQuery>;
export type DelayedWithdrawalsSettingsLazyQueryHookResult = ReturnType<typeof useDelayedWithdrawalsSettingsLazyQuery>;
export type DelayedWithdrawalsSettingsSuspenseQueryHookResult = ReturnType<typeof useDelayedWithdrawalsSettingsSuspenseQuery>;
export type DelayedWithdrawalsSettingsQueryResult = Apollo.QueryResult<DelayedWithdrawalsSettingsQuery, DelayedWithdrawalsSettingsQueryVariables>;
export const SetDelayedWithdrawalsSettingsDocument = gql`
    mutation SetDelayedWithdrawalsSettings($input: DelayedWithdrawalsSettingsInput!) {
  setDelayedWithdrawalsSettings(input: $input) {
    enabled
    disabledAfterHours
    delayHours
  }
}
    `;
export type SetDelayedWithdrawalsSettingsMutationFn = Apollo.MutationFunction<SetDelayedWithdrawalsSettingsMutation, SetDelayedWithdrawalsSettingsMutationVariables>;

/**
 * __useSetDelayedWithdrawalsSettingsMutation__
 *
 * To run a mutation, you first call `useSetDelayedWithdrawalsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDelayedWithdrawalsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDelayedWithdrawalsSettingsMutation, { data, loading, error }] = useSetDelayedWithdrawalsSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDelayedWithdrawalsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetDelayedWithdrawalsSettingsMutation, SetDelayedWithdrawalsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDelayedWithdrawalsSettingsMutation, SetDelayedWithdrawalsSettingsMutationVariables>(SetDelayedWithdrawalsSettingsDocument, options);
      }
export type SetDelayedWithdrawalsSettingsMutationHookResult = ReturnType<typeof useSetDelayedWithdrawalsSettingsMutation>;
export type SetDelayedWithdrawalsSettingsMutationResult = Apollo.MutationResult<SetDelayedWithdrawalsSettingsMutation>;
export type SetDelayedWithdrawalsSettingsMutationOptions = Apollo.BaseMutationOptions<SetDelayedWithdrawalsSettingsMutation, SetDelayedWithdrawalsSettingsMutationVariables>;
export const DepositDocument = gql`
    query Deposit($id: ID!) {
  deposit(id: $id) {
    ...DepositInfo
  }
}
    ${DepositInfoFragmentDoc}`;

/**
 * __useDepositQuery__
 *
 * To run a query within a React component, call `useDepositQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepositQuery(baseOptions: Apollo.QueryHookOptions<DepositQuery, DepositQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepositQuery, DepositQueryVariables>(DepositDocument, options);
      }
export function useDepositLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositQuery, DepositQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepositQuery, DepositQueryVariables>(DepositDocument, options);
        }
export function useDepositSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepositQuery, DepositQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepositQuery, DepositQueryVariables>(DepositDocument, options);
        }
export type DepositQueryHookResult = ReturnType<typeof useDepositQuery>;
export type DepositLazyQueryHookResult = ReturnType<typeof useDepositLazyQuery>;
export type DepositSuspenseQueryHookResult = ReturnType<typeof useDepositSuspenseQuery>;
export type DepositQueryResult = Apollo.QueryResult<DepositQuery, DepositQueryVariables>;
export const SubmitEmailApprovalVoteDocument = gql`
    mutation SubmitEmailApprovalVote($input: SubmitEmailApprovalVoteInput!) {
  submitEmailApprovalVote(input: $input)
}
    `;
export type SubmitEmailApprovalVoteMutationFn = Apollo.MutationFunction<SubmitEmailApprovalVoteMutation, SubmitEmailApprovalVoteMutationVariables>;

/**
 * __useSubmitEmailApprovalVoteMutation__
 *
 * To run a mutation, you first call `useSubmitEmailApprovalVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEmailApprovalVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEmailApprovalVoteMutation, { data, loading, error }] = useSubmitEmailApprovalVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEmailApprovalVoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEmailApprovalVoteMutation, SubmitEmailApprovalVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEmailApprovalVoteMutation, SubmitEmailApprovalVoteMutationVariables>(SubmitEmailApprovalVoteDocument, options);
      }
export type SubmitEmailApprovalVoteMutationHookResult = ReturnType<typeof useSubmitEmailApprovalVoteMutation>;
export type SubmitEmailApprovalVoteMutationResult = Apollo.MutationResult<SubmitEmailApprovalVoteMutation>;
export type SubmitEmailApprovalVoteMutationOptions = Apollo.BaseMutationOptions<SubmitEmailApprovalVoteMutation, SubmitEmailApprovalVoteMutationVariables>;
export const EntitiesDocument = gql`
    query Entities {
  entities {
    ...EntityInfo
  }
}
    ${EntityInfoFragmentDoc}`;

/**
 * __useEntitiesQuery__
 *
 * To run a query within a React component, call `useEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
      }
export function useEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
        }
export function useEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitiesQuery, EntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesQuery, EntitiesQueryVariables>(EntitiesDocument, options);
        }
export type EntitiesQueryHookResult = ReturnType<typeof useEntitiesQuery>;
export type EntitiesLazyQueryHookResult = ReturnType<typeof useEntitiesLazyQuery>;
export type EntitiesSuspenseQueryHookResult = ReturnType<typeof useEntitiesSuspenseQuery>;
export type EntitiesQueryResult = Apollo.QueryResult<EntitiesQuery, EntitiesQueryVariables>;
export const EntityDocument = gql`
    query Entity($entityId: ID) {
  entity(entityId: $entityId) {
    ...EntityInfo
  }
}
    ${EntityInfoFragmentDoc}`;

/**
 * __useEntityQuery__
 *
 * To run a query within a React component, call `useEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityQuery(baseOptions?: Apollo.QueryHookOptions<EntityQuery, EntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
      }
export function useEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
export function useEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
export type EntityQueryHookResult = ReturnType<typeof useEntityQuery>;
export type EntityLazyQueryHookResult = ReturnType<typeof useEntityLazyQuery>;
export type EntitySuspenseQueryHookResult = ReturnType<typeof useEntitySuspenseQuery>;
export type EntityQueryResult = Apollo.QueryResult<EntityQuery, EntityQueryVariables>;
export const EntityLimitsDocument = gql`
    query EntityLimits($currency: Currency!, $type: WireTransferTypeEnum!) {
  entityLimits(currency: $currency, type: $type) {
    currency
    total
    used
    available
    duration
  }
}
    `;

/**
 * __useEntityLimitsQuery__
 *
 * To run a query within a React component, call `useEntityLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLimitsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useEntityLimitsQuery(baseOptions: Apollo.QueryHookOptions<EntityLimitsQuery, EntityLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLimitsQuery, EntityLimitsQueryVariables>(EntityLimitsDocument, options);
      }
export function useEntityLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLimitsQuery, EntityLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLimitsQuery, EntityLimitsQueryVariables>(EntityLimitsDocument, options);
        }
export function useEntityLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLimitsQuery, EntityLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLimitsQuery, EntityLimitsQueryVariables>(EntityLimitsDocument, options);
        }
export type EntityLimitsQueryHookResult = ReturnType<typeof useEntityLimitsQuery>;
export type EntityLimitsLazyQueryHookResult = ReturnType<typeof useEntityLimitsLazyQuery>;
export type EntityLimitsSuspenseQueryHookResult = ReturnType<typeof useEntityLimitsSuspenseQuery>;
export type EntityLimitsQueryResult = Apollo.QueryResult<EntityLimitsQuery, EntityLimitsQueryVariables>;
export const ActivateMfaDocument = gql`
    mutation ActivateMfa($factorId: ID!, $code: String!) {
  activateMfa(factorId: $factorId, code: $code)
}
    `;
export type ActivateMfaMutationFn = Apollo.MutationFunction<ActivateMfaMutation, ActivateMfaMutationVariables>;

/**
 * __useActivateMfaMutation__
 *
 * To run a mutation, you first call `useActivateMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMfaMutation, { data, loading, error }] = useActivateMfaMutation({
 *   variables: {
 *      factorId: // value for 'factorId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useActivateMfaMutation(baseOptions?: Apollo.MutationHookOptions<ActivateMfaMutation, ActivateMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateMfaMutation, ActivateMfaMutationVariables>(ActivateMfaDocument, options);
      }
export type ActivateMfaMutationHookResult = ReturnType<typeof useActivateMfaMutation>;
export type ActivateMfaMutationResult = Apollo.MutationResult<ActivateMfaMutation>;
export type ActivateMfaMutationOptions = Apollo.BaseMutationOptions<ActivateMfaMutation, ActivateMfaMutationVariables>;
export const EligibleUserFactorsDocument = gql`
    query EligibleUserFactors {
  eligibleUserFactors {
    type
    provider
    status
  }
}
    `;

/**
 * __useEligibleUserFactorsQuery__
 *
 * To run a query within a React component, call `useEligibleUserFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleUserFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleUserFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEligibleUserFactorsQuery(baseOptions?: Apollo.QueryHookOptions<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>(EligibleUserFactorsDocument, options);
      }
export function useEligibleUserFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>(EligibleUserFactorsDocument, options);
        }
export function useEligibleUserFactorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>(EligibleUserFactorsDocument, options);
        }
export type EligibleUserFactorsQueryHookResult = ReturnType<typeof useEligibleUserFactorsQuery>;
export type EligibleUserFactorsLazyQueryHookResult = ReturnType<typeof useEligibleUserFactorsLazyQuery>;
export type EligibleUserFactorsSuspenseQueryHookResult = ReturnType<typeof useEligibleUserFactorsSuspenseQuery>;
export type EligibleUserFactorsQueryResult = Apollo.QueryResult<EligibleUserFactorsQuery, EligibleUserFactorsQueryVariables>;
export const EnrollInOktaVerifyMfaDocument = gql`
    mutation EnrollInOktaVerifyMfa {
  enrollInOktaVerifyMfa {
    id
    qrHref
  }
}
    `;
export type EnrollInOktaVerifyMfaMutationFn = Apollo.MutationFunction<EnrollInOktaVerifyMfaMutation, EnrollInOktaVerifyMfaMutationVariables>;

/**
 * __useEnrollInOktaVerifyMfaMutation__
 *
 * To run a mutation, you first call `useEnrollInOktaVerifyMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollInOktaVerifyMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollInOktaVerifyMfaMutation, { data, loading, error }] = useEnrollInOktaVerifyMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnrollInOktaVerifyMfaMutation(baseOptions?: Apollo.MutationHookOptions<EnrollInOktaVerifyMfaMutation, EnrollInOktaVerifyMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollInOktaVerifyMfaMutation, EnrollInOktaVerifyMfaMutationVariables>(EnrollInOktaVerifyMfaDocument, options);
      }
export type EnrollInOktaVerifyMfaMutationHookResult = ReturnType<typeof useEnrollInOktaVerifyMfaMutation>;
export type EnrollInOktaVerifyMfaMutationResult = Apollo.MutationResult<EnrollInOktaVerifyMfaMutation>;
export type EnrollInOktaVerifyMfaMutationOptions = Apollo.BaseMutationOptions<EnrollInOktaVerifyMfaMutation, EnrollInOktaVerifyMfaMutationVariables>;
export const EnrollInTotpMfaDocument = gql`
    mutation EnrollInTotpMfa {
  enrollInTotpMfa {
    id
    qrHref
    sharedSecret
  }
}
    `;
export type EnrollInTotpMfaMutationFn = Apollo.MutationFunction<EnrollInTotpMfaMutation, EnrollInTotpMfaMutationVariables>;

/**
 * __useEnrollInTotpMfaMutation__
 *
 * To run a mutation, you first call `useEnrollInTotpMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollInTotpMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollInTotpMfaMutation, { data, loading, error }] = useEnrollInTotpMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnrollInTotpMfaMutation(baseOptions?: Apollo.MutationHookOptions<EnrollInTotpMfaMutation, EnrollInTotpMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollInTotpMfaMutation, EnrollInTotpMfaMutationVariables>(EnrollInTotpMfaDocument, options);
      }
export type EnrollInTotpMfaMutationHookResult = ReturnType<typeof useEnrollInTotpMfaMutation>;
export type EnrollInTotpMfaMutationResult = Apollo.MutationResult<EnrollInTotpMfaMutation>;
export type EnrollInTotpMfaMutationOptions = Apollo.BaseMutationOptions<EnrollInTotpMfaMutation, EnrollInTotpMfaMutationVariables>;
export const FactorDocument = gql`
    query Factor($factorType: FactorType!) {
  factor(factorType: $factorType) {
    ...FactorInfo
  }
}
    ${FactorInfoFragmentDoc}`;

/**
 * __useFactorQuery__
 *
 * To run a query within a React component, call `useFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactorQuery({
 *   variables: {
 *      factorType: // value for 'factorType'
 *   },
 * });
 */
export function useFactorQuery(baseOptions: Apollo.QueryHookOptions<FactorQuery, FactorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FactorQuery, FactorQueryVariables>(FactorDocument, options);
      }
export function useFactorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FactorQuery, FactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FactorQuery, FactorQueryVariables>(FactorDocument, options);
        }
export function useFactorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FactorQuery, FactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FactorQuery, FactorQueryVariables>(FactorDocument, options);
        }
export type FactorQueryHookResult = ReturnType<typeof useFactorQuery>;
export type FactorLazyQueryHookResult = ReturnType<typeof useFactorLazyQuery>;
export type FactorSuspenseQueryHookResult = ReturnType<typeof useFactorSuspenseQuery>;
export type FactorQueryResult = Apollo.QueryResult<FactorQuery, FactorQueryVariables>;
export const OktaVerifyActivationStatusDocument = gql`
    query OktaVerifyActivationStatus($input: OktaVerifyActivationStatusInput!) {
  oktaVerifyActivationStatus(input: $input) {
    status
  }
}
    `;

/**
 * __useOktaVerifyActivationStatusQuery__
 *
 * To run a query within a React component, call `useOktaVerifyActivationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOktaVerifyActivationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOktaVerifyActivationStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOktaVerifyActivationStatusQuery(baseOptions: Apollo.QueryHookOptions<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>(OktaVerifyActivationStatusDocument, options);
      }
export function useOktaVerifyActivationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>(OktaVerifyActivationStatusDocument, options);
        }
export function useOktaVerifyActivationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>(OktaVerifyActivationStatusDocument, options);
        }
export type OktaVerifyActivationStatusQueryHookResult = ReturnType<typeof useOktaVerifyActivationStatusQuery>;
export type OktaVerifyActivationStatusLazyQueryHookResult = ReturnType<typeof useOktaVerifyActivationStatusLazyQuery>;
export type OktaVerifyActivationStatusSuspenseQueryHookResult = ReturnType<typeof useOktaVerifyActivationStatusSuspenseQuery>;
export type OktaVerifyActivationStatusQueryResult = Apollo.QueryResult<OktaVerifyActivationStatusQuery, OktaVerifyActivationStatusQueryVariables>;
export const ScaFactorInfoDocument = gql`
    query ScaFactorInfo {
  scaFactorInfo {
    isScaRequired
    oktaVerify {
      status
    }
    pinCode {
      status
    }
  }
}
    `;

/**
 * __useScaFactorInfoQuery__
 *
 * To run a query within a React component, call `useScaFactorInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useScaFactorInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScaFactorInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useScaFactorInfoQuery(baseOptions?: Apollo.QueryHookOptions<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>(ScaFactorInfoDocument, options);
      }
export function useScaFactorInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>(ScaFactorInfoDocument, options);
        }
export function useScaFactorInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>(ScaFactorInfoDocument, options);
        }
export type ScaFactorInfoQueryHookResult = ReturnType<typeof useScaFactorInfoQuery>;
export type ScaFactorInfoLazyQueryHookResult = ReturnType<typeof useScaFactorInfoLazyQuery>;
export type ScaFactorInfoSuspenseQueryHookResult = ReturnType<typeof useScaFactorInfoSuspenseQuery>;
export type ScaFactorInfoQueryResult = Apollo.QueryResult<ScaFactorInfoQuery, ScaFactorInfoQueryVariables>;
export const SetMfaRequiredDocument = gql`
    mutation SetMfaRequired {
  setMfaRequired
}
    `;
export type SetMfaRequiredMutationFn = Apollo.MutationFunction<SetMfaRequiredMutation, SetMfaRequiredMutationVariables>;

/**
 * __useSetMfaRequiredMutation__
 *
 * To run a mutation, you first call `useSetMfaRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMfaRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMfaRequiredMutation, { data, loading, error }] = useSetMfaRequiredMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetMfaRequiredMutation(baseOptions?: Apollo.MutationHookOptions<SetMfaRequiredMutation, SetMfaRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMfaRequiredMutation, SetMfaRequiredMutationVariables>(SetMfaRequiredDocument, options);
      }
export type SetMfaRequiredMutationHookResult = ReturnType<typeof useSetMfaRequiredMutation>;
export type SetMfaRequiredMutationResult = Apollo.MutationResult<SetMfaRequiredMutation>;
export type SetMfaRequiredMutationOptions = Apollo.BaseMutationOptions<SetMfaRequiredMutation, SetMfaRequiredMutationVariables>;
export const SignInFactorDocument = gql`
    query SignInFactor {
  signInFactor {
    enrolled
  }
}
    `;

/**
 * __useSignInFactorQuery__
 *
 * To run a query within a React component, call `useSignInFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignInFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignInFactorQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignInFactorQuery(baseOptions?: Apollo.QueryHookOptions<SignInFactorQuery, SignInFactorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignInFactorQuery, SignInFactorQueryVariables>(SignInFactorDocument, options);
      }
export function useSignInFactorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignInFactorQuery, SignInFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignInFactorQuery, SignInFactorQueryVariables>(SignInFactorDocument, options);
        }
export function useSignInFactorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignInFactorQuery, SignInFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignInFactorQuery, SignInFactorQueryVariables>(SignInFactorDocument, options);
        }
export type SignInFactorQueryHookResult = ReturnType<typeof useSignInFactorQuery>;
export type SignInFactorLazyQueryHookResult = ReturnType<typeof useSignInFactorLazyQuery>;
export type SignInFactorSuspenseQueryHookResult = ReturnType<typeof useSignInFactorSuspenseQuery>;
export type SignInFactorQueryResult = Apollo.QueryResult<SignInFactorQuery, SignInFactorQueryVariables>;
export const FeeReportsDocument = gql`
    query FeeReports($page: PaginationInput, $filter: FeeReportsFilterInput) {
  feeReports(page: $page, filter: $filter) {
    ...PaginationInfo
    ...FeeReportsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${FeeReportsInfoFragmentDoc}`;

/**
 * __useFeeReportsQuery__
 *
 * To run a query within a React component, call `useFeeReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeeReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeeReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFeeReportsQuery(baseOptions?: Apollo.QueryHookOptions<FeeReportsQuery, FeeReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeeReportsQuery, FeeReportsQueryVariables>(FeeReportsDocument, options);
      }
export function useFeeReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeeReportsQuery, FeeReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeeReportsQuery, FeeReportsQueryVariables>(FeeReportsDocument, options);
        }
export function useFeeReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeeReportsQuery, FeeReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeeReportsQuery, FeeReportsQueryVariables>(FeeReportsDocument, options);
        }
export type FeeReportsQueryHookResult = ReturnType<typeof useFeeReportsQuery>;
export type FeeReportsLazyQueryHookResult = ReturnType<typeof useFeeReportsLazyQuery>;
export type FeeReportsSuspenseQueryHookResult = ReturnType<typeof useFeeReportsSuspenseQuery>;
export type FeeReportsQueryResult = Apollo.QueryResult<FeeReportsQuery, FeeReportsQueryVariables>;
export const FxQuoteDocument = gql`
    query FxQuote($input: GetFxQuoteInput!) {
  fxQuote(input: $input) {
    ...FxQuoteInputInfo
  }
}
    ${FxQuoteInputInfoFragmentDoc}`;

/**
 * __useFxQuoteQuery__
 *
 * To run a query within a React component, call `useFxQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFxQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFxQuoteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFxQuoteQuery(baseOptions: Apollo.QueryHookOptions<FxQuoteQuery, FxQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FxQuoteQuery, FxQuoteQueryVariables>(FxQuoteDocument, options);
      }
export function useFxQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FxQuoteQuery, FxQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FxQuoteQuery, FxQuoteQueryVariables>(FxQuoteDocument, options);
        }
export function useFxQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FxQuoteQuery, FxQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FxQuoteQuery, FxQuoteQueryVariables>(FxQuoteDocument, options);
        }
export type FxQuoteQueryHookResult = ReturnType<typeof useFxQuoteQuery>;
export type FxQuoteLazyQueryHookResult = ReturnType<typeof useFxQuoteLazyQuery>;
export type FxQuoteSuspenseQueryHookResult = ReturnType<typeof useFxQuoteSuspenseQuery>;
export type FxQuoteQueryResult = Apollo.QueryResult<FxQuoteQuery, FxQuoteQueryVariables>;
export const IdentityChallengeDocument = gql`
    query IdentityChallenge($addressId: ID!) {
  identityChallenge(addressId: $addressId) {
    id
    addressId
    sourceAddress
    destinationAddress
    chain
    paymentId
    amount {
      ...AmountInfo
    }
    status
    createDate
    updateDate
    expiryDate
  }
}
    ${AmountInfoFragmentDoc}`;

/**
 * __useIdentityChallengeQuery__
 *
 * To run a query within a React component, call `useIdentityChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityChallengeQuery({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useIdentityChallengeQuery(baseOptions: Apollo.QueryHookOptions<IdentityChallengeQuery, IdentityChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityChallengeQuery, IdentityChallengeQueryVariables>(IdentityChallengeDocument, options);
      }
export function useIdentityChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityChallengeQuery, IdentityChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityChallengeQuery, IdentityChallengeQueryVariables>(IdentityChallengeDocument, options);
        }
export function useIdentityChallengeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityChallengeQuery, IdentityChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityChallengeQuery, IdentityChallengeQueryVariables>(IdentityChallengeDocument, options);
        }
export type IdentityChallengeQueryHookResult = ReturnType<typeof useIdentityChallengeQuery>;
export type IdentityChallengeLazyQueryHookResult = ReturnType<typeof useIdentityChallengeLazyQuery>;
export type IdentityChallengeSuspenseQueryHookResult = ReturnType<typeof useIdentityChallengeSuspenseQuery>;
export type IdentityChallengeQueryResult = Apollo.QueryResult<IdentityChallengeQuery, IdentityChallengeQueryVariables>;
export const AllInAppNotificationsDocument = gql`
    query AllInAppNotifications($page: PaginationInput) {
  allInAppNotifications(page: $page) {
    ...InAppNotificationsInfo
  }
}
    ${InAppNotificationsInfoFragmentDoc}`;

/**
 * __useAllInAppNotificationsQuery__
 *
 * To run a query within a React component, call `useAllInAppNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInAppNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInAppNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAllInAppNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>(AllInAppNotificationsDocument, options);
      }
export function useAllInAppNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>(AllInAppNotificationsDocument, options);
        }
export function useAllInAppNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>(AllInAppNotificationsDocument, options);
        }
export type AllInAppNotificationsQueryHookResult = ReturnType<typeof useAllInAppNotificationsQuery>;
export type AllInAppNotificationsLazyQueryHookResult = ReturnType<typeof useAllInAppNotificationsLazyQuery>;
export type AllInAppNotificationsSuspenseQueryHookResult = ReturnType<typeof useAllInAppNotificationsSuspenseQuery>;
export type AllInAppNotificationsQueryResult = Apollo.QueryResult<AllInAppNotificationsQuery, AllInAppNotificationsQueryVariables>;
export const FilteredLongPollInAppNotificationDocument = gql`
    query FilteredLongPollInAppNotification($input: FilteredLongPollInAppNotificationInput!) {
  filteredLongPollInAppNotification(input: $input) {
    ...InAppNotificationInfo
  }
}
    ${InAppNotificationInfoFragmentDoc}`;

/**
 * __useFilteredLongPollInAppNotificationQuery__
 *
 * To run a query within a React component, call `useFilteredLongPollInAppNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredLongPollInAppNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredLongPollInAppNotificationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilteredLongPollInAppNotificationQuery(baseOptions: Apollo.QueryHookOptions<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>(FilteredLongPollInAppNotificationDocument, options);
      }
export function useFilteredLongPollInAppNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>(FilteredLongPollInAppNotificationDocument, options);
        }
export function useFilteredLongPollInAppNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>(FilteredLongPollInAppNotificationDocument, options);
        }
export type FilteredLongPollInAppNotificationQueryHookResult = ReturnType<typeof useFilteredLongPollInAppNotificationQuery>;
export type FilteredLongPollInAppNotificationLazyQueryHookResult = ReturnType<typeof useFilteredLongPollInAppNotificationLazyQuery>;
export type FilteredLongPollInAppNotificationSuspenseQueryHookResult = ReturnType<typeof useFilteredLongPollInAppNotificationSuspenseQuery>;
export type FilteredLongPollInAppNotificationQueryResult = Apollo.QueryResult<FilteredLongPollInAppNotificationQuery, FilteredLongPollInAppNotificationQueryVariables>;
export const LongPollEmailVerifiedNotificationDocument = gql`
    query LongPollEmailVerifiedNotification {
  longPollEmailVerifiedNotification {
    ...EmailVerifiedNotificationInfo
  }
}
    ${EmailVerifiedNotificationInfoFragmentDoc}`;

/**
 * __useLongPollEmailVerifiedNotificationQuery__
 *
 * To run a query within a React component, call `useLongPollEmailVerifiedNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLongPollEmailVerifiedNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLongPollEmailVerifiedNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLongPollEmailVerifiedNotificationQuery(baseOptions?: Apollo.QueryHookOptions<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>(LongPollEmailVerifiedNotificationDocument, options);
      }
export function useLongPollEmailVerifiedNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>(LongPollEmailVerifiedNotificationDocument, options);
        }
export function useLongPollEmailVerifiedNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>(LongPollEmailVerifiedNotificationDocument, options);
        }
export type LongPollEmailVerifiedNotificationQueryHookResult = ReturnType<typeof useLongPollEmailVerifiedNotificationQuery>;
export type LongPollEmailVerifiedNotificationLazyQueryHookResult = ReturnType<typeof useLongPollEmailVerifiedNotificationLazyQuery>;
export type LongPollEmailVerifiedNotificationSuspenseQueryHookResult = ReturnType<typeof useLongPollEmailVerifiedNotificationSuspenseQuery>;
export type LongPollEmailVerifiedNotificationQueryResult = Apollo.QueryResult<LongPollEmailVerifiedNotificationQuery, LongPollEmailVerifiedNotificationQueryVariables>;
export const LongPollInAppNotificationDocument = gql`
    query LongPollInAppNotification {
  longPollInAppNotification {
    ...InAppNotificationInfo
  }
}
    ${InAppNotificationInfoFragmentDoc}`;

/**
 * __useLongPollInAppNotificationQuery__
 *
 * To run a query within a React component, call `useLongPollInAppNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLongPollInAppNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLongPollInAppNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLongPollInAppNotificationQuery(baseOptions?: Apollo.QueryHookOptions<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>(LongPollInAppNotificationDocument, options);
      }
export function useLongPollInAppNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>(LongPollInAppNotificationDocument, options);
        }
export function useLongPollInAppNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>(LongPollInAppNotificationDocument, options);
        }
export type LongPollInAppNotificationQueryHookResult = ReturnType<typeof useLongPollInAppNotificationQuery>;
export type LongPollInAppNotificationLazyQueryHookResult = ReturnType<typeof useLongPollInAppNotificationLazyQuery>;
export type LongPollInAppNotificationSuspenseQueryHookResult = ReturnType<typeof useLongPollInAppNotificationSuspenseQuery>;
export type LongPollInAppNotificationQueryResult = Apollo.QueryResult<LongPollInAppNotificationQuery, LongPollInAppNotificationQueryVariables>;
export const MarkInAppNotificationsAsReadDocument = gql`
    mutation MarkInAppNotificationsAsRead($notificationIds: [ID!]!) {
  markInAppNotificationsAsRead(notificationIds: $notificationIds)
}
    `;
export type MarkInAppNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkInAppNotificationsAsReadMutation, MarkInAppNotificationsAsReadMutationVariables>;

/**
 * __useMarkInAppNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkInAppNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInAppNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInAppNotificationsAsReadMutation, { data, loading, error }] = useMarkInAppNotificationsAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkInAppNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkInAppNotificationsAsReadMutation, MarkInAppNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInAppNotificationsAsReadMutation, MarkInAppNotificationsAsReadMutationVariables>(MarkInAppNotificationsAsReadDocument, options);
      }
export type MarkInAppNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkInAppNotificationsAsReadMutation>;
export type MarkInAppNotificationsAsReadMutationResult = Apollo.MutationResult<MarkInAppNotificationsAsReadMutation>;
export type MarkInAppNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkInAppNotificationsAsReadMutation, MarkInAppNotificationsAsReadMutationVariables>;
export const TestPushInAppNotificationMessageDocument = gql`
    mutation TestPushInAppNotificationMessage {
  testPushInAppNotificationMessage
}
    `;
export type TestPushInAppNotificationMessageMutationFn = Apollo.MutationFunction<TestPushInAppNotificationMessageMutation, TestPushInAppNotificationMessageMutationVariables>;

/**
 * __useTestPushInAppNotificationMessageMutation__
 *
 * To run a mutation, you first call `useTestPushInAppNotificationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestPushInAppNotificationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testPushInAppNotificationMessageMutation, { data, loading, error }] = useTestPushInAppNotificationMessageMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestPushInAppNotificationMessageMutation(baseOptions?: Apollo.MutationHookOptions<TestPushInAppNotificationMessageMutation, TestPushInAppNotificationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestPushInAppNotificationMessageMutation, TestPushInAppNotificationMessageMutationVariables>(TestPushInAppNotificationMessageDocument, options);
      }
export type TestPushInAppNotificationMessageMutationHookResult = ReturnType<typeof useTestPushInAppNotificationMessageMutation>;
export type TestPushInAppNotificationMessageMutationResult = Apollo.MutationResult<TestPushInAppNotificationMessageMutation>;
export type TestPushInAppNotificationMessageMutationOptions = Apollo.BaseMutationOptions<TestPushInAppNotificationMessageMutation, TestPushInAppNotificationMessageMutationVariables>;
export const UnreadInAppNotificationsDocument = gql`
    query UnreadInAppNotifications($page: PaginationInput) {
  unreadInAppNotifications(page: $page) {
    ...InAppNotificationsInfo
  }
}
    ${InAppNotificationsInfoFragmentDoc}`;

/**
 * __useUnreadInAppNotificationsQuery__
 *
 * To run a query within a React component, call `useUnreadInAppNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadInAppNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadInAppNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUnreadInAppNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>(UnreadInAppNotificationsDocument, options);
      }
export function useUnreadInAppNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>(UnreadInAppNotificationsDocument, options);
        }
export function useUnreadInAppNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>(UnreadInAppNotificationsDocument, options);
        }
export type UnreadInAppNotificationsQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsQuery>;
export type UnreadInAppNotificationsLazyQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsLazyQuery>;
export type UnreadInAppNotificationsSuspenseQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsSuspenseQuery>;
export type UnreadInAppNotificationsQueryResult = Apollo.QueryResult<UnreadInAppNotificationsQuery, UnreadInAppNotificationsQueryVariables>;
export const UnreadInAppNotificationsCountDocument = gql`
    query UnreadInAppNotificationsCount {
  unreadInAppNotificationsCount
}
    `;

/**
 * __useUnreadInAppNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadInAppNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadInAppNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadInAppNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadInAppNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>(UnreadInAppNotificationsCountDocument, options);
      }
export function useUnreadInAppNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>(UnreadInAppNotificationsCountDocument, options);
        }
export function useUnreadInAppNotificationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>(UnreadInAppNotificationsCountDocument, options);
        }
export type UnreadInAppNotificationsCountQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsCountQuery>;
export type UnreadInAppNotificationsCountLazyQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsCountLazyQuery>;
export type UnreadInAppNotificationsCountSuspenseQueryHookResult = ReturnType<typeof useUnreadInAppNotificationsCountSuspenseQuery>;
export type UnreadInAppNotificationsCountQueryResult = Apollo.QueryResult<UnreadInAppNotificationsCountQuery, UnreadInAppNotificationsCountQueryVariables>;
export const BillingProfileDocument = gql`
    query BillingProfile {
  billingProfile {
    billingContact {
      email
    }
    billingAddress {
      line1
      line2
      city
      district
      postalCode
      country
    }
    phoneNumber
    vatNumber
  }
}
    `;

/**
 * __useBillingProfileQuery__
 *
 * To run a query within a React component, call `useBillingProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingProfileQuery(baseOptions?: Apollo.QueryHookOptions<BillingProfileQuery, BillingProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingProfileQuery, BillingProfileQueryVariables>(BillingProfileDocument, options);
      }
export function useBillingProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingProfileQuery, BillingProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingProfileQuery, BillingProfileQueryVariables>(BillingProfileDocument, options);
        }
export function useBillingProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingProfileQuery, BillingProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingProfileQuery, BillingProfileQueryVariables>(BillingProfileDocument, options);
        }
export type BillingProfileQueryHookResult = ReturnType<typeof useBillingProfileQuery>;
export type BillingProfileLazyQueryHookResult = ReturnType<typeof useBillingProfileLazyQuery>;
export type BillingProfileSuspenseQueryHookResult = ReturnType<typeof useBillingProfileSuspenseQuery>;
export type BillingProfileQueryResult = Apollo.QueryResult<BillingProfileQuery, BillingProfileQueryVariables>;
export const InvoiceDetailDocument = gql`
    query InvoiceDetail($id: ID!) {
  invoiceDetail(id: $id) {
    ...InvoiceDetailInfo
  }
}
    ${InvoiceDetailInfoFragmentDoc}`;

/**
 * __useInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceDetailQuery(baseOptions: Apollo.QueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
      }
export function useInvoiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
        }
export function useInvoiceDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
        }
export type InvoiceDetailQueryHookResult = ReturnType<typeof useInvoiceDetailQuery>;
export type InvoiceDetailLazyQueryHookResult = ReturnType<typeof useInvoiceDetailLazyQuery>;
export type InvoiceDetailSuspenseQueryHookResult = ReturnType<typeof useInvoiceDetailSuspenseQuery>;
export type InvoiceDetailQueryResult = Apollo.QueryResult<InvoiceDetailQuery, InvoiceDetailQueryVariables>;
export const InvoicePaymentDocument = gql`
    mutation InvoicePayment($invoicePaymentInput: InvoicePaymentInput!) {
  invoicePayment(invoicePaymentInput: $invoicePaymentInput) {
    ...InvoicePaymentInfo
  }
}
    ${InvoicePaymentInfoFragmentDoc}`;
export type InvoicePaymentMutationFn = Apollo.MutationFunction<InvoicePaymentMutation, InvoicePaymentMutationVariables>;

/**
 * __useInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePaymentMutation, { data, loading, error }] = useInvoicePaymentMutation({
 *   variables: {
 *      invoicePaymentInput: // value for 'invoicePaymentInput'
 *   },
 * });
 */
export function useInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePaymentMutation, InvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePaymentMutation, InvoicePaymentMutationVariables>(InvoicePaymentDocument, options);
      }
export type InvoicePaymentMutationHookResult = ReturnType<typeof useInvoicePaymentMutation>;
export type InvoicePaymentMutationResult = Apollo.MutationResult<InvoicePaymentMutation>;
export type InvoicePaymentMutationOptions = Apollo.BaseMutationOptions<InvoicePaymentMutation, InvoicePaymentMutationVariables>;
export const InvoicePaymentDetailDocument = gql`
    query InvoicePaymentDetail($id: ID!) {
  invoicePaymentDetail(id: $id) {
    ...InvoicePaymentDetailInfo
  }
}
    ${InvoicePaymentDetailInfoFragmentDoc}`;

/**
 * __useInvoicePaymentDetailQuery__
 *
 * To run a query within a React component, call `useInvoicePaymentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePaymentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoicePaymentDetailQuery(baseOptions: Apollo.QueryHookOptions<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>(InvoicePaymentDetailDocument, options);
      }
export function useInvoicePaymentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>(InvoicePaymentDetailDocument, options);
        }
export function useInvoicePaymentDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>(InvoicePaymentDetailDocument, options);
        }
export type InvoicePaymentDetailQueryHookResult = ReturnType<typeof useInvoicePaymentDetailQuery>;
export type InvoicePaymentDetailLazyQueryHookResult = ReturnType<typeof useInvoicePaymentDetailLazyQuery>;
export type InvoicePaymentDetailSuspenseQueryHookResult = ReturnType<typeof useInvoicePaymentDetailSuspenseQuery>;
export type InvoicePaymentDetailQueryResult = Apollo.QueryResult<InvoicePaymentDetailQuery, InvoicePaymentDetailQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($page: PaginationInput) {
  invoices(page: $page) {
    ...PaginationInfo
    ...InvoicesInfo
  }
}
    ${PaginationInfoFragmentDoc}
${InvoicesInfoFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const UpdateBillingProfileDocument = gql`
    mutation UpdateBillingProfile($input: UpdateBillingProfileInput!) {
  updateBillingProfile(input: $input)
}
    `;
export type UpdateBillingProfileMutationFn = Apollo.MutationFunction<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>;

/**
 * __useUpdateBillingProfileMutation__
 *
 * To run a mutation, you first call `useUpdateBillingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingProfileMutation, { data, loading, error }] = useUpdateBillingProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>(UpdateBillingProfileDocument, options);
      }
export type UpdateBillingProfileMutationHookResult = ReturnType<typeof useUpdateBillingProfileMutation>;
export type UpdateBillingProfileMutationResult = Apollo.MutationResult<UpdateBillingProfileMutation>;
export type UpdateBillingProfileMutationOptions = Apollo.BaseMutationOptions<UpdateBillingProfileMutation, UpdateBillingProfileMutationVariables>;
export const ClientIpAddressDocument = gql`
    query ClientIpAddress {
  clientIpAddress {
    ip
  }
}
    `;

/**
 * __useClientIpAddressQuery__
 *
 * To run a query within a React component, call `useClientIpAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientIpAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientIpAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientIpAddressQuery(baseOptions?: Apollo.QueryHookOptions<ClientIpAddressQuery, ClientIpAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientIpAddressQuery, ClientIpAddressQueryVariables>(ClientIpAddressDocument, options);
      }
export function useClientIpAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientIpAddressQuery, ClientIpAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientIpAddressQuery, ClientIpAddressQueryVariables>(ClientIpAddressDocument, options);
        }
export function useClientIpAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientIpAddressQuery, ClientIpAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientIpAddressQuery, ClientIpAddressQueryVariables>(ClientIpAddressDocument, options);
        }
export type ClientIpAddressQueryHookResult = ReturnType<typeof useClientIpAddressQuery>;
export type ClientIpAddressLazyQueryHookResult = ReturnType<typeof useClientIpAddressLazyQuery>;
export type ClientIpAddressSuspenseQueryHookResult = ReturnType<typeof useClientIpAddressSuspenseQuery>;
export type ClientIpAddressQueryResult = Apollo.QueryResult<ClientIpAddressQuery, ClientIpAddressQueryVariables>;
export const CreateIpAllowListingIpAddressDocument = gql`
    mutation CreateIpAllowListingIpAddress($input: CreateIpAllowListingIpAddressInput!) {
  createIpAllowListingIpAddress(input: $input)
}
    `;
export type CreateIpAllowListingIpAddressMutationFn = Apollo.MutationFunction<CreateIpAllowListingIpAddressMutation, CreateIpAllowListingIpAddressMutationVariables>;

/**
 * __useCreateIpAllowListingIpAddressMutation__
 *
 * To run a mutation, you first call `useCreateIpAllowListingIpAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIpAllowListingIpAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIpAllowListingIpAddressMutation, { data, loading, error }] = useCreateIpAllowListingIpAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIpAllowListingIpAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateIpAllowListingIpAddressMutation, CreateIpAllowListingIpAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIpAllowListingIpAddressMutation, CreateIpAllowListingIpAddressMutationVariables>(CreateIpAllowListingIpAddressDocument, options);
      }
export type CreateIpAllowListingIpAddressMutationHookResult = ReturnType<typeof useCreateIpAllowListingIpAddressMutation>;
export type CreateIpAllowListingIpAddressMutationResult = Apollo.MutationResult<CreateIpAllowListingIpAddressMutation>;
export type CreateIpAllowListingIpAddressMutationOptions = Apollo.BaseMutationOptions<CreateIpAllowListingIpAddressMutation, CreateIpAllowListingIpAddressMutationVariables>;
export const IpAllowListingIpAddressesDocument = gql`
    query IpAllowListingIpAddresses {
  ipAllowListingIpAddresses {
    ...IpAllowListingIpAddressInfo
  }
}
    ${IpAllowListingIpAddressInfoFragmentDoc}`;

/**
 * __useIpAllowListingIpAddressesQuery__
 *
 * To run a query within a React component, call `useIpAllowListingIpAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIpAllowListingIpAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIpAllowListingIpAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIpAllowListingIpAddressesQuery(baseOptions?: Apollo.QueryHookOptions<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>(IpAllowListingIpAddressesDocument, options);
      }
export function useIpAllowListingIpAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>(IpAllowListingIpAddressesDocument, options);
        }
export function useIpAllowListingIpAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>(IpAllowListingIpAddressesDocument, options);
        }
export type IpAllowListingIpAddressesQueryHookResult = ReturnType<typeof useIpAllowListingIpAddressesQuery>;
export type IpAllowListingIpAddressesLazyQueryHookResult = ReturnType<typeof useIpAllowListingIpAddressesLazyQuery>;
export type IpAllowListingIpAddressesSuspenseQueryHookResult = ReturnType<typeof useIpAllowListingIpAddressesSuspenseQuery>;
export type IpAllowListingIpAddressesQueryResult = Apollo.QueryResult<IpAllowListingIpAddressesQuery, IpAllowListingIpAddressesQueryVariables>;
export const IpAllowListingSettingDocument = gql`
    query IpAllowListingSetting {
  ipAllowListingSetting {
    enabled
  }
}
    `;

/**
 * __useIpAllowListingSettingQuery__
 *
 * To run a query within a React component, call `useIpAllowListingSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIpAllowListingSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIpAllowListingSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useIpAllowListingSettingQuery(baseOptions?: Apollo.QueryHookOptions<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>(IpAllowListingSettingDocument, options);
      }
export function useIpAllowListingSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>(IpAllowListingSettingDocument, options);
        }
export function useIpAllowListingSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>(IpAllowListingSettingDocument, options);
        }
export type IpAllowListingSettingQueryHookResult = ReturnType<typeof useIpAllowListingSettingQuery>;
export type IpAllowListingSettingLazyQueryHookResult = ReturnType<typeof useIpAllowListingSettingLazyQuery>;
export type IpAllowListingSettingSuspenseQueryHookResult = ReturnType<typeof useIpAllowListingSettingSuspenseQuery>;
export type IpAllowListingSettingQueryResult = Apollo.QueryResult<IpAllowListingSettingQuery, IpAllowListingSettingQueryVariables>;
export const RemoveIpAllowListingIpAddressDocument = gql`
    mutation RemoveIpAllowListingIpAddress($id: ID!) {
  removeIpAllowListingIpAddress(id: $id)
}
    `;
export type RemoveIpAllowListingIpAddressMutationFn = Apollo.MutationFunction<RemoveIpAllowListingIpAddressMutation, RemoveIpAllowListingIpAddressMutationVariables>;

/**
 * __useRemoveIpAllowListingIpAddressMutation__
 *
 * To run a mutation, you first call `useRemoveIpAllowListingIpAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIpAllowListingIpAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIpAllowListingIpAddressMutation, { data, loading, error }] = useRemoveIpAllowListingIpAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveIpAllowListingIpAddressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIpAllowListingIpAddressMutation, RemoveIpAllowListingIpAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIpAllowListingIpAddressMutation, RemoveIpAllowListingIpAddressMutationVariables>(RemoveIpAllowListingIpAddressDocument, options);
      }
export type RemoveIpAllowListingIpAddressMutationHookResult = ReturnType<typeof useRemoveIpAllowListingIpAddressMutation>;
export type RemoveIpAllowListingIpAddressMutationResult = Apollo.MutationResult<RemoveIpAllowListingIpAddressMutation>;
export type RemoveIpAllowListingIpAddressMutationOptions = Apollo.BaseMutationOptions<RemoveIpAllowListingIpAddressMutation, RemoveIpAllowListingIpAddressMutationVariables>;
export const SetIpAllowListingSettingDocument = gql`
    mutation SetIpAllowListingSetting($enabled: Boolean!) {
  setIpAllowListingSetting(enabled: $enabled)
}
    `;
export type SetIpAllowListingSettingMutationFn = Apollo.MutationFunction<SetIpAllowListingSettingMutation, SetIpAllowListingSettingMutationVariables>;

/**
 * __useSetIpAllowListingSettingMutation__
 *
 * To run a mutation, you first call `useSetIpAllowListingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIpAllowListingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIpAllowListingSettingMutation, { data, loading, error }] = useSetIpAllowListingSettingMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetIpAllowListingSettingMutation(baseOptions?: Apollo.MutationHookOptions<SetIpAllowListingSettingMutation, SetIpAllowListingSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIpAllowListingSettingMutation, SetIpAllowListingSettingMutationVariables>(SetIpAllowListingSettingDocument, options);
      }
export type SetIpAllowListingSettingMutationHookResult = ReturnType<typeof useSetIpAllowListingSettingMutation>;
export type SetIpAllowListingSettingMutationResult = Apollo.MutationResult<SetIpAllowListingSettingMutation>;
export type SetIpAllowListingSettingMutationOptions = Apollo.BaseMutationOptions<SetIpAllowListingSettingMutation, SetIpAllowListingSettingMutationVariables>;
export const MerchantChargebackDocument = gql`
    query MerchantChargeback($id: ID!) {
  merchantChargeback(id: $id) {
    ...MerchantChargebackInfo
  }
}
    ${MerchantChargebackInfoFragmentDoc}`;

/**
 * __useMerchantChargebackQuery__
 *
 * To run a query within a React component, call `useMerchantChargebackQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantChargebackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantChargebackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantChargebackQuery(baseOptions: Apollo.QueryHookOptions<MerchantChargebackQuery, MerchantChargebackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantChargebackQuery, MerchantChargebackQueryVariables>(MerchantChargebackDocument, options);
      }
export function useMerchantChargebackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantChargebackQuery, MerchantChargebackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantChargebackQuery, MerchantChargebackQueryVariables>(MerchantChargebackDocument, options);
        }
export function useMerchantChargebackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantChargebackQuery, MerchantChargebackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantChargebackQuery, MerchantChargebackQueryVariables>(MerchantChargebackDocument, options);
        }
export type MerchantChargebackQueryHookResult = ReturnType<typeof useMerchantChargebackQuery>;
export type MerchantChargebackLazyQueryHookResult = ReturnType<typeof useMerchantChargebackLazyQuery>;
export type MerchantChargebackSuspenseQueryHookResult = ReturnType<typeof useMerchantChargebackSuspenseQuery>;
export type MerchantChargebackQueryResult = Apollo.QueryResult<MerchantChargebackQuery, MerchantChargebackQueryVariables>;
export const MerchantChargebacksDocument = gql`
    query MerchantChargebacks($page: PaginationInput, $category: ChargebackCategory) {
  merchantChargebacks(page: $page, category: $category) {
    ...PaginationInfo
    ...MerchantChargebacksInfo
  }
}
    ${PaginationInfoFragmentDoc}
${MerchantChargebacksInfoFragmentDoc}`;

/**
 * __useMerchantChargebacksQuery__
 *
 * To run a query within a React component, call `useMerchantChargebacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantChargebacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantChargebacksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useMerchantChargebacksQuery(baseOptions?: Apollo.QueryHookOptions<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>(MerchantChargebacksDocument, options);
      }
export function useMerchantChargebacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>(MerchantChargebacksDocument, options);
        }
export function useMerchantChargebacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>(MerchantChargebacksDocument, options);
        }
export type MerchantChargebacksQueryHookResult = ReturnType<typeof useMerchantChargebacksQuery>;
export type MerchantChargebacksLazyQueryHookResult = ReturnType<typeof useMerchantChargebacksLazyQuery>;
export type MerchantChargebacksSuspenseQueryHookResult = ReturnType<typeof useMerchantChargebacksSuspenseQuery>;
export type MerchantChargebacksQueryResult = Apollo.QueryResult<MerchantChargebacksQuery, MerchantChargebacksQueryVariables>;
export const AddMerchantCreditCardDocument = gql`
    mutation AddMerchantCreditCard($merchantCreditCardInput: MerchantCreditCardInput!) {
  addMerchantCreditCard(merchantCreditCardInput: $merchantCreditCardInput) {
    ...MerchantCreditCardInfo
  }
}
    ${MerchantCreditCardInfoFragmentDoc}`;
export type AddMerchantCreditCardMutationFn = Apollo.MutationFunction<AddMerchantCreditCardMutation, AddMerchantCreditCardMutationVariables>;

/**
 * __useAddMerchantCreditCardMutation__
 *
 * To run a mutation, you first call `useAddMerchantCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMerchantCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMerchantCreditCardMutation, { data, loading, error }] = useAddMerchantCreditCardMutation({
 *   variables: {
 *      merchantCreditCardInput: // value for 'merchantCreditCardInput'
 *   },
 * });
 */
export function useAddMerchantCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<AddMerchantCreditCardMutation, AddMerchantCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMerchantCreditCardMutation, AddMerchantCreditCardMutationVariables>(AddMerchantCreditCardDocument, options);
      }
export type AddMerchantCreditCardMutationHookResult = ReturnType<typeof useAddMerchantCreditCardMutation>;
export type AddMerchantCreditCardMutationResult = Apollo.MutationResult<AddMerchantCreditCardMutation>;
export type AddMerchantCreditCardMutationOptions = Apollo.BaseMutationOptions<AddMerchantCreditCardMutation, AddMerchantCreditCardMutationVariables>;
export const RemoveMerchantCreditCardDocument = gql`
    mutation RemoveMerchantCreditCard($id: String!) {
  removeMerchantCreditCard(id: $id) {
    id
  }
}
    `;
export type RemoveMerchantCreditCardMutationFn = Apollo.MutationFunction<RemoveMerchantCreditCardMutation, RemoveMerchantCreditCardMutationVariables>;

/**
 * __useRemoveMerchantCreditCardMutation__
 *
 * To run a mutation, you first call `useRemoveMerchantCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMerchantCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMerchantCreditCardMutation, { data, loading, error }] = useRemoveMerchantCreditCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMerchantCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMerchantCreditCardMutation, RemoveMerchantCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMerchantCreditCardMutation, RemoveMerchantCreditCardMutationVariables>(RemoveMerchantCreditCardDocument, options);
      }
export type RemoveMerchantCreditCardMutationHookResult = ReturnType<typeof useRemoveMerchantCreditCardMutation>;
export type RemoveMerchantCreditCardMutationResult = Apollo.MutationResult<RemoveMerchantCreditCardMutation>;
export type RemoveMerchantCreditCardMutationOptions = Apollo.BaseMutationOptions<RemoveMerchantCreditCardMutation, RemoveMerchantCreditCardMutationVariables>;
export const SetMerchantCreditCardDocument = gql`
    mutation SetMerchantCreditCard($setMerchantCreditCardInput: SetMerchantCreditCardInput!) {
  setMerchantCreditCard(setMerchantCreditCardInput: $setMerchantCreditCardInput) {
    ...MerchantCreditCardInfo
  }
}
    ${MerchantCreditCardInfoFragmentDoc}`;
export type SetMerchantCreditCardMutationFn = Apollo.MutationFunction<SetMerchantCreditCardMutation, SetMerchantCreditCardMutationVariables>;

/**
 * __useSetMerchantCreditCardMutation__
 *
 * To run a mutation, you first call `useSetMerchantCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMerchantCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMerchantCreditCardMutation, { data, loading, error }] = useSetMerchantCreditCardMutation({
 *   variables: {
 *      setMerchantCreditCardInput: // value for 'setMerchantCreditCardInput'
 *   },
 * });
 */
export function useSetMerchantCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<SetMerchantCreditCardMutation, SetMerchantCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMerchantCreditCardMutation, SetMerchantCreditCardMutationVariables>(SetMerchantCreditCardDocument, options);
      }
export type SetMerchantCreditCardMutationHookResult = ReturnType<typeof useSetMerchantCreditCardMutation>;
export type SetMerchantCreditCardMutationResult = Apollo.MutationResult<SetMerchantCreditCardMutation>;
export type SetMerchantCreditCardMutationOptions = Apollo.BaseMutationOptions<SetMerchantCreditCardMutation, SetMerchantCreditCardMutationVariables>;
export const MerchantPaymentDocument = gql`
    query MerchantPayment($id: ID!) {
  merchantPayment(id: $id) {
    ...MerchantPaymentInfo
  }
}
    ${MerchantPaymentInfoFragmentDoc}`;

/**
 * __useMerchantPaymentQuery__
 *
 * To run a query within a React component, call `useMerchantPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantPaymentQuery(baseOptions: Apollo.QueryHookOptions<MerchantPaymentQuery, MerchantPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPaymentQuery, MerchantPaymentQueryVariables>(MerchantPaymentDocument, options);
      }
export function useMerchantPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPaymentQuery, MerchantPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPaymentQuery, MerchantPaymentQueryVariables>(MerchantPaymentDocument, options);
        }
export function useMerchantPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPaymentQuery, MerchantPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPaymentQuery, MerchantPaymentQueryVariables>(MerchantPaymentDocument, options);
        }
export type MerchantPaymentQueryHookResult = ReturnType<typeof useMerchantPaymentQuery>;
export type MerchantPaymentLazyQueryHookResult = ReturnType<typeof useMerchantPaymentLazyQuery>;
export type MerchantPaymentSuspenseQueryHookResult = ReturnType<typeof useMerchantPaymentSuspenseQuery>;
export type MerchantPaymentQueryResult = Apollo.QueryResult<MerchantPaymentQuery, MerchantPaymentQueryVariables>;
export const MerchantPaymentCancellationDocument = gql`
    mutation MerchantPaymentCancellation($input: MerchantPaymentCancellationInput!) {
  merchantPaymentCancellation(input: $input) {
    ...MerchantPaymentInfo
  }
}
    ${MerchantPaymentInfoFragmentDoc}`;
export type MerchantPaymentCancellationMutationFn = Apollo.MutationFunction<MerchantPaymentCancellationMutation, MerchantPaymentCancellationMutationVariables>;

/**
 * __useMerchantPaymentCancellationMutation__
 *
 * To run a mutation, you first call `useMerchantPaymentCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantPaymentCancellationMutation, { data, loading, error }] = useMerchantPaymentCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantPaymentCancellationMutation(baseOptions?: Apollo.MutationHookOptions<MerchantPaymentCancellationMutation, MerchantPaymentCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantPaymentCancellationMutation, MerchantPaymentCancellationMutationVariables>(MerchantPaymentCancellationDocument, options);
      }
export type MerchantPaymentCancellationMutationHookResult = ReturnType<typeof useMerchantPaymentCancellationMutation>;
export type MerchantPaymentCancellationMutationResult = Apollo.MutationResult<MerchantPaymentCancellationMutation>;
export type MerchantPaymentCancellationMutationOptions = Apollo.BaseMutationOptions<MerchantPaymentCancellationMutation, MerchantPaymentCancellationMutationVariables>;
export const MerchantPaymentRefundDocument = gql`
    mutation MerchantPaymentRefund($input: MerchantPaymentRefundInput!) {
  merchantPaymentRefund(input: $input) {
    ...MerchantPaymentInfo
  }
}
    ${MerchantPaymentInfoFragmentDoc}`;
export type MerchantPaymentRefundMutationFn = Apollo.MutationFunction<MerchantPaymentRefundMutation, MerchantPaymentRefundMutationVariables>;

/**
 * __useMerchantPaymentRefundMutation__
 *
 * To run a mutation, you first call `useMerchantPaymentRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantPaymentRefundMutation, { data, loading, error }] = useMerchantPaymentRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantPaymentRefundMutation(baseOptions?: Apollo.MutationHookOptions<MerchantPaymentRefundMutation, MerchantPaymentRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantPaymentRefundMutation, MerchantPaymentRefundMutationVariables>(MerchantPaymentRefundDocument, options);
      }
export type MerchantPaymentRefundMutationHookResult = ReturnType<typeof useMerchantPaymentRefundMutation>;
export type MerchantPaymentRefundMutationResult = Apollo.MutationResult<MerchantPaymentRefundMutation>;
export type MerchantPaymentRefundMutationOptions = Apollo.BaseMutationOptions<MerchantPaymentRefundMutation, MerchantPaymentRefundMutationVariables>;
export const MerchantPaymentsDocument = gql`
    query MerchantPayments($page: PaginationInput, $filter: MerchantPaymentFilterInput) {
  merchantPayments(page: $page, filter: $filter) {
    ...PaginationInfo
    ...MerchantPaymentsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${MerchantPaymentsInfoFragmentDoc}`;

/**
 * __useMerchantPaymentsQuery__
 *
 * To run a query within a React component, call `useMerchantPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPaymentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMerchantPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>(MerchantPaymentsDocument, options);
      }
export function useMerchantPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>(MerchantPaymentsDocument, options);
        }
export function useMerchantPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>(MerchantPaymentsDocument, options);
        }
export type MerchantPaymentsQueryHookResult = ReturnType<typeof useMerchantPaymentsQuery>;
export type MerchantPaymentsLazyQueryHookResult = ReturnType<typeof useMerchantPaymentsLazyQuery>;
export type MerchantPaymentsSuspenseQueryHookResult = ReturnType<typeof useMerchantPaymentsSuspenseQuery>;
export type MerchantPaymentsQueryResult = Apollo.QueryResult<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>;
export const MerchantPaymentIntentDocument = gql`
    query MerchantPaymentIntent($id: ID!) {
  merchantPaymentIntent(id: $id) {
    ...MerchantPaymentIntentInfo
  }
}
    ${MerchantPaymentIntentInfoFragmentDoc}`;

/**
 * __useMerchantPaymentIntentQuery__
 *
 * To run a query within a React component, call `useMerchantPaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPaymentIntentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantPaymentIntentQuery(baseOptions: Apollo.QueryHookOptions<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>(MerchantPaymentIntentDocument, options);
      }
export function useMerchantPaymentIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>(MerchantPaymentIntentDocument, options);
        }
export function useMerchantPaymentIntentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>(MerchantPaymentIntentDocument, options);
        }
export type MerchantPaymentIntentQueryHookResult = ReturnType<typeof useMerchantPaymentIntentQuery>;
export type MerchantPaymentIntentLazyQueryHookResult = ReturnType<typeof useMerchantPaymentIntentLazyQuery>;
export type MerchantPaymentIntentSuspenseQueryHookResult = ReturnType<typeof useMerchantPaymentIntentSuspenseQuery>;
export type MerchantPaymentIntentQueryResult = Apollo.QueryResult<MerchantPaymentIntentQuery, MerchantPaymentIntentQueryVariables>;
export const MerchantPaymentIntentRefundDocument = gql`
    mutation MerchantPaymentIntentRefund($input: MerchantPaymentIntentRefundInput!) {
  merchantPaymentIntentRefund(input: $input) {
    ...MerchantPaymentInfo
  }
}
    ${MerchantPaymentInfoFragmentDoc}`;
export type MerchantPaymentIntentRefundMutationFn = Apollo.MutationFunction<MerchantPaymentIntentRefundMutation, MerchantPaymentIntentRefundMutationVariables>;

/**
 * __useMerchantPaymentIntentRefundMutation__
 *
 * To run a mutation, you first call `useMerchantPaymentIntentRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentIntentRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantPaymentIntentRefundMutation, { data, loading, error }] = useMerchantPaymentIntentRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantPaymentIntentRefundMutation(baseOptions?: Apollo.MutationHookOptions<MerchantPaymentIntentRefundMutation, MerchantPaymentIntentRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchantPaymentIntentRefundMutation, MerchantPaymentIntentRefundMutationVariables>(MerchantPaymentIntentRefundDocument, options);
      }
export type MerchantPaymentIntentRefundMutationHookResult = ReturnType<typeof useMerchantPaymentIntentRefundMutation>;
export type MerchantPaymentIntentRefundMutationResult = Apollo.MutationResult<MerchantPaymentIntentRefundMutation>;
export type MerchantPaymentIntentRefundMutationOptions = Apollo.BaseMutationOptions<MerchantPaymentIntentRefundMutation, MerchantPaymentIntentRefundMutationVariables>;
export const MerchantPaymentIntentsDocument = gql`
    query MerchantPaymentIntents($page: PaginationInput, $filter: MerchantPaymentIntentsFilterInput) {
  merchantPaymentIntents(page: $page, filter: $filter) {
    ...PaginationInfo
    ...MerchantPaymentIntentsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${MerchantPaymentIntentsInfoFragmentDoc}`;

/**
 * __useMerchantPaymentIntentsQuery__
 *
 * To run a query within a React component, call `useMerchantPaymentIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPaymentIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPaymentIntentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMerchantPaymentIntentsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>(MerchantPaymentIntentsDocument, options);
      }
export function useMerchantPaymentIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>(MerchantPaymentIntentsDocument, options);
        }
export function useMerchantPaymentIntentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>(MerchantPaymentIntentsDocument, options);
        }
export type MerchantPaymentIntentsQueryHookResult = ReturnType<typeof useMerchantPaymentIntentsQuery>;
export type MerchantPaymentIntentsLazyQueryHookResult = ReturnType<typeof useMerchantPaymentIntentsLazyQuery>;
export type MerchantPaymentIntentsSuspenseQueryHookResult = ReturnType<typeof useMerchantPaymentIntentsSuspenseQuery>;
export type MerchantPaymentIntentsQueryResult = Apollo.QueryResult<MerchantPaymentIntentsQuery, MerchantPaymentIntentsQueryVariables>;
export const MerchantPayoutDocument = gql`
    query MerchantPayout($id: ID!) {
  merchantPayout(id: $id) {
    ...MerchantPayoutInfo
    externalRef
  }
}
    ${MerchantPayoutInfoFragmentDoc}`;

/**
 * __useMerchantPayoutQuery__
 *
 * To run a query within a React component, call `useMerchantPayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantPayoutQuery(baseOptions: Apollo.QueryHookOptions<MerchantPayoutQuery, MerchantPayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPayoutQuery, MerchantPayoutQueryVariables>(MerchantPayoutDocument, options);
      }
export function useMerchantPayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPayoutQuery, MerchantPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPayoutQuery, MerchantPayoutQueryVariables>(MerchantPayoutDocument, options);
        }
export function useMerchantPayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPayoutQuery, MerchantPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPayoutQuery, MerchantPayoutQueryVariables>(MerchantPayoutDocument, options);
        }
export type MerchantPayoutQueryHookResult = ReturnType<typeof useMerchantPayoutQuery>;
export type MerchantPayoutLazyQueryHookResult = ReturnType<typeof useMerchantPayoutLazyQuery>;
export type MerchantPayoutSuspenseQueryHookResult = ReturnType<typeof useMerchantPayoutSuspenseQuery>;
export type MerchantPayoutQueryResult = Apollo.QueryResult<MerchantPayoutQuery, MerchantPayoutQueryVariables>;
export const MerchantPayoutsDocument = gql`
    query MerchantPayouts($page: PaginationInput, $status: MerchantPayoutStatus, $destination: MerchantPayoutType) {
  merchantPayouts(page: $page, status: $status, destination: $destination) {
    ...PaginationInfo
    ...MerchantPayoutsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${MerchantPayoutsInfoFragmentDoc}`;

/**
 * __useMerchantPayoutsQuery__
 *
 * To run a query within a React component, call `useMerchantPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantPayoutsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      status: // value for 'status'
 *      destination: // value for 'destination'
 *   },
 * });
 */
export function useMerchantPayoutsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>(MerchantPayoutsDocument, options);
      }
export function useMerchantPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>(MerchantPayoutsDocument, options);
        }
export function useMerchantPayoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>(MerchantPayoutsDocument, options);
        }
export type MerchantPayoutsQueryHookResult = ReturnType<typeof useMerchantPayoutsQuery>;
export type MerchantPayoutsLazyQueryHookResult = ReturnType<typeof useMerchantPayoutsLazyQuery>;
export type MerchantPayoutsSuspenseQueryHookResult = ReturnType<typeof useMerchantPayoutsSuspenseQuery>;
export type MerchantPayoutsQueryResult = Apollo.QueryResult<MerchantPayoutsQuery, MerchantPayoutsQueryVariables>;
export const MerchantWireBankAccountDocument = gql`
    query MerchantWireBankAccount($accountId: String!) {
  merchantWireBankAccount(accountId: $accountId) {
    ...MerchantWireBankAccountInfo
  }
}
    ${MerchantWireBankAccountInfoFragmentDoc}`;

/**
 * __useMerchantWireBankAccountQuery__
 *
 * To run a query within a React component, call `useMerchantWireBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantWireBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantWireBankAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMerchantWireBankAccountQuery(baseOptions: Apollo.QueryHookOptions<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>(MerchantWireBankAccountDocument, options);
      }
export function useMerchantWireBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>(MerchantWireBankAccountDocument, options);
        }
export function useMerchantWireBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>(MerchantWireBankAccountDocument, options);
        }
export type MerchantWireBankAccountQueryHookResult = ReturnType<typeof useMerchantWireBankAccountQuery>;
export type MerchantWireBankAccountLazyQueryHookResult = ReturnType<typeof useMerchantWireBankAccountLazyQuery>;
export type MerchantWireBankAccountSuspenseQueryHookResult = ReturnType<typeof useMerchantWireBankAccountSuspenseQuery>;
export type MerchantWireBankAccountQueryResult = Apollo.QueryResult<MerchantWireBankAccountQuery, MerchantWireBankAccountQueryVariables>;
export const MockStepUpDocument = gql`
    mutation MockStepUp {
  mockStepUp
}
    `;
export type MockStepUpMutationFn = Apollo.MutationFunction<MockStepUpMutation, MockStepUpMutationVariables>;

/**
 * __useMockStepUpMutation__
 *
 * To run a mutation, you first call `useMockStepUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMockStepUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mockStepUpMutation, { data, loading, error }] = useMockStepUpMutation({
 *   variables: {
 *   },
 * });
 */
export function useMockStepUpMutation(baseOptions?: Apollo.MutationHookOptions<MockStepUpMutation, MockStepUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MockStepUpMutation, MockStepUpMutationVariables>(MockStepUpDocument, options);
      }
export type MockStepUpMutationHookResult = ReturnType<typeof useMockStepUpMutation>;
export type MockStepUpMutationResult = Apollo.MutationResult<MockStepUpMutation>;
export type MockStepUpMutationOptions = Apollo.BaseMutationOptions<MockStepUpMutation, MockStepUpMutationVariables>;
export const CreateNotificationSubscriptionDocument = gql`
    mutation CreateNotificationSubscription($input: CreateNotificationSubscriptionInput!) {
  createNotificationSubscription(input: $input) {
    ...NotificationSubscriptionInfo
  }
}
    ${NotificationSubscriptionInfoFragmentDoc}`;
export type CreateNotificationSubscriptionMutationFn = Apollo.MutationFunction<CreateNotificationSubscriptionMutation, CreateNotificationSubscriptionMutationVariables>;

/**
 * __useCreateNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationSubscriptionMutation, { data, loading, error }] = useCreateNotificationSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationSubscriptionMutation, CreateNotificationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationSubscriptionMutation, CreateNotificationSubscriptionMutationVariables>(CreateNotificationSubscriptionDocument, options);
      }
export type CreateNotificationSubscriptionMutationHookResult = ReturnType<typeof useCreateNotificationSubscriptionMutation>;
export type CreateNotificationSubscriptionMutationResult = Apollo.MutationResult<CreateNotificationSubscriptionMutation>;
export type CreateNotificationSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateNotificationSubscriptionMutation, CreateNotificationSubscriptionMutationVariables>;
export const DeleteNotificationSubscriptionDocument = gql`
    mutation DeleteNotificationSubscription($id: ID!) {
  deleteNotificationSubscription(id: $id)
}
    `;
export type DeleteNotificationSubscriptionMutationFn = Apollo.MutationFunction<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>;

/**
 * __useDeleteNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationSubscriptionMutation, { data, loading, error }] = useDeleteNotificationSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>(DeleteNotificationSubscriptionDocument, options);
      }
export type DeleteNotificationSubscriptionMutationHookResult = ReturnType<typeof useDeleteNotificationSubscriptionMutation>;
export type DeleteNotificationSubscriptionMutationResult = Apollo.MutationResult<DeleteNotificationSubscriptionMutation>;
export type DeleteNotificationSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>;
export const NotificationSubscriptionsDocument = gql`
    query NotificationSubscriptions {
  notificationSubscriptions {
    ...NotificationSubscriptionInfo
  }
}
    ${NotificationSubscriptionInfoFragmentDoc}`;

/**
 * __useNotificationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useNotificationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>(NotificationSubscriptionsDocument, options);
      }
export function useNotificationSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>(NotificationSubscriptionsDocument, options);
        }
export function useNotificationSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>(NotificationSubscriptionsDocument, options);
        }
export type NotificationSubscriptionsQueryHookResult = ReturnType<typeof useNotificationSubscriptionsQuery>;
export type NotificationSubscriptionsLazyQueryHookResult = ReturnType<typeof useNotificationSubscriptionsLazyQuery>;
export type NotificationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useNotificationSubscriptionsSuspenseQuery>;
export type NotificationSubscriptionsQueryResult = Apollo.QueryResult<NotificationSubscriptionsQuery, NotificationSubscriptionsQueryVariables>;
export const AccountSetupInfoDocument = gql`
    query AccountSetupInfo {
  accountSetupInfo {
    hasConfirmedDetails
    hasCompletedAllVerifications
    isNonAuthorizedRep
    isOnboardingInitiator
    isRolrUser
    isCOPBusinessOnboardingInProgress
  }
}
    `;

/**
 * __useAccountSetupInfoQuery__
 *
 * To run a query within a React component, call `useAccountSetupInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSetupInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSetupInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSetupInfoQuery(baseOptions?: Apollo.QueryHookOptions<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>(AccountSetupInfoDocument, options);
      }
export function useAccountSetupInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>(AccountSetupInfoDocument, options);
        }
export function useAccountSetupInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>(AccountSetupInfoDocument, options);
        }
export type AccountSetupInfoQueryHookResult = ReturnType<typeof useAccountSetupInfoQuery>;
export type AccountSetupInfoLazyQueryHookResult = ReturnType<typeof useAccountSetupInfoLazyQuery>;
export type AccountSetupInfoSuspenseQueryHookResult = ReturnType<typeof useAccountSetupInfoSuspenseQuery>;
export type AccountSetupInfoQueryResult = Apollo.QueryResult<AccountSetupInfoQuery, AccountSetupInfoQueryVariables>;
export const CompleteInviteDocument = gql`
    mutation CompleteInvite($input: CompleteInviteInput!) {
  completeInvite(input: $input) {
    sessionToken
  }
}
    `;
export type CompleteInviteMutationFn = Apollo.MutationFunction<CompleteInviteMutation, CompleteInviteMutationVariables>;

/**
 * __useCompleteInviteMutation__
 *
 * To run a mutation, you first call `useCompleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeInviteMutation, { data, loading, error }] = useCompleteInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteInviteMutation(baseOptions?: Apollo.MutationHookOptions<CompleteInviteMutation, CompleteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteInviteMutation, CompleteInviteMutationVariables>(CompleteInviteDocument, options);
      }
export type CompleteInviteMutationHookResult = ReturnType<typeof useCompleteInviteMutation>;
export type CompleteInviteMutationResult = Apollo.MutationResult<CompleteInviteMutation>;
export type CompleteInviteMutationOptions = Apollo.BaseMutationOptions<CompleteInviteMutation, CompleteInviteMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    sessionToken
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateRolrAccountDocument = gql`
    mutation CreateRolrAccount($input: CreateRolrAccountInput!) {
  createRolrAccount(input: $input) {
    sessionToken
  }
}
    `;
export type CreateRolrAccountMutationFn = Apollo.MutationFunction<CreateRolrAccountMutation, CreateRolrAccountMutationVariables>;

/**
 * __useCreateRolrAccountMutation__
 *
 * To run a mutation, you first call `useCreateRolrAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRolrAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRolrAccountMutation, { data, loading, error }] = useCreateRolrAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRolrAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateRolrAccountMutation, CreateRolrAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRolrAccountMutation, CreateRolrAccountMutationVariables>(CreateRolrAccountDocument, options);
      }
export type CreateRolrAccountMutationHookResult = ReturnType<typeof useCreateRolrAccountMutation>;
export type CreateRolrAccountMutationResult = Apollo.MutationResult<CreateRolrAccountMutation>;
export type CreateRolrAccountMutationOptions = Apollo.BaseMutationOptions<CreateRolrAccountMutation, CreateRolrAccountMutationVariables>;
export const PreQualificationDataDocument = gql`
    query preQualificationData {
  preQualificationData {
    state
    businessEntityName
    businessCountry
    businessState
    businessWebsite
    entityType
    natureOfBusiness
    expectedUsdcMintingVolume
    activeUsersOnPlatform
    usdcRedemptionAmount
    eurcRedemptionAmount
  }
}
    `;

/**
 * __usePreQualificationDataQuery__
 *
 * To run a query within a React component, call `usePreQualificationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreQualificationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreQualificationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreQualificationDataQuery(baseOptions?: Apollo.QueryHookOptions<PreQualificationDataQuery, PreQualificationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreQualificationDataQuery, PreQualificationDataQueryVariables>(PreQualificationDataDocument, options);
      }
export function usePreQualificationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreQualificationDataQuery, PreQualificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreQualificationDataQuery, PreQualificationDataQueryVariables>(PreQualificationDataDocument, options);
        }
export function usePreQualificationDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreQualificationDataQuery, PreQualificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreQualificationDataQuery, PreQualificationDataQueryVariables>(PreQualificationDataDocument, options);
        }
export type PreQualificationDataQueryHookResult = ReturnType<typeof usePreQualificationDataQuery>;
export type PreQualificationDataLazyQueryHookResult = ReturnType<typeof usePreQualificationDataLazyQuery>;
export type PreQualificationDataSuspenseQueryHookResult = ReturnType<typeof usePreQualificationDataSuspenseQuery>;
export type PreQualificationDataQueryResult = Apollo.QueryResult<PreQualificationDataQuery, PreQualificationDataQueryVariables>;
export const SetProductInterestsDocument = gql`
    mutation SetProductInterests($input: SetProductInterestsInput!) {
  setProductInterests(input: $input)
}
    `;
export type SetProductInterestsMutationFn = Apollo.MutationFunction<SetProductInterestsMutation, SetProductInterestsMutationVariables>;

/**
 * __useSetProductInterestsMutation__
 *
 * To run a mutation, you first call `useSetProductInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductInterestsMutation, { data, loading, error }] = useSetProductInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProductInterestsMutation(baseOptions?: Apollo.MutationHookOptions<SetProductInterestsMutation, SetProductInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProductInterestsMutation, SetProductInterestsMutationVariables>(SetProductInterestsDocument, options);
      }
export type SetProductInterestsMutationHookResult = ReturnType<typeof useSetProductInterestsMutation>;
export type SetProductInterestsMutationResult = Apollo.MutationResult<SetProductInterestsMutation>;
export type SetProductInterestsMutationOptions = Apollo.BaseMutationOptions<SetProductInterestsMutation, SetProductInterestsMutationVariables>;
export const UpdateOnboardingDataDocument = gql`
    mutation UpdateOnboardingData($input: UpdateOnboardingDataInput!) {
  updateOnboardingData(input: $input)
}
    `;
export type UpdateOnboardingDataMutationFn = Apollo.MutationFunction<UpdateOnboardingDataMutation, UpdateOnboardingDataMutationVariables>;

/**
 * __useUpdateOnboardingDataMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingDataMutation, { data, loading, error }] = useUpdateOnboardingDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOnboardingDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingDataMutation, UpdateOnboardingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnboardingDataMutation, UpdateOnboardingDataMutationVariables>(UpdateOnboardingDataDocument, options);
      }
export type UpdateOnboardingDataMutationHookResult = ReturnType<typeof useUpdateOnboardingDataMutation>;
export type UpdateOnboardingDataMutationResult = Apollo.MutationResult<UpdateOnboardingDataMutation>;
export type UpdateOnboardingDataMutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingDataMutation, UpdateOnboardingDataMutationVariables>;
export const OnboardingApplicationDocument = gql`
    query OnboardingApplication {
  onboardingApplication {
    ...OnboardingApplicationInfo
  }
}
    ${OnboardingApplicationInfoFragmentDoc}`;

/**
 * __useOnboardingApplicationQuery__
 *
 * To run a query within a React component, call `useOnboardingApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingApplicationQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>(OnboardingApplicationDocument, options);
      }
export function useOnboardingApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>(OnboardingApplicationDocument, options);
        }
export function useOnboardingApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>(OnboardingApplicationDocument, options);
        }
export type OnboardingApplicationQueryHookResult = ReturnType<typeof useOnboardingApplicationQuery>;
export type OnboardingApplicationLazyQueryHookResult = ReturnType<typeof useOnboardingApplicationLazyQuery>;
export type OnboardingApplicationSuspenseQueryHookResult = ReturnType<typeof useOnboardingApplicationSuspenseQuery>;
export type OnboardingApplicationQueryResult = Apollo.QueryResult<OnboardingApplicationQuery, OnboardingApplicationQueryVariables>;
export const OnboardingCertificationsDocument = gql`
    query OnboardingCertifications($onboardingId: ID!) {
  onboardingCertifications(onboardingId: $onboardingId) {
    ...OnboardingCertificationInfo
  }
}
    ${OnboardingCertificationInfoFragmentDoc}`;

/**
 * __useOnboardingCertificationsQuery__
 *
 * To run a query within a React component, call `useOnboardingCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingCertificationsQuery({
 *   variables: {
 *      onboardingId: // value for 'onboardingId'
 *   },
 * });
 */
export function useOnboardingCertificationsQuery(baseOptions: Apollo.QueryHookOptions<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>(OnboardingCertificationsDocument, options);
      }
export function useOnboardingCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>(OnboardingCertificationsDocument, options);
        }
export function useOnboardingCertificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>(OnboardingCertificationsDocument, options);
        }
export type OnboardingCertificationsQueryHookResult = ReturnType<typeof useOnboardingCertificationsQuery>;
export type OnboardingCertificationsLazyQueryHookResult = ReturnType<typeof useOnboardingCertificationsLazyQuery>;
export type OnboardingCertificationsSuspenseQueryHookResult = ReturnType<typeof useOnboardingCertificationsSuspenseQuery>;
export type OnboardingCertificationsQueryResult = Apollo.QueryResult<OnboardingCertificationsQuery, OnboardingCertificationsQueryVariables>;
export const OnboardingChildSectionsDocument = gql`
    query OnboardingChildSections($filter: OnboardingGroupSectionFilter) {
  onboardingChildSections(filter: $filter) {
    ...OnboardingChildSectionInfo
  }
}
    ${OnboardingChildSectionInfoFragmentDoc}`;

/**
 * __useOnboardingChildSectionsQuery__
 *
 * To run a query within a React component, call `useOnboardingChildSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingChildSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingChildSectionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOnboardingChildSectionsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>(OnboardingChildSectionsDocument, options);
      }
export function useOnboardingChildSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>(OnboardingChildSectionsDocument, options);
        }
export function useOnboardingChildSectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>(OnboardingChildSectionsDocument, options);
        }
export type OnboardingChildSectionsQueryHookResult = ReturnType<typeof useOnboardingChildSectionsQuery>;
export type OnboardingChildSectionsLazyQueryHookResult = ReturnType<typeof useOnboardingChildSectionsLazyQuery>;
export type OnboardingChildSectionsSuspenseQueryHookResult = ReturnType<typeof useOnboardingChildSectionsSuspenseQuery>;
export type OnboardingChildSectionsQueryResult = Apollo.QueryResult<OnboardingChildSectionsQuery, OnboardingChildSectionsQueryVariables>;
export const OnboardingCreateMsaOperationDocument = gql`
    mutation OnboardingCreateMsaOperation($input: MsaOperationInput!) {
  onboardingCreateMsaOperation(input: $input) {
    operation {
      ...OnboardingApplicationInfo
    }
    certification {
      ...OnboardingCertificationInfo
    }
  }
}
    ${OnboardingApplicationInfoFragmentDoc}
${OnboardingCertificationInfoFragmentDoc}`;
export type OnboardingCreateMsaOperationMutationFn = Apollo.MutationFunction<OnboardingCreateMsaOperationMutation, OnboardingCreateMsaOperationMutationVariables>;

/**
 * __useOnboardingCreateMsaOperationMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateMsaOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateMsaOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateMsaOperationMutation, { data, loading, error }] = useOnboardingCreateMsaOperationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingCreateMsaOperationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateMsaOperationMutation, OnboardingCreateMsaOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateMsaOperationMutation, OnboardingCreateMsaOperationMutationVariables>(OnboardingCreateMsaOperationDocument, options);
      }
export type OnboardingCreateMsaOperationMutationHookResult = ReturnType<typeof useOnboardingCreateMsaOperationMutation>;
export type OnboardingCreateMsaOperationMutationResult = Apollo.MutationResult<OnboardingCreateMsaOperationMutation>;
export type OnboardingCreateMsaOperationMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateMsaOperationMutation, OnboardingCreateMsaOperationMutationVariables>;
export const OnboardingCreateRfiUserCommentDocument = gql`
    mutation OnboardingCreateRfiUserComment($input: OnboardingCreateRfiUserCommentInput!) {
  onboardingCreateRfiUserComment(input: $input)
}
    `;
export type OnboardingCreateRfiUserCommentMutationFn = Apollo.MutationFunction<OnboardingCreateRfiUserCommentMutation, OnboardingCreateRfiUserCommentMutationVariables>;

/**
 * __useOnboardingCreateRfiUserCommentMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateRfiUserCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateRfiUserCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateRfiUserCommentMutation, { data, loading, error }] = useOnboardingCreateRfiUserCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingCreateRfiUserCommentMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateRfiUserCommentMutation, OnboardingCreateRfiUserCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateRfiUserCommentMutation, OnboardingCreateRfiUserCommentMutationVariables>(OnboardingCreateRfiUserCommentDocument, options);
      }
export type OnboardingCreateRfiUserCommentMutationHookResult = ReturnType<typeof useOnboardingCreateRfiUserCommentMutation>;
export type OnboardingCreateRfiUserCommentMutationResult = Apollo.MutationResult<OnboardingCreateRfiUserCommentMutation>;
export type OnboardingCreateRfiUserCommentMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateRfiUserCommentMutation, OnboardingCreateRfiUserCommentMutationVariables>;
export const OnboardingDeleteGroupValueDocument = gql`
    mutation OnboardingDeleteGroupValue($input: OnboardingDeleteGroupValueInput!) {
  onboardingDeleteGroupValue(input: $input)
}
    `;
export type OnboardingDeleteGroupValueMutationFn = Apollo.MutationFunction<OnboardingDeleteGroupValueMutation, OnboardingDeleteGroupValueMutationVariables>;

/**
 * __useOnboardingDeleteGroupValueMutation__
 *
 * To run a mutation, you first call `useOnboardingDeleteGroupValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingDeleteGroupValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingDeleteGroupValueMutation, { data, loading, error }] = useOnboardingDeleteGroupValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingDeleteGroupValueMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingDeleteGroupValueMutation, OnboardingDeleteGroupValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingDeleteGroupValueMutation, OnboardingDeleteGroupValueMutationVariables>(OnboardingDeleteGroupValueDocument, options);
      }
export type OnboardingDeleteGroupValueMutationHookResult = ReturnType<typeof useOnboardingDeleteGroupValueMutation>;
export type OnboardingDeleteGroupValueMutationResult = Apollo.MutationResult<OnboardingDeleteGroupValueMutation>;
export type OnboardingDeleteGroupValueMutationOptions = Apollo.BaseMutationOptions<OnboardingDeleteGroupValueMutation, OnboardingDeleteGroupValueMutationVariables>;
export const OnboardingFlowNavigatorDocument = gql`
    query OnboardingFlowNavigator($operationId: ID!) {
  onboardingOverviewSectionsV2(operationId: $operationId) {
    ...OnboardingOverviewSectionInfo
    groups {
      ...OnboardingChildSectionInfo
      groups {
        ...OnboardingChildSectionInfo
        groups {
          ...OnboardingChildSectionInfo
        }
      }
    }
  }
}
    ${OnboardingOverviewSectionInfoFragmentDoc}
${OnboardingChildSectionInfoFragmentDoc}`;

/**
 * __useOnboardingFlowNavigatorQuery__
 *
 * To run a query within a React component, call `useOnboardingFlowNavigatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFlowNavigatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingFlowNavigatorQuery({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useOnboardingFlowNavigatorQuery(baseOptions: Apollo.QueryHookOptions<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>(OnboardingFlowNavigatorDocument, options);
      }
export function useOnboardingFlowNavigatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>(OnboardingFlowNavigatorDocument, options);
        }
export function useOnboardingFlowNavigatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>(OnboardingFlowNavigatorDocument, options);
        }
export type OnboardingFlowNavigatorQueryHookResult = ReturnType<typeof useOnboardingFlowNavigatorQuery>;
export type OnboardingFlowNavigatorLazyQueryHookResult = ReturnType<typeof useOnboardingFlowNavigatorLazyQuery>;
export type OnboardingFlowNavigatorSuspenseQueryHookResult = ReturnType<typeof useOnboardingFlowNavigatorSuspenseQuery>;
export type OnboardingFlowNavigatorQueryResult = Apollo.QueryResult<OnboardingFlowNavigatorQuery, OnboardingFlowNavigatorQueryVariables>;
export const OnboardingGroupDataV2Document = gql`
    query OnboardingGroupDataV2($input: OnboardingGroupDataV2Input!) {
  onboardingGroupDataV2(input: $input) {
    ...OnboardingGroupDataV2Info
  }
}
    ${OnboardingGroupDataV2InfoFragmentDoc}`;

/**
 * __useOnboardingGroupDataV2Query__
 *
 * To run a query within a React component, call `useOnboardingGroupDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingGroupDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingGroupDataV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingGroupDataV2Query(baseOptions: Apollo.QueryHookOptions<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>(OnboardingGroupDataV2Document, options);
      }
export function useOnboardingGroupDataV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>(OnboardingGroupDataV2Document, options);
        }
export function useOnboardingGroupDataV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>(OnboardingGroupDataV2Document, options);
        }
export type OnboardingGroupDataV2QueryHookResult = ReturnType<typeof useOnboardingGroupDataV2Query>;
export type OnboardingGroupDataV2LazyQueryHookResult = ReturnType<typeof useOnboardingGroupDataV2LazyQuery>;
export type OnboardingGroupDataV2SuspenseQueryHookResult = ReturnType<typeof useOnboardingGroupDataV2SuspenseQuery>;
export type OnboardingGroupDataV2QueryResult = Apollo.QueryResult<OnboardingGroupDataV2Query, OnboardingGroupDataV2QueryVariables>;
export const OnboardingInitiateKycApplicationDocument = gql`
    mutation OnboardingInitiateKycApplication {
  onboardingInitiateKycApplication {
    ...OnboardingApplicationInfo
  }
}
    ${OnboardingApplicationInfoFragmentDoc}`;
export type OnboardingInitiateKycApplicationMutationFn = Apollo.MutationFunction<OnboardingInitiateKycApplicationMutation, OnboardingInitiateKycApplicationMutationVariables>;

/**
 * __useOnboardingInitiateKycApplicationMutation__
 *
 * To run a mutation, you first call `useOnboardingInitiateKycApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingInitiateKycApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingInitiateKycApplicationMutation, { data, loading, error }] = useOnboardingInitiateKycApplicationMutation({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingInitiateKycApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingInitiateKycApplicationMutation, OnboardingInitiateKycApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingInitiateKycApplicationMutation, OnboardingInitiateKycApplicationMutationVariables>(OnboardingInitiateKycApplicationDocument, options);
      }
export type OnboardingInitiateKycApplicationMutationHookResult = ReturnType<typeof useOnboardingInitiateKycApplicationMutation>;
export type OnboardingInitiateKycApplicationMutationResult = Apollo.MutationResult<OnboardingInitiateKycApplicationMutation>;
export type OnboardingInitiateKycApplicationMutationOptions = Apollo.BaseMutationOptions<OnboardingInitiateKycApplicationMutation, OnboardingInitiateKycApplicationMutationVariables>;
export const OnboardingInitiateRolrApplicationDocument = gql`
    mutation OnboardingInitiateRolrApplication {
  onboardingInitiateRolrApplication {
    ...OnboardingApplicationInfo
  }
}
    ${OnboardingApplicationInfoFragmentDoc}`;
export type OnboardingInitiateRolrApplicationMutationFn = Apollo.MutationFunction<OnboardingInitiateRolrApplicationMutation, OnboardingInitiateRolrApplicationMutationVariables>;

/**
 * __useOnboardingInitiateRolrApplicationMutation__
 *
 * To run a mutation, you first call `useOnboardingInitiateRolrApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingInitiateRolrApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingInitiateRolrApplicationMutation, { data, loading, error }] = useOnboardingInitiateRolrApplicationMutation({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingInitiateRolrApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingInitiateRolrApplicationMutation, OnboardingInitiateRolrApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingInitiateRolrApplicationMutation, OnboardingInitiateRolrApplicationMutationVariables>(OnboardingInitiateRolrApplicationDocument, options);
      }
export type OnboardingInitiateRolrApplicationMutationHookResult = ReturnType<typeof useOnboardingInitiateRolrApplicationMutation>;
export type OnboardingInitiateRolrApplicationMutationResult = Apollo.MutationResult<OnboardingInitiateRolrApplicationMutation>;
export type OnboardingInitiateRolrApplicationMutationOptions = Apollo.BaseMutationOptions<OnboardingInitiateRolrApplicationMutation, OnboardingInitiateRolrApplicationMutationVariables>;
export const OnboardingL3ProviderDocument = gql`
    query OnboardingL3Provider {
  onboardingApplication {
    ...OnboardingApplicationInfo
  }
  onboardingChildSections(filter: {includeChildSubGroups: true}) {
    ...OnboardingChildSectionInfo
  }
}
    ${OnboardingApplicationInfoFragmentDoc}
${OnboardingChildSectionInfoFragmentDoc}`;

/**
 * __useOnboardingL3ProviderQuery__
 *
 * To run a query within a React component, call `useOnboardingL3ProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingL3ProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingL3ProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingL3ProviderQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>(OnboardingL3ProviderDocument, options);
      }
export function useOnboardingL3ProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>(OnboardingL3ProviderDocument, options);
        }
export function useOnboardingL3ProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>(OnboardingL3ProviderDocument, options);
        }
export type OnboardingL3ProviderQueryHookResult = ReturnType<typeof useOnboardingL3ProviderQuery>;
export type OnboardingL3ProviderLazyQueryHookResult = ReturnType<typeof useOnboardingL3ProviderLazyQuery>;
export type OnboardingL3ProviderSuspenseQueryHookResult = ReturnType<typeof useOnboardingL3ProviderSuspenseQuery>;
export type OnboardingL3ProviderQueryResult = Apollo.QueryResult<OnboardingL3ProviderQuery, OnboardingL3ProviderQueryVariables>;
export const OnboardingMarkRfisAsRespondedDocument = gql`
    mutation OnboardingMarkRfisAsResponded($input: OnboardingMarkRfisAsRespondedInput!) {
  onboardingMarkRfisAsResponded(input: $input)
}
    `;
export type OnboardingMarkRfisAsRespondedMutationFn = Apollo.MutationFunction<OnboardingMarkRfisAsRespondedMutation, OnboardingMarkRfisAsRespondedMutationVariables>;

/**
 * __useOnboardingMarkRfisAsRespondedMutation__
 *
 * To run a mutation, you first call `useOnboardingMarkRfisAsRespondedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingMarkRfisAsRespondedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingMarkRfisAsRespondedMutation, { data, loading, error }] = useOnboardingMarkRfisAsRespondedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingMarkRfisAsRespondedMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingMarkRfisAsRespondedMutation, OnboardingMarkRfisAsRespondedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingMarkRfisAsRespondedMutation, OnboardingMarkRfisAsRespondedMutationVariables>(OnboardingMarkRfisAsRespondedDocument, options);
      }
export type OnboardingMarkRfisAsRespondedMutationHookResult = ReturnType<typeof useOnboardingMarkRfisAsRespondedMutation>;
export type OnboardingMarkRfisAsRespondedMutationResult = Apollo.MutationResult<OnboardingMarkRfisAsRespondedMutation>;
export type OnboardingMarkRfisAsRespondedMutationOptions = Apollo.BaseMutationOptions<OnboardingMarkRfisAsRespondedMutation, OnboardingMarkRfisAsRespondedMutationVariables>;
export const OnboardingMsaOperationDocument = gql`
    query OnboardingMsaOperation($input: MsaOperationInput!) {
  onboardingMsaOperation(input: $input) {
    operation {
      ...OnboardingApplicationInfo
    }
    certification {
      ...OnboardingCertificationInfo
    }
  }
}
    ${OnboardingApplicationInfoFragmentDoc}
${OnboardingCertificationInfoFragmentDoc}`;

/**
 * __useOnboardingMsaOperationQuery__
 *
 * To run a query within a React component, call `useOnboardingMsaOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingMsaOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingMsaOperationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingMsaOperationQuery(baseOptions: Apollo.QueryHookOptions<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>(OnboardingMsaOperationDocument, options);
      }
export function useOnboardingMsaOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>(OnboardingMsaOperationDocument, options);
        }
export function useOnboardingMsaOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>(OnboardingMsaOperationDocument, options);
        }
export type OnboardingMsaOperationQueryHookResult = ReturnType<typeof useOnboardingMsaOperationQuery>;
export type OnboardingMsaOperationLazyQueryHookResult = ReturnType<typeof useOnboardingMsaOperationLazyQuery>;
export type OnboardingMsaOperationSuspenseQueryHookResult = ReturnType<typeof useOnboardingMsaOperationSuspenseQuery>;
export type OnboardingMsaOperationQueryResult = Apollo.QueryResult<OnboardingMsaOperationQuery, OnboardingMsaOperationQueryVariables>;
export const OnboardingNaturesOfBusinessDocument = gql`
    query OnboardingNaturesOfBusiness($input: OnboardingNaturesOfBusinessInput) {
  onboardingNaturesOfBusiness(input: $input) {
    ...OnboardingNaturesOfBusinessInfo
  }
}
    ${OnboardingNaturesOfBusinessInfoFragmentDoc}`;

/**
 * __useOnboardingNaturesOfBusinessQuery__
 *
 * To run a query within a React component, call `useOnboardingNaturesOfBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingNaturesOfBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingNaturesOfBusinessQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingNaturesOfBusinessQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>(OnboardingNaturesOfBusinessDocument, options);
      }
export function useOnboardingNaturesOfBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>(OnboardingNaturesOfBusinessDocument, options);
        }
export function useOnboardingNaturesOfBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>(OnboardingNaturesOfBusinessDocument, options);
        }
export type OnboardingNaturesOfBusinessQueryHookResult = ReturnType<typeof useOnboardingNaturesOfBusinessQuery>;
export type OnboardingNaturesOfBusinessLazyQueryHookResult = ReturnType<typeof useOnboardingNaturesOfBusinessLazyQuery>;
export type OnboardingNaturesOfBusinessSuspenseQueryHookResult = ReturnType<typeof useOnboardingNaturesOfBusinessSuspenseQuery>;
export type OnboardingNaturesOfBusinessQueryResult = Apollo.QueryResult<OnboardingNaturesOfBusinessQuery, OnboardingNaturesOfBusinessQueryVariables>;
export const OnboardingOverviewGroupDocument = gql`
    query OnboardingOverviewGroup {
  onboardingApplication {
    ...OnboardingApplicationInfo
  }
}
    ${OnboardingApplicationInfoFragmentDoc}`;

/**
 * __useOnboardingOverviewGroupQuery__
 *
 * To run a query within a React component, call `useOnboardingOverviewGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingOverviewGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingOverviewGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingOverviewGroupQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>(OnboardingOverviewGroupDocument, options);
      }
export function useOnboardingOverviewGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>(OnboardingOverviewGroupDocument, options);
        }
export function useOnboardingOverviewGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>(OnboardingOverviewGroupDocument, options);
        }
export type OnboardingOverviewGroupQueryHookResult = ReturnType<typeof useOnboardingOverviewGroupQuery>;
export type OnboardingOverviewGroupLazyQueryHookResult = ReturnType<typeof useOnboardingOverviewGroupLazyQuery>;
export type OnboardingOverviewGroupSuspenseQueryHookResult = ReturnType<typeof useOnboardingOverviewGroupSuspenseQuery>;
export type OnboardingOverviewGroupQueryResult = Apollo.QueryResult<OnboardingOverviewGroupQuery, OnboardingOverviewGroupQueryVariables>;
export const OnboardingOverviewV2Document = gql`
    query OnboardingOverviewV2($operationId: ID!) {
  onboardingOverviewSectionsV2(operationId: $operationId) {
    ...OnboardingOverviewSectionInfo
    groups {
      ...OnboardingChildSectionInfo
      overviewGroups
      groups {
        ...OnboardingChildSectionInfo
      }
    }
  }
  onboardingApplication {
    ...OnboardingApplicationInfo
  }
  onboardingChildSections(filter: {includeChildSubGroups: true}) {
    ...OnboardingChildSectionInfo
  }
}
    ${OnboardingOverviewSectionInfoFragmentDoc}
${OnboardingChildSectionInfoFragmentDoc}
${OnboardingApplicationInfoFragmentDoc}`;

/**
 * __useOnboardingOverviewV2Query__
 *
 * To run a query within a React component, call `useOnboardingOverviewV2Query` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingOverviewV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingOverviewV2Query({
 *   variables: {
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useOnboardingOverviewV2Query(baseOptions: Apollo.QueryHookOptions<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>(OnboardingOverviewV2Document, options);
      }
export function useOnboardingOverviewV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>(OnboardingOverviewV2Document, options);
        }
export function useOnboardingOverviewV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>(OnboardingOverviewV2Document, options);
        }
export type OnboardingOverviewV2QueryHookResult = ReturnType<typeof useOnboardingOverviewV2Query>;
export type OnboardingOverviewV2LazyQueryHookResult = ReturnType<typeof useOnboardingOverviewV2LazyQuery>;
export type OnboardingOverviewV2SuspenseQueryHookResult = ReturnType<typeof useOnboardingOverviewV2SuspenseQuery>;
export type OnboardingOverviewV2QueryResult = Apollo.QueryResult<OnboardingOverviewV2Query, OnboardingOverviewV2QueryVariables>;
export const OnboardingSaveFieldValuesV2Document = gql`
    mutation OnboardingSaveFieldValuesV2($input: OnboardingSaveFieldValuesV2Input!) {
  onboardingSaveFieldValuesV2(input: $input) {
    groupId
    refId
    fields {
      id
      name
      value
      rfiId
      rfiStatus
      rfiComment
    }
  }
}
    `;
export type OnboardingSaveFieldValuesV2MutationFn = Apollo.MutationFunction<OnboardingSaveFieldValuesV2Mutation, OnboardingSaveFieldValuesV2MutationVariables>;

/**
 * __useOnboardingSaveFieldValuesV2Mutation__
 *
 * To run a mutation, you first call `useOnboardingSaveFieldValuesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSaveFieldValuesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingSaveFieldValuesV2Mutation, { data, loading, error }] = useOnboardingSaveFieldValuesV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingSaveFieldValuesV2Mutation(baseOptions?: Apollo.MutationHookOptions<OnboardingSaveFieldValuesV2Mutation, OnboardingSaveFieldValuesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingSaveFieldValuesV2Mutation, OnboardingSaveFieldValuesV2MutationVariables>(OnboardingSaveFieldValuesV2Document, options);
      }
export type OnboardingSaveFieldValuesV2MutationHookResult = ReturnType<typeof useOnboardingSaveFieldValuesV2Mutation>;
export type OnboardingSaveFieldValuesV2MutationResult = Apollo.MutationResult<OnboardingSaveFieldValuesV2Mutation>;
export type OnboardingSaveFieldValuesV2MutationOptions = Apollo.BaseMutationOptions<OnboardingSaveFieldValuesV2Mutation, OnboardingSaveFieldValuesV2MutationVariables>;
export const OnboardingSideRailDocument = gql`
    query OnboardingSideRail {
  signInFactor {
    enrolled
  }
  qualificationsSummary {
    ...QualificationsSummaryInfo
  }
  onboardingApplication {
    onboardingId
    operationType
    status
  }
  onboardingNaturesOfBusiness(input: {excludeProhibited: true}) {
    ...OnboardingNaturesOfBusinessInfo
  }
  onboardingChildSections(filter: {includeChildSubGroups: true}) {
    ...OnboardingChildSectionInfo
  }
}
    ${QualificationsSummaryInfoFragmentDoc}
${OnboardingNaturesOfBusinessInfoFragmentDoc}
${OnboardingChildSectionInfoFragmentDoc}`;

/**
 * __useOnboardingSideRailQuery__
 *
 * To run a query within a React component, call `useOnboardingSideRailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSideRailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingSideRailQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingSideRailQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>(OnboardingSideRailDocument, options);
      }
export function useOnboardingSideRailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>(OnboardingSideRailDocument, options);
        }
export function useOnboardingSideRailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>(OnboardingSideRailDocument, options);
        }
export type OnboardingSideRailQueryHookResult = ReturnType<typeof useOnboardingSideRailQuery>;
export type OnboardingSideRailLazyQueryHookResult = ReturnType<typeof useOnboardingSideRailLazyQuery>;
export type OnboardingSideRailSuspenseQueryHookResult = ReturnType<typeof useOnboardingSideRailSuspenseQuery>;
export type OnboardingSideRailQueryResult = Apollo.QueryResult<OnboardingSideRailQuery, OnboardingSideRailQueryVariables>;
export const OnboardingStatusSummaryDocument = gql`
    query OnboardingStatusSummary {
  signInFactor {
    enrolled
  }
  qualificationsSummary {
    ...QualificationsSummaryInfo
  }
  onboardingApplication {
    onboardingId
    operationType
    status
  }
}
    ${QualificationsSummaryInfoFragmentDoc}`;

/**
 * __useOnboardingStatusSummaryQuery__
 *
 * To run a query within a React component, call `useOnboardingStatusSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingStatusSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingStatusSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingStatusSummaryQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>(OnboardingStatusSummaryDocument, options);
      }
export function useOnboardingStatusSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>(OnboardingStatusSummaryDocument, options);
        }
export function useOnboardingStatusSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>(OnboardingStatusSummaryDocument, options);
        }
export type OnboardingStatusSummaryQueryHookResult = ReturnType<typeof useOnboardingStatusSummaryQuery>;
export type OnboardingStatusSummaryLazyQueryHookResult = ReturnType<typeof useOnboardingStatusSummaryLazyQuery>;
export type OnboardingStatusSummarySuspenseQueryHookResult = ReturnType<typeof useOnboardingStatusSummarySuspenseQuery>;
export type OnboardingStatusSummaryQueryResult = Apollo.QueryResult<OnboardingStatusSummaryQuery, OnboardingStatusSummaryQueryVariables>;
export const OnboardingSubmitApplicationDocument = gql`
    mutation OnboardingSubmitApplication($input: OnboardingApplicationSubmissionInput!) {
  onboardingSubmitApplication(input: $input) {
    ...OnboardingSubmitApplicationInfo
  }
}
    ${OnboardingSubmitApplicationInfoFragmentDoc}`;
export type OnboardingSubmitApplicationMutationFn = Apollo.MutationFunction<OnboardingSubmitApplicationMutation, OnboardingSubmitApplicationMutationVariables>;

/**
 * __useOnboardingSubmitApplicationMutation__
 *
 * To run a mutation, you first call `useOnboardingSubmitApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSubmitApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingSubmitApplicationMutation, { data, loading, error }] = useOnboardingSubmitApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingSubmitApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingSubmitApplicationMutation, OnboardingSubmitApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingSubmitApplicationMutation, OnboardingSubmitApplicationMutationVariables>(OnboardingSubmitApplicationDocument, options);
      }
export type OnboardingSubmitApplicationMutationHookResult = ReturnType<typeof useOnboardingSubmitApplicationMutation>;
export type OnboardingSubmitApplicationMutationResult = Apollo.MutationResult<OnboardingSubmitApplicationMutation>;
export type OnboardingSubmitApplicationMutationOptions = Apollo.BaseMutationOptions<OnboardingSubmitApplicationMutation, OnboardingSubmitApplicationMutationVariables>;
export const OnboardingUploadDocumentWithoutLinkingDocument = gql`
    mutation OnboardingUploadDocumentWithoutLinking($onboardingId: ID!, $document: OnboardingUploadDocumentWithoutLinkingInput!) {
  onboardingUploadDocumentWithoutLinking(
    onboardingId: $onboardingId
    document: $document
  ) {
    ...OnboardingUploadDocumentResponseInfo
  }
}
    ${OnboardingUploadDocumentResponseInfoFragmentDoc}`;
export type OnboardingUploadDocumentWithoutLinkingMutationFn = Apollo.MutationFunction<OnboardingUploadDocumentWithoutLinkingMutation, OnboardingUploadDocumentWithoutLinkingMutationVariables>;

/**
 * __useOnboardingUploadDocumentWithoutLinkingMutation__
 *
 * To run a mutation, you first call `useOnboardingUploadDocumentWithoutLinkingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingUploadDocumentWithoutLinkingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingUploadDocumentWithoutLinkingMutation, { data, loading, error }] = useOnboardingUploadDocumentWithoutLinkingMutation({
 *   variables: {
 *      onboardingId: // value for 'onboardingId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useOnboardingUploadDocumentWithoutLinkingMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingUploadDocumentWithoutLinkingMutation, OnboardingUploadDocumentWithoutLinkingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingUploadDocumentWithoutLinkingMutation, OnboardingUploadDocumentWithoutLinkingMutationVariables>(OnboardingUploadDocumentWithoutLinkingDocument, options);
      }
export type OnboardingUploadDocumentWithoutLinkingMutationHookResult = ReturnType<typeof useOnboardingUploadDocumentWithoutLinkingMutation>;
export type OnboardingUploadDocumentWithoutLinkingMutationResult = Apollo.MutationResult<OnboardingUploadDocumentWithoutLinkingMutation>;
export type OnboardingUploadDocumentWithoutLinkingMutationOptions = Apollo.BaseMutationOptions<OnboardingUploadDocumentWithoutLinkingMutation, OnboardingUploadDocumentWithoutLinkingMutationVariables>;
export const OnboardingRfiBundleDocument = gql`
    query OnboardingRfiBundle($input: OnboardingRfiBundleInput!) {
  onboardingRfiBundle(input: $input) {
    id
    status
    createDate
    fields {
      id
      fieldId
      refId
      rfiType
      responded
      groupIds
      groupNames
      elementType
      elementName
    }
  }
}
    `;

/**
 * __useOnboardingRfiBundleQuery__
 *
 * To run a query within a React component, call `useOnboardingRfiBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRfiBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingRfiBundleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingRfiBundleQuery(baseOptions: Apollo.QueryHookOptions<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>(OnboardingRfiBundleDocument, options);
      }
export function useOnboardingRfiBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>(OnboardingRfiBundleDocument, options);
        }
export function useOnboardingRfiBundleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>(OnboardingRfiBundleDocument, options);
        }
export type OnboardingRfiBundleQueryHookResult = ReturnType<typeof useOnboardingRfiBundleQuery>;
export type OnboardingRfiBundleLazyQueryHookResult = ReturnType<typeof useOnboardingRfiBundleLazyQuery>;
export type OnboardingRfiBundleSuspenseQueryHookResult = ReturnType<typeof useOnboardingRfiBundleSuspenseQuery>;
export type OnboardingRfiBundleQueryResult = Apollo.QueryResult<OnboardingRfiBundleQuery, OnboardingRfiBundleQueryVariables>;
export const OnboardingRfiGroupCommentsDocument = gql`
    query OnboardingRfiGroupComments($input: OnboardingRfiGroupCommentsInput!) {
  onboardingRfiGroupComments(input: $input) {
    circleComment {
      id
      authorType
      rfiId
      content
    }
    userComment {
      id
      authorType
      rfiId
      content
    }
  }
}
    `;

/**
 * __useOnboardingRfiGroupCommentsQuery__
 *
 * To run a query within a React component, call `useOnboardingRfiGroupCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRfiGroupCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingRfiGroupCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingRfiGroupCommentsQuery(baseOptions: Apollo.QueryHookOptions<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>(OnboardingRfiGroupCommentsDocument, options);
      }
export function useOnboardingRfiGroupCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>(OnboardingRfiGroupCommentsDocument, options);
        }
export function useOnboardingRfiGroupCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>(OnboardingRfiGroupCommentsDocument, options);
        }
export type OnboardingRfiGroupCommentsQueryHookResult = ReturnType<typeof useOnboardingRfiGroupCommentsQuery>;
export type OnboardingRfiGroupCommentsLazyQueryHookResult = ReturnType<typeof useOnboardingRfiGroupCommentsLazyQuery>;
export type OnboardingRfiGroupCommentsSuspenseQueryHookResult = ReturnType<typeof useOnboardingRfiGroupCommentsSuspenseQuery>;
export type OnboardingRfiGroupCommentsQueryResult = Apollo.QueryResult<OnboardingRfiGroupCommentsQuery, OnboardingRfiGroupCommentsQueryVariables>;
export const OrganizationConfigurationsDocument = gql`
    query OrganizationConfigurations {
  organizationConfigurations {
    userLimit
  }
}
    `;

/**
 * __useOrganizationConfigurationsQuery__
 *
 * To run a query within a React component, call `useOrganizationConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>(OrganizationConfigurationsDocument, options);
      }
export function useOrganizationConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>(OrganizationConfigurationsDocument, options);
        }
export function useOrganizationConfigurationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>(OrganizationConfigurationsDocument, options);
        }
export type OrganizationConfigurationsQueryHookResult = ReturnType<typeof useOrganizationConfigurationsQuery>;
export type OrganizationConfigurationsLazyQueryHookResult = ReturnType<typeof useOrganizationConfigurationsLazyQuery>;
export type OrganizationConfigurationsSuspenseQueryHookResult = ReturnType<typeof useOrganizationConfigurationsSuspenseQuery>;
export type OrganizationConfigurationsQueryResult = Apollo.QueryResult<OrganizationConfigurationsQuery, OrganizationConfigurationsQueryVariables>;
export const PciPublicKeyDocument = gql`
    query PciPublicKey {
  pciPublicKey {
    ...PciPublicKeyInfo
  }
}
    ${PciPublicKeyInfoFragmentDoc}`;

/**
 * __usePciPublicKeyQuery__
 *
 * To run a query within a React component, call `usePciPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePciPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePciPublicKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePciPublicKeyQuery(baseOptions?: Apollo.QueryHookOptions<PciPublicKeyQuery, PciPublicKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PciPublicKeyQuery, PciPublicKeyQueryVariables>(PciPublicKeyDocument, options);
      }
export function usePciPublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PciPublicKeyQuery, PciPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PciPublicKeyQuery, PciPublicKeyQueryVariables>(PciPublicKeyDocument, options);
        }
export function usePciPublicKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PciPublicKeyQuery, PciPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PciPublicKeyQuery, PciPublicKeyQueryVariables>(PciPublicKeyDocument, options);
        }
export type PciPublicKeyQueryHookResult = ReturnType<typeof usePciPublicKeyQuery>;
export type PciPublicKeyLazyQueryHookResult = ReturnType<typeof usePciPublicKeyLazyQuery>;
export type PciPublicKeySuspenseQueryHookResult = ReturnType<typeof usePciPublicKeySuspenseQuery>;
export type PciPublicKeyQueryResult = Apollo.QueryResult<PciPublicKeyQuery, PciPublicKeyQueryVariables>;
export const PaymentDetailsDocument = gql`
    query PaymentDetails($id: ID!) {
  paymentDetails(id: $id) {
    ...PaymentDetailsInfo
  }
}
    ${PaymentDetailsInfoFragmentDoc}`;

/**
 * __usePaymentDetailsQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
      }
export function usePaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
export function usePaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentDetailsQuery, PaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentDetailsQuery, PaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
export type PaymentDetailsQueryHookResult = ReturnType<typeof usePaymentDetailsQuery>;
export type PaymentDetailsLazyQueryHookResult = ReturnType<typeof usePaymentDetailsLazyQuery>;
export type PaymentDetailsSuspenseQueryHookResult = ReturnType<typeof usePaymentDetailsSuspenseQuery>;
export type PaymentDetailsQueryResult = Apollo.QueryResult<PaymentDetailsQuery, PaymentDetailsQueryVariables>;
export const PaymentsDocument = gql`
    query Payments($page: PaginationInput, $filter: PaymentInput) {
  payments(page: $page, filter: $filter) {
    ...PaginationInfo
    ...PaymentsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${PaymentsInfoFragmentDoc}`;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export function usePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsSuspenseQueryHookResult = ReturnType<typeof usePaymentsSuspenseQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const PendingOnchainReceivesDocument = gql`
    query PendingOnchainReceives($currency: Currency, $dedupe: Boolean) {
  pendingOnchainReceives(currency: $currency, dedupe: $dedupe) {
    ...OnchainReceiveInfo
  }
}
    ${OnchainReceiveInfoFragmentDoc}`;

/**
 * __usePendingOnchainReceivesQuery__
 *
 * To run a query within a React component, call `usePendingOnchainReceivesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingOnchainReceivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingOnchainReceivesQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      dedupe: // value for 'dedupe'
 *   },
 * });
 */
export function usePendingOnchainReceivesQuery(baseOptions?: Apollo.QueryHookOptions<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>(PendingOnchainReceivesDocument, options);
      }
export function usePendingOnchainReceivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>(PendingOnchainReceivesDocument, options);
        }
export function usePendingOnchainReceivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>(PendingOnchainReceivesDocument, options);
        }
export type PendingOnchainReceivesQueryHookResult = ReturnType<typeof usePendingOnchainReceivesQuery>;
export type PendingOnchainReceivesLazyQueryHookResult = ReturnType<typeof usePendingOnchainReceivesLazyQuery>;
export type PendingOnchainReceivesSuspenseQueryHookResult = ReturnType<typeof usePendingOnchainReceivesSuspenseQuery>;
export type PendingOnchainReceivesQueryResult = Apollo.QueryResult<PendingOnchainReceivesQuery, PendingOnchainReceivesQueryVariables>;
export const AddPaymentMethodDocument = gql`
    mutation AddPaymentMethod($isDefault: Boolean!, $paymentProviderPaymentMethodId: String!) {
  addPaymentMethod(
    isDefault: $isDefault
    paymentProviderPaymentMethodId: $paymentProviderPaymentMethodId
  )
}
    `;
export type AddPaymentMethodMutationFn = Apollo.MutationFunction<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      isDefault: // value for 'isDefault'
 *      paymentProviderPaymentMethodId: // value for 'paymentProviderPaymentMethodId'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>(AddPaymentMethodDocument, options);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = Apollo.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const CardPaymentDocument = gql`
    query CardPayment($id: ID!) {
  cardPayment(id: $id) {
    ...CardPaymentInfo
  }
}
    ${CardPaymentInfoFragmentDoc}`;

/**
 * __useCardPaymentQuery__
 *
 * To run a query within a React component, call `useCardPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardPaymentQuery(baseOptions: Apollo.QueryHookOptions<CardPaymentQuery, CardPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardPaymentQuery, CardPaymentQueryVariables>(CardPaymentDocument, options);
      }
export function useCardPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardPaymentQuery, CardPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardPaymentQuery, CardPaymentQueryVariables>(CardPaymentDocument, options);
        }
export function useCardPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardPaymentQuery, CardPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardPaymentQuery, CardPaymentQueryVariables>(CardPaymentDocument, options);
        }
export type CardPaymentQueryHookResult = ReturnType<typeof useCardPaymentQuery>;
export type CardPaymentLazyQueryHookResult = ReturnType<typeof useCardPaymentLazyQuery>;
export type CardPaymentSuspenseQueryHookResult = ReturnType<typeof useCardPaymentSuspenseQuery>;
export type CardPaymentQueryResult = Apollo.QueryResult<CardPaymentQuery, CardPaymentQueryVariables>;
export const CardPaymentMethodByIdDocument = gql`
    query CardPaymentMethodById($id: ID!) {
  cardPaymentMethodById(id: $id) {
    ...CardPaymentMethodInfo
  }
}
    ${CardPaymentMethodInfoFragmentDoc}`;

/**
 * __useCardPaymentMethodByIdQuery__
 *
 * To run a query within a React component, call `useCardPaymentMethodByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPaymentMethodByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPaymentMethodByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCardPaymentMethodByIdQuery(baseOptions: Apollo.QueryHookOptions<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>(CardPaymentMethodByIdDocument, options);
      }
export function useCardPaymentMethodByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>(CardPaymentMethodByIdDocument, options);
        }
export function useCardPaymentMethodByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>(CardPaymentMethodByIdDocument, options);
        }
export type CardPaymentMethodByIdQueryHookResult = ReturnType<typeof useCardPaymentMethodByIdQuery>;
export type CardPaymentMethodByIdLazyQueryHookResult = ReturnType<typeof useCardPaymentMethodByIdLazyQuery>;
export type CardPaymentMethodByIdSuspenseQueryHookResult = ReturnType<typeof useCardPaymentMethodByIdSuspenseQuery>;
export type CardPaymentMethodByIdQueryResult = Apollo.QueryResult<CardPaymentMethodByIdQuery, CardPaymentMethodByIdQueryVariables>;
export const CardPaymentMethodsDocument = gql`
    query CardPaymentMethods($page: PaginationInput) {
  cardPaymentMethods(page: $page) {
    ...PaginationInfo
    ...CardPaymentMethodsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${CardPaymentMethodsInfoFragmentDoc}`;

/**
 * __useCardPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCardPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardPaymentMethodsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCardPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>(CardPaymentMethodsDocument, options);
      }
export function useCardPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>(CardPaymentMethodsDocument, options);
        }
export function useCardPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>(CardPaymentMethodsDocument, options);
        }
export type CardPaymentMethodsQueryHookResult = ReturnType<typeof useCardPaymentMethodsQuery>;
export type CardPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCardPaymentMethodsLazyQuery>;
export type CardPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useCardPaymentMethodsSuspenseQuery>;
export type CardPaymentMethodsQueryResult = Apollo.QueryResult<CardPaymentMethodsQuery, CardPaymentMethodsQueryVariables>;
export const CreateCardSetupDocument = gql`
    mutation CreateCardSetup($userEmail: String!) {
  createCardSetup(userEmail: $userEmail) {
    clientSecret
    accountId
  }
}
    `;
export type CreateCardSetupMutationFn = Apollo.MutationFunction<CreateCardSetupMutation, CreateCardSetupMutationVariables>;

/**
 * __useCreateCardSetupMutation__
 *
 * To run a mutation, you first call `useCreateCardSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardSetupMutation, { data, loading, error }] = useCreateCardSetupMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useCreateCardSetupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardSetupMutation, CreateCardSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardSetupMutation, CreateCardSetupMutationVariables>(CreateCardSetupDocument, options);
      }
export type CreateCardSetupMutationHookResult = ReturnType<typeof useCreateCardSetupMutation>;
export type CreateCardSetupMutationResult = Apollo.MutationResult<CreateCardSetupMutation>;
export type CreateCardSetupMutationOptions = Apollo.BaseMutationOptions<CreateCardSetupMutation, CreateCardSetupMutationVariables>;
export const DefaultPaymentMethodDocument = gql`
    query DefaultPaymentMethod {
  defaultPaymentMethod {
    ...DefaultPaymentMethodInfo
  }
}
    ${DefaultPaymentMethodInfoFragmentDoc}`;

/**
 * __useDefaultPaymentMethodQuery__
 *
 * To run a query within a React component, call `useDefaultPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>(DefaultPaymentMethodDocument, options);
      }
export function useDefaultPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>(DefaultPaymentMethodDocument, options);
        }
export function useDefaultPaymentMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>(DefaultPaymentMethodDocument, options);
        }
export type DefaultPaymentMethodQueryHookResult = ReturnType<typeof useDefaultPaymentMethodQuery>;
export type DefaultPaymentMethodLazyQueryHookResult = ReturnType<typeof useDefaultPaymentMethodLazyQuery>;
export type DefaultPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useDefaultPaymentMethodSuspenseQuery>;
export type DefaultPaymentMethodQueryResult = Apollo.QueryResult<DefaultPaymentMethodQuery, DefaultPaymentMethodQueryVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation SetDefaultPaymentMethod($defaultPaymentMethodInput: DefaultPaymentMethodInput!) {
  setDefaultPaymentMethod(defaultPaymentMethodInput: $defaultPaymentMethodInput)
}
    `;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      defaultPaymentMethodInput: // value for 'defaultPaymentMethodInput'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const UpdateCardPaymentMethodDocument = gql`
    mutation UpdateCardPaymentMethod($cardId: String!, $isDefault: Boolean!, $updateCardPaymentMethodInput: UpdateCardPaymentMethodInput!) {
  updateCardPaymentMethod(
    cardId: $cardId
    isDefault: $isDefault
    input: $updateCardPaymentMethodInput
  )
}
    `;
export type UpdateCardPaymentMethodMutationFn = Apollo.MutationFunction<UpdateCardPaymentMethodMutation, UpdateCardPaymentMethodMutationVariables>;

/**
 * __useUpdateCardPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCardPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardPaymentMethodMutation, { data, loading, error }] = useUpdateCardPaymentMethodMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      isDefault: // value for 'isDefault'
 *      updateCardPaymentMethodInput: // value for 'updateCardPaymentMethodInput'
 *   },
 * });
 */
export function useUpdateCardPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardPaymentMethodMutation, UpdateCardPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardPaymentMethodMutation, UpdateCardPaymentMethodMutationVariables>(UpdateCardPaymentMethodDocument, options);
      }
export type UpdateCardPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCardPaymentMethodMutation>;
export type UpdateCardPaymentMethodMutationResult = Apollo.MutationResult<UpdateCardPaymentMethodMutation>;
export type UpdateCardPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCardPaymentMethodMutation, UpdateCardPaymentMethodMutationVariables>;
export const WalletPaymentMethodDocument = gql`
    query WalletPaymentMethod {
  walletPaymentMethods {
    ...WalletPaymentMethodInfo
  }
}
    ${WalletPaymentMethodInfoFragmentDoc}`;

/**
 * __useWalletPaymentMethodQuery__
 *
 * To run a query within a React component, call `useWalletPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>(WalletPaymentMethodDocument, options);
      }
export function useWalletPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>(WalletPaymentMethodDocument, options);
        }
export function useWalletPaymentMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>(WalletPaymentMethodDocument, options);
        }
export type WalletPaymentMethodQueryHookResult = ReturnType<typeof useWalletPaymentMethodQuery>;
export type WalletPaymentMethodLazyQueryHookResult = ReturnType<typeof useWalletPaymentMethodLazyQuery>;
export type WalletPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useWalletPaymentMethodSuspenseQuery>;
export type WalletPaymentMethodQueryResult = Apollo.QueryResult<WalletPaymentMethodQuery, WalletPaymentMethodQueryVariables>;
export const CreatePayoutDocument = gql`
    mutation CreatePayout($input: CreatePayoutInput!) {
  createPayout(input: $input) {
    ...PayoutInfo
  }
}
    ${PayoutInfoFragmentDoc}`;
export type CreatePayoutMutationFn = Apollo.MutationFunction<CreatePayoutMutation, CreatePayoutMutationVariables>;

/**
 * __useCreatePayoutMutation__
 *
 * To run a mutation, you first call `useCreatePayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoutMutation, { data, loading, error }] = useCreatePayoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayoutMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayoutMutation, CreatePayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayoutMutation, CreatePayoutMutationVariables>(CreatePayoutDocument, options);
      }
export type CreatePayoutMutationHookResult = ReturnType<typeof useCreatePayoutMutation>;
export type CreatePayoutMutationResult = Apollo.MutationResult<CreatePayoutMutation>;
export type CreatePayoutMutationOptions = Apollo.BaseMutationOptions<CreatePayoutMutation, CreatePayoutMutationVariables>;
export const PayoutDocument = gql`
    query Payout($id: ID!) {
  payout(id: $id) {
    ...PayoutInfo
  }
}
    ${PayoutInfoFragmentDoc}`;

/**
 * __usePayoutQuery__
 *
 * To run a query within a React component, call `usePayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayoutQuery(baseOptions: Apollo.QueryHookOptions<PayoutQuery, PayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutQuery, PayoutQueryVariables>(PayoutDocument, options);
      }
export function usePayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutQuery, PayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutQuery, PayoutQueryVariables>(PayoutDocument, options);
        }
export function usePayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutQuery, PayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutQuery, PayoutQueryVariables>(PayoutDocument, options);
        }
export type PayoutQueryHookResult = ReturnType<typeof usePayoutQuery>;
export type PayoutLazyQueryHookResult = ReturnType<typeof usePayoutLazyQuery>;
export type PayoutSuspenseQueryHookResult = ReturnType<typeof usePayoutSuspenseQuery>;
export type PayoutQueryResult = Apollo.QueryResult<PayoutQuery, PayoutQueryVariables>;
export const ProposalsDocument = gql`
    query Proposals($input: ProposalsInput!) {
  proposals(input: $input) {
    deleteGroup {
      ...ProposalInfo
      data {
        groupId
        name
        members {
          ...UserGroupMemberInfo
        }
      }
    }
  }
}
    ${ProposalInfoFragmentDoc}
${UserGroupMemberInfoFragmentDoc}`;

/**
 * __useProposalsQuery__
 *
 * To run a query within a React component, call `useProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProposalsQuery(baseOptions: Apollo.QueryHookOptions<ProposalsQuery, ProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalsQuery, ProposalsQueryVariables>(ProposalsDocument, options);
      }
export function useProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalsQuery, ProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalsQuery, ProposalsQueryVariables>(ProposalsDocument, options);
        }
export function useProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalsQuery, ProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalsQuery, ProposalsQueryVariables>(ProposalsDocument, options);
        }
export type ProposalsQueryHookResult = ReturnType<typeof useProposalsQuery>;
export type ProposalsLazyQueryHookResult = ReturnType<typeof useProposalsLazyQuery>;
export type ProposalsSuspenseQueryHookResult = ReturnType<typeof useProposalsSuspenseQuery>;
export type ProposalsQueryResult = Apollo.QueryResult<ProposalsQuery, ProposalsQueryVariables>;
export const OnboardingQualificationsDocument = gql`
    query OnboardingQualifications {
  onboardingQualifications {
    kyb {
      ...KybInfo
    }
    kyc {
      state
    }
  }
}
    ${KybInfoFragmentDoc}`;

/**
 * __useOnboardingQualificationsQuery__
 *
 * To run a query within a React component, call `useOnboardingQualificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQualificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQualificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingQualificationsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>(OnboardingQualificationsDocument, options);
      }
export function useOnboardingQualificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>(OnboardingQualificationsDocument, options);
        }
export function useOnboardingQualificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>(OnboardingQualificationsDocument, options);
        }
export type OnboardingQualificationsQueryHookResult = ReturnType<typeof useOnboardingQualificationsQuery>;
export type OnboardingQualificationsLazyQueryHookResult = ReturnType<typeof useOnboardingQualificationsLazyQuery>;
export type OnboardingQualificationsSuspenseQueryHookResult = ReturnType<typeof useOnboardingQualificationsSuspenseQuery>;
export type OnboardingQualificationsQueryResult = Apollo.QueryResult<OnboardingQualificationsQuery, OnboardingQualificationsQueryVariables>;
export const QualificationsSummaryDocument = gql`
    query QualificationsSummary {
  qualificationsSummary {
    ...QualificationsSummaryInfo
  }
}
    ${QualificationsSummaryInfoFragmentDoc}`;

/**
 * __useQualificationsSummaryQuery__
 *
 * To run a query within a React component, call `useQualificationsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualificationsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualificationsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useQualificationsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>(QualificationsSummaryDocument, options);
      }
export function useQualificationsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>(QualificationsSummaryDocument, options);
        }
export function useQualificationsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>(QualificationsSummaryDocument, options);
        }
export type QualificationsSummaryQueryHookResult = ReturnType<typeof useQualificationsSummaryQuery>;
export type QualificationsSummaryLazyQueryHookResult = ReturnType<typeof useQualificationsSummaryLazyQuery>;
export type QualificationsSummarySuspenseQueryHookResult = ReturnType<typeof useQualificationsSummarySuspenseQuery>;
export type QualificationsSummaryQueryResult = Apollo.QueryResult<QualificationsSummaryQuery, QualificationsSummaryQueryVariables>;
export const PeriodicReviewLegacyQualificationDocument = gql`
    query PeriodicReviewLegacyQualification {
  periodicReviewLegacyQualification {
    state
    properties {
      dueDate
    }
  }
}
    `;

/**
 * __usePeriodicReviewLegacyQualificationQuery__
 *
 * To run a query within a React component, call `usePeriodicReviewLegacyQualificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicReviewLegacyQualificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicReviewLegacyQualificationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeriodicReviewLegacyQualificationQuery(baseOptions?: Apollo.QueryHookOptions<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>(PeriodicReviewLegacyQualificationDocument, options);
      }
export function usePeriodicReviewLegacyQualificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>(PeriodicReviewLegacyQualificationDocument, options);
        }
export function usePeriodicReviewLegacyQualificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>(PeriodicReviewLegacyQualificationDocument, options);
        }
export type PeriodicReviewLegacyQualificationQueryHookResult = ReturnType<typeof usePeriodicReviewLegacyQualificationQuery>;
export type PeriodicReviewLegacyQualificationLazyQueryHookResult = ReturnType<typeof usePeriodicReviewLegacyQualificationLazyQuery>;
export type PeriodicReviewLegacyQualificationSuspenseQueryHookResult = ReturnType<typeof usePeriodicReviewLegacyQualificationSuspenseQuery>;
export type PeriodicReviewLegacyQualificationQueryResult = Apollo.QueryResult<PeriodicReviewLegacyQualificationQuery, PeriodicReviewLegacyQualificationQueryVariables>;
export const PeriodicReviewQualificationDocument = gql`
    query PeriodicReviewQualification {
  periodicReviewQualification {
    dueDate
    dayRemaining
    inProgress
    actionRequired
  }
}
    `;

/**
 * __usePeriodicReviewQualificationQuery__
 *
 * To run a query within a React component, call `usePeriodicReviewQualificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicReviewQualificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicReviewQualificationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeriodicReviewQualificationQuery(baseOptions?: Apollo.QueryHookOptions<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>(PeriodicReviewQualificationDocument, options);
      }
export function usePeriodicReviewQualificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>(PeriodicReviewQualificationDocument, options);
        }
export function usePeriodicReviewQualificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>(PeriodicReviewQualificationDocument, options);
        }
export type PeriodicReviewQualificationQueryHookResult = ReturnType<typeof usePeriodicReviewQualificationQuery>;
export type PeriodicReviewQualificationLazyQueryHookResult = ReturnType<typeof usePeriodicReviewQualificationLazyQuery>;
export type PeriodicReviewQualificationSuspenseQueryHookResult = ReturnType<typeof usePeriodicReviewQualificationSuspenseQuery>;
export type PeriodicReviewQualificationQueryResult = Apollo.QueryResult<PeriodicReviewQualificationQuery, PeriodicReviewQualificationQueryVariables>;
export const QualificationProgressDocument = gql`
    query QualificationProgress($type: QualificationType!) {
  qualificationProgress(type: $type) {
    state
  }
}
    `;

/**
 * __useQualificationProgressQuery__
 *
 * To run a query within a React component, call `useQualificationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualificationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualificationProgressQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useQualificationProgressQuery(baseOptions: Apollo.QueryHookOptions<QualificationProgressQuery, QualificationProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QualificationProgressQuery, QualificationProgressQueryVariables>(QualificationProgressDocument, options);
      }
export function useQualificationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QualificationProgressQuery, QualificationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QualificationProgressQuery, QualificationProgressQueryVariables>(QualificationProgressDocument, options);
        }
export function useQualificationProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QualificationProgressQuery, QualificationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QualificationProgressQuery, QualificationProgressQueryVariables>(QualificationProgressDocument, options);
        }
export type QualificationProgressQueryHookResult = ReturnType<typeof useQualificationProgressQuery>;
export type QualificationProgressLazyQueryHookResult = ReturnType<typeof useQualificationProgressLazyQuery>;
export type QualificationProgressSuspenseQueryHookResult = ReturnType<typeof useQualificationProgressSuspenseQuery>;
export type QualificationProgressQueryResult = Apollo.QueryResult<QualificationProgressQuery, QualificationProgressQueryVariables>;
export const ReportDocument = gql`
    query Report($input: ReportInput!) {
  report(input: $input) {
    ...ReportCompleteInfo
    ...ReportIncompleteInfo
  }
}
    ${ReportCompleteInfoFragmentDoc}
${ReportIncompleteInfoFragmentDoc}`;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export function useReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportSuspenseQueryHookResult = ReturnType<typeof useReportSuspenseQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;
export const ReversalDocument = gql`
    query Reversal($id: ID!) {
  reversal(id: $id) {
    ...ReversalInfo
  }
}
    ${ReversalInfoFragmentDoc}`;

/**
 * __useReversalQuery__
 *
 * To run a query within a React component, call `useReversalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReversalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReversalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReversalQuery(baseOptions: Apollo.QueryHookOptions<ReversalQuery, ReversalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReversalQuery, ReversalQueryVariables>(ReversalDocument, options);
      }
export function useReversalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReversalQuery, ReversalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReversalQuery, ReversalQueryVariables>(ReversalDocument, options);
        }
export function useReversalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReversalQuery, ReversalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReversalQuery, ReversalQueryVariables>(ReversalDocument, options);
        }
export type ReversalQueryHookResult = ReturnType<typeof useReversalQuery>;
export type ReversalLazyQueryHookResult = ReturnType<typeof useReversalLazyQuery>;
export type ReversalSuspenseQueryHookResult = ReturnType<typeof useReversalSuspenseQuery>;
export type ReversalQueryResult = Apollo.QueryResult<ReversalQuery, ReversalQueryVariables>;
export const ReversalsDocument = gql`
    query Reversals($page: PaginationInput, $status: MerchantPaymentStatus) {
  reversals(page: $page, status: $status) {
    ...PaginationInfo
    ...ReversalsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${ReversalsInfoFragmentDoc}`;

/**
 * __useReversalsQuery__
 *
 * To run a query within a React component, call `useReversalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReversalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReversalsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useReversalsQuery(baseOptions?: Apollo.QueryHookOptions<ReversalsQuery, ReversalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReversalsQuery, ReversalsQueryVariables>(ReversalsDocument, options);
      }
export function useReversalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReversalsQuery, ReversalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReversalsQuery, ReversalsQueryVariables>(ReversalsDocument, options);
        }
export function useReversalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReversalsQuery, ReversalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReversalsQuery, ReversalsQueryVariables>(ReversalsDocument, options);
        }
export type ReversalsQueryHookResult = ReturnType<typeof useReversalsQuery>;
export type ReversalsLazyQueryHookResult = ReturnType<typeof useReversalsLazyQuery>;
export type ReversalsSuspenseQueryHookResult = ReturnType<typeof useReversalsSuspenseQuery>;
export type ReversalsQueryResult = Apollo.QueryResult<ReversalsQuery, ReversalsQueryVariables>;
export const SandboxSignupDocument = gql`
    mutation SandboxSignup($input: SandboxSignupInput!) {
  sandboxSignup(input: $input)
}
    `;
export type SandboxSignupMutationFn = Apollo.MutationFunction<SandboxSignupMutation, SandboxSignupMutationVariables>;

/**
 * __useSandboxSignupMutation__
 *
 * To run a mutation, you first call `useSandboxSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxSignupMutation, { data, loading, error }] = useSandboxSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSandboxSignupMutation(baseOptions?: Apollo.MutationHookOptions<SandboxSignupMutation, SandboxSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxSignupMutation, SandboxSignupMutationVariables>(SandboxSignupDocument, options);
      }
export type SandboxSignupMutationHookResult = ReturnType<typeof useSandboxSignupMutation>;
export type SandboxSignupMutationResult = Apollo.MutationResult<SandboxSignupMutation>;
export type SandboxSignupMutationOptions = Apollo.BaseMutationOptions<SandboxSignupMutation, SandboxSignupMutationVariables>;
export const SetSettingsFeatureDocument = gql`
    mutation SetSettingsFeature($type: SettingsFeaturesType!) {
  setSettingsFeature(type: $type) {
    features {
      ...SettingsFeaturesInfo
    }
  }
}
    ${SettingsFeaturesInfoFragmentDoc}`;
export type SetSettingsFeatureMutationFn = Apollo.MutationFunction<SetSettingsFeatureMutation, SetSettingsFeatureMutationVariables>;

/**
 * __useSetSettingsFeatureMutation__
 *
 * To run a mutation, you first call `useSetSettingsFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSettingsFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSettingsFeatureMutation, { data, loading, error }] = useSetSettingsFeatureMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSetSettingsFeatureMutation(baseOptions?: Apollo.MutationHookOptions<SetSettingsFeatureMutation, SetSettingsFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSettingsFeatureMutation, SetSettingsFeatureMutationVariables>(SetSettingsFeatureDocument, options);
      }
export type SetSettingsFeatureMutationHookResult = ReturnType<typeof useSetSettingsFeatureMutation>;
export type SetSettingsFeatureMutationResult = Apollo.MutationResult<SetSettingsFeatureMutation>;
export type SetSettingsFeatureMutationOptions = Apollo.BaseMutationOptions<SetSettingsFeatureMutation, SetSettingsFeatureMutationVariables>;
export const SettingsFeaturesDocument = gql`
    query SettingsFeatures {
  settings {
    features {
      ...SettingsFeaturesInfo
    }
  }
}
    ${SettingsFeaturesInfoFragmentDoc}`;

/**
 * __useSettingsFeaturesQuery__
 *
 * To run a query within a React component, call `useSettingsFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>(SettingsFeaturesDocument, options);
      }
export function useSettingsFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>(SettingsFeaturesDocument, options);
        }
export function useSettingsFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>(SettingsFeaturesDocument, options);
        }
export type SettingsFeaturesQueryHookResult = ReturnType<typeof useSettingsFeaturesQuery>;
export type SettingsFeaturesLazyQueryHookResult = ReturnType<typeof useSettingsFeaturesLazyQuery>;
export type SettingsFeaturesSuspenseQueryHookResult = ReturnType<typeof useSettingsFeaturesSuspenseQuery>;
export type SettingsFeaturesQueryResult = Apollo.QueryResult<SettingsFeaturesQuery, SettingsFeaturesQueryVariables>;
export const CreateSettlementCreditTransferDocument = gql`
    mutation createSettlementCreditTransfer($input: SettlementCreditTransferInput!) {
  createSettlementCreditTransfer(input: $input) {
    ...SettlementCreditTransferInfo
  }
}
    ${SettlementCreditTransferInfoFragmentDoc}`;
export type CreateSettlementCreditTransferMutationFn = Apollo.MutationFunction<CreateSettlementCreditTransferMutation, CreateSettlementCreditTransferMutationVariables>;

/**
 * __useCreateSettlementCreditTransferMutation__
 *
 * To run a mutation, you first call `useCreateSettlementCreditTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettlementCreditTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettlementCreditTransferMutation, { data, loading, error }] = useCreateSettlementCreditTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSettlementCreditTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateSettlementCreditTransferMutation, CreateSettlementCreditTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSettlementCreditTransferMutation, CreateSettlementCreditTransferMutationVariables>(CreateSettlementCreditTransferDocument, options);
      }
export type CreateSettlementCreditTransferMutationHookResult = ReturnType<typeof useCreateSettlementCreditTransferMutation>;
export type CreateSettlementCreditTransferMutationResult = Apollo.MutationResult<CreateSettlementCreditTransferMutation>;
export type CreateSettlementCreditTransferMutationOptions = Apollo.BaseMutationOptions<CreateSettlementCreditTransferMutation, CreateSettlementCreditTransferMutationVariables>;
export const SettlementCreditLinesDocument = gql`
    query SettlementCreditLines {
  settlementCreditLines {
    ...SettlementCreditLineInfo
  }
}
    ${SettlementCreditLineInfoFragmentDoc}`;

/**
 * __useSettlementCreditLinesQuery__
 *
 * To run a query within a React component, call `useSettlementCreditLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditLinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettlementCreditLinesQuery(baseOptions?: Apollo.QueryHookOptions<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>(SettlementCreditLinesDocument, options);
      }
export function useSettlementCreditLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>(SettlementCreditLinesDocument, options);
        }
export function useSettlementCreditLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>(SettlementCreditLinesDocument, options);
        }
export type SettlementCreditLinesQueryHookResult = ReturnType<typeof useSettlementCreditLinesQuery>;
export type SettlementCreditLinesLazyQueryHookResult = ReturnType<typeof useSettlementCreditLinesLazyQuery>;
export type SettlementCreditLinesSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditLinesSuspenseQuery>;
export type SettlementCreditLinesQueryResult = Apollo.QueryResult<SettlementCreditLinesQuery, SettlementCreditLinesQueryVariables>;
export const SettlementCreditTransferDocument = gql`
    query SettlementCreditTransfer($id: ID!) {
  settlementCreditTransfer(id: $id) {
    ...SettlementCreditTransferDetailsInfo
  }
}
    ${SettlementCreditTransferDetailsInfoFragmentDoc}`;

/**
 * __useSettlementCreditTransferQuery__
 *
 * To run a query within a React component, call `useSettlementCreditTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditTransferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettlementCreditTransferQuery(baseOptions: Apollo.QueryHookOptions<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>(SettlementCreditTransferDocument, options);
      }
export function useSettlementCreditTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>(SettlementCreditTransferDocument, options);
        }
export function useSettlementCreditTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>(SettlementCreditTransferDocument, options);
        }
export type SettlementCreditTransferQueryHookResult = ReturnType<typeof useSettlementCreditTransferQuery>;
export type SettlementCreditTransferLazyQueryHookResult = ReturnType<typeof useSettlementCreditTransferLazyQuery>;
export type SettlementCreditTransferSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditTransferSuspenseQuery>;
export type SettlementCreditTransferQueryResult = Apollo.QueryResult<SettlementCreditTransferQuery, SettlementCreditTransferQueryVariables>;
export const SettlementCreditTransferFeeDocument = gql`
    query SettlementCreditTransferFee($id: ID!) {
  settlementCreditTransferFee(id: $id) {
    ...SettlementCreditTransferFeeInfo
  }
}
    ${SettlementCreditTransferFeeInfoFragmentDoc}`;

/**
 * __useSettlementCreditTransferFeeQuery__
 *
 * To run a query within a React component, call `useSettlementCreditTransferFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditTransferFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditTransferFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettlementCreditTransferFeeQuery(baseOptions: Apollo.QueryHookOptions<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>(SettlementCreditTransferFeeDocument, options);
      }
export function useSettlementCreditTransferFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>(SettlementCreditTransferFeeDocument, options);
        }
export function useSettlementCreditTransferFeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>(SettlementCreditTransferFeeDocument, options);
        }
export type SettlementCreditTransferFeeQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeeQuery>;
export type SettlementCreditTransferFeeLazyQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeeLazyQuery>;
export type SettlementCreditTransferFeeSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeeSuspenseQuery>;
export type SettlementCreditTransferFeeQueryResult = Apollo.QueryResult<SettlementCreditTransferFeeQuery, SettlementCreditTransferFeeQueryVariables>;
export const SettlementCreditTransferFeesDocument = gql`
    query SettlementCreditTransferFees($page: PaginationInput, $settlementCreditTransferId: ID!) {
  settlementCreditTransferFees(
    page: $page
    settlementCreditTransferId: $settlementCreditTransferId
  ) {
    ...SettlementCreditTransferFeesInfo
    ...PaginationInfo
  }
}
    ${SettlementCreditTransferFeesInfoFragmentDoc}
${PaginationInfoFragmentDoc}`;

/**
 * __useSettlementCreditTransferFeesQuery__
 *
 * To run a query within a React component, call `useSettlementCreditTransferFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditTransferFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditTransferFeesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      settlementCreditTransferId: // value for 'settlementCreditTransferId'
 *   },
 * });
 */
export function useSettlementCreditTransferFeesQuery(baseOptions: Apollo.QueryHookOptions<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>(SettlementCreditTransferFeesDocument, options);
      }
export function useSettlementCreditTransferFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>(SettlementCreditTransferFeesDocument, options);
        }
export function useSettlementCreditTransferFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>(SettlementCreditTransferFeesDocument, options);
        }
export type SettlementCreditTransferFeesQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeesQuery>;
export type SettlementCreditTransferFeesLazyQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeesLazyQuery>;
export type SettlementCreditTransferFeesSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditTransferFeesSuspenseQuery>;
export type SettlementCreditTransferFeesQueryResult = Apollo.QueryResult<SettlementCreditTransferFeesQuery, SettlementCreditTransferFeesQueryVariables>;
export const SettlementCreditTransferValidationDocument = gql`
    query SettlementCreditTransferValidation($id: ID!) {
  settlementCreditTransferValidation(id: $id) {
    ...SettlementCreditTransferValidationInfo
  }
}
    ${SettlementCreditTransferValidationInfoFragmentDoc}`;

/**
 * __useSettlementCreditTransferValidationQuery__
 *
 * To run a query within a React component, call `useSettlementCreditTransferValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditTransferValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditTransferValidationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettlementCreditTransferValidationQuery(baseOptions: Apollo.QueryHookOptions<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>(SettlementCreditTransferValidationDocument, options);
      }
export function useSettlementCreditTransferValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>(SettlementCreditTransferValidationDocument, options);
        }
export function useSettlementCreditTransferValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>(SettlementCreditTransferValidationDocument, options);
        }
export type SettlementCreditTransferValidationQueryHookResult = ReturnType<typeof useSettlementCreditTransferValidationQuery>;
export type SettlementCreditTransferValidationLazyQueryHookResult = ReturnType<typeof useSettlementCreditTransferValidationLazyQuery>;
export type SettlementCreditTransferValidationSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditTransferValidationSuspenseQuery>;
export type SettlementCreditTransferValidationQueryResult = Apollo.QueryResult<SettlementCreditTransferValidationQuery, SettlementCreditTransferValidationQueryVariables>;
export const SettlementCreditTransfersDocument = gql`
    query SettlementCreditTransfers($page: PaginationInput, $filter: SettlementCreditTransfersInput) {
  settlementCreditTransfers(page: $page, filter: $filter) {
    ...PaginationInfo
    ...SettlementCreditTransfersInfo
  }
}
    ${PaginationInfoFragmentDoc}
${SettlementCreditTransfersInfoFragmentDoc}`;

/**
 * __useSettlementCreditTransfersQuery__
 *
 * To run a query within a React component, call `useSettlementCreditTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditTransfersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSettlementCreditTransfersQuery(baseOptions?: Apollo.QueryHookOptions<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>(SettlementCreditTransfersDocument, options);
      }
export function useSettlementCreditTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>(SettlementCreditTransfersDocument, options);
        }
export function useSettlementCreditTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>(SettlementCreditTransfersDocument, options);
        }
export type SettlementCreditTransfersQueryHookResult = ReturnType<typeof useSettlementCreditTransfersQuery>;
export type SettlementCreditTransfersLazyQueryHookResult = ReturnType<typeof useSettlementCreditTransfersLazyQuery>;
export type SettlementCreditTransfersSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditTransfersSuspenseQuery>;
export type SettlementCreditTransfersQueryResult = Apollo.QueryResult<SettlementCreditTransfersQuery, SettlementCreditTransfersQueryVariables>;
export const SettlementCreditWireInstructionDocument = gql`
    query SettlementCreditWireInstruction($id: String!) {
  settlementCreditWireInstruction(id: $id) {
    ...SettlementCreditWireInstructionInfo
  }
}
    ${SettlementCreditWireInstructionInfoFragmentDoc}`;

/**
 * __useSettlementCreditWireInstructionQuery__
 *
 * To run a query within a React component, call `useSettlementCreditWireInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementCreditWireInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementCreditWireInstructionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettlementCreditWireInstructionQuery(baseOptions: Apollo.QueryHookOptions<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>(SettlementCreditWireInstructionDocument, options);
      }
export function useSettlementCreditWireInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>(SettlementCreditWireInstructionDocument, options);
        }
export function useSettlementCreditWireInstructionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>(SettlementCreditWireInstructionDocument, options);
        }
export type SettlementCreditWireInstructionQueryHookResult = ReturnType<typeof useSettlementCreditWireInstructionQuery>;
export type SettlementCreditWireInstructionLazyQueryHookResult = ReturnType<typeof useSettlementCreditWireInstructionLazyQuery>;
export type SettlementCreditWireInstructionSuspenseQueryHookResult = ReturnType<typeof useSettlementCreditWireInstructionSuspenseQuery>;
export type SettlementCreditWireInstructionQueryResult = Apollo.QueryResult<SettlementCreditWireInstructionQuery, SettlementCreditWireInstructionQueryVariables>;
export const SettlementDocument = gql`
    query Settlement($id: ID!) {
  settlement(id: $id) {
    ...SettlementInfo
  }
}
    ${SettlementInfoFragmentDoc}`;

/**
 * __useSettlementQuery__
 *
 * To run a query within a React component, call `useSettlementQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSettlementQuery(baseOptions: Apollo.QueryHookOptions<SettlementQuery, SettlementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementQuery, SettlementQueryVariables>(SettlementDocument, options);
      }
export function useSettlementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementQuery, SettlementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementQuery, SettlementQueryVariables>(SettlementDocument, options);
        }
export function useSettlementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementQuery, SettlementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementQuery, SettlementQueryVariables>(SettlementDocument, options);
        }
export type SettlementQueryHookResult = ReturnType<typeof useSettlementQuery>;
export type SettlementLazyQueryHookResult = ReturnType<typeof useSettlementLazyQuery>;
export type SettlementSuspenseQueryHookResult = ReturnType<typeof useSettlementSuspenseQuery>;
export type SettlementQueryResult = Apollo.QueryResult<SettlementQuery, SettlementQueryVariables>;
export const SettlementsDocument = gql`
    query Settlements($page: PaginationInput) {
  settlements(page: $page) {
    ...PaginationInfo
    ...SettlementsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${SettlementsInfoFragmentDoc}`;

/**
 * __useSettlementsQuery__
 *
 * To run a query within a React component, call `useSettlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSettlementsQuery(baseOptions?: Apollo.QueryHookOptions<SettlementsQuery, SettlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettlementsQuery, SettlementsQueryVariables>(SettlementsDocument, options);
      }
export function useSettlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettlementsQuery, SettlementsQueryVariables>(SettlementsDocument, options);
        }
export function useSettlementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettlementsQuery, SettlementsQueryVariables>(SettlementsDocument, options);
        }
export type SettlementsQueryHookResult = ReturnType<typeof useSettlementsQuery>;
export type SettlementsLazyQueryHookResult = ReturnType<typeof useSettlementsLazyQuery>;
export type SettlementsSuspenseQueryHookResult = ReturnType<typeof useSettlementsSuspenseQuery>;
export type SettlementsQueryResult = Apollo.QueryResult<SettlementsQuery, SettlementsQueryVariables>;
export const CreateStablecoinExpressDepositRouteDocument = gql`
    mutation CreateStablecoinExpressDepositRoute($input: CreateStablecoinExpressDepositRouteInput!) {
  createStablecoinExpressDepositRoute(input: $input) {
    ...StablecoinExpressRouteInfo
  }
}
    ${StablecoinExpressRouteInfoFragmentDoc}`;
export type CreateStablecoinExpressDepositRouteMutationFn = Apollo.MutationFunction<CreateStablecoinExpressDepositRouteMutation, CreateStablecoinExpressDepositRouteMutationVariables>;

/**
 * __useCreateStablecoinExpressDepositRouteMutation__
 *
 * To run a mutation, you first call `useCreateStablecoinExpressDepositRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStablecoinExpressDepositRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStablecoinExpressDepositRouteMutation, { data, loading, error }] = useCreateStablecoinExpressDepositRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStablecoinExpressDepositRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateStablecoinExpressDepositRouteMutation, CreateStablecoinExpressDepositRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStablecoinExpressDepositRouteMutation, CreateStablecoinExpressDepositRouteMutationVariables>(CreateStablecoinExpressDepositRouteDocument, options);
      }
export type CreateStablecoinExpressDepositRouteMutationHookResult = ReturnType<typeof useCreateStablecoinExpressDepositRouteMutation>;
export type CreateStablecoinExpressDepositRouteMutationResult = Apollo.MutationResult<CreateStablecoinExpressDepositRouteMutation>;
export type CreateStablecoinExpressDepositRouteMutationOptions = Apollo.BaseMutationOptions<CreateStablecoinExpressDepositRouteMutation, CreateStablecoinExpressDepositRouteMutationVariables>;
export const CreateStablecoinExpressWithdrawalRouteDocument = gql`
    mutation CreateStablecoinExpressWithdrawalRoute($input: CreateStablecoinExpressWithdrawalRouteInput!) {
  createStablecoinExpressWithdrawalRoute(input: $input) {
    ...StablecoinExpressRouteInfo
  }
}
    ${StablecoinExpressRouteInfoFragmentDoc}`;
export type CreateStablecoinExpressWithdrawalRouteMutationFn = Apollo.MutationFunction<CreateStablecoinExpressWithdrawalRouteMutation, CreateStablecoinExpressWithdrawalRouteMutationVariables>;

/**
 * __useCreateStablecoinExpressWithdrawalRouteMutation__
 *
 * To run a mutation, you first call `useCreateStablecoinExpressWithdrawalRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStablecoinExpressWithdrawalRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStablecoinExpressWithdrawalRouteMutation, { data, loading, error }] = useCreateStablecoinExpressWithdrawalRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStablecoinExpressWithdrawalRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateStablecoinExpressWithdrawalRouteMutation, CreateStablecoinExpressWithdrawalRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStablecoinExpressWithdrawalRouteMutation, CreateStablecoinExpressWithdrawalRouteMutationVariables>(CreateStablecoinExpressWithdrawalRouteDocument, options);
      }
export type CreateStablecoinExpressWithdrawalRouteMutationHookResult = ReturnType<typeof useCreateStablecoinExpressWithdrawalRouteMutation>;
export type CreateStablecoinExpressWithdrawalRouteMutationResult = Apollo.MutationResult<CreateStablecoinExpressWithdrawalRouteMutation>;
export type CreateStablecoinExpressWithdrawalRouteMutationOptions = Apollo.BaseMutationOptions<CreateStablecoinExpressWithdrawalRouteMutation, CreateStablecoinExpressWithdrawalRouteMutationVariables>;
export const SetStablecoinExpressRouteDocument = gql`
    mutation SetStablecoinExpressRoute($input: StablecoinExpressRouteInput!) {
  setStablecoinExpressRoute(input: $input) {
    ...StablecoinExpressRouteInfo
  }
}
    ${StablecoinExpressRouteInfoFragmentDoc}`;
export type SetStablecoinExpressRouteMutationFn = Apollo.MutationFunction<SetStablecoinExpressRouteMutation, SetStablecoinExpressRouteMutationVariables>;

/**
 * __useSetStablecoinExpressRouteMutation__
 *
 * To run a mutation, you first call `useSetStablecoinExpressRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStablecoinExpressRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStablecoinExpressRouteMutation, { data, loading, error }] = useSetStablecoinExpressRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStablecoinExpressRouteMutation(baseOptions?: Apollo.MutationHookOptions<SetStablecoinExpressRouteMutation, SetStablecoinExpressRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStablecoinExpressRouteMutation, SetStablecoinExpressRouteMutationVariables>(SetStablecoinExpressRouteDocument, options);
      }
export type SetStablecoinExpressRouteMutationHookResult = ReturnType<typeof useSetStablecoinExpressRouteMutation>;
export type SetStablecoinExpressRouteMutationResult = Apollo.MutationResult<SetStablecoinExpressRouteMutation>;
export type SetStablecoinExpressRouteMutationOptions = Apollo.BaseMutationOptions<SetStablecoinExpressRouteMutation, SetStablecoinExpressRouteMutationVariables>;
export const StablecoinExpressRoutesDocument = gql`
    query StablecoinExpressRoutes {
  stablecoinExpressRoutes {
    ...StablecoinExpressRouteInfo
  }
}
    ${StablecoinExpressRouteInfoFragmentDoc}`;

/**
 * __useStablecoinExpressRoutesQuery__
 *
 * To run a query within a React component, call `useStablecoinExpressRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStablecoinExpressRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStablecoinExpressRoutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStablecoinExpressRoutesQuery(baseOptions?: Apollo.QueryHookOptions<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>(StablecoinExpressRoutesDocument, options);
      }
export function useStablecoinExpressRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>(StablecoinExpressRoutesDocument, options);
        }
export function useStablecoinExpressRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>(StablecoinExpressRoutesDocument, options);
        }
export type StablecoinExpressRoutesQueryHookResult = ReturnType<typeof useStablecoinExpressRoutesQuery>;
export type StablecoinExpressRoutesLazyQueryHookResult = ReturnType<typeof useStablecoinExpressRoutesLazyQuery>;
export type StablecoinExpressRoutesSuspenseQueryHookResult = ReturnType<typeof useStablecoinExpressRoutesSuspenseQuery>;
export type StablecoinExpressRoutesQueryResult = Apollo.QueryResult<StablecoinExpressRoutesQuery, StablecoinExpressRoutesQueryVariables>;
export const StatesDocument = gql`
    query States($filter: StatesInput!) {
  states(filter: $filter) {
    ...StatesInfo
  }
}
    ${StatesInfoFragmentDoc}`;

/**
 * __useStatesQuery__
 *
 * To run a query within a React component, call `useStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStatesQuery(baseOptions: Apollo.QueryHookOptions<StatesQuery, StatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
      }
export function useStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatesQuery, StatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
        }
export function useStatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StatesQuery, StatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
        }
export type StatesQueryHookResult = ReturnType<typeof useStatesQuery>;
export type StatesLazyQueryHookResult = ReturnType<typeof useStatesLazyQuery>;
export type StatesSuspenseQueryHookResult = ReturnType<typeof useStatesSuspenseQuery>;
export type StatesQueryResult = Apollo.QueryResult<StatesQuery, StatesQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions {
  subscriptions {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionsSuspenseQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const UpdateAutoPayDocument = gql`
    mutation UpdateAutoPay($automaticPaymentEnabled: Boolean!) {
  updateAutoPay(automaticPaymentEnabled: $automaticPaymentEnabled)
}
    `;
export type UpdateAutoPayMutationFn = Apollo.MutationFunction<UpdateAutoPayMutation, UpdateAutoPayMutationVariables>;

/**
 * __useUpdateAutoPayMutation__
 *
 * To run a mutation, you first call `useUpdateAutoPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoPayMutation, { data, loading, error }] = useUpdateAutoPayMutation({
 *   variables: {
 *      automaticPaymentEnabled: // value for 'automaticPaymentEnabled'
 *   },
 * });
 */
export function useUpdateAutoPayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutoPayMutation, UpdateAutoPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutoPayMutation, UpdateAutoPayMutationVariables>(UpdateAutoPayDocument, options);
      }
export type UpdateAutoPayMutationHookResult = ReturnType<typeof useUpdateAutoPayMutation>;
export type UpdateAutoPayMutationResult = Apollo.MutationResult<UpdateAutoPayMutation>;
export type UpdateAutoPayMutationOptions = Apollo.BaseMutationOptions<UpdateAutoPayMutation, UpdateAutoPayMutationVariables>;
export const TakeoverInfoDocument = gql`
    query TakeoverInfo {
  periodicReviewQualification {
    dueDate
    dayRemaining
    inProgress
    actionRequired
  }
  scaFactorInfo {
    pinCode {
      status
    }
  }
}
    `;

/**
 * __useTakeoverInfoQuery__
 *
 * To run a query within a React component, call `useTakeoverInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoverInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoverInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTakeoverInfoQuery(baseOptions?: Apollo.QueryHookOptions<TakeoverInfoQuery, TakeoverInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TakeoverInfoQuery, TakeoverInfoQueryVariables>(TakeoverInfoDocument, options);
      }
export function useTakeoverInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TakeoverInfoQuery, TakeoverInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TakeoverInfoQuery, TakeoverInfoQueryVariables>(TakeoverInfoDocument, options);
        }
export function useTakeoverInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TakeoverInfoQuery, TakeoverInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TakeoverInfoQuery, TakeoverInfoQueryVariables>(TakeoverInfoDocument, options);
        }
export type TakeoverInfoQueryHookResult = ReturnType<typeof useTakeoverInfoQuery>;
export type TakeoverInfoLazyQueryHookResult = ReturnType<typeof useTakeoverInfoLazyQuery>;
export type TakeoverInfoSuspenseQueryHookResult = ReturnType<typeof useTakeoverInfoSuspenseQuery>;
export type TakeoverInfoQueryResult = Apollo.QueryResult<TakeoverInfoQuery, TakeoverInfoQueryVariables>;
export const CreateTradeDocument = gql`
    mutation CreateTrade($quoteId: ID!) {
  createTrade(quoteId: $quoteId) {
    ...TradeInfo
  }
}
    ${TradeInfoFragmentDoc}`;
export type CreateTradeMutationFn = Apollo.MutationFunction<CreateTradeMutation, CreateTradeMutationVariables>;

/**
 * __useCreateTradeMutation__
 *
 * To run a mutation, you first call `useCreateTradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTradeMutation, { data, loading, error }] = useCreateTradeMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useCreateTradeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTradeMutation, CreateTradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTradeMutation, CreateTradeMutationVariables>(CreateTradeDocument, options);
      }
export type CreateTradeMutationHookResult = ReturnType<typeof useCreateTradeMutation>;
export type CreateTradeMutationResult = Apollo.MutationResult<CreateTradeMutation>;
export type CreateTradeMutationOptions = Apollo.BaseMutationOptions<CreateTradeMutation, CreateTradeMutationVariables>;
export const DailyLimitsDocument = gql`
    query DailyLimits {
  dailyLimits {
    ...DailyLimitsInfo
  }
}
    ${DailyLimitsInfoFragmentDoc}`;

/**
 * __useDailyLimitsQuery__
 *
 * To run a query within a React component, call `useDailyLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDailyLimitsQuery(baseOptions?: Apollo.QueryHookOptions<DailyLimitsQuery, DailyLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyLimitsQuery, DailyLimitsQueryVariables>(DailyLimitsDocument, options);
      }
export function useDailyLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyLimitsQuery, DailyLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyLimitsQuery, DailyLimitsQueryVariables>(DailyLimitsDocument, options);
        }
export function useDailyLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyLimitsQuery, DailyLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyLimitsQuery, DailyLimitsQueryVariables>(DailyLimitsDocument, options);
        }
export type DailyLimitsQueryHookResult = ReturnType<typeof useDailyLimitsQuery>;
export type DailyLimitsLazyQueryHookResult = ReturnType<typeof useDailyLimitsLazyQuery>;
export type DailyLimitsSuspenseQueryHookResult = ReturnType<typeof useDailyLimitsSuspenseQuery>;
export type DailyLimitsQueryResult = Apollo.QueryResult<DailyLimitsQuery, DailyLimitsQueryVariables>;
export const TradeDocument = gql`
    query Trade($id: ID!) {
  trade(id: $id) {
    ...TradeInfo
  }
}
    ${TradeInfoFragmentDoc}`;

/**
 * __useTradeQuery__
 *
 * To run a query within a React component, call `useTradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradeQuery(baseOptions: Apollo.QueryHookOptions<TradeQuery, TradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeQuery, TradeQueryVariables>(TradeDocument, options);
      }
export function useTradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeQuery, TradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeQuery, TradeQueryVariables>(TradeDocument, options);
        }
export function useTradeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TradeQuery, TradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TradeQuery, TradeQueryVariables>(TradeDocument, options);
        }
export type TradeQueryHookResult = ReturnType<typeof useTradeQuery>;
export type TradeLazyQueryHookResult = ReturnType<typeof useTradeLazyQuery>;
export type TradeSuspenseQueryHookResult = ReturnType<typeof useTradeSuspenseQuery>;
export type TradeQueryResult = Apollo.QueryResult<TradeQuery, TradeQueryVariables>;
export const TradeByJobIdDocument = gql`
    query TradeByJobId($jobId: ID!) {
  tradeByJobId(jobId: $jobId) {
    ...TradeInfo
  }
}
    ${TradeInfoFragmentDoc}`;

/**
 * __useTradeByJobIdQuery__
 *
 * To run a query within a React component, call `useTradeByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useTradeByJobIdQuery(baseOptions: Apollo.QueryHookOptions<TradeByJobIdQuery, TradeByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeByJobIdQuery, TradeByJobIdQueryVariables>(TradeByJobIdDocument, options);
      }
export function useTradeByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeByJobIdQuery, TradeByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeByJobIdQuery, TradeByJobIdQueryVariables>(TradeByJobIdDocument, options);
        }
export function useTradeByJobIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TradeByJobIdQuery, TradeByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TradeByJobIdQuery, TradeByJobIdQueryVariables>(TradeByJobIdDocument, options);
        }
export type TradeByJobIdQueryHookResult = ReturnType<typeof useTradeByJobIdQuery>;
export type TradeByJobIdLazyQueryHookResult = ReturnType<typeof useTradeByJobIdLazyQuery>;
export type TradeByJobIdSuspenseQueryHookResult = ReturnType<typeof useTradeByJobIdSuspenseQuery>;
export type TradeByJobIdQueryResult = Apollo.QueryResult<TradeByJobIdQuery, TradeByJobIdQueryVariables>;
export const ChainedTransferDocument = gql`
    query ChainedTransfer($id: ID!) {
  chainedTransfer(id: $id) {
    ...TransferInfo
  }
}
    ${TransferInfoFragmentDoc}`;

/**
 * __useChainedTransferQuery__
 *
 * To run a query within a React component, call `useChainedTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useChainedTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChainedTransferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChainedTransferQuery(baseOptions: Apollo.QueryHookOptions<ChainedTransferQuery, ChainedTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChainedTransferQuery, ChainedTransferQueryVariables>(ChainedTransferDocument, options);
      }
export function useChainedTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChainedTransferQuery, ChainedTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChainedTransferQuery, ChainedTransferQueryVariables>(ChainedTransferDocument, options);
        }
export function useChainedTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChainedTransferQuery, ChainedTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChainedTransferQuery, ChainedTransferQueryVariables>(ChainedTransferDocument, options);
        }
export type ChainedTransferQueryHookResult = ReturnType<typeof useChainedTransferQuery>;
export type ChainedTransferLazyQueryHookResult = ReturnType<typeof useChainedTransferLazyQuery>;
export type ChainedTransferSuspenseQueryHookResult = ReturnType<typeof useChainedTransferSuspenseQuery>;
export type ChainedTransferQueryResult = Apollo.QueryResult<ChainedTransferQuery, ChainedTransferQueryVariables>;
export const IncompleteChainedTransfersDocument = gql`
    query IncompleteChainedTransfers {
  incompleteChainedTransfers {
    id
    destination {
      ...TransferLocationInfo
    }
    amount {
      ...AmountInfo
    }
    status
    chainedBlockchainTransferStatus
  }
}
    ${TransferLocationInfoFragmentDoc}
${AmountInfoFragmentDoc}`;

/**
 * __useIncompleteChainedTransfersQuery__
 *
 * To run a query within a React component, call `useIncompleteChainedTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncompleteChainedTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncompleteChainedTransfersQuery({
 *   variables: {
 *   },
 * });
 */
export function useIncompleteChainedTransfersQuery(baseOptions?: Apollo.QueryHookOptions<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>(IncompleteChainedTransfersDocument, options);
      }
export function useIncompleteChainedTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>(IncompleteChainedTransfersDocument, options);
        }
export function useIncompleteChainedTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>(IncompleteChainedTransfersDocument, options);
        }
export type IncompleteChainedTransfersQueryHookResult = ReturnType<typeof useIncompleteChainedTransfersQuery>;
export type IncompleteChainedTransfersLazyQueryHookResult = ReturnType<typeof useIncompleteChainedTransfersLazyQuery>;
export type IncompleteChainedTransfersSuspenseQueryHookResult = ReturnType<typeof useIncompleteChainedTransfersSuspenseQuery>;
export type IncompleteChainedTransfersQueryResult = Apollo.QueryResult<IncompleteChainedTransfersQuery, IncompleteChainedTransfersQueryVariables>;
export const TransferDocument = gql`
    query Transfer($id: ID!) {
  transfer(id: $id) {
    ...TransferInfo
  }
}
    ${TransferInfoFragmentDoc}`;

/**
 * __useTransferQuery__
 *
 * To run a query within a React component, call `useTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransferQuery(baseOptions: Apollo.QueryHookOptions<TransferQuery, TransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferQuery, TransferQueryVariables>(TransferDocument, options);
      }
export function useTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferQuery, TransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferQuery, TransferQueryVariables>(TransferDocument, options);
        }
export function useTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransferQuery, TransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferQuery, TransferQueryVariables>(TransferDocument, options);
        }
export type TransferQueryHookResult = ReturnType<typeof useTransferQuery>;
export type TransferLazyQueryHookResult = ReturnType<typeof useTransferLazyQuery>;
export type TransferSuspenseQueryHookResult = ReturnType<typeof useTransferSuspenseQuery>;
export type TransferQueryResult = Apollo.QueryResult<TransferQuery, TransferQueryVariables>;
export const TransfersDocument = gql`
    query Transfers($page: PaginationInput, $walletId: ID, $sourceWalletId: ID, $destinationWalletId: ID) {
  transfers(
    page: $page
    walletId: $walletId
    sourceWalletId: $sourceWalletId
    destinationWalletId: $destinationWalletId
  ) {
    ...PaginationInfo
    ...TransfersInfo
  }
}
    ${PaginationInfoFragmentDoc}
${TransfersInfoFragmentDoc}`;

/**
 * __useTransfersQuery__
 *
 * To run a query within a React component, call `useTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransfersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      walletId: // value for 'walletId'
 *      sourceWalletId: // value for 'sourceWalletId'
 *      destinationWalletId: // value for 'destinationWalletId'
 *   },
 * });
 */
export function useTransfersQuery(baseOptions?: Apollo.QueryHookOptions<TransfersQuery, TransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransfersQuery, TransfersQueryVariables>(TransfersDocument, options);
      }
export function useTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransfersQuery, TransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransfersQuery, TransfersQueryVariables>(TransfersDocument, options);
        }
export function useTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransfersQuery, TransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransfersQuery, TransfersQueryVariables>(TransfersDocument, options);
        }
export type TransfersQueryHookResult = ReturnType<typeof useTransfersQuery>;
export type TransfersLazyQueryHookResult = ReturnType<typeof useTransfersLazyQuery>;
export type TransfersSuspenseQueryHookResult = ReturnType<typeof useTransfersSuspenseQuery>;
export type TransfersQueryResult = Apollo.QueryResult<TransfersQuery, TransfersQueryVariables>;
export const TravelRuleSpeDisputeDocument = gql`
    mutation TravelRuleSpeDispute($linkId: String!) {
  travelRuleSpeDispute(linkId: $linkId)
}
    `;
export type TravelRuleSpeDisputeMutationFn = Apollo.MutationFunction<TravelRuleSpeDisputeMutation, TravelRuleSpeDisputeMutationVariables>;

/**
 * __useTravelRuleSpeDisputeMutation__
 *
 * To run a mutation, you first call `useTravelRuleSpeDisputeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSpeDisputeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelRuleSpeDisputeMutation, { data, loading, error }] = useTravelRuleSpeDisputeMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useTravelRuleSpeDisputeMutation(baseOptions?: Apollo.MutationHookOptions<TravelRuleSpeDisputeMutation, TravelRuleSpeDisputeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelRuleSpeDisputeMutation, TravelRuleSpeDisputeMutationVariables>(TravelRuleSpeDisputeDocument, options);
      }
export type TravelRuleSpeDisputeMutationHookResult = ReturnType<typeof useTravelRuleSpeDisputeMutation>;
export type TravelRuleSpeDisputeMutationResult = Apollo.MutationResult<TravelRuleSpeDisputeMutation>;
export type TravelRuleSpeDisputeMutationOptions = Apollo.BaseMutationOptions<TravelRuleSpeDisputeMutation, TravelRuleSpeDisputeMutationVariables>;
export const TravelRuleSpePiiDocument = gql`
    query TravelRuleSpePii($linkId: String!) {
  travelRuleSpePii(linkId: $linkId) {
    ...TravelRulePiiInfo
  }
}
    ${TravelRulePiiInfoFragmentDoc}`;

/**
 * __useTravelRuleSpePiiQuery__
 *
 * To run a query within a React component, call `useTravelRuleSpePiiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSpePiiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRuleSpePiiQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useTravelRuleSpePiiQuery(baseOptions: Apollo.QueryHookOptions<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>(TravelRuleSpePiiDocument, options);
      }
export function useTravelRuleSpePiiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>(TravelRuleSpePiiDocument, options);
        }
export function useTravelRuleSpePiiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>(TravelRuleSpePiiDocument, options);
        }
export type TravelRuleSpePiiQueryHookResult = ReturnType<typeof useTravelRuleSpePiiQuery>;
export type TravelRuleSpePiiLazyQueryHookResult = ReturnType<typeof useTravelRuleSpePiiLazyQuery>;
export type TravelRuleSpePiiSuspenseQueryHookResult = ReturnType<typeof useTravelRuleSpePiiSuspenseQuery>;
export type TravelRuleSpePiiQueryResult = Apollo.QueryResult<TravelRuleSpePiiQuery, TravelRuleSpePiiQueryVariables>;
export const TravelRuleSpeRequestOtpDocument = gql`
    mutation TravelRuleSpeRequestOtp($linkId: String!) {
  travelRuleSpeRequestOtp(linkId: $linkId)
}
    `;
export type TravelRuleSpeRequestOtpMutationFn = Apollo.MutationFunction<TravelRuleSpeRequestOtpMutation, TravelRuleSpeRequestOtpMutationVariables>;

/**
 * __useTravelRuleSpeRequestOtpMutation__
 *
 * To run a mutation, you first call `useTravelRuleSpeRequestOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSpeRequestOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelRuleSpeRequestOtpMutation, { data, loading, error }] = useTravelRuleSpeRequestOtpMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useTravelRuleSpeRequestOtpMutation(baseOptions?: Apollo.MutationHookOptions<TravelRuleSpeRequestOtpMutation, TravelRuleSpeRequestOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelRuleSpeRequestOtpMutation, TravelRuleSpeRequestOtpMutationVariables>(TravelRuleSpeRequestOtpDocument, options);
      }
export type TravelRuleSpeRequestOtpMutationHookResult = ReturnType<typeof useTravelRuleSpeRequestOtpMutation>;
export type TravelRuleSpeRequestOtpMutationResult = Apollo.MutationResult<TravelRuleSpeRequestOtpMutation>;
export type TravelRuleSpeRequestOtpMutationOptions = Apollo.BaseMutationOptions<TravelRuleSpeRequestOtpMutation, TravelRuleSpeRequestOtpMutationVariables>;
export const TravelRuleSpeReviewDocument = gql`
    query TravelRuleSpeReview($linkId: String!) {
  travelRuleSpeReview(linkId: $linkId) {
    requestType
    txHash
    date
    amount
    token
    address
  }
}
    `;

/**
 * __useTravelRuleSpeReviewQuery__
 *
 * To run a query within a React component, call `useTravelRuleSpeReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSpeReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelRuleSpeReviewQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useTravelRuleSpeReviewQuery(baseOptions: Apollo.QueryHookOptions<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>(TravelRuleSpeReviewDocument, options);
      }
export function useTravelRuleSpeReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>(TravelRuleSpeReviewDocument, options);
        }
export function useTravelRuleSpeReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>(TravelRuleSpeReviewDocument, options);
        }
export type TravelRuleSpeReviewQueryHookResult = ReturnType<typeof useTravelRuleSpeReviewQuery>;
export type TravelRuleSpeReviewLazyQueryHookResult = ReturnType<typeof useTravelRuleSpeReviewLazyQuery>;
export type TravelRuleSpeReviewSuspenseQueryHookResult = ReturnType<typeof useTravelRuleSpeReviewSuspenseQuery>;
export type TravelRuleSpeReviewQueryResult = Apollo.QueryResult<TravelRuleSpeReviewQuery, TravelRuleSpeReviewQueryVariables>;
export const TravelRuleSpeVerifyOtpDocument = gql`
    mutation TravelRuleSpeVerifyOtp($linkId: String!, $otp: String!) {
  travelRuleSpeVerifyOtp(linkId: $linkId, otp: $otp)
}
    `;
export type TravelRuleSpeVerifyOtpMutationFn = Apollo.MutationFunction<TravelRuleSpeVerifyOtpMutation, TravelRuleSpeVerifyOtpMutationVariables>;

/**
 * __useTravelRuleSpeVerifyOtpMutation__
 *
 * To run a mutation, you first call `useTravelRuleSpeVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSpeVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelRuleSpeVerifyOtpMutation, { data, loading, error }] = useTravelRuleSpeVerifyOtpMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useTravelRuleSpeVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<TravelRuleSpeVerifyOtpMutation, TravelRuleSpeVerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelRuleSpeVerifyOtpMutation, TravelRuleSpeVerifyOtpMutationVariables>(TravelRuleSpeVerifyOtpDocument, options);
      }
export type TravelRuleSpeVerifyOtpMutationHookResult = ReturnType<typeof useTravelRuleSpeVerifyOtpMutation>;
export type TravelRuleSpeVerifyOtpMutationResult = Apollo.MutationResult<TravelRuleSpeVerifyOtpMutation>;
export type TravelRuleSpeVerifyOtpMutationOptions = Apollo.BaseMutationOptions<TravelRuleSpeVerifyOtpMutation, TravelRuleSpeVerifyOtpMutationVariables>;
export const TravelRuleSubmitSpePiiDocument = gql`
    mutation TravelRuleSubmitSpePii($input: TravelRuleSubmitSpePiiInput!) {
  travelRuleSubmitSpePii(input: $input)
}
    `;
export type TravelRuleSubmitSpePiiMutationFn = Apollo.MutationFunction<TravelRuleSubmitSpePiiMutation, TravelRuleSubmitSpePiiMutationVariables>;

/**
 * __useTravelRuleSubmitSpePiiMutation__
 *
 * To run a mutation, you first call `useTravelRuleSubmitSpePiiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelRuleSubmitSpePiiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelRuleSubmitSpePiiMutation, { data, loading, error }] = useTravelRuleSubmitSpePiiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelRuleSubmitSpePiiMutation(baseOptions?: Apollo.MutationHookOptions<TravelRuleSubmitSpePiiMutation, TravelRuleSubmitSpePiiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelRuleSubmitSpePiiMutation, TravelRuleSubmitSpePiiMutationVariables>(TravelRuleSubmitSpePiiDocument, options);
      }
export type TravelRuleSubmitSpePiiMutationHookResult = ReturnType<typeof useTravelRuleSubmitSpePiiMutation>;
export type TravelRuleSubmitSpePiiMutationResult = Apollo.MutationResult<TravelRuleSubmitSpePiiMutation>;
export type TravelRuleSubmitSpePiiMutationOptions = Apollo.BaseMutationOptions<TravelRuleSubmitSpePiiMutation, TravelRuleSubmitSpePiiMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const EnrollPinCodeDocument = gql`
    mutation EnrollPinCode($code: String!) {
  enrollPinCode(code: $code)
}
    `;
export type EnrollPinCodeMutationFn = Apollo.MutationFunction<EnrollPinCodeMutation, EnrollPinCodeMutationVariables>;

/**
 * __useEnrollPinCodeMutation__
 *
 * To run a mutation, you first call `useEnrollPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollPinCodeMutation, { data, loading, error }] = useEnrollPinCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEnrollPinCodeMutation(baseOptions?: Apollo.MutationHookOptions<EnrollPinCodeMutation, EnrollPinCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollPinCodeMutation, EnrollPinCodeMutationVariables>(EnrollPinCodeDocument, options);
      }
export type EnrollPinCodeMutationHookResult = ReturnType<typeof useEnrollPinCodeMutation>;
export type EnrollPinCodeMutationResult = Apollo.MutationResult<EnrollPinCodeMutation>;
export type EnrollPinCodeMutationOptions = Apollo.BaseMutationOptions<EnrollPinCodeMutation, EnrollPinCodeMutationVariables>;
export const InviteAuthorizedRepDocument = gql`
    mutation InviteAuthorizedRep($input: InviteAuthorizedRepInput!) {
  inviteAuthorizedRep(input: $input)
}
    `;
export type InviteAuthorizedRepMutationFn = Apollo.MutationFunction<InviteAuthorizedRepMutation, InviteAuthorizedRepMutationVariables>;

/**
 * __useInviteAuthorizedRepMutation__
 *
 * To run a mutation, you first call `useInviteAuthorizedRepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteAuthorizedRepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteAuthorizedRepMutation, { data, loading, error }] = useInviteAuthorizedRepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteAuthorizedRepMutation(baseOptions?: Apollo.MutationHookOptions<InviteAuthorizedRepMutation, InviteAuthorizedRepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteAuthorizedRepMutation, InviteAuthorizedRepMutationVariables>(InviteAuthorizedRepDocument, options);
      }
export type InviteAuthorizedRepMutationHookResult = ReturnType<typeof useInviteAuthorizedRepMutation>;
export type InviteAuthorizedRepMutationResult = Apollo.MutationResult<InviteAuthorizedRepMutation>;
export type InviteAuthorizedRepMutationOptions = Apollo.BaseMutationOptions<InviteAuthorizedRepMutation, InviteAuthorizedRepMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($invitee: InviteeInput!) {
  inviteUser(invitee: $invitee)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      invitee: // value for 'invitee'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const ManageableUsersDocument = gql`
    query ManageableUsers {
  manageableUsers {
    ...UserInfo
    proposalId
    isAuthorizedRepresentative
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useManageableUsersQuery__
 *
 * To run a query within a React component, call `useManageableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useManageableUsersQuery(baseOptions?: Apollo.QueryHookOptions<ManageableUsersQuery, ManageableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageableUsersQuery, ManageableUsersQueryVariables>(ManageableUsersDocument, options);
      }
export function useManageableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageableUsersQuery, ManageableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageableUsersQuery, ManageableUsersQueryVariables>(ManageableUsersDocument, options);
        }
export function useManageableUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManageableUsersQuery, ManageableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManageableUsersQuery, ManageableUsersQueryVariables>(ManageableUsersDocument, options);
        }
export type ManageableUsersQueryHookResult = ReturnType<typeof useManageableUsersQuery>;
export type ManageableUsersLazyQueryHookResult = ReturnType<typeof useManageableUsersLazyQuery>;
export type ManageableUsersSuspenseQueryHookResult = ReturnType<typeof useManageableUsersSuspenseQuery>;
export type ManageableUsersQueryResult = Apollo.QueryResult<ManageableUsersQuery, ManageableUsersQueryVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser($email: String!, $userId: ID) {
  removeUser(email: $email, userId: $userId)
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($email: String!) {
  resendInvite(email: $email)
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const ResendUserActivationDocument = gql`
    mutation ResendUserActivation($email: String!) {
  resendUserActivation(email: $email)
}
    `;
export type ResendUserActivationMutationFn = Apollo.MutationFunction<ResendUserActivationMutation, ResendUserActivationMutationVariables>;

/**
 * __useResendUserActivationMutation__
 *
 * To run a mutation, you first call `useResendUserActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserActivationMutation, { data, loading, error }] = useResendUserActivationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendUserActivationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserActivationMutation, ResendUserActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserActivationMutation, ResendUserActivationMutationVariables>(ResendUserActivationDocument, options);
      }
export type ResendUserActivationMutationHookResult = ReturnType<typeof useResendUserActivationMutation>;
export type ResendUserActivationMutationResult = Apollo.MutationResult<ResendUserActivationMutation>;
export type ResendUserActivationMutationOptions = Apollo.BaseMutationOptions<ResendUserActivationMutation, ResendUserActivationMutationVariables>;
export const ResetMfaRequestDocument = gql`
    mutation ResetMfaRequest($input: ResetMfaRequestInput!) {
  resetMfaRequest(input: $input)
}
    `;
export type ResetMfaRequestMutationFn = Apollo.MutationFunction<ResetMfaRequestMutation, ResetMfaRequestMutationVariables>;

/**
 * __useResetMfaRequestMutation__
 *
 * To run a mutation, you first call `useResetMfaRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMfaRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMfaRequestMutation, { data, loading, error }] = useResetMfaRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetMfaRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResetMfaRequestMutation, ResetMfaRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMfaRequestMutation, ResetMfaRequestMutationVariables>(ResetMfaRequestDocument, options);
      }
export type ResetMfaRequestMutationHookResult = ReturnType<typeof useResetMfaRequestMutation>;
export type ResetMfaRequestMutationResult = Apollo.MutationResult<ResetMfaRequestMutation>;
export type ResetMfaRequestMutationOptions = Apollo.BaseMutationOptions<ResetMfaRequestMutation, ResetMfaRequestMutationVariables>;
export const ResetPinCodeDocument = gql`
    mutation ResetPinCode {
  resetPinCode
}
    `;
export type ResetPinCodeMutationFn = Apollo.MutationFunction<ResetPinCodeMutation, ResetPinCodeMutationVariables>;

/**
 * __useResetPinCodeMutation__
 *
 * To run a mutation, you first call `useResetPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPinCodeMutation, { data, loading, error }] = useResetPinCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetPinCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResetPinCodeMutation, ResetPinCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPinCodeMutation, ResetPinCodeMutationVariables>(ResetPinCodeDocument, options);
      }
export type ResetPinCodeMutationHookResult = ReturnType<typeof useResetPinCodeMutation>;
export type ResetPinCodeMutationResult = Apollo.MutationResult<ResetPinCodeMutation>;
export type ResetPinCodeMutationOptions = Apollo.BaseMutationOptions<ResetPinCodeMutation, ResetPinCodeMutationVariables>;
export const UpdateAndReturnEmailVerifiedDocument = gql`
    mutation UpdateAndReturnEmailVerified {
  updateAndReturnEmailVerified
}
    `;
export type UpdateAndReturnEmailVerifiedMutationFn = Apollo.MutationFunction<UpdateAndReturnEmailVerifiedMutation, UpdateAndReturnEmailVerifiedMutationVariables>;

/**
 * __useUpdateAndReturnEmailVerifiedMutation__
 *
 * To run a mutation, you first call `useUpdateAndReturnEmailVerifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndReturnEmailVerifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndReturnEmailVerifiedMutation, { data, loading, error }] = useUpdateAndReturnEmailVerifiedMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateAndReturnEmailVerifiedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndReturnEmailVerifiedMutation, UpdateAndReturnEmailVerifiedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndReturnEmailVerifiedMutation, UpdateAndReturnEmailVerifiedMutationVariables>(UpdateAndReturnEmailVerifiedDocument, options);
      }
export type UpdateAndReturnEmailVerifiedMutationHookResult = ReturnType<typeof useUpdateAndReturnEmailVerifiedMutation>;
export type UpdateAndReturnEmailVerifiedMutationResult = Apollo.MutationResult<UpdateAndReturnEmailVerifiedMutation>;
export type UpdateAndReturnEmailVerifiedMutationOptions = Apollo.BaseMutationOptions<UpdateAndReturnEmailVerifiedMutation, UpdateAndReturnEmailVerifiedMutationVariables>;
export const UpdatePinCodeDocument = gql`
    mutation UpdatePinCode($input: UpdatePinCodeInput!) {
  updatePinCode(input: $input)
}
    `;
export type UpdatePinCodeMutationFn = Apollo.MutationFunction<UpdatePinCodeMutation, UpdatePinCodeMutationVariables>;

/**
 * __useUpdatePinCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePinCodeMutation, { data, loading, error }] = useUpdatePinCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePinCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePinCodeMutation, UpdatePinCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePinCodeMutation, UpdatePinCodeMutationVariables>(UpdatePinCodeDocument, options);
      }
export type UpdatePinCodeMutationHookResult = ReturnType<typeof useUpdatePinCodeMutation>;
export type UpdatePinCodeMutationResult = Apollo.MutationResult<UpdatePinCodeMutation>;
export type UpdatePinCodeMutationOptions = Apollo.BaseMutationOptions<UpdatePinCodeMutation, UpdatePinCodeMutationVariables>;
export const UserDocument = gql`
    query User($userId: String) {
  user(userId: $userId) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserActivationDocument = gql`
    query UserActivation($token: String!) {
  userActivation(token: $token) {
    stateToken
    institutionName
    firstName
    lastName
    email
    existingUser
    tokenConsumed
  }
}
    `;

/**
 * __useUserActivationQuery__
 *
 * To run a query within a React component, call `useUserActivationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserActivationQuery(baseOptions: Apollo.QueryHookOptions<UserActivationQuery, UserActivationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserActivationQuery, UserActivationQueryVariables>(UserActivationDocument, options);
      }
export function useUserActivationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserActivationQuery, UserActivationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserActivationQuery, UserActivationQueryVariables>(UserActivationDocument, options);
        }
export function useUserActivationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserActivationQuery, UserActivationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserActivationQuery, UserActivationQueryVariables>(UserActivationDocument, options);
        }
export type UserActivationQueryHookResult = ReturnType<typeof useUserActivationQuery>;
export type UserActivationLazyQueryHookResult = ReturnType<typeof useUserActivationLazyQuery>;
export type UserActivationSuspenseQueryHookResult = ReturnType<typeof useUserActivationSuspenseQuery>;
export type UserActivationQueryResult = Apollo.QueryResult<UserActivationQuery, UserActivationQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const VerifiedUsersDocument = gql`
    query VerifiedUsers($filter: VerifiedUsersFilterInput) {
  verifiedUsers(filter: $filter) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useVerifiedUsersQuery__
 *
 * To run a query within a React component, call `useVerifiedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiedUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVerifiedUsersQuery(baseOptions?: Apollo.QueryHookOptions<VerifiedUsersQuery, VerifiedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifiedUsersQuery, VerifiedUsersQueryVariables>(VerifiedUsersDocument, options);
      }
export function useVerifiedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifiedUsersQuery, VerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifiedUsersQuery, VerifiedUsersQueryVariables>(VerifiedUsersDocument, options);
        }
export function useVerifiedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifiedUsersQuery, VerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifiedUsersQuery, VerifiedUsersQueryVariables>(VerifiedUsersDocument, options);
        }
export type VerifiedUsersQueryHookResult = ReturnType<typeof useVerifiedUsersQuery>;
export type VerifiedUsersLazyQueryHookResult = ReturnType<typeof useVerifiedUsersLazyQuery>;
export type VerifiedUsersSuspenseQueryHookResult = ReturnType<typeof useVerifiedUsersSuspenseQuery>;
export type VerifiedUsersQueryResult = Apollo.QueryResult<VerifiedUsersQuery, VerifiedUsersQueryVariables>;
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($input: CreateUserGroupInput!) {
  createUserGroup(input: $input) {
    id
  }
}
    `;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const UserGroupDocument = gql`
    query UserGroup($id: String!) {
  userGroup(id: $id) {
    ...UserGroupInfo
  }
}
    ${UserGroupInfoFragmentDoc}`;

/**
 * __useUserGroupQuery__
 *
 * To run a query within a React component, call `useUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupQuery(baseOptions: Apollo.QueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
      }
export function useUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
        }
export function useUserGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
        }
export type UserGroupQueryHookResult = ReturnType<typeof useUserGroupQuery>;
export type UserGroupLazyQueryHookResult = ReturnType<typeof useUserGroupLazyQuery>;
export type UserGroupSuspenseQueryHookResult = ReturnType<typeof useUserGroupSuspenseQuery>;
export type UserGroupQueryResult = Apollo.QueryResult<UserGroupQuery, UserGroupQueryVariables>;
export const UserGroupsDocument = gql`
    query UserGroups {
  userGroups {
    ...UserGroupInfo
  }
}
    ${UserGroupInfoFragmentDoc}`;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export function useUserGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserGroupsSuspenseQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const VerificationDocument = gql`
    query Verification {
  signInFactor {
    enrolled
  }
  preQualificationData {
    businessEntityName
    businessCountry
    businessState
    entityType
    natureOfBusiness
    expectedUsdcMintingVolume
    activeUsersOnPlatform
  }
}
    `;

/**
 * __useVerificationQuery__
 *
 * To run a query within a React component, call `useVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerificationQuery(baseOptions?: Apollo.QueryHookOptions<VerificationQuery, VerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerificationQuery, VerificationQueryVariables>(VerificationDocument, options);
      }
export function useVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerificationQuery, VerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerificationQuery, VerificationQueryVariables>(VerificationDocument, options);
        }
export function useVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerificationQuery, VerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerificationQuery, VerificationQueryVariables>(VerificationDocument, options);
        }
export type VerificationQueryHookResult = ReturnType<typeof useVerificationQuery>;
export type VerificationLazyQueryHookResult = ReturnType<typeof useVerificationLazyQuery>;
export type VerificationSuspenseQueryHookResult = ReturnType<typeof useVerificationSuspenseQuery>;
export type VerificationQueryResult = Apollo.QueryResult<VerificationQuery, VerificationQueryVariables>;
export const ActiveWalletApprovalPolicyDocument = gql`
    query ActiveWalletApprovalPolicy($currency: Currency!) {
  activeWalletApprovalPolicy(currency: $currency) {
    ...WalletApprovalPolicyInfo
  }
}
    ${WalletApprovalPolicyInfoFragmentDoc}`;

/**
 * __useActiveWalletApprovalPolicyQuery__
 *
 * To run a query within a React component, call `useActiveWalletApprovalPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveWalletApprovalPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveWalletApprovalPolicyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useActiveWalletApprovalPolicyQuery(baseOptions: Apollo.QueryHookOptions<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>(ActiveWalletApprovalPolicyDocument, options);
      }
export function useActiveWalletApprovalPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>(ActiveWalletApprovalPolicyDocument, options);
        }
export function useActiveWalletApprovalPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>(ActiveWalletApprovalPolicyDocument, options);
        }
export type ActiveWalletApprovalPolicyQueryHookResult = ReturnType<typeof useActiveWalletApprovalPolicyQuery>;
export type ActiveWalletApprovalPolicyLazyQueryHookResult = ReturnType<typeof useActiveWalletApprovalPolicyLazyQuery>;
export type ActiveWalletApprovalPolicySuspenseQueryHookResult = ReturnType<typeof useActiveWalletApprovalPolicySuspenseQuery>;
export type ActiveWalletApprovalPolicyQueryResult = Apollo.QueryResult<ActiveWalletApprovalPolicyQuery, ActiveWalletApprovalPolicyQueryVariables>;
export const CancelWalletApprovalPendingTransactionDocument = gql`
    mutation CancelWalletApprovalPendingTransaction($proposalId: String!) {
  cancelWalletApprovalPendingTransaction(proposalId: $proposalId)
}
    `;
export type CancelWalletApprovalPendingTransactionMutationFn = Apollo.MutationFunction<CancelWalletApprovalPendingTransactionMutation, CancelWalletApprovalPendingTransactionMutationVariables>;

/**
 * __useCancelWalletApprovalPendingTransactionMutation__
 *
 * To run a mutation, you first call `useCancelWalletApprovalPendingTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWalletApprovalPendingTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWalletApprovalPendingTransactionMutation, { data, loading, error }] = useCancelWalletApprovalPendingTransactionMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCancelWalletApprovalPendingTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CancelWalletApprovalPendingTransactionMutation, CancelWalletApprovalPendingTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWalletApprovalPendingTransactionMutation, CancelWalletApprovalPendingTransactionMutationVariables>(CancelWalletApprovalPendingTransactionDocument, options);
      }
export type CancelWalletApprovalPendingTransactionMutationHookResult = ReturnType<typeof useCancelWalletApprovalPendingTransactionMutation>;
export type CancelWalletApprovalPendingTransactionMutationResult = Apollo.MutationResult<CancelWalletApprovalPendingTransactionMutation>;
export type CancelWalletApprovalPendingTransactionMutationOptions = Apollo.BaseMutationOptions<CancelWalletApprovalPendingTransactionMutation, CancelWalletApprovalPendingTransactionMutationVariables>;
export const CancelWalletApprovalSubmittedPolicyDocument = gql`
    mutation CancelWalletApprovalSubmittedPolicy($input: ManageWalletApprovalPolicyInput!) {
  cancelWalletApprovalSubmittedPolicy(input: $input)
}
    `;
export type CancelWalletApprovalSubmittedPolicyMutationFn = Apollo.MutationFunction<CancelWalletApprovalSubmittedPolicyMutation, CancelWalletApprovalSubmittedPolicyMutationVariables>;

/**
 * __useCancelWalletApprovalSubmittedPolicyMutation__
 *
 * To run a mutation, you first call `useCancelWalletApprovalSubmittedPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWalletApprovalSubmittedPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWalletApprovalSubmittedPolicyMutation, { data, loading, error }] = useCancelWalletApprovalSubmittedPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWalletApprovalSubmittedPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CancelWalletApprovalSubmittedPolicyMutation, CancelWalletApprovalSubmittedPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWalletApprovalSubmittedPolicyMutation, CancelWalletApprovalSubmittedPolicyMutationVariables>(CancelWalletApprovalSubmittedPolicyDocument, options);
      }
export type CancelWalletApprovalSubmittedPolicyMutationHookResult = ReturnType<typeof useCancelWalletApprovalSubmittedPolicyMutation>;
export type CancelWalletApprovalSubmittedPolicyMutationResult = Apollo.MutationResult<CancelWalletApprovalSubmittedPolicyMutation>;
export type CancelWalletApprovalSubmittedPolicyMutationOptions = Apollo.BaseMutationOptions<CancelWalletApprovalSubmittedPolicyMutation, CancelWalletApprovalSubmittedPolicyMutationVariables>;
export const DiscardWalletApprovalDraftPolicyDocument = gql`
    mutation DiscardWalletApprovalDraftPolicy($input: ManageWalletApprovalPolicyInput!) {
  discardWalletApprovalDraftPolicy(input: $input)
}
    `;
export type DiscardWalletApprovalDraftPolicyMutationFn = Apollo.MutationFunction<DiscardWalletApprovalDraftPolicyMutation, DiscardWalletApprovalDraftPolicyMutationVariables>;

/**
 * __useDiscardWalletApprovalDraftPolicyMutation__
 *
 * To run a mutation, you first call `useDiscardWalletApprovalDraftPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardWalletApprovalDraftPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardWalletApprovalDraftPolicyMutation, { data, loading, error }] = useDiscardWalletApprovalDraftPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardWalletApprovalDraftPolicyMutation(baseOptions?: Apollo.MutationHookOptions<DiscardWalletApprovalDraftPolicyMutation, DiscardWalletApprovalDraftPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardWalletApprovalDraftPolicyMutation, DiscardWalletApprovalDraftPolicyMutationVariables>(DiscardWalletApprovalDraftPolicyDocument, options);
      }
export type DiscardWalletApprovalDraftPolicyMutationHookResult = ReturnType<typeof useDiscardWalletApprovalDraftPolicyMutation>;
export type DiscardWalletApprovalDraftPolicyMutationResult = Apollo.MutationResult<DiscardWalletApprovalDraftPolicyMutation>;
export type DiscardWalletApprovalDraftPolicyMutationOptions = Apollo.BaseMutationOptions<DiscardWalletApprovalDraftPolicyMutation, DiscardWalletApprovalDraftPolicyMutationVariables>;
export const DraftWalletApprovalPolicyDocument = gql`
    query DraftWalletApprovalPolicy($currency: Currency!) {
  draftWalletApprovalPolicy(currency: $currency) {
    ...WalletApprovalPolicyInfo
  }
}
    ${WalletApprovalPolicyInfoFragmentDoc}`;

/**
 * __useDraftWalletApprovalPolicyQuery__
 *
 * To run a query within a React component, call `useDraftWalletApprovalPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftWalletApprovalPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftWalletApprovalPolicyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useDraftWalletApprovalPolicyQuery(baseOptions: Apollo.QueryHookOptions<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>(DraftWalletApprovalPolicyDocument, options);
      }
export function useDraftWalletApprovalPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>(DraftWalletApprovalPolicyDocument, options);
        }
export function useDraftWalletApprovalPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>(DraftWalletApprovalPolicyDocument, options);
        }
export type DraftWalletApprovalPolicyQueryHookResult = ReturnType<typeof useDraftWalletApprovalPolicyQuery>;
export type DraftWalletApprovalPolicyLazyQueryHookResult = ReturnType<typeof useDraftWalletApprovalPolicyLazyQuery>;
export type DraftWalletApprovalPolicySuspenseQueryHookResult = ReturnType<typeof useDraftWalletApprovalPolicySuspenseQuery>;
export type DraftWalletApprovalPolicyQueryResult = Apollo.QueryResult<DraftWalletApprovalPolicyQuery, DraftWalletApprovalPolicyQueryVariables>;
export const SubmitWalletApprovalDraftPolicyDocument = gql`
    mutation SubmitWalletApprovalDraftPolicy($input: ManageWalletApprovalPolicyInput!) {
  submitWalletApprovalDraftPolicy(input: $input)
}
    `;
export type SubmitWalletApprovalDraftPolicyMutationFn = Apollo.MutationFunction<SubmitWalletApprovalDraftPolicyMutation, SubmitWalletApprovalDraftPolicyMutationVariables>;

/**
 * __useSubmitWalletApprovalDraftPolicyMutation__
 *
 * To run a mutation, you first call `useSubmitWalletApprovalDraftPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWalletApprovalDraftPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWalletApprovalDraftPolicyMutation, { data, loading, error }] = useSubmitWalletApprovalDraftPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitWalletApprovalDraftPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWalletApprovalDraftPolicyMutation, SubmitWalletApprovalDraftPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWalletApprovalDraftPolicyMutation, SubmitWalletApprovalDraftPolicyMutationVariables>(SubmitWalletApprovalDraftPolicyDocument, options);
      }
export type SubmitWalletApprovalDraftPolicyMutationHookResult = ReturnType<typeof useSubmitWalletApprovalDraftPolicyMutation>;
export type SubmitWalletApprovalDraftPolicyMutationResult = Apollo.MutationResult<SubmitWalletApprovalDraftPolicyMutation>;
export type SubmitWalletApprovalDraftPolicyMutationOptions = Apollo.BaseMutationOptions<SubmitWalletApprovalDraftPolicyMutation, SubmitWalletApprovalDraftPolicyMutationVariables>;
export const SubmittedWalletApprovalPolicyDocument = gql`
    query SubmittedWalletApprovalPolicy($currency: Currency!) {
  submittedWalletApprovalPolicy(currency: $currency) {
    ...WalletApprovalPolicyInfo
  }
}
    ${WalletApprovalPolicyInfoFragmentDoc}`;

/**
 * __useSubmittedWalletApprovalPolicyQuery__
 *
 * To run a query within a React component, call `useSubmittedWalletApprovalPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedWalletApprovalPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedWalletApprovalPolicyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSubmittedWalletApprovalPolicyQuery(baseOptions: Apollo.QueryHookOptions<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>(SubmittedWalletApprovalPolicyDocument, options);
      }
export function useSubmittedWalletApprovalPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>(SubmittedWalletApprovalPolicyDocument, options);
        }
export function useSubmittedWalletApprovalPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>(SubmittedWalletApprovalPolicyDocument, options);
        }
export type SubmittedWalletApprovalPolicyQueryHookResult = ReturnType<typeof useSubmittedWalletApprovalPolicyQuery>;
export type SubmittedWalletApprovalPolicyLazyQueryHookResult = ReturnType<typeof useSubmittedWalletApprovalPolicyLazyQuery>;
export type SubmittedWalletApprovalPolicySuspenseQueryHookResult = ReturnType<typeof useSubmittedWalletApprovalPolicySuspenseQuery>;
export type SubmittedWalletApprovalPolicyQueryResult = Apollo.QueryResult<SubmittedWalletApprovalPolicyQuery, SubmittedWalletApprovalPolicyQueryVariables>;
export const UpsertWalletApprovalDraftPolicyDocument = gql`
    mutation UpsertWalletApprovalDraftPolicy($input: UpsertWalletApprovalPolicyInput!) {
  upsertWalletApprovalDraftPolicy(input: $input)
}
    `;
export type UpsertWalletApprovalDraftPolicyMutationFn = Apollo.MutationFunction<UpsertWalletApprovalDraftPolicyMutation, UpsertWalletApprovalDraftPolicyMutationVariables>;

/**
 * __useUpsertWalletApprovalDraftPolicyMutation__
 *
 * To run a mutation, you first call `useUpsertWalletApprovalDraftPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWalletApprovalDraftPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWalletApprovalDraftPolicyMutation, { data, loading, error }] = useUpsertWalletApprovalDraftPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertWalletApprovalDraftPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertWalletApprovalDraftPolicyMutation, UpsertWalletApprovalDraftPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertWalletApprovalDraftPolicyMutation, UpsertWalletApprovalDraftPolicyMutationVariables>(UpsertWalletApprovalDraftPolicyDocument, options);
      }
export type UpsertWalletApprovalDraftPolicyMutationHookResult = ReturnType<typeof useUpsertWalletApprovalDraftPolicyMutation>;
export type UpsertWalletApprovalDraftPolicyMutationResult = Apollo.MutationResult<UpsertWalletApprovalDraftPolicyMutation>;
export type UpsertWalletApprovalDraftPolicyMutationOptions = Apollo.BaseMutationOptions<UpsertWalletApprovalDraftPolicyMutation, UpsertWalletApprovalDraftPolicyMutationVariables>;
export const WalletApprovalCreateOnchainTransferDocument = gql`
    mutation WalletApprovalCreateOnchainTransfer($input: CreateTransferInput!) {
  walletApprovalCreateOnchainTransfer(input: $input) {
    proposalId
    transferId
  }
}
    `;
export type WalletApprovalCreateOnchainTransferMutationFn = Apollo.MutationFunction<WalletApprovalCreateOnchainTransferMutation, WalletApprovalCreateOnchainTransferMutationVariables>;

/**
 * __useWalletApprovalCreateOnchainTransferMutation__
 *
 * To run a mutation, you first call `useWalletApprovalCreateOnchainTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalCreateOnchainTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletApprovalCreateOnchainTransferMutation, { data, loading, error }] = useWalletApprovalCreateOnchainTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalletApprovalCreateOnchainTransferMutation(baseOptions?: Apollo.MutationHookOptions<WalletApprovalCreateOnchainTransferMutation, WalletApprovalCreateOnchainTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletApprovalCreateOnchainTransferMutation, WalletApprovalCreateOnchainTransferMutationVariables>(WalletApprovalCreateOnchainTransferDocument, options);
      }
export type WalletApprovalCreateOnchainTransferMutationHookResult = ReturnType<typeof useWalletApprovalCreateOnchainTransferMutation>;
export type WalletApprovalCreateOnchainTransferMutationResult = Apollo.MutationResult<WalletApprovalCreateOnchainTransferMutation>;
export type WalletApprovalCreateOnchainTransferMutationOptions = Apollo.BaseMutationOptions<WalletApprovalCreateOnchainTransferMutation, WalletApprovalCreateOnchainTransferMutationVariables>;
export const WalletApprovalCreatePayoutTransferDocument = gql`
    mutation WalletApprovalCreatePayoutTransfer($input: CreatePayoutInput!) {
  walletApprovalCreatePayoutTransfer(input: $input)
}
    `;
export type WalletApprovalCreatePayoutTransferMutationFn = Apollo.MutationFunction<WalletApprovalCreatePayoutTransferMutation, WalletApprovalCreatePayoutTransferMutationVariables>;

/**
 * __useWalletApprovalCreatePayoutTransferMutation__
 *
 * To run a mutation, you first call `useWalletApprovalCreatePayoutTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalCreatePayoutTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletApprovalCreatePayoutTransferMutation, { data, loading, error }] = useWalletApprovalCreatePayoutTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalletApprovalCreatePayoutTransferMutation(baseOptions?: Apollo.MutationHookOptions<WalletApprovalCreatePayoutTransferMutation, WalletApprovalCreatePayoutTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletApprovalCreatePayoutTransferMutation, WalletApprovalCreatePayoutTransferMutationVariables>(WalletApprovalCreatePayoutTransferDocument, options);
      }
export type WalletApprovalCreatePayoutTransferMutationHookResult = ReturnType<typeof useWalletApprovalCreatePayoutTransferMutation>;
export type WalletApprovalCreatePayoutTransferMutationResult = Apollo.MutationResult<WalletApprovalCreatePayoutTransferMutation>;
export type WalletApprovalCreatePayoutTransferMutationOptions = Apollo.BaseMutationOptions<WalletApprovalCreatePayoutTransferMutation, WalletApprovalCreatePayoutTransferMutationVariables>;
export const WalletApprovalPendingTransactionsDocument = gql`
    query WalletApprovalPendingTransactions($page: PaginationInput, $filter: WalletApprovalTransactionFilterInput) {
  walletApprovalPendingTransactions(page: $page, filter: $filter) {
    ...PaginationInfo
    ...WalletApprovalTransactionsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${WalletApprovalTransactionsInfoFragmentDoc}`;

/**
 * __useWalletApprovalPendingTransactionsQuery__
 *
 * To run a query within a React component, call `useWalletApprovalPendingTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalPendingTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalPendingTransactionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWalletApprovalPendingTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>(WalletApprovalPendingTransactionsDocument, options);
      }
export function useWalletApprovalPendingTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>(WalletApprovalPendingTransactionsDocument, options);
        }
export function useWalletApprovalPendingTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>(WalletApprovalPendingTransactionsDocument, options);
        }
export type WalletApprovalPendingTransactionsQueryHookResult = ReturnType<typeof useWalletApprovalPendingTransactionsQuery>;
export type WalletApprovalPendingTransactionsLazyQueryHookResult = ReturnType<typeof useWalletApprovalPendingTransactionsLazyQuery>;
export type WalletApprovalPendingTransactionsSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalPendingTransactionsSuspenseQuery>;
export type WalletApprovalPendingTransactionsQueryResult = Apollo.QueryResult<WalletApprovalPendingTransactionsQuery, WalletApprovalPendingTransactionsQueryVariables>;
export const WalletApprovalPolicyDocument = gql`
    query WalletApprovalPolicy($currency: Currency!) {
  walletApprovalPolicy(currency: $currency) {
    ...WalletApprovalPolicyInfo
  }
}
    ${WalletApprovalPolicyInfoFragmentDoc}`;

/**
 * __useWalletApprovalPolicyQuery__
 *
 * To run a query within a React component, call `useWalletApprovalPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalPolicyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useWalletApprovalPolicyQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>(WalletApprovalPolicyDocument, options);
      }
export function useWalletApprovalPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>(WalletApprovalPolicyDocument, options);
        }
export function useWalletApprovalPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>(WalletApprovalPolicyDocument, options);
        }
export type WalletApprovalPolicyQueryHookResult = ReturnType<typeof useWalletApprovalPolicyQuery>;
export type WalletApprovalPolicyLazyQueryHookResult = ReturnType<typeof useWalletApprovalPolicyLazyQuery>;
export type WalletApprovalPolicySuspenseQueryHookResult = ReturnType<typeof useWalletApprovalPolicySuspenseQuery>;
export type WalletApprovalPolicyQueryResult = Apollo.QueryResult<WalletApprovalPolicyQuery, WalletApprovalPolicyQueryVariables>;
export const WalletApprovalSubmittedPolicyProgressDocument = gql`
    query WalletApprovalSubmittedPolicyProgress($policyId: ID!) {
  walletApprovalSubmittedPolicyProgress(policyId: $policyId) {
    policyId
    approvedByUser {
      name
    }
    rejectedByUser {
      name
    }
    pendingApprovalsUser {
      name
    }
  }
}
    `;

/**
 * __useWalletApprovalSubmittedPolicyProgressQuery__
 *
 * To run a query within a React component, call `useWalletApprovalSubmittedPolicyProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalSubmittedPolicyProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalSubmittedPolicyProgressQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useWalletApprovalSubmittedPolicyProgressQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>(WalletApprovalSubmittedPolicyProgressDocument, options);
      }
export function useWalletApprovalSubmittedPolicyProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>(WalletApprovalSubmittedPolicyProgressDocument, options);
        }
export function useWalletApprovalSubmittedPolicyProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>(WalletApprovalSubmittedPolicyProgressDocument, options);
        }
export type WalletApprovalSubmittedPolicyProgressQueryHookResult = ReturnType<typeof useWalletApprovalSubmittedPolicyProgressQuery>;
export type WalletApprovalSubmittedPolicyProgressLazyQueryHookResult = ReturnType<typeof useWalletApprovalSubmittedPolicyProgressLazyQuery>;
export type WalletApprovalSubmittedPolicyProgressSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalSubmittedPolicyProgressSuspenseQuery>;
export type WalletApprovalSubmittedPolicyProgressQueryResult = Apollo.QueryResult<WalletApprovalSubmittedPolicyProgressQuery, WalletApprovalSubmittedPolicyProgressQueryVariables>;
export const WalletApprovalTransactionDetailDocument = gql`
    query WalletApprovalTransactionDetail($proposalId: ID!) {
  walletApprovalTransactionDetail(proposalId: $proposalId) {
    ...WalletApprovalTransactionDetailInfo
  }
}
    ${WalletApprovalTransactionDetailInfoFragmentDoc}`;

/**
 * __useWalletApprovalTransactionDetailQuery__
 *
 * To run a query within a React component, call `useWalletApprovalTransactionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalTransactionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalTransactionDetailQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useWalletApprovalTransactionDetailQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>(WalletApprovalTransactionDetailDocument, options);
      }
export function useWalletApprovalTransactionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>(WalletApprovalTransactionDetailDocument, options);
        }
export function useWalletApprovalTransactionDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>(WalletApprovalTransactionDetailDocument, options);
        }
export type WalletApprovalTransactionDetailQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailQuery>;
export type WalletApprovalTransactionDetailLazyQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailLazyQuery>;
export type WalletApprovalTransactionDetailSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailSuspenseQuery>;
export type WalletApprovalTransactionDetailQueryResult = Apollo.QueryResult<WalletApprovalTransactionDetailQuery, WalletApprovalTransactionDetailQueryVariables>;
export const WalletApprovalTransactionDetailByJobIdDocument = gql`
    query WalletApprovalTransactionDetailByJobId($jobId: ID!) {
  walletApprovalTransactionDetailByJobId(jobId: $jobId) {
    ...WalletApprovalTransactionDetailInfo
  }
}
    ${WalletApprovalTransactionDetailInfoFragmentDoc}`;

/**
 * __useWalletApprovalTransactionDetailByJobIdQuery__
 *
 * To run a query within a React component, call `useWalletApprovalTransactionDetailByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalTransactionDetailByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalTransactionDetailByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useWalletApprovalTransactionDetailByJobIdQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>(WalletApprovalTransactionDetailByJobIdDocument, options);
      }
export function useWalletApprovalTransactionDetailByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>(WalletApprovalTransactionDetailByJobIdDocument, options);
        }
export function useWalletApprovalTransactionDetailByJobIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>(WalletApprovalTransactionDetailByJobIdDocument, options);
        }
export type WalletApprovalTransactionDetailByJobIdQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailByJobIdQuery>;
export type WalletApprovalTransactionDetailByJobIdLazyQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailByJobIdLazyQuery>;
export type WalletApprovalTransactionDetailByJobIdSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalTransactionDetailByJobIdSuspenseQuery>;
export type WalletApprovalTransactionDetailByJobIdQueryResult = Apollo.QueryResult<WalletApprovalTransactionDetailByJobIdQuery, WalletApprovalTransactionDetailByJobIdQueryVariables>;
export const WalletApprovalTransactionPendingProposalCountDocument = gql`
    query WalletApprovalTransactionPendingProposalCount($currency: Currency!) {
  walletApprovalTransactionPendingProposalCount(currency: $currency) {
    count
  }
}
    `;

/**
 * __useWalletApprovalTransactionPendingProposalCountQuery__
 *
 * To run a query within a React component, call `useWalletApprovalTransactionPendingProposalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalTransactionPendingProposalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalTransactionPendingProposalCountQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useWalletApprovalTransactionPendingProposalCountQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>(WalletApprovalTransactionPendingProposalCountDocument, options);
      }
export function useWalletApprovalTransactionPendingProposalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>(WalletApprovalTransactionPendingProposalCountDocument, options);
        }
export function useWalletApprovalTransactionPendingProposalCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>(WalletApprovalTransactionPendingProposalCountDocument, options);
        }
export type WalletApprovalTransactionPendingProposalCountQueryHookResult = ReturnType<typeof useWalletApprovalTransactionPendingProposalCountQuery>;
export type WalletApprovalTransactionPendingProposalCountLazyQueryHookResult = ReturnType<typeof useWalletApprovalTransactionPendingProposalCountLazyQuery>;
export type WalletApprovalTransactionPendingProposalCountSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalTransactionPendingProposalCountSuspenseQuery>;
export type WalletApprovalTransactionPendingProposalCountQueryResult = Apollo.QueryResult<WalletApprovalTransactionPendingProposalCountQuery, WalletApprovalTransactionPendingProposalCountQueryVariables>;
export const WalletApprovalWorkflowDashboardDocument = gql`
    query WalletApprovalWorkflowDashboard($currency: Currency!) {
  walletApprovalPolicy(currency: $currency) {
    ...WalletApprovalPolicyInfo
  }
  walletApprovalPolicyDefaultUserLimits {
    ...WalletApprovalPolicyUserLimitInfo
  }
}
    ${WalletApprovalPolicyInfoFragmentDoc}
${WalletApprovalPolicyUserLimitInfoFragmentDoc}`;

/**
 * __useWalletApprovalWorkflowDashboardQuery__
 *
 * To run a query within a React component, call `useWalletApprovalWorkflowDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletApprovalWorkflowDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletApprovalWorkflowDashboardQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useWalletApprovalWorkflowDashboardQuery(baseOptions: Apollo.QueryHookOptions<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>(WalletApprovalWorkflowDashboardDocument, options);
      }
export function useWalletApprovalWorkflowDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>(WalletApprovalWorkflowDashboardDocument, options);
        }
export function useWalletApprovalWorkflowDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>(WalletApprovalWorkflowDashboardDocument, options);
        }
export type WalletApprovalWorkflowDashboardQueryHookResult = ReturnType<typeof useWalletApprovalWorkflowDashboardQuery>;
export type WalletApprovalWorkflowDashboardLazyQueryHookResult = ReturnType<typeof useWalletApprovalWorkflowDashboardLazyQuery>;
export type WalletApprovalWorkflowDashboardSuspenseQueryHookResult = ReturnType<typeof useWalletApprovalWorkflowDashboardSuspenseQuery>;
export type WalletApprovalWorkflowDashboardQueryResult = Apollo.QueryResult<WalletApprovalWorkflowDashboardQuery, WalletApprovalWorkflowDashboardQueryVariables>;
export const DownloadReportDocument = gql`
    query DownloadReport($reportId: String!) {
  downloadReport(reportId: $reportId) {
    ...DownloadReportInfo
  }
}
    ${DownloadReportInfoFragmentDoc}`;

/**
 * __useDownloadReportQuery__
 *
 * To run a query within a React component, call `useDownloadReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDownloadReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportQuery, DownloadReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportQuery, DownloadReportQueryVariables>(DownloadReportDocument, options);
      }
export function useDownloadReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportQuery, DownloadReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportQuery, DownloadReportQueryVariables>(DownloadReportDocument, options);
        }
export function useDownloadReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadReportQuery, DownloadReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadReportQuery, DownloadReportQueryVariables>(DownloadReportDocument, options);
        }
export type DownloadReportQueryHookResult = ReturnType<typeof useDownloadReportQuery>;
export type DownloadReportLazyQueryHookResult = ReturnType<typeof useDownloadReportLazyQuery>;
export type DownloadReportSuspenseQueryHookResult = ReturnType<typeof useDownloadReportSuspenseQuery>;
export type DownloadReportQueryResult = Apollo.QueryResult<DownloadReportQuery, DownloadReportQueryVariables>;
export const WalletReportsDocument = gql`
    query WalletReports($page: PaginationInput, $walletReportType: WalletReportType) {
  walletReports(page: $page, walletReportType: $walletReportType) {
    ...PaginationInfo
    ...WalletReportsInfo
  }
}
    ${PaginationInfoFragmentDoc}
${WalletReportsInfoFragmentDoc}`;

/**
 * __useWalletReportsQuery__
 *
 * To run a query within a React component, call `useWalletReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      walletReportType: // value for 'walletReportType'
 *   },
 * });
 */
export function useWalletReportsQuery(baseOptions?: Apollo.QueryHookOptions<WalletReportsQuery, WalletReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletReportsQuery, WalletReportsQueryVariables>(WalletReportsDocument, options);
      }
export function useWalletReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletReportsQuery, WalletReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletReportsQuery, WalletReportsQueryVariables>(WalletReportsDocument, options);
        }
export function useWalletReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletReportsQuery, WalletReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletReportsQuery, WalletReportsQueryVariables>(WalletReportsDocument, options);
        }
export type WalletReportsQueryHookResult = ReturnType<typeof useWalletReportsQuery>;
export type WalletReportsLazyQueryHookResult = ReturnType<typeof useWalletReportsLazyQuery>;
export type WalletReportsSuspenseQueryHookResult = ReturnType<typeof useWalletReportsSuspenseQuery>;
export type WalletReportsQueryResult = Apollo.QueryResult<WalletReportsQuery, WalletReportsQueryVariables>;
export const AddEntriesToWatchListDocument = gql`
    mutation AddEntriesToWatchList($input: AddEntriesToWatchListInput!) {
  addEntriesToWatchList(input: $input) {
    ...WatchlistEntryInfo
  }
}
    ${WatchlistEntryInfoFragmentDoc}`;
export type AddEntriesToWatchListMutationFn = Apollo.MutationFunction<AddEntriesToWatchListMutation, AddEntriesToWatchListMutationVariables>;

/**
 * __useAddEntriesToWatchListMutation__
 *
 * To run a mutation, you first call `useAddEntriesToWatchListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEntriesToWatchListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEntriesToWatchListMutation, { data, loading, error }] = useAddEntriesToWatchListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEntriesToWatchListMutation(baseOptions?: Apollo.MutationHookOptions<AddEntriesToWatchListMutation, AddEntriesToWatchListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEntriesToWatchListMutation, AddEntriesToWatchListMutationVariables>(AddEntriesToWatchListDocument, options);
      }
export type AddEntriesToWatchListMutationHookResult = ReturnType<typeof useAddEntriesToWatchListMutation>;
export type AddEntriesToWatchListMutationResult = Apollo.MutationResult<AddEntriesToWatchListMutation>;
export type AddEntriesToWatchListMutationOptions = Apollo.BaseMutationOptions<AddEntriesToWatchListMutation, AddEntriesToWatchListMutationVariables>;
export const SetWatchListEntryDocument = gql`
    mutation SetWatchListEntry($input: SetWatchListEntryInput!) {
  setWatchListEntry(input: $input) {
    ...SetWatchListEntryInfo
  }
}
    ${SetWatchListEntryInfoFragmentDoc}`;
export type SetWatchListEntryMutationFn = Apollo.MutationFunction<SetWatchListEntryMutation, SetWatchListEntryMutationVariables>;

/**
 * __useSetWatchListEntryMutation__
 *
 * To run a mutation, you first call `useSetWatchListEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWatchListEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWatchListEntryMutation, { data, loading, error }] = useSetWatchListEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWatchListEntryMutation(baseOptions?: Apollo.MutationHookOptions<SetWatchListEntryMutation, SetWatchListEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWatchListEntryMutation, SetWatchListEntryMutationVariables>(SetWatchListEntryDocument, options);
      }
export type SetWatchListEntryMutationHookResult = ReturnType<typeof useSetWatchListEntryMutation>;
export type SetWatchListEntryMutationResult = Apollo.MutationResult<SetWatchListEntryMutation>;
export type SetWatchListEntryMutationOptions = Apollo.BaseMutationOptions<SetWatchListEntryMutation, SetWatchListEntryMutationVariables>;
export const WatchlistAllowReasonsDocument = gql`
    query WatchlistAllowReasons {
  watchlistAllowReasons {
    ...WatchlistAllowReasonInfo
  }
}
    ${WatchlistAllowReasonInfoFragmentDoc}`;

/**
 * __useWatchlistAllowReasonsQuery__
 *
 * To run a query within a React component, call `useWatchlistAllowReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistAllowReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistAllowReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWatchlistAllowReasonsQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>(WatchlistAllowReasonsDocument, options);
      }
export function useWatchlistAllowReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>(WatchlistAllowReasonsDocument, options);
        }
export function useWatchlistAllowReasonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>(WatchlistAllowReasonsDocument, options);
        }
export type WatchlistAllowReasonsQueryHookResult = ReturnType<typeof useWatchlistAllowReasonsQuery>;
export type WatchlistAllowReasonsLazyQueryHookResult = ReturnType<typeof useWatchlistAllowReasonsLazyQuery>;
export type WatchlistAllowReasonsSuspenseQueryHookResult = ReturnType<typeof useWatchlistAllowReasonsSuspenseQuery>;
export type WatchlistAllowReasonsQueryResult = Apollo.QueryResult<WatchlistAllowReasonsQuery, WatchlistAllowReasonsQueryVariables>;
export const WatchlistBlockReasonsDocument = gql`
    query WatchlistBlockReasons {
  watchlistBlockReasons {
    ...WatchlistBlockReasonInfo
  }
}
    ${WatchlistBlockReasonInfoFragmentDoc}`;

/**
 * __useWatchlistBlockReasonsQuery__
 *
 * To run a query within a React component, call `useWatchlistBlockReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistBlockReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistBlockReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWatchlistBlockReasonsQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>(WatchlistBlockReasonsDocument, options);
      }
export function useWatchlistBlockReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>(WatchlistBlockReasonsDocument, options);
        }
export function useWatchlistBlockReasonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>(WatchlistBlockReasonsDocument, options);
        }
export type WatchlistBlockReasonsQueryHookResult = ReturnType<typeof useWatchlistBlockReasonsQuery>;
export type WatchlistBlockReasonsLazyQueryHookResult = ReturnType<typeof useWatchlistBlockReasonsLazyQuery>;
export type WatchlistBlockReasonsSuspenseQueryHookResult = ReturnType<typeof useWatchlistBlockReasonsSuspenseQuery>;
export type WatchlistBlockReasonsQueryResult = Apollo.QueryResult<WatchlistBlockReasonsQuery, WatchlistBlockReasonsQueryVariables>;
export const WatchlistEntitiesDocument = gql`
    query WatchlistEntities($type: WatchlistTypes!) {
  watchlistEntities(type: $type) {
    ...WatchlistEntityInfo
  }
}
    ${WatchlistEntityInfoFragmentDoc}`;

/**
 * __useWatchlistEntitiesQuery__
 *
 * To run a query within a React component, call `useWatchlistEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistEntitiesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useWatchlistEntitiesQuery(baseOptions: Apollo.QueryHookOptions<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>(WatchlistEntitiesDocument, options);
      }
export function useWatchlistEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>(WatchlistEntitiesDocument, options);
        }
export function useWatchlistEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>(WatchlistEntitiesDocument, options);
        }
export type WatchlistEntitiesQueryHookResult = ReturnType<typeof useWatchlistEntitiesQuery>;
export type WatchlistEntitiesLazyQueryHookResult = ReturnType<typeof useWatchlistEntitiesLazyQuery>;
export type WatchlistEntitiesSuspenseQueryHookResult = ReturnType<typeof useWatchlistEntitiesSuspenseQuery>;
export type WatchlistEntitiesQueryResult = Apollo.QueryResult<WatchlistEntitiesQuery, WatchlistEntitiesQueryVariables>;
export const WatchlistTypesDocument = gql`
    query WatchlistTypes($variant: WatchLists!) {
  watchlistTypes(variant: $variant) {
    ...WatchlistTypeInfo
  }
}
    ${WatchlistTypeInfoFragmentDoc}`;

/**
 * __useWatchlistTypesQuery__
 *
 * To run a query within a React component, call `useWatchlistTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistTypesQuery({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useWatchlistTypesQuery(baseOptions: Apollo.QueryHookOptions<WatchlistTypesQuery, WatchlistTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistTypesQuery, WatchlistTypesQueryVariables>(WatchlistTypesDocument, options);
      }
export function useWatchlistTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistTypesQuery, WatchlistTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistTypesQuery, WatchlistTypesQueryVariables>(WatchlistTypesDocument, options);
        }
export function useWatchlistTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistTypesQuery, WatchlistTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistTypesQuery, WatchlistTypesQueryVariables>(WatchlistTypesDocument, options);
        }
export type WatchlistTypesQueryHookResult = ReturnType<typeof useWatchlistTypesQuery>;
export type WatchlistTypesLazyQueryHookResult = ReturnType<typeof useWatchlistTypesLazyQuery>;
export type WatchlistTypesSuspenseQueryHookResult = ReturnType<typeof useWatchlistTypesSuspenseQuery>;
export type WatchlistTypesQueryResult = Apollo.QueryResult<WatchlistTypesQuery, WatchlistTypesQueryVariables>;
export const WatchlistDocument = gql`
    query Watchlist($type: WatchlistTypes) {
  watchlist(type: $type) {
    allow {
      ...WatchlistEntryInfo
    }
    block {
      ...WatchlistEntryInfo
    }
  }
}
    ${WatchlistEntryInfoFragmentDoc}`;

/**
 * __useWatchlistQuery__
 *
 * To run a query within a React component, call `useWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useWatchlistQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistQuery, WatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistQuery, WatchlistQueryVariables>(WatchlistDocument, options);
      }
export function useWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistQuery, WatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistQuery, WatchlistQueryVariables>(WatchlistDocument, options);
        }
export function useWatchlistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchlistQuery, WatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistQuery, WatchlistQueryVariables>(WatchlistDocument, options);
        }
export type WatchlistQueryHookResult = ReturnType<typeof useWatchlistQuery>;
export type WatchlistLazyQueryHookResult = ReturnType<typeof useWatchlistLazyQuery>;
export type WatchlistSuspenseQueryHookResult = ReturnType<typeof useWatchlistSuspenseQuery>;
export type WatchlistQueryResult = Apollo.QueryResult<WatchlistQuery, WatchlistQueryVariables>;
export const TransferInstructionDocument = gql`
    query TransferInstruction($input: TransferInstructionInput!) {
  transferInstruction(input: $input) {
    ...TransferInstructionInfo
  }
}
    ${TransferInstructionInfoFragmentDoc}`;

/**
 * __useTransferInstructionQuery__
 *
 * To run a query within a React component, call `useTransferInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferInstructionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferInstructionQuery(baseOptions: Apollo.QueryHookOptions<TransferInstructionQuery, TransferInstructionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferInstructionQuery, TransferInstructionQueryVariables>(TransferInstructionDocument, options);
      }
export function useTransferInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferInstructionQuery, TransferInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferInstructionQuery, TransferInstructionQueryVariables>(TransferInstructionDocument, options);
        }
export function useTransferInstructionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransferInstructionQuery, TransferInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferInstructionQuery, TransferInstructionQueryVariables>(TransferInstructionDocument, options);
        }
export type TransferInstructionQueryHookResult = ReturnType<typeof useTransferInstructionQuery>;
export type TransferInstructionLazyQueryHookResult = ReturnType<typeof useTransferInstructionLazyQuery>;
export type TransferInstructionSuspenseQueryHookResult = ReturnType<typeof useTransferInstructionSuspenseQuery>;
export type TransferInstructionQueryResult = Apollo.QueryResult<TransferInstructionQuery, TransferInstructionQueryVariables>;
export const WireTransferLimitDocument = gql`
    query WireTransferLimit($currency: Currency!, $type: WireTransferTypeEnum!) {
  wireTransferLimit(currency: $currency, type: $type) {
    ...WireTransferLimitInfo
  }
}
    ${WireTransferLimitInfoFragmentDoc}`;

/**
 * __useWireTransferLimitQuery__
 *
 * To run a query within a React component, call `useWireTransferLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useWireTransferLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWireTransferLimitQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useWireTransferLimitQuery(baseOptions: Apollo.QueryHookOptions<WireTransferLimitQuery, WireTransferLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WireTransferLimitQuery, WireTransferLimitQueryVariables>(WireTransferLimitDocument, options);
      }
export function useWireTransferLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WireTransferLimitQuery, WireTransferLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WireTransferLimitQuery, WireTransferLimitQueryVariables>(WireTransferLimitDocument, options);
        }
export function useWireTransferLimitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WireTransferLimitQuery, WireTransferLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WireTransferLimitQuery, WireTransferLimitQueryVariables>(WireTransferLimitDocument, options);
        }
export type WireTransferLimitQueryHookResult = ReturnType<typeof useWireTransferLimitQuery>;
export type WireTransferLimitLazyQueryHookResult = ReturnType<typeof useWireTransferLimitLazyQuery>;
export type WireTransferLimitSuspenseQueryHookResult = ReturnType<typeof useWireTransferLimitSuspenseQuery>;
export type WireTransferLimitQueryResult = Apollo.QueryResult<WireTransferLimitQuery, WireTransferLimitQueryVariables>;
export interface Pagination<T extends PaginatedType> extends PaginationExtends { list: Array<T> }